import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type Access = {
  __typename?: 'Access';
  permission: AccessPermission;
  scope: AccessScope;
};

export enum AccessPermission {
  Modify = 'Modify',
  ReadOnly = 'ReadOnly'
}

export enum AccessScope {
  All = 'All',
  Dashboards = 'Dashboards',
  DataExport = 'DataExport',
  InboundIntegrations = 'InboundIntegrations',
  LabelManagement = 'LabelManagement',
  OutboundIntegrations = 'OutboundIntegrations',
  PermissionManagement = 'PermissionManagement',
  TenantSettings = 'TenantSettings',
  ThemeManagement = 'ThemeManagement'
}

export type Actions = {
  __typename?: 'Actions';
  alert?: Maybe<AlertConfig>;
};

export type ActionsInput = {
  alert?: InputMaybe<AlertConfigInput>;
};

export enum ActorType {
  Agent = 'Agent',
  Bot = 'Bot',
  User = 'User'
}

export type AddAnalysisToDashboardInput = {
  editToken: Scalars['ID'];
  id: Scalars['ID'];
  metadataV2?: InputMaybe<DashboardMetadataInput>;
  version?: InputMaybe<Scalars['Int']>;
};

export type AddReasonsSuggestionInput = {
  entityID: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
};

export type AddUserTagsInput = {
  tags?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type AddUserTagsResponse = MutationResponse & {
  __typename?: 'AddUserTagsResponse';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type AggregateBucketKey = {
  __typename?: 'AggregateBucketKey';
  category?: Maybe<Category>;
  entitySentiment?: Maybe<SentimentType>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Label>;
  labelID?: Maybe<Scalars['String']>;
  language?: Maybe<Language>;
  metadata?: Maybe<MetadataAggregateBucketKey>;
  namespace?: Maybe<Scalars['String']>;
  source?: Maybe<Source>;
  timestamp?: Maybe<Scalars['Int']>;
};

export type AggregateChangeDataPoint = {
  __typename?: 'AggregateChangeDataPoint';
  changeInAggregationWindow?: Maybe<Scalars['Float']>;
  changeInTimeRange: Scalars['Float'];
  key: AggregateBucketKey;
  trend: Array<AggregateDataPoint>;
  volume: Scalars['Float'];
};

export enum AggregateChangeSortField {
  PeriodDelta = 'PERIOD_DELTA',
  Volume = 'VOLUME'
}

export enum AggregateChangeSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum AggregateChangeType {
  Absolute = 'ABSOLUTE',
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type AggregateDataPoint = {
  __typename?: 'AggregateDataPoint';
  bucket?: Maybe<AggregateBucketKey>;
  intermediates?: Maybe<Array<IntermediateAggregateDataPoint>>;
  joinKey?: Maybe<AggregateBucketKey>;
  queryID?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type AggregateDataPointV2 = {
  __typename?: 'AggregateDataPointV2';
  entitySentiment?: Maybe<SentimentType>;
  intermediates?: Maybe<Array<IntermediateAggregateDataPoint>>;
  queryID?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Int']>;
  value: Scalars['Float'];
};

export type AggregateDataV2 = {
  __typename?: 'AggregateDataV2';
  bucket?: Maybe<AggregateBucketKey>;
  values: Array<AggregateDataPointV2>;
};

export type AggregateStatKey = {
  __typename?: 'AggregateStatKey';
  facetID: Scalars['ID'];
  timestamp: Scalars['Int'];
};

export enum AggregateUnit {
  Count = 'COUNT',
  SentimentScore = 'SENTIMENT_SCORE'
}

export type AlertConfig = {
  __typename?: 'AlertConfig';
  channels?: Maybe<Array<Scalars['String']>>;
  integrations?: Maybe<Array<Integration>>;
  level: AnomalyLevel;
};

export type AlertConfigInput = {
  channels?: InputMaybe<Array<Scalars['String']>>;
  level: AnomalyLevel;
};

export type AmazonConnectIntegrationData = {
  __typename?: 'AmazonConnectIntegrationData';
  connectAccessURL: Scalars['String'];
  connectInstanceARN: Scalars['String'];
  region: Scalars['String'];
  s3Uri: Scalars['String'];
};

export type AmazonConnectIntegrationInputData = {
  accessKey: Scalars['String'];
  connectAccessURL: Scalars['String'];
  connectInstanceARN: Scalars['String'];
  region: Scalars['String'];
  s3Uri: Scalars['String'];
  secretKey: Scalars['String'];
};

export type AmplitudeIntegrationData = {
  __typename?: 'AmplitudeIntegrationData';
  placeholder?: Maybe<Scalars['Boolean']>;
};

export type AmplitudeIntegrationInputData = {
  placeholder?: InputMaybe<Scalars['Boolean']>;
};

export type Analysis = {
  __typename?: 'Analysis';
  context: AnalysisContext;
  createdAt: Scalars['Int'];
  createdBy: UserInfo;
  description?: Maybe<Scalars['String']>;
  editToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isReportingDisabled: Scalars['Boolean'];
  metadata: Scalars['String'];
  metadataV2?: Maybe<AnalysisMetadata>;
  originAnalysisViewToken?: Maybe<Scalars['String']>;
  panels: Array<AnalysisPanel>;
  reporting?: Maybe<Reporting>;
  scope: Scope;
  status: Status;
  tenantID: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['Int'];
  useCase: AnalysisUseCase;
  viewToken: Scalars['String'];
};

export type AnalysisArtefactDetails = {
  __typename?: 'AnalysisArtefactDetails';
  useCase: AnalysisUseCase;
};

export type AnalysisContext = {
  __typename?: 'AnalysisContext';
  eql?: Maybe<EqlQuery>;
  eqlExpression: Scalars['String'];
  prompt?: Maybe<Scalars['String']>;
};

export type AnalysisContextInput = {
  eql?: InputMaybe<EqlQueryInput>;
  eqlExpression: Scalars['String'];
  prompt?: InputMaybe<Scalars['String']>;
};

export type AnalysisFilter = {
  createdBy?: InputMaybe<Scalars['ID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scope>;
  status?: InputMaybe<Status>;
  useCase?: InputMaybe<AnalysisUseCase>;
};

export type AnalysisListItem = {
  __typename?: 'AnalysisListItem';
  context?: Maybe<AnalysisContext>;
  createdBy: UserInfo;
  editToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadataV2?: Maybe<AnalysisMetadata>;
  recency: Scalars['Int'];
  scope: Scope;
  title: Scalars['String'];
  useCase?: Maybe<AnalysisUseCase>;
  viewToken: Scalars['String'];
};

export type AnalysisMetadata = {
  __typename?: 'AnalysisMetadata';
  collection?: Maybe<CollectionMetadata>;
  quantify?: Maybe<QuantifyMetadata>;
};

export type AnalysisMetadataInput = {
  collection?: InputMaybe<CollectionMetadataInput>;
  quantify?: InputMaybe<QuantifyMetadataInput>;
};

export type AnalysisPanel = {
  __typename?: 'AnalysisPanel';
  alerts?: Maybe<Array<Maybe<PanelQueryAlert>>>;
  id?: Maybe<Scalars['ID']>;
  metadata: Scalars['String'];
  panelQueries: Array<AnalysisPanelQuery>;
  title: Scalars['String'];
};

export type AnalysisPanelInput = {
  alerts?: InputMaybe<Array<InputMaybe<PanelQueryAlertInput>>>;
  id?: InputMaybe<Scalars['ID']>;
  metadata: Scalars['String'];
  panelQueries: Array<AnalysisPanelQueryInput>;
  title: Scalars['String'];
};

export type AnalysisPanelQuery = {
  __typename?: 'AnalysisPanelQuery';
  eqlExpression: Scalars['String'];
  id: Scalars['ID'];
};

export type AnalysisPanelQueryInput = {
  eqlExpression: Scalars['String'];
  id: Scalars['ID'];
};

export enum AnalysisSortBy {
  Recency = 'RECENCY',
  Scope = 'SCOPE',
  Title = 'TITLE'
}

export enum AnalysisUseCase {
  Collection = 'COLLECTION',
  Compare = 'COMPARE',
  CustomFilter = 'CUSTOM_FILTER',
  Default = 'DEFAULT',
  Feed = 'FEED'
}

export type Anomaly = {
  __typename?: 'Anomaly';
  anomalyTimestamp: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Array<AggregateDataPoint>;
  id: Scalars['ID'];
  identifier: AggregateBucketKey;
  level: AnomalyLevel;
  mean: Scalars['Float'];
  rule: Rule;
  ruleVersion: Scalars['Int'];
  score: Scalars['Float'];
  value: Scalars['Float'];
  valueByTotalFeedback: Scalars['Float'];
  volumeData: Array<AggregateDataPoint>;
};

export type AnomalyFilterParams = {
  changeThreshold?: InputMaybe<Scalars['Int']>;
  volumeThreshold?: InputMaybe<Scalars['Int']>;
};

export enum AnomalyLevel {
  Critical = 'CRITICAL',
  Warning = 'WARNING'
}

export type AnomalyRuleListItem = {
  __typename?: 'AnomalyRuleListItem';
  createdBy?: Maybe<UserInfo>;
  discoverability: Scope;
  editToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  tenantID: Scalars['ID'];
  viewToken: Scalars['String'];
};

export type AnomalySettings = {
  __typename?: 'AnomalySettings';
  homePageRuleIDs: Array<Scalars['ID']>;
};

export type AppstoreData = SourceData & {
  __typename?: 'AppstoreData';
  appID?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rating?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  upvotes?: Maybe<Scalars['Int']>;
  version?: Maybe<Scalars['String']>;
};

export type AppstoreIntegrationData = {
  __typename?: 'AppstoreIntegrationData';
  AppID: Scalars['String'];
  AppName: Scalars['String'];
};

export type AppstoreIntegrationInputData = {
  appID?: InputMaybe<Scalars['String']>;
  appName?: InputMaybe<Scalars['String']>;
  appURL?: InputMaybe<Scalars['String']>;
  issuerID?: InputMaybe<Scalars['String']>;
  privateAPIKey?: InputMaybe<Scalars['String']>;
  privateAPIKeyID?: InputMaybe<Scalars['String']>;
};

export type AppstoreUpdateIntegrationData = {
  issuerID?: InputMaybe<Scalars['String']>;
  privateAPIKey?: InputMaybe<Scalars['String']>;
  privateAPIKeyID?: InputMaybe<Scalars['String']>;
};

export type ArchiveLabelInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type ArchiveLabelResponse = {
  __typename?: 'ArchiveLabelResponse';
  archived: Scalars['Boolean'];
};

export type ArrayType = {
  type: PrimitiveDataType;
};

export type ArtefactAnalysisFilter = {
  feedbackFilter?: InputMaybe<SavedFeedbackMetadataInput>;
  useCases?: InputMaybe<Array<AnalysisUseCase>>;
};

export enum ArtefactCreatedByFilter {
  All = 'ALL',
  Others = 'OTHERS',
  User = 'USER'
}

export type ArtefactDashboardFilter = {
  useCases?: InputMaybe<Array<DashboardUseCase>>;
};

export type ArtefactDetails = {
  __typename?: 'ArtefactDetails';
  analysis?: Maybe<AnalysisArtefactDetails>;
  dashboard?: Maybe<DashboardArtefactDetails>;
};

export enum ArtefactEditableByFilter {
  All = 'ALL',
  Others = 'OTHERS',
  User = 'USER'
}

export type ArtefactListItem = {
  __typename?: 'ArtefactListItem';
  artefactDetails?: Maybe<ArtefactDetails>;
  createdAt: Scalars['Int'];
  createdBy: UserInfo;
  id: Scalars['ID'];
  scope?: Maybe<Scope>;
  status?: Maybe<Status>;
  title: Scalars['String'];
  type: ArtefactType;
  updatedAt: Scalars['Int'];
  viewToken: Scalars['String'];
};

export type ArtefactSpecificFilter = {
  analysisFilter?: InputMaybe<ArtefactAnalysisFilter>;
  dashboardFilter?: InputMaybe<ArtefactDashboardFilter>;
};

export enum ArtefactType {
  Analysis = 'ANALYSIS',
  AnomalyRule = 'ANOMALY_RULE',
  Chat = 'CHAT',
  Dashboard = 'DASHBOARD',
  Invalid = 'INVALID'
}

export type AskForArtefactAccessInput = {
  approvalURL: Scalars['String'];
  artefactID: Scalars['ID'];
  artefactType: ArtefactType;
  tenantID: Scalars['ID'];
};

export type AskForArtefactAccessResponse = {
  __typename?: 'AskForArtefactAccessResponse';
  success: Scalars['Boolean'];
};

export type Aspect = Label & TaxonomyNode & {
  __typename?: 'Aspect';
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isUncategorized?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  metadata?: Maybe<AspectMetadata>;
  progress?: Maybe<ProgressInfo>;
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export enum AspectCategory {
  Competitor = 'COMPETITOR',
  Feature = 'FEATURE'
}

export type AspectMetadata = {
  __typename?: 'AspectMetadata';
  category?: Maybe<AspectCategory>;
  excludedPhrases?: Maybe<Array<Scalars['String']>>;
  phrases?: Maybe<Array<Scalars['String']>>;
};

export type AspectPredictionMetadata = {
  __typename?: 'AspectPredictionMetadata';
  keywordSummary?: Maybe<RecordSummary>;
  keywordSummaryHash?: Maybe<Scalars['String']>;
  sentiment: SentimentType;
  units?: Maybe<Array<AspectPredictionMetadataUnit>>;
};

export type AspectPredictionMetadataUnit = {
  __typename?: 'AspectPredictionMetadataUnit';
  category?: Maybe<Category>;
  endOffset: Scalars['Int'];
  indexMetadata: IndexMetadata;
  msgIndex?: Maybe<Scalars['Int']>;
  sentiment: SentimentType;
  startOffset: Scalars['Int'];
};

export type AspectSuggestionMetadataInput = {
  indexMetadata: IndexMetadataInput;
  sentiment?: InputMaybe<SentimentType>;
};

export type AssistantResponseAnswer = {
  __typename?: 'AssistantResponseAnswer';
  tokens: Array<AssistantResponseToken>;
  tokensV2: Array<AssistantResponseTokenV2>;
  userQuote?: Maybe<Array<FeedbackSummaryUserQuote>>;
};

export type AssistantResponseArtefactToken = {
  __typename?: 'AssistantResponseArtefactToken';
  analysis?: Maybe<Analysis>;
  artefactID?: Maybe<Scalars['ID']>;
  feedbackCount?: Maybe<Scalars['Int']>;
  forClaim?: Maybe<Scalars['String']>;
};

export type AssistantResponseEqlToken = {
  __typename?: 'AssistantResponseEQLToken';
  eql?: Maybe<EqlQuery>;
};

export type AssistantResponseFuture = {
  __typename?: 'AssistantResponseFuture';
  chat?: Maybe<Chat>;
  responseID: Scalars['String'];
};

export type AssistantResponsePart = {
  __typename?: 'AssistantResponsePart';
  answer?: Maybe<AssistantResponseAnswer>;
  stepAnswer?: Maybe<AssistantResponseStepAnswer>;
  steps?: Maybe<Array<AssistantResponseStep>>;
};

export type AssistantResponseStep = {
  __typename?: 'AssistantResponseStep';
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type AssistantResponseStepAnswer = {
  __typename?: 'AssistantResponseStepAnswer';
  end?: Maybe<Scalars['Boolean']>;
  isSameAsAnswer?: Maybe<Scalars['Boolean']>;
  stepID: Scalars['ID'];
  tokens: Array<AssistantResponseToken>;
  tokensV2: Array<AssistantResponseTokenV2>;
  userQuotes?: Maybe<Array<FeedbackSummaryUserQuote>>;
};

export type AssistantResponseTextToken = {
  __typename?: 'AssistantResponseTextToken';
  id: Scalars['ID'];
  markdownContent: Scalars['String'];
  summaryDetails?: Maybe<FeedbackSummaryTokenDetails>;
};

export type AssistantResponseToken = {
  __typename?: 'AssistantResponseToken';
  details?: Maybe<FeedbackSummaryTokenDetails>;
  id: Scalars['ID'];
  markdownContent: Scalars['String'];
};

export type AssistantResponseTokenV2 = {
  __typename?: 'AssistantResponseTokenV2';
  artefact?: Maybe<AssistantResponseArtefactToken>;
  eql?: Maybe<AssistantResponseEqlToken>;
  id: Scalars['ID'];
  text?: Maybe<AssistantResponseTextToken>;
};

export type AssistantSampleQuestion = {
  __typename?: 'AssistantSampleQuestion';
  header: Scalars['String'];
  question: Scalars['String'];
  type: AssistantSampleQuestionType;
};

export enum AssistantSampleQuestionType {
  Action = 'ACTION',
  Invalid = 'INVALID',
  Investigate = 'INVESTIGATE',
  Quantify = 'QUANTIFY',
  Summary = 'SUMMARY'
}

export type Association = {
  __typename?: 'Association';
  destination: AssociationNode;
  source: AssociationNode;
  type: AssociationType;
  weight: Scalars['Int'];
};

export type AssociationInput = {
  destination: AssociationNodeInput;
  source: AssociationNodeInput;
  type: AssociationType;
  weight: Scalars['Int'];
};

export type AssociationNode = Aspect | Reason | Tag;

export type AssociationNodeInput = {
  id: Scalars['ID'];
  type: AssociationNodeType;
};

export enum AssociationNodeType {
  Entity = 'ENTITY',
  Reason = 'REASON',
  Tag = 'TAG'
}

export enum AssociationType {
  MentionedIn = 'MentionedIn',
  MergedFrom = 'MergedFrom',
  MergedTo = 'MergedTo',
  RelatedTo = 'RelatedTo',
  SimilarTo = 'SimilarTo',
  TaxonomyEdge = 'TaxonomyEdge',
  UnRelatedTo = 'UnRelatedTo'
}

export type AudioConversation = {
  __typename?: 'AudioConversation';
  audioFileS3: Scalars['String'];
  units?: Maybe<Array<AudioRecordingMessageUnit>>;
};

export type AudioConversationDetails = {
  __typename?: 'AudioConversationDetails';
  audioFileS3: Scalars['String'];
  endTime: Scalars['Float'];
  startTime: Scalars['Float'];
};

export type AudioRecordingMessageUnit = {
  __typename?: 'AudioRecordingMessageUnit';
  actor: Scalars['String'];
  actorType: ActorType;
  metadata: AudioRecordingMetadata;
  text: Scalars['String'];
};

export type AudioRecordingMetadata = {
  __typename?: 'AudioRecordingMetadata';
  endTime: Scalars['Float'];
  startTime: Scalars['Float'];
};

export type AudioSnippet = {
  __typename?: 'AudioSnippet';
  audioConversation: AudioConversation;
  forLabelID?: Maybe<Scalars['String']>;
  metadata?: Maybe<AudioRecordingMetadata>;
  relativeQuoteLocation: IndexTypeConversation;
  summaryText?: Maybe<Scalars['String']>;
};

export type Backfill = {
  __typename?: 'Backfill';
  backfillID: Scalars['ID'];
  jobID: Scalars['ID'];
};

export type BackfillCompleted = {
  __typename?: 'BackfillCompleted';
  backfills: Array<Backfill>;
  isSuccessful: Scalars['Boolean'];
};

export type BackfillSettings = {
  __typename?: 'BackfillSettings';
  duration: RelativeTimeRangeResponse;
};

export enum BackfillStrategy {
  Instant = 'Instant',
  Scheduled = 'Scheduled'
}

export type BatchExecuteEqlExpression = {
  cursor?: InputMaybe<Scalars['String']>;
  expression: Scalars['String'];
  id: Scalars['String'];
};

export type BatchExecuteEqlInput = {
  expressions: Array<BatchExecuteEqlExpression>;
  tenantID: Scalars['ID'];
};

export type BatchExecuteEqlResponse = {
  __typename?: 'BatchExecuteEQLResponse';
  results?: Maybe<Array<BatchExecuteEqlResponseItem>>;
};

export type BatchExecuteEqlResponseItem = {
  __typename?: 'BatchExecuteEQLResponseItem';
  id: Scalars['String'];
  result: EqlResult;
};

export type BatchGetAggregatesInput = {
  queries: Array<BatchGetAggregatesInputQuery>;
  taxonomyID: Scalars['String'];
  tenantID: Scalars['String'];
};

export type BatchGetAggregatesInputQuery = {
  aggregationCalendarWindow?: InputMaybe<CalendarUnit>;
  aggregationWindowInSec?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<FilterQueryUnion>;
  groupBy?: InputMaybe<GroupBy>;
  queryID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
};

export type BatchGetAggregatesResponse = {
  __typename?: 'BatchGetAggregatesResponse';
  aggregates?: Maybe<Array<Maybe<BatchGetAggregatesResponseListItem>>>;
};

export type BatchGetAggregatesResponseListItem = {
  __typename?: 'BatchGetAggregatesResponseListItem';
  data: Array<AggregateDataPoint>;
  queryID: Scalars['String'];
};

export type BoolCollectionDataValue = {
  __typename?: 'BoolCollectionDataValue';
  bools: Array<Scalars['Boolean']>;
};

export type BoolDataValue = {
  __typename?: 'BoolDataValue';
  bool: Scalars['Boolean'];
};

export enum BucketType {
  InvalidBucketType = 'INVALID_BUCKET_TYPE',
  Last_6Months = 'LAST_6_MONTHS',
  LastMonth = 'LAST_MONTH',
  LastYear = 'LAST_YEAR'
}

export enum CsvColumnType {
  Float = 'FLOAT',
  Integer = 'INTEGER',
  String = 'STRING'
}

export type CalendarUnit = {
  timezone: Timezone;
  unit: TimeUnit;
};

export type CalendarWindow = {
  __typename?: 'CalendarWindow';
  timezone: Scalars['String'];
  unit: TimeUnit;
};

export type CalendarWindowInput = {
  timezone: Scalars['String'];
  unit: TimeUnit;
};

export type CaptureSnapshotCanvasSizeInput = {
  height?: InputMaybe<Scalars['Int']>;
  width: Scalars['Int'];
};

export type CaptureSnapshotInput = {
  id?: InputMaybe<Scalars['ID']>;
  settings?: InputMaybe<CaptureSnapshotSettingsInput>;
  tenantID: Scalars['ID'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CaptureSnapshotResponse = {
  __typename?: 'CaptureSnapshotResponse';
  id: Scalars['ID'];
  imageURL?: Maybe<Scalars['String']>;
  status: CaptureSnapshotStatus;
};

export type CaptureSnapshotSettingsInput = {
  canvasSize?: InputMaybe<CaptureSnapshotCanvasSizeInput>;
};

export enum CaptureSnapshotStatus {
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum Category {
  Help = 'HELP',
  Improvement = 'IMPROVEMENT',
  Issue = 'ISSUE',
  Praise = 'PRAISE'
}

export type Change = {
  __typename?: 'Change';
  actor: ChangeActor;
  details: ChangeDetails;
  level: ChangeLevel;
  subjectID: Scalars['ID'];
  tenantID: Scalars['ID'];
  timeEpochS: Scalars['Int'];
};

export type ChangeActor = {
  __typename?: 'ChangeActor';
  isSystem?: Maybe<Scalars['Boolean']>;
  user?: Maybe<UserInfo>;
};

export type ChangeDetails = {
  __typename?: 'ChangeDetails';
  backfillCompleted?: Maybe<BackfillCompleted>;
  keywordExcludedPhrasesUpdated?: Maybe<KeywordPhrasesUpdated>;
  keywordPhrasesUpdated?: Maybe<KeywordPhrasesUpdated>;
  labelAssocitationsUpdated?: Maybe<LabelAssociationsUpdated>;
  labelCreated?: Maybe<LabelCreated>;
  labelDeleted?: Maybe<Scalars['Boolean']>;
  labelDescriptionUpdated?: Maybe<LabelDescriptionUpdated>;
  labelNameUpdated?: Maybe<LabelNameUpdated>;
  labelVisibilityUpdated?: Maybe<LabelVisibilityUpdated>;
  reasonCategoryUpdated?: Maybe<ReasonCategoryUpdated>;
  reasonMerged?: Maybe<ReasonMerged>;
  reasonRCsUpdated?: Maybe<ReasonRCsUpdated>;
};

export enum ChangeLevel {
  Debug = 'DEBUG',
  Info = 'INFO'
}

export type ChannelConfig = {
  __typename?: 'ChannelConfig';
  isDisabled: Scalars['Boolean'];
  outbound: Scalars['String'];
};

export type Chat = {
  __typename?: 'Chat';
  createdAt: Scalars['Int'];
  createdBy: UserInfo;
  editToken?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  responses: Array<ChatResponse>;
  sessionID: Scalars['ID'];
  status: Status;
  tenantID: Scalars['ID'];
  title: Scalars['String'];
  updatedAt: Scalars['Int'];
  viewToken: Scalars['ID'];
};

export type ChatResponse = {
  __typename?: 'ChatResponse';
  answer: AssistantResponseAnswer;
  createdAt: Scalars['Int'];
  editedFromResponseID?: Maybe<Scalars['ID']>;
  editedToResponseID?: Maybe<Scalars['ID']>;
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEdited?: Maybe<Scalars['Boolean']>;
  isStopped?: Maybe<Scalars['Boolean']>;
  nextResponseIDs?: Maybe<Array<Scalars['ID']>>;
  previousResponseID?: Maybe<Scalars['ID']>;
  question: Scalars['String'];
  steps?: Maybe<Array<ChatResponseStep>>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type ChatResponseStep = {
  __typename?: 'ChatResponseStep';
  answer: AssistantResponseStepAnswer;
  id: Scalars['ID'];
  question: Scalars['String'];
};

export type ChorusIntegrationData = {
  __typename?: 'ChorusIntegrationData';
  connected?: Maybe<Scalars['Boolean']>;
};

export type ChorusIntegrationInputData = {
  apiKey: Scalars['String'];
};

export type ClaimExample = {
  __typename?: 'ClaimExample';
  forClaim: Scalars['String'];
  records: Array<ClaimExampleRecord>;
};

export type ClaimExampleRecord = {
  __typename?: 'ClaimExampleRecord';
  labelID: Scalars['ID'];
  recordID: Scalars['ID'];
};

export type Cluster = Label & TaxonomyNode & {
  __typename?: 'Cluster';
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  metadata?: Maybe<ClusterMetadata>;
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export type ClusterMetadata = {
  __typename?: 'ClusterMetadata';
  keywords?: Maybe<Array<Scalars['String']>>;
  samples?: Maybe<Array<Scalars['String']>>;
  sentiment?: Maybe<SentimentType>;
  size: Scalars['Int'];
  type?: Maybe<ClusterType>;
};

export type ClusterPredictionMetadata = {
  __typename?: 'ClusterPredictionMetadata';
  endOffset?: Maybe<Scalars['Int']>;
  startOffset?: Maybe<Scalars['Int']>;
};

export enum ClusterType {
  Frozen = 'FROZEN',
  Residual = 'RESIDUAL'
}

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  savedFeedbackMetadata?: Maybe<Array<SavedFeedbackMetadata>>;
};

export type CollectionMetadataInput = {
  savedFeedbackMetadata?: InputMaybe<Array<SavedFeedbackMetadataInput>>;
};

export type CompareMetadata = {
  __typename?: 'CompareMetadata';
  baseQueryName?: Maybe<Scalars['String']>;
  deltaQueryName?: Maybe<Scalars['String']>;
};

export type CompareMetadataInput = {
  baseQueryName?: InputMaybe<Scalars['String']>;
  deltaQueryName?: InputMaybe<Scalars['String']>;
};

export type CompareQuery = {
  __typename?: 'CompareQuery';
  formula?: Maybe<FormulaQuery>;
  previousPeriod?: Maybe<RelativeTimeRangeResponse>;
  timerange?: Maybe<TimeRangeResponse>;
  whereClause?: Maybe<Scalars['String']>;
};

export type CompareQueryInput = {
  formula?: InputMaybe<FormulaQueryInput>;
  previousPeriod?: InputMaybe<RelativeTimeRange>;
  timerange?: InputMaybe<TimeRange>;
  whereClause?: InputMaybe<Scalars['String']>;
};

export enum ComparisonOperator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE'
}

export type CondensedRecord = {
  __typename?: 'CondensedRecord';
  id: Scalars['ID'];
  language?: Maybe<Language>;
  matchingLabels: Array<Label>;
  namespace?: Maybe<Scalars['String']>;
  otherLabels: Array<Label>;
  quotes: Array<Quotes>;
  recordTypeDetails?: Maybe<RecordTypeDetails>;
  segments: Array<RecordSegment>;
  sentiment?: Maybe<SentimentType>;
  sourceDataV2: SourceDataV2;
  sourceTimestamp: Scalars['Int'];
  summaryText?: Maybe<Scalars['String']>;
  summaryV2: Array<SummaryV2>;
  type: RecordType;
};

export type Conversation = {
  __typename?: 'Conversation';
  msgs?: Maybe<Array<ConversationMsg>>;
};

export type ConversationMsg = {
  __typename?: 'ConversationMsg';
  actor: ActorType;
  actorID?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type CopyChatInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type CopyChatResponse = {
  __typename?: 'CopyChatResponse';
  chat: Chat;
};

export type CorrelatedLabel = {
  __typename?: 'CorrelatedLabel';
  label: Label;
  match: Scalars['Float'];
};

export type CreateAnalysisInput = {
  addToDashboard?: InputMaybe<AddAnalysisToDashboardInput>;
  addToDuplicateOfDashboard?: InputMaybe<DuplicateDashboardInput>;
  addToNewDashboard?: InputMaybe<CreateDashboardInput>;
  context: AnalysisContextInput;
  createdBy: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  metadata: Scalars['String'];
  metadataV2?: InputMaybe<AnalysisMetadataInput>;
  panels: Array<AnalysisPanelInput>;
  scope?: InputMaybe<Scope>;
  tenantID: Scalars['ID'];
  title: Scalars['String'];
  useCase?: InputMaybe<AnalysisUseCase>;
};

export type CreateAnalysisResponse = {
  __typename?: 'CreateAnalysisResponse';
  createDashboardResponse?: Maybe<CreateDashboardResponse>;
  duplicateDashboardResponse?: Maybe<DuplicateDashboardResponse>;
  editToken: Scalars['String'];
  id: Scalars['ID'];
  viewToken: Scalars['String'];
};

export type CreateAspectMetadataInput = {
  phrases: Array<Scalars['String']>;
  themes?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateAssociationResponse = {
  __typename?: 'CreateAssociationResponse';
  isCreated: Scalars['Boolean'];
};

export type CreateAssociationsInput = {
  associations?: InputMaybe<Array<AssociationInput>>;
  tenantID: Scalars['ID'];
  userID?: InputMaybe<Scalars['ID']>;
};

export type CreateDashboardAnalysisInput = {
  context: AnalysisContextInput;
  metadata: Scalars['String'];
  panels: Array<AnalysisPanelInput>;
  title: Scalars['String'];
  useCase?: InputMaybe<AnalysisUseCase>;
};

export type CreateDashboardFromTemplateInput = {
  filterClause?: InputMaybe<FilterClauseInput>;
  scope?: InputMaybe<Scope>;
  templateID: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type CreateDashboardFromTemplateResponse = {
  __typename?: 'CreateDashboardFromTemplateResponse';
  dashboard: Dashboard;
};

export type CreateDashboardInput = {
  addWidget?: InputMaybe<CreateDashboardWidgetInput>;
  analyses?: InputMaybe<Array<CreateDashboardAnalysisInput>>;
  analysisIDs?: InputMaybe<Array<Scalars['String']>>;
  analysisWidgetSelection?: InputMaybe<Array<MapStrToStrListTupleInput>>;
  createdBy: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  editorsToAdd?: InputMaybe<Array<Scalars['ID']>>;
  editorsToInvite?: InputMaybe<Array<Scalars['String']>>;
  filterClause?: InputMaybe<FilterClauseInput>;
  metadata: Scalars['String'];
  metadataV2?: InputMaybe<DashboardMetadataInput>;
  scope?: InputMaybe<Scope>;
  shortMetadata?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['String'];
  title: Scalars['String'];
  useCase?: InputMaybe<DashboardUseCase>;
};

export type CreateDashboardResponse = {
  __typename?: 'CreateDashboardResponse';
  analyses?: Maybe<Array<CreateAnalysisResponse>>;
  dashboard: Dashboard;
  editToken: Scalars['String'];
  id: Scalars['ID'];
  viewToken: Scalars['String'];
};

export type CreateDashboardWidgetInput = {
  cellIdentifier: DashboardCellIdentifierInput;
  id: Scalars['ID'];
  imageWidget?: InputMaybe<ImageWidgetInput>;
  textWidget?: InputMaybe<TextWidgetInput>;
  videoWidget?: InputMaybe<VideoWidgetInput>;
};

export type CreateFieldInput = {
  alias: Scalars['String'];
  dataType: PrimitiveDataType;
  id: Scalars['ID'];
  isPIIEligible: Scalars['Boolean'];
  tenantID: Scalars['ID'];
};

export type CreateFieldResponse = {
  __typename?: 'CreateFieldResponse';
  id: Scalars['ID'];
};

export type CreateIntegrationRequest = {
  channel: IntegrationChannelType;
  createdByUser: Scalars['String'];
  data: IntegrationInputData;
  direction: IntegrationDirection;
  displayName?: InputMaybe<Scalars['String']>;
  externalLinkKey?: InputMaybe<Scalars['String']>;
  integrationDescription?: InputMaybe<IntegrationDescriptionInput>;
  integrationType: IntegrationType;
  tenantID: Scalars['ID'];
};

export type CreateIntegrationResponse = {
  __typename?: 'CreateIntegrationResponse';
  id: Scalars['ID'];
};

export type CreateKeywordInput = {
  associatedReasons?: InputMaybe<Array<Scalars['String']>>;
  backfillPeriod?: InputMaybe<TimeRange>;
  category?: InputMaybe<AspectCategory>;
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  excludedPhrases?: InputMaybe<Array<Scalars['String']>>;
  path?: InputMaybe<TaxonomyT3Path>;
  phrases: Array<Scalars['String']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type CreateKeywordResponse = {
  __typename?: 'CreateKeywordResponse';
  id: Scalars['ID'];
};

export type CreateL1Input = {
  associatedKeywords?: InputMaybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type CreateL1Response = {
  __typename?: 'CreateL1Response';
  id: Scalars['ID'];
};

export type CreateLabelInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  metadata: CreateLabelMetadataInput;
};

export type CreateLabelMetadataInput = {
  aspect?: InputMaybe<CreateAspectMetadataInput>;
  reason?: InputMaybe<CreateReasonMetadataInput>;
};

export type CreateLevelRequest = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type CreateLevelResponse = {
  __typename?: 'CreateLevelResponse';
  id: Scalars['ID'];
};

export type CreateReasonInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  metadata: ReasonMetadataInput;
  tenantID: Scalars['ID'];
};

export type CreateReasonMetadataInput = {
  entities?: InputMaybe<Array<Scalars['ID']>>;
  representativeSentences: Array<Scalars['String']>;
  sentiment: SentimentType;
};

export type CreateReasonResponse = {
  __typename?: 'CreateReasonResponse';
  id: Scalars['ID'];
};

export type CreateReasonV2Input = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  metadata: ReasonMetadataInput;
  path?: InputMaybe<TaxonomyT3Path>;
  records: Array<MapIdToStringInput>;
  tenantID: Scalars['ID'];
  userID?: InputMaybe<Scalars['ID']>;
};

export type CreateReasonV2Response = {
  __typename?: 'CreateReasonV2Response';
  id: Scalars['ID'];
};

export type CreateRuleInput = {
  anomalyFunction: Scalars['String'];
  createdBy: Scalars['String'];
  data: DataInput;
  discoverability?: InputMaybe<Scope>;
  name: Scalars['String'];
  schedule: TimeUnit;
  tenantID: Scalars['ID'];
  thresholds: Array<ThresholdInput>;
  valueFunctions: Array<Scalars['String']>;
};

export type CreateRuleResponse = {
  __typename?: 'CreateRuleResponse';
  id: Scalars['ID'];
};

export type CreateScheduleInput = {
  cron: CronInput;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<ScheduleMetadataInput>;
  outbounds: Array<Scalars['String']>;
  reportType: ReportingType;
  subjectID: Scalars['ID'];
  subjectType: SubjectType;
  tenantID: Scalars['ID'];
};

export type CreateScheduleResponse = {
  __typename?: 'CreateScheduleResponse';
  id: Scalars['ID'];
};

export type CreateSuggestionRequest = {
  createdBy: Scalars['String'];
  data: SuggestionDataInput;
  description?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<SuggestionTagInput>>;
  tenantID: Scalars['ID'];
  type: SuggestionType;
};

export type CreateSuggestionResponse = {
  __typename?: 'CreateSuggestionResponse';
  created: Scalars['Boolean'];
};

export type CreateTagInput = {
  conditionExpression: Scalars['String'];
  createdBy: Scalars['String'];
  description: Scalars['String'];
  displayName: Scalars['String'];
  isVisible: Scalars['Boolean'];
  tenantID: Scalars['ID'];
};

export type CreateTagResponse = {
  __typename?: 'CreateTagResponse';
  id: Scalars['ID'];
};

export type CreateTaxonomyInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type CreateTaxonomyResponse = {
  __typename?: 'CreateTaxonomyResponse';
  id: Scalars['ID'];
};

export type CreateTenantInput = {
  avatar?: InputMaybe<Scalars['String']>;
  dashboardSettings?: InputMaybe<TenantDashboardSettingsInput>;
  domains: Array<Scalars['String']>;
  name: Scalars['String'];
  tier: TenantTier;
  timezone?: InputMaybe<Scalars['String']>;
};

export type CreateTenantResponse = MutationResponse & {
  __typename?: 'CreateTenantResponse';
  code: Scalars['String'];
  id: Scalars['ID'];
  message: Scalars['String'];
};

export type CreateThemeInput = {
  children: Array<Scalars['ID']>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  taxonomyID: Scalars['ID'];
  tenantID: Scalars['ID'];
  version?: InputMaybe<Scalars['Int']>;
};

export type CreateThemeResponse = {
  __typename?: 'CreateThemeResponse';
  id: Scalars['ID'];
};

export type CreateUnifiedFieldInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  referencedKeys: Array<Scalars['String']>;
  shouldHideReferencedKeys?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  type?: InputMaybe<MetadataDataType>;
  userID: Scalars['ID'];
};

export type CreateUnifiedFieldResponse = {
  __typename?: 'CreateUnifiedFieldResponse';
  success: Scalars['Boolean'];
};

export type CreateUserInput = {
  customRole?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<UserInterestsInput>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole>;
  slug?: InputMaybe<Scalars['String']>;
};

export type CreateUserResponse = MutationResponse & {
  __typename?: 'CreateUserResponse';
  code: Scalars['String'];
  id: Scalars['String'];
  message: Scalars['String'];
};

export type CreateWebSocketSessionRequest = {
  __typename?: 'CreateWebSocketSessionRequest';
  userID: Scalars['ID'];
};

export type CreateWebSocketSessionResponse = {
  __typename?: 'CreateWebSocketSessionResponse';
  sessionID: Scalars['ID'];
};

export type Cron = {
  __typename?: 'Cron';
  realtime?: Maybe<Scalars['Boolean']>;
  value?: Maybe<CronValue>;
  valueV2?: Maybe<CronValueV2>;
};

export type CronInput = {
  realtime?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<CronValueInput>;
  valueV2?: InputMaybe<CronValueInputV2>;
};

export enum CronUnit {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type CronValue = {
  __typename?: 'CronValue';
  Offset?: Maybe<CronValue>;
  count: Scalars['Int'];
  unit: CronUnit;
};

export type CronValueInput = {
  count: Scalars['Int'];
  offset?: InputMaybe<CronValueInput>;
  unit: CronUnit;
};

export type CronValueInputV2 = {
  dayOfMonth?: InputMaybe<DayOfMonthInput>;
  dayOfWeek?: InputMaybe<Array<DayName>>;
  hourOfDay: Scalars['Int'];
  minuteOfHour?: InputMaybe<Scalars['Int']>;
};

export type CronValueV2 = {
  __typename?: 'CronValueV2';
  dayOfMonth?: Maybe<DayOfMonth>;
  dayOfWeek?: Maybe<Array<DayName>>;
  hourOfDay: Scalars['Int'];
  minuteOfHour?: Maybe<Scalars['Int']>;
};

export type CustomField = {
  isPIIEligible: Scalars['Boolean'];
  key: Scalars['String'];
  type: DataType;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  analyses?: Maybe<Array<Analysis>>;
  analysisWidgetSelection?: Maybe<Array<MapStrToStrListTuple>>;
  createdAt: Scalars['Int'];
  createdBy: UserInfo;
  description: Scalars['String'];
  editToken?: Maybe<Scalars['String']>;
  editors?: Maybe<Array<UserInfo>>;
  filterClause?: Maybe<FilterClause>;
  id: Scalars['ID'];
  isReportingDisabled: Scalars['Boolean'];
  metadata: Scalars['String'];
  metadataV2?: Maybe<DashboardMetadata>;
  originDashboard?: Maybe<DashboardListItem>;
  reporting?: Maybe<Reporting>;
  scope: Scope;
  shortMetadata: Scalars['String'];
  status: Status;
  tenantID: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['Int'];
  useCase?: Maybe<DashboardUseCase>;
  version: Scalars['Int'];
  viewToken: Scalars['String'];
  widgets?: Maybe<Array<DashboardWidget>>;
};

export type DashboardAnalysisMetadata = {
  __typename?: 'DashboardAnalysisMetadata';
  barLabelWidth?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  shouldExcludeCooccurring?: Maybe<Scalars['Boolean']>;
  shouldShowAnomaliesAsChart?: Maybe<Scalars['Boolean']>;
  shouldShowAsFeed?: Maybe<Scalars['Boolean']>;
  shouldShowAsTable?: Maybe<Scalars['Boolean']>;
};

export type DashboardAnalysisMetadataInput = {
  barLabelWidth?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  shouldExcludeCooccurring?: InputMaybe<Scalars['Boolean']>;
  shouldShowAnomaliesAsChart?: InputMaybe<Scalars['Boolean']>;
  shouldShowAsFeed?: InputMaybe<Scalars['Boolean']>;
  shouldShowAsTable?: InputMaybe<Scalars['Boolean']>;
};

export type DashboardArtefactDetails = {
  __typename?: 'DashboardArtefactDetails';
  useCase: DashboardUseCase;
};

export type DashboardCell = {
  __typename?: 'DashboardCell';
  columnSpan: Scalars['Int'];
  contentID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DashboardCellIdentifierInput = {
  cellId: Scalars['ID'];
  rowId: Scalars['ID'];
};

export type DashboardCellInput = {
  columnSpan: Scalars['Int'];
  contentID: Scalars['ID'];
  id: Scalars['ID'];
};

export type DashboardFilter = {
  analysisID?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  editableBy?: InputMaybe<Scalars['ID']>;
  isArchived?: InputMaybe<Scalars['Boolean']>;
  notEditableBy?: InputMaybe<Scalars['ID']>;
  query?: InputMaybe<Scalars['String']>;
  scope?: InputMaybe<Scope>;
  status?: InputMaybe<Status>;
  useCase?: InputMaybe<DashboardUseCase>;
  useCases?: InputMaybe<Array<DashboardUseCase>>;
};

export type DashboardLayout = {
  __typename?: 'DashboardLayout';
  rows: Array<DashboardRow>;
};

export type DashboardLayoutInput = {
  rows: Array<DashboardRowInput>;
};

export type DashboardListItem = {
  __typename?: 'DashboardListItem';
  analysisIDs?: Maybe<Array<Scalars['ID']>>;
  createdAt: Scalars['Int'];
  createdBy: UserInfo;
  description?: Maybe<Scalars['String']>;
  editToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  metadataV2?: Maybe<DashboardMetadata>;
  recency: Scalars['Int'];
  scope: Scope;
  shortMetadata: Scalars['String'];
  tenantID: Scalars['ID'];
  title: Scalars['String'];
  useCase?: Maybe<DashboardUseCase>;
  version: Scalars['Int'];
  viewToken: Scalars['String'];
};

export type DashboardMetadata = {
  __typename?: 'DashboardMetadata';
  analysesMetadata?: Maybe<Array<DashboardAnalysisMetadata>>;
  layout?: Maybe<DashboardLayout>;
};

export type DashboardMetadataInput = {
  analysesMetadata?: InputMaybe<Array<DashboardAnalysisMetadataInput>>;
  layout?: InputMaybe<DashboardLayoutInput>;
};

export type DashboardRow = {
  __typename?: 'DashboardRow';
  cells: Array<DashboardCell>;
  height: Scalars['Int'];
  id: Scalars['ID'];
};

export type DashboardRowInput = {
  cells: Array<DashboardCellInput>;
  height: Scalars['Int'];
  id: Scalars['ID'];
};

export enum DashboardSortBy {
  Recency = 'RECENCY',
  Scope = 'SCOPE',
  Title = 'TITLE'
}

export enum DashboardUseCase {
  Default = 'DEFAULT',
  Search = 'SEARCH',
  Template = 'TEMPLATE'
}

export type DashboardWidget = {
  __typename?: 'DashboardWidget';
  analysis?: Maybe<Analysis>;
  id: Scalars['ID'];
  imageWidget?: Maybe<ImageWidget>;
  textWidget?: Maybe<TextWidget>;
  videoWidget?: Maybe<VideoWidget>;
};

export type Data = {
  __typename?: 'Data';
  eql: Array<Scalars['String']>;
};

export type DataInput = {
  eql: Array<Scalars['String']>;
};

export type DataMap = {
  __typename?: 'DataMap';
  key: Scalars['String'];
  value: DataValue;
};

export type DataType = {
  array?: InputMaybe<ArrayType>;
  primitive?: InputMaybe<PrimitiveDataType>;
};

export type DataValue = BoolCollectionDataValue | BoolDataValue | NumberCollectionDataValue | NumberDataValue | StringCollectionDataValue | StringDataValue;

export enum DayName {
  Fri = 'FRI',
  Invalid = 'INVALID',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export type DayOfMonth = {
  __typename?: 'DayOfMonth';
  day?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Boolean']>;
};

export type DayOfMonthInput = {
  day?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Boolean']>;
};

export type DefaultReportMetadata = {
  __typename?: 'DefaultReportMetadata';
  skipSnapshot?: Maybe<Scalars['Boolean']>;
};

export type DefaultReportMetadataInput = {
  skipSnapshot?: InputMaybe<Scalars['Boolean']>;
};

export type DeleteAnalysisInput = {
  editToken: Scalars['String'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteAnalysisResponse = {
  __typename?: 'DeleteAnalysisResponse';
  deleted: Scalars['Boolean'];
};

export type DeleteAssociationsInput = {
  associations?: InputMaybe<Array<AssociationInput>>;
  tenantID: Scalars['ID'];
  userID?: InputMaybe<Scalars['ID']>;
};

export type DeleteAssociationsResponse = {
  __typename?: 'DeleteAssociationsResponse';
  isDeleted: Scalars['Boolean'];
};

export type DeleteDashboardInput = {
  editToken: Scalars['String'];
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteDashboardResponse = {
  __typename?: 'DeleteDashboardResponse';
  deleted: Scalars['Boolean'];
};

export type DeleteDashboardWidgetInput = {
  id: Scalars['ID'];
};

export type DeleteLabelRequest = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteLabelResponse = {
  __typename?: 'DeleteLabelResponse';
  updated: Scalars['Boolean'];
};

export type DeleteLabelsInput = {
  ids: Array<Scalars['ID']>;
};

export type DeleteScheduleInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteScheduleResponse = {
  __typename?: 'DeleteScheduleResponse';
  deleted: Scalars['Boolean'];
};

export type DeleteTagInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type DeleteTagResponse = {
  __typename?: 'DeleteTagResponse';
  deleted: Scalars['Boolean'];
};

export type DeleteUnifiedFieldInput = {
  key: Scalars['String'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type DeleteUnifiedFieldResponse = {
  __typename?: 'DeleteUnifiedFieldResponse';
  success: Scalars['Boolean'];
};

export type DelightedData = SourceData & {
  __typename?: 'DelightedData';
  browser?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  device?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  npsScore: Scalars['Int'];
  oS?: Maybe<Scalars['String']>;
  responses?: Maybe<Array<DataMap>>;
  tagsList?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
};

export type DelightedFormData = IntegrationFormData & {
  __typename?: 'DelightedFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
};

export type DelightedIntegrationData = {
  __typename?: 'DelightedIntegrationData';
  apiToken: Scalars['String'];
};

export type DelightedIntegrationInputData = {
  apiToken: Scalars['String'];
};

export type DeltaAggregateDataPoint = {
  __typename?: 'DeltaAggregateDataPoint';
  absoluteDelta: Scalars['Float'];
  bucket?: Maybe<AggregateBucketKey>;
  currIntermediates?: Maybe<Array<IntermediateAggregateDataPoint>>;
  currValue: Scalars['Float'];
  prevIntermediates?: Maybe<Array<IntermediateAggregateDataPoint>>;
  prevValue: Scalars['Float'];
  relativeDelta: Scalars['Float'];
};

export type DescriptionMap = {
  __typename?: 'DescriptionMap';
  description: Scalars['String'];
  sourceID: Scalars['String'];
};

export type DescriptionMapInput = {
  description: Scalars['String'];
  sourceID: Scalars['String'];
};

export type DescriptionTemplate = {
  __typename?: 'DescriptionTemplate';
  description: Scalars['String'];
  name: Scalars['String'];
};

export type DiscordChannel = {
  __typename?: 'DiscordChannel';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DiscordChannelInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DiscordEditFormData = {
  __typename?: 'DiscordEditFormData';
  channelsInGuild: Array<DiscordChannel>;
};

export type DiscordIntegrationData = {
  __typename?: 'DiscordIntegrationData';
  guildID: Scalars['String'];
  guildName: Scalars['String'];
  subscribedChannels: Array<DiscordChannel>;
};

export type DiscordIntegrationInputData = {
  authGrant: Scalars['String'];
  redirectURI?: InputMaybe<Scalars['String']>;
};

export type DiscordUpdateIntegrationData = {
  subscribedChannels: Array<DiscordChannelInput>;
};

export type DiscourseCategory = {
  __typename?: 'DiscourseCategory';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DiscourseCategoryInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type DiscourseData = SourceData & {
  __typename?: 'DiscourseData';
  categoryID?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topicCreatedAt: Scalars['Int'];
  topicID?: Maybe<Scalars['String']>;
  topicSlug?: Maybe<Scalars['String']>;
};

export type DiscourseIntegrationData = {
  __typename?: 'DiscourseIntegrationData';
  forumURL: Scalars['String'];
  subscribedCategories: Array<DiscourseCategory>;
};

export type DiscourseIntegrationInputData = {
  forumURL: Scalars['String'];
  subscribedCategories: Array<DiscourseCategoryInput>;
};

export type DuplicateAndUpdateDashboardInput = {
  dashboardID: Scalars['ID'];
  shouldDuplicateAnalyses?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  updateParams?: InputMaybe<DuplicateAndUpdateDashboardParams>;
  userID: Scalars['ID'];
};

export type DuplicateAndUpdateDashboardParams = {
  addAnalysisIDs?: InputMaybe<Array<Scalars['String']>>;
  addWidget?: InputMaybe<CreateDashboardWidgetInput>;
  deleteWidget?: InputMaybe<DeleteDashboardWidgetInput>;
  description?: InputMaybe<Scalars['String']>;
  filterClause?: InputMaybe<FilterClauseInput>;
  metadataV2?: InputMaybe<DashboardMetadataInput>;
  removeAnalysisIDs?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<Scope>;
  shortMetadata?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updateWidget?: InputMaybe<UpdateDashboardWidgetInput>;
  useCase?: InputMaybe<DashboardUseCase>;
};

export type DuplicateAndUpdateDashboardResponse = {
  __typename?: 'DuplicateAndUpdateDashboardResponse';
  dashboard: Dashboard;
};

export type DuplicateDashboardInput = {
  dashboardID: Scalars['ID'];
  description?: InputMaybe<Scalars['String']>;
  filterClause?: InputMaybe<FilterClauseInput>;
  scope?: InputMaybe<Scope>;
  shortMetadata?: InputMaybe<Scalars['String']>;
  shouldDuplicateAnalyses?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  userID: Scalars['ID'];
};

export type DuplicateDashboardResponse = {
  __typename?: 'DuplicateDashboardResponse';
  dashboard: Dashboard;
};

export type EqlContextInput = {
  eql: Scalars['String'];
};

export type EqlField = {
  __typename?: 'EQLField';
  detail?: Maybe<EqlFieldDetail>;
  displayName: Scalars['String'];
  field: Scalars['String'];
  iconURL?: Maybe<Scalars['String']>;
  isMultiValue: Scalars['Boolean'];
  objectType: ObjectType;
  valueType: EqlFieldValueType;
};

export type EqlFieldDetail = {
  __typename?: 'EQLFieldDetail';
  metadata?: Maybe<EqlFieldMetadataDetail>;
  reference?: Maybe<EqlFieldReferenceDetail>;
};

export type EqlFieldInput = {
  field: Scalars['String'];
};

export type EqlFieldMetadataDetail = {
  __typename?: 'EQLFieldMetadataDetail';
  references?: Maybe<Array<EqlFieldMetadataReference>>;
  source: Scalars['String'];
};

export type EqlFieldMetadataReference = {
  __typename?: 'EQLFieldMetadataReference';
  displayName: Scalars['String'];
  iconURL: Scalars['String'];
  key: Scalars['String'];
  source: Scalars['String'];
};

export type EqlFieldReferenceDetail = {
  __typename?: 'EQLFieldReferenceDetail';
  creatorID?: Maybe<Scalars['ID']>;
  creatorName?: Maybe<Scalars['String']>;
  referenceID: Scalars['ID'];
  referenceType: EqlFieldReferenceType;
};

export enum EqlFieldReferenceType {
  CustomFilters = 'CUSTOM_FILTERS'
}

export type EqlFieldValue = {
  __typename?: 'EQLFieldValue';
  category?: Maybe<Category>;
  displayName: Scalars['String'];
  iconURL?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export enum EqlFieldValueType {
  Boolean = 'BOOLEAN',
  None = 'NONE',
  Number = 'NUMBER',
  String = 'STRING'
}

export type EqlFunction = {
  __typename?: 'EQLFunction';
  anomaly?: Maybe<EqlFunctionAnomaly>;
  deltaOrder?: Maybe<EqlFunctionDeltaOrder>;
  deltaPaginate?: Maybe<EqlFunctionDeltaPaginate>;
  deltaTop?: Maybe<EqlFunctionDeltaTop>;
  order?: Maybe<EqlFunctionOrder>;
  paginate?: Maybe<EqlFunctionPaginate>;
  search?: Maybe<EqlFunctionSearch>;
  selection?: Maybe<EqlFunctionSelection>;
  subGroupBy?: Maybe<EqlFunctionSubGroupByQuery>;
  taxonomy?: Maybe<EqlFunctionTaxonomy>;
  top?: Maybe<EqlFunctionTopQuery>;
};

export type EqlFunctionAnomaly = {
  __typename?: 'EQLFunctionAnomaly';
  shouldIncludeNonAnomalies: Scalars['Boolean'];
  threshold: Scalars['Float'];
};

export type EqlFunctionAnomalyInput = {
  shouldIncludeNonAnomalies: Scalars['Boolean'];
  threshold: Scalars['Float'];
};

export type EqlFunctionDeltaOrder = {
  __typename?: 'EQLFunctionDeltaOrder';
  absoluteDifference?: Maybe<Scalars['Boolean']>;
  baseline?: Maybe<Scalars['Boolean']>;
  difference?: Maybe<Scalars['Boolean']>;
  inspect?: Maybe<Scalars['Boolean']>;
  isDescending: Scalars['Boolean'];
  metadataValue?: Maybe<Scalars['Boolean']>;
};

export type EqlFunctionDeltaOrderInput = {
  absoluteDifference?: InputMaybe<Scalars['Boolean']>;
  baseline?: InputMaybe<Scalars['Boolean']>;
  difference?: InputMaybe<Scalars['Boolean']>;
  inspect?: InputMaybe<Scalars['Boolean']>;
  isDescending: Scalars['Boolean'];
  metadataValue?: InputMaybe<Scalars['Boolean']>;
};

export type EqlFunctionDeltaPaginate = {
  __typename?: 'EQLFunctionDeltaPaginate';
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type EqlFunctionDeltaPaginateInput = {
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type EqlFunctionDeltaTop = {
  __typename?: 'EQLFunctionDeltaTop';
  count: Scalars['Int'];
};

export type EqlFunctionDeltaTopInput = {
  count: Scalars['Int'];
};

export type EqlFunctionInput = {
  anomaly?: InputMaybe<EqlFunctionAnomalyInput>;
  deltaOrder?: InputMaybe<EqlFunctionDeltaOrderInput>;
  deltaPaginate?: InputMaybe<EqlFunctionDeltaPaginateInput>;
  deltaTop?: InputMaybe<EqlFunctionDeltaTopInput>;
  order?: InputMaybe<EqlFunctionOrderInput>;
  paginate?: InputMaybe<EqlFunctionPaginateInput>;
  search?: InputMaybe<EqlFunctionSearchInput>;
  selection?: InputMaybe<EqlFunctionSelectionInput>;
  subGroupBy?: InputMaybe<EqlFunctionSubGroupByInput>;
  taxonomy?: InputMaybe<EqlFunctionTaxonomyInput>;
  top?: InputMaybe<EqlFunctionTopQueryInput>;
};

export type EqlFunctionOrder = {
  __typename?: 'EQLFunctionOrder';
  anomalousValue?: Maybe<Scalars['Boolean']>;
  isDescending: Scalars['Boolean'];
  metadataValue?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Boolean']>;
  volume?: Maybe<Scalars['Boolean']>;
};

export type EqlFunctionOrderInput = {
  anomalousValue?: InputMaybe<Scalars['Boolean']>;
  isDescending: Scalars['Boolean'];
  metadataValue?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Boolean']>;
  volume?: InputMaybe<Scalars['Boolean']>;
};

export type EqlFunctionPaginate = {
  __typename?: 'EQLFunctionPaginate';
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type EqlFunctionPaginateInput = {
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
};

export type EqlFunctionSearch = {
  __typename?: 'EQLFunctionSearch';
  terms: Array<Scalars['String']>;
};

export type EqlFunctionSearchInput = {
  terms: Array<Scalars['String']>;
};

export type EqlFunctionSelection = {
  __typename?: 'EQLFunctionSelection';
  values: Array<Scalars['String']>;
};

export type EqlFunctionSelectionInput = {
  values: Array<Scalars['String']>;
};

export type EqlFunctionSubGroupByInput = {
  groupBy: EqlFieldInput;
  limit: Scalars['Int'];
};

export type EqlFunctionSubGroupByQuery = {
  __typename?: 'EQLFunctionSubGroupByQuery';
  groupBy: EqlField;
  isAsc?: Maybe<Scalars['Boolean']>;
  limit: Scalars['Int'];
};

export type EqlFunctionTaxonomy = {
  __typename?: 'EQLFunctionTaxonomy';
  shouldIncludeIrrelevant: Scalars['Boolean'];
};

export type EqlFunctionTaxonomyInput = {
  shouldIncludeIrrelevant: Scalars['Boolean'];
};

export type EqlFunctionTopQuery = {
  __typename?: 'EQLFunctionTopQuery';
  count: Scalars['Int'];
};

export type EqlFunctionTopQueryInput = {
  count: Scalars['Int'];
};

export type EqlOrderBy = {
  __typename?: 'EQLOrderBy';
  field: EqlOrderByField;
  isDescending: Scalars['Boolean'];
};

export enum EqlOrderByField {
  Time = 'TIME'
}

export type EqlOrderByInput = {
  field: EqlOrderByField;
  isDescending: Scalars['Boolean'];
};

export type EqlQuery = {
  __typename?: 'EQLQuery';
  eql: Scalars['String'];
  properties: EqlQueryProperties;
};

export type EqlQueryInput = {
  properties: EqlQueryPropertiesInput;
};

export type EqlQueryProperties = {
  __typename?: 'EQLQueryProperties';
  aggregatePeriod?: Maybe<TimeUnit>;
  compareQuery?: Maybe<CompareQuery>;
  duration?: Maybe<TimeRangeResponse>;
  formula?: Maybe<Formula>;
  formulaQuery?: Maybe<FormulaQuery>;
  functions?: Maybe<Array<EqlFunction>>;
  groupBy?: Maybe<GroupByResponse>;
  groupByField?: Maybe<EqlField>;
  isCoOccurring?: Maybe<Scalars['Boolean']>;
  orderBy?: Maybe<Array<EqlOrderBy>>;
  type: EqlQueryType;
  whereClause?: Maybe<Scalars['String']>;
};

export type EqlQueryPropertiesInput = {
  aggregatePeriod?: InputMaybe<TimeUnit>;
  compareQuery?: InputMaybe<CompareQueryInput>;
  duration?: InputMaybe<TimeRange>;
  formulaQuery?: InputMaybe<FormulaQueryInput>;
  functions?: InputMaybe<Array<EqlFunctionInput>>;
  groupByField?: InputMaybe<EqlFieldInput>;
  orderBy?: InputMaybe<Array<EqlOrderByInput>>;
  type: EqlQueryType;
  whereClause?: InputMaybe<Scalars['String']>;
};

export enum EqlQueryType {
  Aggregates = 'AGGREGATES',
  Records = 'RECORDS'
}

export type EqlResult = GetAggregatesResponse | GetDeltaAggregatesResponse | GetRecordsResponse;

export enum EqlType {
  EqlTypeFeed = 'EQL_TYPE_FEED',
  EqlTypeNotSpecified = 'EQL_TYPE_NOT_SPECIFIED',
  EqlTypeQuantify = 'EQL_TYPE_QUANTIFY'
}

export type EmailInboundInputData = {
  displayName: Scalars['String'];
};

export type EmailInboundIntegrationData = {
  __typename?: 'EmailInboundIntegrationData';
  receiveOnEmail: Scalars['String'];
};

export type EmailIntegrationData = {
  __typename?: 'EmailIntegrationData';
  ccEmails?: Maybe<Array<Scalars['String']>>;
  toEmails: Array<Scalars['String']>;
};

export type EmailIntegrationInputData = {
  ccEmails?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Scalars['String']>;
  toEmails: Array<Scalars['String']>;
};

export type EmailUpdateIntegrationData = {
  emails?: InputMaybe<Array<Scalars['String']>>;
};

export type EntityManipulation = {
  child?: InputMaybe<ReasonManipulation>;
  labelID: Scalars['ID'];
  manipulationType?: InputMaybe<HierarchyManipulationType>;
  newCategory?: InputMaybe<Category>;
  oldCategory?: InputMaybe<Category>;
  type?: InputMaybe<EntityManipulationType>;
};

export enum EntityManipulationType {
  Add = 'ADD',
  Modify = 'MODIFY'
}

export type ExecuteEqlInput = {
  cursor?: InputMaybe<Scalars['String']>;
  expression: Scalars['String'];
  quoteContext?: InputMaybe<QuoteContext>;
  removeSparsity?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
};

export type ExecuteEqlResponse = {
  __typename?: 'ExecuteEQLResponse';
  result: EqlResult;
};

export type ExportCsvColumn = {
  entitySentiment?: InputMaybe<SentimentType>;
  isFieldColumn?: InputMaybe<Scalars['Boolean']>;
  queryID?: InputMaybe<Scalars['String']>;
  timestamp?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  type: CsvColumnType;
};

export type ExportEqlAsCsvInput = {
  columns: Array<ExportCsvColumn>;
  expression: Scalars['String'];
  filename: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type ExportEqlAsCsvResponse = {
  __typename?: 'ExportEQLAsCSVResponse';
  url: Scalars['String'];
};

export type ExportEqlResultInput = {
  eqlExpression: Scalars['String'];
  includeContent?: InputMaybe<Scalars['Boolean']>;
  includeOriginalContent?: InputMaybe<Scalars['Boolean']>;
  reportFileType?: InputMaybe<ReportType>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type ExportEqlResultResponse = {
  __typename?: 'ExportEQLResultResponse';
  reportID: Scalars['String'];
};

export type FacebookPage = {
  __typename?: 'FacebookPage';
  id: Scalars['String'];
  name: Scalars['String'];
  token?: Maybe<Scalars['String']>;
};

export type FacebookPagesEditFormData = {
  __typename?: 'FacebookPagesEditFormData';
  pages: Array<FacebookPage>;
};

export type FacebookPagesIntegrationData = {
  __typename?: 'FacebookPagesIntegrationData';
  subscribedPage?: Maybe<FacebookPage>;
  userAccessToken: Scalars['String'];
};

export type FacebookPagesIntegrationInputData = {
  code: Scalars['String'];
  redirectURI: Scalars['String'];
};

export type FacebookPagesUpdateIntegrationData = {
  subscribedPage: SubscribedFacebookPageInput;
};

export enum FacetType {
  Aspect = 'ASPECT',
  InvalidEntityType = 'INVALID_ENTITY_TYPE',
  Reason = 'REASON',
  Tag = 'TAG'
}

export type FeedbackMetadataEnrichmentIntegrationData = {
  __typename?: 'FeedbackMetadataEnrichmentIntegrationData';
  metadataEnrichmentName: Scalars['String'];
  metadataKeys?: Maybe<Array<Scalars['String']>>;
};

export type FeedbackMetadataEnrichmentIntegrationInputData = {
  metadataEnrichmentName: Scalars['String'];
  metadataKeys?: InputMaybe<Array<Scalars['String']>>;
};

export type FeedbackMetadataEnrichmentUpdateIntegrationData = {
  metadataKeys?: InputMaybe<Array<Scalars['String']>>;
};

export type FeedbackReportMetadata = {
  __typename?: 'FeedbackReportMetadata';
  recordCount: Scalars['Int'];
};

export type FeedbackReportMetadataInput = {
  recordCount: Scalars['Int'];
};

export type FeedbackSummaryArtefact = {
  __typename?: 'FeedbackSummaryArtefact';
  analysis?: Maybe<Analysis>;
  artefactID?: Maybe<Scalars['ID']>;
  feedbackCount?: Maybe<Scalars['Int']>;
  forClaim?: Maybe<Scalars['String']>;
  forLabelID?: Maybe<Scalars['ID']>;
};

export type FeedbackSummaryExample = {
  __typename?: 'FeedbackSummaryExample';
  claimExample?: Maybe<ClaimExample>;
  count: Scalars['Int'];
  forClaim?: Maybe<Scalars['String']>;
  forMessage?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  labelExample?: Maybe<LabelExample>;
  recordIDs: Array<Scalars['ID']>;
};

export type FeedbackSummaryLabel = {
  __typename?: 'FeedbackSummaryLabel';
  details: Label;
  labelID: Scalars['ID'];
};

export type FeedbackSummaryMessage = {
  __typename?: 'FeedbackSummaryMessage';
  id: Scalars['ID'];
  token?: Maybe<FeedbackSummaryToken>;
  userQuote?: Maybe<FeedbackSummaryUserQuote>;
  userQuoteToken?: Maybe<FeedbackSummaryUserQuoteToken>;
};

export type FeedbackSummaryToken = {
  __typename?: 'FeedbackSummaryToken';
  content: Scalars['String'];
  details?: Maybe<FeedbackSummaryTokenDetails>;
};

export type FeedbackSummaryTokenDetails = {
  __typename?: 'FeedbackSummaryTokenDetails';
  artefact?: Maybe<FeedbackSummaryArtefact>;
  examples?: Maybe<FeedbackSummaryExample>;
  label?: Maybe<FeedbackSummaryLabel>;
};

export type FeedbackSummaryUserQuote = {
  __typename?: 'FeedbackSummaryUserQuote';
  endTime?: Maybe<Scalars['Float']>;
  exampleID: Scalars['ID'];
  externalLink?: Maybe<Scalars['String']>;
  labelID?: Maybe<Scalars['ID']>;
  quote: Scalars['String'];
  recordID: Scalars['ID'];
  source?: Maybe<Scalars['String']>;
  sourceIcon?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['Float']>;
};

export type FeedbackSummaryUserQuoteToken = {
  __typename?: 'FeedbackSummaryUserQuoteToken';
  content: Scalars['String'];
};

export type Field = {
  __typename?: 'Field';
  alias: Scalars['String'];
  createdAt: Scalars['Int'];
  dataType: PrimitiveDataType;
  id: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  isPIIEligible: Scalars['Boolean'];
  isStatic: Scalars['Boolean'];
  tenantID: Scalars['ID'];
};

export type FieldRelation = {
  __typename?: 'FieldRelation';
  field1: Scalars['String'];
  field2: Scalars['String'];
};

export type FieldRelationInput = {
  field1: Scalars['String'];
  field2: Scalars['String'];
};

export enum FieldResolutionType {
  AllOf = 'AllOf',
  OneOf = 'OneOf'
}

export type FieldResolver = {
  __typename?: 'FieldResolver';
  defaultValues?: Maybe<PrimitiveValueArray>;
  field: Field;
  isStatic: Scalars['Boolean'];
  mappings: Array<MappingInstructions>;
  resolutionType: FieldResolutionType;
};

export type FieldResolverInput = {
  defaultValues?: InputMaybe<PrimitiveValueArrayInput>;
  fieldID: Scalars['ID'];
  mappings: Array<MappingInstructionsInput>;
  resolutionType: FieldResolutionType;
};

export enum FileType {
  Csv = 'CSV',
  Gif = 'GIF',
  Jpeg = 'JPEG',
  Png = 'PNG',
  Svg = 'SVG',
  Webp = 'WEBP'
}

export type FileUploadData = SourceData & {
  __typename?: 'FileUploadData';
  b?: Maybe<Array<MapStrToBoolTuple>>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  fileID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<DataMap>>;
  n?: Maybe<Array<MapStrToFloatTuple>>;
  name: Scalars['String'];
  s?: Maybe<Array<MapStrToStrTuple>>;
  timezone?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum FileUploadFieldType {
  Grouped = 'GROUPED',
  Numeric = 'NUMERIC',
  String = 'STRING'
}

export type FileUploadIntegrationData = {
  __typename?: 'FileUploadIntegrationData';
  fileSource: Scalars['String'];
  isEmpty: Scalars['Boolean'];
};

export type FileUploadIntegrationInputData = {
  fileSource: Scalars['String'];
};

export type FilterClause = {
  __typename?: 'FilterClause';
  timeRange?: Maybe<TimeRangeResponse>;
  whereClause?: Maybe<Scalars['String']>;
};

export type FilterClauseInput = {
  timeRange?: InputMaybe<TimeRange>;
  whereClause?: InputMaybe<Scalars['String']>;
};

export type FilterQueryOperation = {
  params: Array<FilterQueryUnion>;
  type: OperationType;
};

export type FilterQueryUnion = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<FilterUnion>;
  op?: InputMaybe<FilterQueryOperation>;
};

export type FilterUnion = {
  hasAspectFilter?: InputMaybe<Scalars['Boolean']>;
  hasClusterFilter?: InputMaybe<Scalars['Boolean']>;
  hasReasonFilter?: InputMaybe<Scalars['Boolean']>;
  labelFilter?: InputMaybe<LabelFilter>;
  labelHierarchyFilter?: InputMaybe<LabelHierarchyFilter>;
  languageFilter?: InputMaybe<LanguageFilter>;
  metadataFilter?: InputMaybe<MetadataFilter>;
  sourceFilter?: InputMaybe<SourceFilter>;
};

export type FlagAssistantResponseInput = {
  chatEditToken?: InputMaybe<Scalars['ID']>;
  comments?: InputMaybe<Scalars['String']>;
  isResponseGood: Scalars['Boolean'];
  reasons?: InputMaybe<Array<Scalars['String']>>;
  responseID: Scalars['ID'];
  sessionID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  viewToken?: InputMaybe<Scalars['ID']>;
};

export type FlagFeedbackSummaryInput = {
  comments?: InputMaybe<Scalars['String']>;
  isResponseGood: Scalars['Boolean'];
  reasons?: InputMaybe<Array<Scalars['String']>>;
  responseID: Scalars['ID'];
  sessionID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  viewToken?: InputMaybe<Scalars['ID']>;
};

export type FlagGeneratedEqlResponse = {
  comments?: InputMaybe<Scalars['String']>;
  generateEQLResponse?: InputMaybe<GeneratedEqlResponse>;
  isResponseGood: Scalars['Boolean'];
  query?: InputMaybe<Scalars['String']>;
  reasons?: InputMaybe<Array<Scalars['String']>>;
  responseID: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type Formula = {
  __typename?: 'Formula';
  description: Scalars['String'];
  displayName: Scalars['String'];
  eqlFunction: Scalars['String'];
  group: Scalars['String'];
  helpCentreURL: Scalars['String'];
  isSupported: Scalars['Boolean'];
  shortName: Scalars['String'];
};

export type FormulaQuery = {
  __typename?: 'FormulaQuery';
  criteria: EqlField;
  denominatorWhereClause?: Maybe<Scalars['String']>;
  eqlFunction: Scalars['String'];
};

export type FormulaQueryInput = {
  criteria: EqlFieldInput;
  denominatorWhereClause?: InputMaybe<Scalars['String']>;
  eqlFunction: Scalars['String'];
};

export type ForumThread = {
  __typename?: 'ForumThread';
  header?: Maybe<ForumThreadMsg>;
  intermediatePosts?: Maybe<Array<ForumThreadMsg>>;
  latestPost?: Maybe<ForumThreadMsg>;
  title?: Maybe<Scalars['String']>;
};

export type ForumThreadMsg = {
  __typename?: 'ForumThreadMsg';
  actorID: Scalars['String'];
  text: Scalars['String'];
};

export type FreshDeskData = SourceData & {
  __typename?: 'FreshDeskData';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
};

export type FreshDeskIntegrationData = {
  __typename?: 'FreshDeskIntegrationData';
  apiKey: Scalars['String'];
  domain: Scalars['String'];
};

export type FreshDeskIntegrationInputData = {
  apiKey: Scalars['String'];
  domain: Scalars['String'];
};

export type FreshchatData = SourceData & {
  __typename?: 'FreshchatData';
  city?: Maybe<Scalars['String']>;
  conversationID: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  labels?: Maybe<Array<Scalars['String']>>;
  metadata?: Maybe<Array<MapStrToStrTuple>>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type FreshchatFormData = IntegrationFormData & {
  __typename?: 'FreshchatFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
};

export type FreshchatIntegrationData = {
  __typename?: 'FreshchatIntegrationData';
  placeholder: Scalars['Boolean'];
};

export type FreshchatIntegrationInputData = {
  accessToken: Scalars['String'];
};

export type FrontData = SourceData & {
  __typename?: 'FrontData';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
};

export type FrontIntegrationData = {
  __typename?: 'FrontIntegrationData';
  accessToken: Scalars['String'];
};

export type FrontIntegrationInputData = {
  accessToken: Scalars['String'];
};

export type FullTextSearchInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<FilterQueryUnion>;
  query: Scalars['String'];
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
};

export type FullTextSearchResponse = {
  __typename?: 'FullTextSearchResponse';
  hits: Scalars['Int'];
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  records?: Maybe<Array<Record>>;
};

export type G2Data = SourceData & {
  __typename?: 'G2Data';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  reviewIncentive?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['String']>;
  starRating?: Maybe<Scalars['Float']>;
  timezone?: Maybe<Scalars['String']>;
  userIndustry?: Maybe<Scalars['String']>;
};

export type G2IntegrationData = {
  __typename?: 'G2IntegrationData';
  orgUUID: Scalars['String'];
};

export type G2IntegrationInputData = {
  slug: Scalars['String'];
};

export type GainsightCategory = {
  __typename?: 'GainsightCategory';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GainsightCategoryInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GainsightEditFormData = {
  __typename?: 'GainsightEditFormData';
  categoryList: Array<GainsightCategory>;
};

export type GainsightIntegrationData = {
  __typename?: 'GainsightIntegrationData';
  subscribedCategories: Array<GainsightCategory>;
};

export type GainsightIntegrationInputData = {
  apiRegion: Scalars['String'];
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  communityDomain: Scalars['String'];
};

export type GainsightUpdateIntegrationData = {
  shouldIngestIdeas: Scalars['Boolean'];
  subscribedCategories: Array<GainsightCategoryInput>;
};

export type GenerateEqlRequest = {
  eqlType: EqlType;
  query: Scalars['String'];
  tenantID: Scalars['String'];
  userID: Scalars['String'];
};

export type GenerateEqlResponse = {
  __typename?: 'GenerateEQLResponse';
  eql?: Maybe<EqlQuery>;
  errorMessage?: Maybe<Scalars['String']>;
  responseID: Scalars['String'];
};

export type GenerateFeedbackSummaryInput = {
  eql: Scalars['String'];
  isExecutiveSummary?: InputMaybe<Scalars['Boolean']>;
  prompt?: InputMaybe<Scalars['String']>;
  sessionID: Scalars['ID'];
  shouldUseArtefactCitations?: InputMaybe<Scalars['Boolean']>;
  shouldUseMarkdown?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GenerateFeedbackSummaryResponse = {
  __typename?: 'GenerateFeedbackSummaryResponse';
  responseID: Scalars['ID'];
};

export type GenerateReportRequest = {
  aggregatesQuery?: InputMaybe<GetAggregatesReportInput>;
  cadence?: InputMaybe<ReportingCadence>;
  predictionQuery?: InputMaybe<GetRecordsReportInput>;
  requestedBy: Scalars['String'];
  sendToEmail?: InputMaybe<PublishChannelEmail>;
  type: ReportType;
};

export type GenerateReportResponse = {
  __typename?: 'GenerateReportResponse';
  reportID: Scalars['String'];
};

export type GeneratedEqlResponse = {
  eql?: InputMaybe<Scalars['String']>;
  errorMessage?: InputMaybe<Scalars['String']>;
};

export type GeneratedRc = {
  __typename?: 'GeneratedRC';
  category?: Maybe<Category>;
  name: Scalars['String'];
};

export type GeneratedRcInput = {
  category?: InputMaybe<Category>;
  name: Scalars['String'];
};

export type GenericLabel = Label & {
  __typename?: 'GenericLabel';
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export type GetAggregatesInput = {
  aggregationCalendarWindow?: InputMaybe<CalendarUnit>;
  aggregationWindowInSec?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<FilterQueryUnion>;
  groupBy?: InputMaybe<GroupBy>;
  includeEmptyBuckets?: InputMaybe<Scalars['Boolean']>;
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
  unit?: InputMaybe<AggregateUnit>;
};

export type GetAggregatesReportInput = {
  aggregationCalendarWindow?: InputMaybe<CalendarUnit>;
  aggregationWindowInSec?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<FilterQueryUnion>;
  groupBy?: InputMaybe<GroupBy>;
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
};

export type GetAggregatesResponse = {
  __typename?: 'GetAggregatesResponse';
  data: Array<AggregateDataPoint>;
  dataV2: Array<AggregateDataV2>;
  hits?: Maybe<Scalars['Int']>;
  valueRange?: Maybe<ValueRage>;
};

export type GetAnalysisByTokenInput = {
  includeScheduleOutbounds?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  token: Scalars['String'];
  userID: Scalars['ID'];
};

export type GetAnomaliesInput = {
  aggregationCalendarWindow: CalendarUnit;
  filter?: InputMaybe<AnomalyFilterParams>;
  tenantID: Scalars['ID'];
  timerange: TimeRange;
};

export type GetAnomaliesResponse = {
  __typename?: 'GetAnomaliesResponse';
  dataPoints?: Maybe<Array<AggregateChangeDataPoint>>;
};

export type GetAssistantResponseInput = {
  chatEditToken?: InputMaybe<Scalars['ID']>;
  question: Scalars['String'];
  sessionID: Scalars['ID'];
  shouldCreateChat?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetAssistantSamplesInput = {
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetAssistantSamplesResponse = {
  __typename?: 'GetAssistantSamplesResponse';
  presets?: Maybe<Array<AssistantSampleQuestion>>;
  samples: Array<Scalars['String']>;
};

export type GetAssociationsInput = {
  paginationToken?: InputMaybe<Scalars['String']>;
  sourceID: Scalars['ID'];
  tenantID: Scalars['ID'];
  type?: InputMaybe<AssociationType>;
};

export type GetAssociationsResponse = {
  __typename?: 'GetAssociationsResponse';
  associations?: Maybe<Array<Association>>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetChatByTokenInput = {
  tenantID: Scalars['ID'];
  token: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetChatByTokenResponse = {
  __typename?: 'GetChatByTokenResponse';
  chat: Chat;
};

export type GetCohortUploadFormDataResponse = {
  __typename?: 'GetCohortUploadFormDataResponse';
  cohortIDs: Array<Scalars['String']>;
  keys: Array<ListCohortJoinKey>;
};

export type GetCorrelatedLabelsInput = {
  entities?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  reasons?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  top: Scalars['Int'];
};

export type GetCorrelatedLabelsResponse = {
  __typename?: 'GetCorrelatedLabelsResponse';
  entities?: Maybe<Array<CorrelatedLabel>>;
  reasons?: Maybe<Array<CorrelatedLabel>>;
};

export type GetDashboardByIdInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetDashboardByIdResponse = {
  __typename?: 'GetDashboardByIDResponse';
  dashboard: Dashboard;
};

export type GetDashboardByTokenInput = {
  includeScheduleOutbounds?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  token: Scalars['String'];
  userID: Scalars['ID'];
};

export type GetDeltaAggregatesInput = {
  aggregationCalendarWindow?: InputMaybe<CalendarUnit>;
  aggregationWindowInSec?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<FilterQueryUnion>;
  groupBy?: InputMaybe<GroupBy>;
  offset: OffsetTime;
  relativeDeltas?: InputMaybe<Scalars['Boolean']>;
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
};

export type GetDeltaAggregatesResponse = {
  __typename?: 'GetDeltaAggregatesResponse';
  data: Array<AggregateDataPoint>;
  dataV2: Array<DeltaAggregateDataPoint>;
  hits?: Maybe<Scalars['Int']>;
  valueRange?: Maybe<ValueRage>;
};

export type GetExtendedUserInput = {
  onlyReference?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetExtendedUserResponse = {
  __typename?: 'GetExtendedUserResponse';
  tags?: Maybe<Array<Scalars['String']>>;
  user?: Maybe<User>;
};

export type GetFieldRelationsInput = {
  source?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type GetFieldRelationsResponse = {
  __typename?: 'GetFieldRelationsResponse';
  relations: Array<FieldRelation>;
};

export enum GetFileUploadFieldProperty {
  HasEmptyValues = 'HAS_EMPTY_VALUES',
  IsUnique = 'IS_UNIQUE',
  SupportsDateFormat = 'SUPPORTS_DATE_FORMAT'
}

export type GetFileUploadFormField = {
  __typename?: 'GetFileUploadFormField';
  fieldName: Scalars['String'];
  index: Scalars['Int'];
  properties: Array<Maybe<GetFileUploadFieldProperty>>;
  sampleValues: Array<Scalars['String']>;
  typeMetadata: TypeMetadata;
  types: Array<FileUploadFieldType>;
  uniqueCount: Scalars['Int'];
};

export type GetFileUploadFormInput = {
  integrationID: Scalars['ID'];
  tenantID: Scalars['ID'];
  url: Scalars['String'];
};

export type GetFileUploadFormResponse = {
  __typename?: 'GetFileUploadFormResponse';
  data: Array<Array<Scalars['String']>>;
  fields: Array<GetFileUploadFormField>;
};

export type GetFileUploadUrlInput = {
  fileName: Scalars['String'];
  fileType: FileType;
  integrationID: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetFileUploadUrlResponse = {
  __typename?: 'GetFileUploadUrlResponse';
  s3Key: Scalars['String'];
  url: Scalars['String'];
};

export type GetFormulasInput = {
  field: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetFormulasResponse = {
  __typename?: 'GetFormulasResponse';
  formulas: Array<Formula>;
};

export type GetFullThreadForRecordInput = {
  recordID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetFullThreadForRecordResponse = {
  __typename?: 'GetFullThreadForRecordResponse';
  thread: Thread;
};

export type GetHighlightsInput = {
  filters?: InputMaybe<FilterQueryUnion>;
  query: Scalars['String'];
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  timerange?: InputMaybe<TimeRange>;
};

export type GetHighlightsResponse = {
  __typename?: 'GetHighlightsResponse';
  text: Scalars['String'];
};

export type GetHistoryInput = {
  cursor?: InputMaybe<Scalars['String']>;
  responseSize?: InputMaybe<Scalars['Int']>;
  subjectID: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetHistoryResponse = {
  __typename?: 'GetHistoryResponse';
  changes: Array<Change>;
  cursor?: Maybe<Scalars['String']>;
};

export type GetIntegrationEditFormDataInput = {
  googleMyBusiness?: InputMaybe<GoogleMyBusinessEditFormDataInput>;
  integrationID: Scalars['ID'];
  salesforce?: InputMaybe<SalesforceEditFormDataInput>;
  slack?: InputMaybe<SlackEditFormDataInput>;
};

export type GetIntegrationEditFormDataResponse = {
  __typename?: 'GetIntegrationEditFormDataResponse';
  formData?: Maybe<IntegrationEditFormData>;
};

export type GetMediaUrlInput = {
  fileName: Scalars['String'];
  fileType: FileType;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetMediaUrlResponse = {
  __typename?: 'GetMediaUrlResponse';
  s3Key: Scalars['String'];
  url: Scalars['String'];
};

export type GetMergeSuggestionsInput = {
  reasonIDs: Array<Scalars['ID']>;
  tenantID: Scalars['ID'];
};

export type GetMergeSuggestionsResponse = {
  __typename?: 'GetMergeSuggestionsResponse';
  suggestions?: Maybe<Array<MergeSuggestion>>;
};

export type GetNotificationSettingsInput = {
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetNotificationSettingsResponse = {
  __typename?: 'GetNotificationSettingsResponse';
  settings: NotificationSettings;
};

export type GetNotificationsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  includeViewed?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetNotificationsResponse = {
  __typename?: 'GetNotificationsResponse';
  cursor?: Maybe<Scalars['String']>;
  hits: Scalars['Int'];
  notifications?: Maybe<Array<Notification>>;
};

export type GetPermissionsForUserTypesInput = {
  tenantID: Scalars['ID'];
  types: Array<UserType>;
};

export type GetPermissionsForUserTypesResponse = {
  __typename?: 'GetPermissionsForUserTypesResponse';
  typeWithPermissions?: Maybe<Array<UserTypeWithPermissions>>;
};

export type GetRcForReasonInput = {
  cursor?: InputMaybe<Scalars['String']>;
  reasonID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetRcForReasonResponse = {
  __typename?: 'GetRCForReasonResponse';
  listRCs?: Maybe<Array<Scalars['String']>>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type GetRcSuggestionInput = {
  limit?: InputMaybe<Scalars['Int']>;
  reasonName: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetRcSuggestionResponse = {
  __typename?: 'GetRCSuggestionResponse';
  suggestedRCs: Array<UnassignedRc>;
};

export type GetRCsForRecordInput = {
  generatedRCs: Array<GeneratedRcInput>;
  recordID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetRCsForRecordResponse = {
  __typename?: 'GetRCsForRecordResponse';
  rcs: Array<Rc>;
};

export type GetRCsFromDescriptionInput = {
  description: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetRCsFromDescriptionResponse = {
  __typename?: 'GetRCsFromDescriptionResponse';
  rcs: Array<Rc>;
};

export type GetReasonNameForCandidatesInput = {
  rcList?: InputMaybe<RcInput>;
  rcs: Array<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type GetReasonNameForCandidatesResponse = {
  __typename?: 'GetReasonNameForCandidatesResponse';
  category: Category;
  displayName: Scalars['String'];
};

export type GetReasonNameRecommendationRequest = {
  reasonIDs?: InputMaybe<Array<Scalars['ID']>>;
  tenantID: Scalars['String'];
};

export type GetReasonNameRecommendationResponse = {
  __typename?: 'GetReasonNameRecommendationResponse';
  category: Category;
  displayName: Scalars['String'];
};

export type GetReasonSentimentInput = {
  reasonName: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetReasonSentimentResponse = {
  __typename?: 'GetReasonSentimentResponse';
  sentiment: SentimentType;
};

export type GetReasonSuggestionInput = {
  recordID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetReasonSuggestionResponse = {
  __typename?: 'GetReasonSuggestionResponse';
  suggestedReasons: Array<SuggestedReason>;
};

export type GetRecordInput = {
  recordID: Scalars['String'];
  tenantID: Scalars['String'];
};

export type GetRecordsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<FilterQueryUnion>;
  offset?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<Array<SortBy>>;
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
};

export type GetRecordsReportInput = {
  filters?: InputMaybe<FilterQueryUnion>;
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
};

export type GetRecordsResponse = {
  __typename?: 'GetRecordsResponse';
  condensedRecords: Array<CondensedRecord>;
  cursor?: Maybe<Scalars['String']>;
  hits: Scalars['Int'];
  previous?: Maybe<Scalars['String']>;
  records: Array<Record>;
};

export type GetRelatedEntitiesInput = {
  query: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetRelatedEntitiesResponse = {
  __typename?: 'GetRelatedEntitiesResponse';
  matches: Array<Aspect>;
};

export type GetRelatedLabelsFilter = {
  labels?: InputMaybe<Array<Scalars['ID']>>;
};

export type GetRelatedLabelsInput = {
  filters: GetRelatedLabelsFilter;
  labelType: LabelType;
  tenantID: Scalars['ID'];
};

export type GetRelatedLabelsResponse = {
  __typename?: 'GetRelatedLabelsResponse';
  labels?: Maybe<Array<Label>>;
};

export type GetRelatedQueriesInput = {
  filters?: InputMaybe<FilterQueryUnion>;
  query: Scalars['String'];
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  timerange?: InputMaybe<TimeRange>;
};

export type GetRelatedQueriesResponse = {
  __typename?: 'GetRelatedQueriesResponse';
  queries: Array<Scalars['String']>;
};

export type GetReportStatusRequest = {
  reportID: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetReportStatusResponse = {
  __typename?: 'GetReportStatusResponse';
  reportURL?: Maybe<Scalars['String']>;
  status: ReportStatus;
};

export type GetReportWindowMetadataInput = {
  cron: CronInput;
  lookBackWindowInHours?: InputMaybe<Scalars['Int']>;
  reportType: ReportingType;
  subjectID: Scalars['ID'];
  subjectType: SubjectType;
  tenantID: Scalars['ID'];
};

export type GetRepresentativeSentencesInput = {
  query: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetRepresentativeSentencesResponse = {
  __typename?: 'GetRepresentativeSentencesResponse';
  proceed: Scalars['Boolean'];
  representativeSentences: Array<Scalars['String']>;
};

export type GetRuleByIdInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetRuleByTokenInput = {
  tenantID: Scalars['ID'];
  token: Scalars['String'];
  userID: Scalars['ID'];
};

export type GetSampleDescriptionInput = {
  tenantID: Scalars['ID'];
};

export type GetSampleDescriptionResponse = {
  __typename?: 'GetSampleDescriptionResponse';
  sampleDescription: Array<DescriptionTemplate>;
};

export type GetScheduleByIdInput = {
  id: Scalars['ID'];
  includeOutbounds?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
};

export type GetSearchRecommendationsInput = {
  maxPerType?: InputMaybe<Scalars['Int']>;
  shouldRecompute?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
};

export type GetSearchRecommendationsResponse = {
  __typename?: 'GetSearchRecommendationsResponse';
  entities?: Maybe<Array<Aspect>>;
  reasons?: Maybe<Array<Reason>>;
};

export type GetSearchSuggestionsInput = {
  include: Array<SuggestionItem>;
  maxPerType?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetSearchSuggestionsResponse = {
  __typename?: 'GetSearchSuggestionsResponse';
  entities?: Maybe<Array<Aspect>>;
  l1s?: Maybe<Array<L1>>;
  reasons?: Maybe<Array<Reason>>;
};

export type GetSimilarReasonsInput = {
  query: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type GetSimilarReasonsResponse = {
  __typename?: 'GetSimilarReasonsResponse';
  exactMatch: Scalars['Boolean'];
  matches: Array<Reason>;
};

export type GetSuggestionByIdInput = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetSummaryUserQuoteInput = {
  claim?: InputMaybe<Scalars['String']>;
  labelID?: InputMaybe<Scalars['ID']>;
  recordID: Scalars['ID'];
  sessionID: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type GetSummaryUserQuoteResponse = {
  __typename?: 'GetSummaryUserQuoteResponse';
  endTime?: Maybe<Scalars['Float']>;
  externalLink?: Maybe<Scalars['String']>;
  labelID?: Maybe<Scalars['ID']>;
  responseID: Scalars['ID'];
  source: Scalars['String'];
  sourceIcon: Scalars['String'];
  startTime?: Maybe<Scalars['Float']>;
};

export type GetTaxonomyInput = {
  applyRelevance?: InputMaybe<Array<Scalars['String']>>;
  labelType: LabelType;
  page: Scalars['Int'];
  responseSize: Scalars['Int'];
  searchFilter?: InputMaybe<Scalars['String']>;
  sortField: TaxonomySortField;
  sortOrder: TaxonomySortOrder;
  tenantID: Scalars['ID'];
};

export type GetTaxonomyResponse = {
  __typename?: 'GetTaxonomyResponse';
  hits: Scalars['Int'];
  nextPage?: Maybe<Scalars['Int']>;
  nodes: Array<TaxonomyNodeV2>;
};

export type GetTaxonomyT3Input = {
  filter?: InputMaybe<TaxonomyT3Filter>;
  labelType: LabelType;
  page?: InputMaybe<Scalars['Int']>;
  responseSize?: InputMaybe<Scalars['Int']>;
  sortField?: InputMaybe<TaxonomySortField>;
  sortOrder?: InputMaybe<TaxonomySortOrder>;
  tenantID: Scalars['ID'];
};

export type GetTaxonomyT3Response = {
  __typename?: 'GetTaxonomyT3Response';
  hits: Scalars['Int'];
  nextPage?: Maybe<Scalars['Int']>;
  nodes: Array<TaxonomyNodeV2>;
};

export type GetTopAggregateChangesInput = {
  aggregationCalendarWindow: CalendarUnit;
  changeType: AggregateChangeType;
  comparisonOffset: OffsetTime;
  count: Scalars['Int'];
  field: GroupBy;
  order: AggregateChangeSortOrder;
  percentage?: InputMaybe<Scalars['Boolean']>;
  sortBy: AggregateChangeSortField;
  tenantID: Scalars['ID'];
  timerange: TimeRange;
};

export type GetTopAggregateChangesResponse = {
  __typename?: 'GetTopAggregateChangesResponse';
  dataPoints: Array<AggregateChangeDataPoint>;
};

export type GetTopAggregatesInput = {
  bucketType: BucketType;
  facetType: FacetType;
  sentiment?: InputMaybe<SentimentType>;
  source?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
  top: Scalars['Int'];
};

export type GetTopAggregatesResponse = {
  __typename?: 'GetTopAggregatesResponse';
  stats?: Maybe<Array<StatDataPoint>>;
};

export type GetUncategorizedNodeInput = {
  path?: InputMaybe<TaxonomyT3Path>;
  tenantID: Scalars['ID'];
};

export type GetUncategorizedNodeResponse = {
  __typename?: 'GetUncategorizedNodeResponse';
  node?: Maybe<TaxonomyNodeV2>;
};

export type GetUserQuoteInput = {
  context: UserQuoteContextInput;
  location?: InputMaybe<IndexMetadataInput>;
  recordID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type GetUserQuoteResponse = {
  __typename?: 'GetUserQuoteResponse';
  quotes: Array<Quote>;
};

export type GongIntegrationInputData = {
  authCode: Scalars['String'];
  redirectURI?: InputMaybe<Scalars['String']>;
};

export type GoogleMyBusinessAccount = {
  __typename?: 'GoogleMyBusinessAccount';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GoogleMyBusinessAccountInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GoogleMyBusinessEditFormData = {
  __typename?: 'GoogleMyBusinessEditFormData';
  accounts?: Maybe<Array<GoogleMyBusinessAccount>>;
  locations?: Maybe<Array<GoogleMyBusinessLocation>>;
  locationsPaginationToken?: Maybe<Scalars['String']>;
};

export type GoogleMyBusinessEditFormDataInput = {
  account?: InputMaybe<GoogleMyBusinessAccountInput>;
  locationsPaginationToken?: InputMaybe<Scalars['String']>;
  queryTerm?: InputMaybe<Scalars['String']>;
};

export type GoogleMyBusinessIntegrationData = {
  __typename?: 'GoogleMyBusinessIntegrationData';
  account?: Maybe<GoogleMyBusinessAccount>;
  locations: Array<GoogleMyBusinessLocation>;
};

export type GoogleMyBusinessIntegrationInputData = {
  code: Scalars['String'];
  redirectURI: Scalars['String'];
};

export type GoogleMyBusinessLocation = {
  __typename?: 'GoogleMyBusinessLocation';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GoogleMyBusinessLocationInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type GoogleMyBusinessLocationsInput = {
  locations: Array<GoogleMyBusinessLocationInput>;
};

export type GoogleMyBusinessUpdateIntegrationData = {
  account?: InputMaybe<GoogleMyBusinessAccountInput>;
  locations?: InputMaybe<GoogleMyBusinessLocationsInput>;
};

export type GrainIntegrationData = {
  __typename?: 'GrainIntegrationData';
  accessToken: Scalars['String'];
};

export type GrainIntegrationInputData = {
  code: Scalars['String'];
};

export type GroupBy = {
  calendar?: InputMaybe<CalendarWindowInput>;
  entity?: InputMaybe<Scalars['Boolean']>;
  entitySentiment?: InputMaybe<Scalars['Boolean']>;
  labelID?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<GroupByMetadata>;
  predictedOn?: InputMaybe<Scalars['Boolean']>;
  reason?: InputMaybe<Scalars['Boolean']>;
  recordSentiment?: InputMaybe<Scalars['Boolean']>;
  source?: InputMaybe<Scalars['Boolean']>;
  time?: InputMaybe<TimePeriodInput>;
};

export type GroupByClause = {
  __typename?: 'GroupByClause';
  calendar?: Maybe<CalendarWindow>;
  entity?: Maybe<Scalars['Boolean']>;
  entitySentiment?: Maybe<Scalars['Boolean']>;
  labelID?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Array<Scalars['String']>>;
  predictedOn?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['Boolean']>;
  recordSentiment?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['Boolean']>;
  time?: Maybe<TimePeriod>;
};

export type GroupByMetadata = {
  keys?: InputMaybe<Array<Scalars['String']>>;
};

export type GroupByMetadataResponse = {
  __typename?: 'GroupByMetadataResponse';
  keys?: Maybe<Array<Scalars['String']>>;
};

export type GroupByResponse = {
  __typename?: 'GroupByResponse';
  category?: Maybe<Scalars['Boolean']>;
  entity?: Maybe<Scalars['Boolean']>;
  entityCategory?: Maybe<Scalars['Boolean']>;
  entitySentiment?: Maybe<Scalars['Boolean']>;
  labelID?: Maybe<Scalars['Boolean']>;
  language?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<GroupByMetadataResponse>;
  predictedOn?: Maybe<Scalars['Boolean']>;
  reason?: Maybe<Scalars['Boolean']>;
  recordSentiment?: Maybe<Scalars['Boolean']>;
  source?: Maybe<Scalars['Boolean']>;
};

export enum HierarchyManipulationType {
  Add = 'ADD',
  Delete = 'DELETE',
  Modify = 'MODIFY'
}

export type ImageWidget = {
  __typename?: 'ImageWidget';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type ImageWidgetInput = {
  url: Scalars['String'];
};

export type InAppIntegrationData = {
  __typename?: 'InAppIntegrationData';
  placeholder?: Maybe<Scalars['Boolean']>;
};

export type IndexMetadata = IndexTypeAudioConversation | IndexTypeConversation | IndexTypeKeywordSummary | IndexTypeSurvey | IndexTypeText;

export type IndexMetadataInput = {
  conversation?: InputMaybe<IndexTypeConversationInput>;
  keywordSummary?: InputMaybe<IndexTypeKeywordSummaryInput>;
  survey?: InputMaybe<IndexTypeSurveyInput>;
  text?: InputMaybe<IndexTypeTextInput>;
};

export type IndexTypeAudioConversation = {
  __typename?: 'IndexTypeAudioConversation';
  endIdx?: Maybe<Scalars['Int']>;
  endTime: Scalars['Int'];
  msgEndIdx?: Maybe<Scalars['Int']>;
  msgIdx: Scalars['Int'];
  startIdx?: Maybe<Scalars['Int']>;
  startTime: Scalars['Int'];
};

export type IndexTypeConversation = {
  __typename?: 'IndexTypeConversation';
  messageEndIndex?: Maybe<Scalars['Int']>;
  messageIndex: Scalars['Int'];
  textIndex: IndexTypeText;
};

export type IndexTypeConversationInput = {
  messageIndex: Scalars['Int'];
  textIndex: IndexTypeTextInput;
};

export type IndexTypeKeywordSummary = {
  __typename?: 'IndexTypeKeywordSummary';
  endIdx?: Maybe<Scalars['Int']>;
  labelID: Scalars['String'];
  msgIdx: Scalars['Int'];
  startIdx?: Maybe<Scalars['Int']>;
};

export type IndexTypeKeywordSummaryInput = {
  endIdx: Scalars['Int'];
  labelID: Scalars['String'];
  msgIdx: Scalars['Int'];
  startIdx: Scalars['Int'];
};

export type IndexTypeSurvey = {
  __typename?: 'IndexTypeSurvey';
  optionIndex?: Maybe<Scalars['Int']>;
  qnaIndex: Scalars['Int'];
  textIndex: IndexTypeText;
};

export type IndexTypeSurveyInput = {
  optionIndex?: InputMaybe<Scalars['Int']>;
  qnaIndex: Scalars['Int'];
  textIndex: IndexTypeTextInput;
};

export type IndexTypeText = {
  __typename?: 'IndexTypeText';
  endOffset: Scalars['Int'];
  startOffset: Scalars['Int'];
};

export type IndexTypeTextInput = {
  endOffset: Scalars['Int'];
  startOffset: Scalars['Int'];
};

export type InputFormData = IntegrationFormData & {
  __typename?: 'InputFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
};

export type Integration = {
  __typename?: 'Integration';
  channel: IntegrationChannel;
  createdAt: Scalars['Int'];
  createdByUser?: Maybe<Scalars['String']>;
  data: IntegrationData;
  description?: Maybe<IntegrationDescription>;
  direction: IntegrationDirection;
  eqlFieldsGroupID?: Maybe<Scalars['String']>;
  externalID?: Maybe<Scalars['String']>;
  externalLinkKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrationType: IntegrationType;
  isActive: Scalars['Boolean'];
  metadataDetails?: Maybe<MetadataDetails>;
  namespace?: Maybe<Scalars['String']>;
  onboardingProgress?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type IntegrationChannel = {
  __typename?: 'IntegrationChannel';
  displayName: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
  supportedTypes: Array<IntegrationType>;
  type: IntegrationChannelType;
};

export enum IntegrationChannelType {
  AmazonConnect = 'AmazonConnect',
  Amplitude = 'Amplitude',
  Appstore = 'Appstore',
  Chorus = 'Chorus',
  Delighted = 'Delighted',
  Discord = 'Discord',
  Discourse = 'Discourse',
  Email = 'Email',
  FacebookPages = 'FacebookPages',
  FileUpload = 'FileUpload',
  FreshDesk = 'FreshDesk',
  Freshchat = 'Freshchat',
  Front = 'Front',
  G2 = 'G2',
  GoogleMyBusiness = 'GOOGLE_MY_BUSINESS',
  Gainsight = 'Gainsight',
  Gong = 'Gong',
  Grain = 'Grain',
  InApp = 'InApp',
  Intercom = 'Intercom',
  Kustomer = 'Kustomer',
  Livechat = 'Livechat',
  MixPanel = 'MixPanel',
  Playstore = 'Playstore',
  Qualtrics = 'Qualtrics',
  Reddit = 'Reddit',
  Salesforce = 'Salesforce',
  Slack = 'Slack',
  Snowflake = 'Snowflake',
  Sprig = 'Sprig',
  StellaConnect = 'StellaConnect',
  SurveyMonkey = 'SurveyMonkey',
  Twitter = 'Twitter',
  Typeform = 'Typeform',
  Webhook = 'Webhook',
  ZendeskChat = 'ZendeskChat',
  ZendeskSupport = 'ZendeskSupport',
  ZohoDesk = 'ZohoDesk'
}

export type IntegrationData = {
  __typename?: 'IntegrationData';
  amazonConnect?: Maybe<AmazonConnectIntegrationData>;
  ampltitude?: Maybe<AmplitudeIntegrationData>;
  appstore?: Maybe<AppstoreIntegrationData>;
  chorus?: Maybe<ChorusIntegrationData>;
  delighted?: Maybe<DelightedIntegrationData>;
  discord?: Maybe<DiscordIntegrationData>;
  discourse?: Maybe<DiscourseIntegrationData>;
  emailInbound?: Maybe<EmailInboundIntegrationData>;
  emails?: Maybe<EmailIntegrationData>;
  facebookPages?: Maybe<FacebookPagesIntegrationData>;
  feedbackMetadataEnrichment?: Maybe<FeedbackMetadataEnrichmentIntegrationData>;
  fileUpload?: Maybe<FileUploadIntegrationData>;
  freshDesk?: Maybe<FreshDeskIntegrationData>;
  freshchat?: Maybe<FreshchatIntegrationData>;
  front?: Maybe<FrontIntegrationData>;
  g2?: Maybe<G2IntegrationData>;
  gainsight?: Maybe<GainsightIntegrationData>;
  googleMyBusiness?: Maybe<GoogleMyBusinessIntegrationData>;
  grain?: Maybe<GrainIntegrationData>;
  inApp?: Maybe<InAppIntegrationData>;
  intercom?: Maybe<IntercomIntegrationData>;
  livechat?: Maybe<LivechatIntegrationData>;
  mixpanel?: Maybe<MixPanelIntegrationData>;
  playstore?: Maybe<PlaystoreIntegrationData>;
  qualtrics?: Maybe<QualtricsIntegrationData>;
  reddit?: Maybe<RedditIntegrationData>;
  salesforce?: Maybe<SalesforceIntegrationData>;
  slack?: Maybe<SlackIntegrationData>;
  snowflake?: Maybe<SnowflakeIntegrationData>;
  sprig?: Maybe<SprigIntegrationData>;
  stellaConnect?: Maybe<StellaConnectIntegrationData>;
  surveyMonkey?: Maybe<SurveyMonkeyIntegrationData>;
  twitter?: Maybe<TwitterIntegrationData>;
  typeform?: Maybe<TypeformIntegrationData>;
  webhook?: Maybe<WebhookIntegrationData>;
  zendeskChat?: Maybe<ZendeskChatIntegrationData>;
  zendeskSupport?: Maybe<ZendeskSupportIntegrationData>;
  zohoDesk?: Maybe<ZohoDeskIntegrationData>;
};

export type IntegrationDescription = {
  __typename?: 'IntegrationDescription';
  description?: Maybe<Scalars['String']>;
  descriptionMap?: Maybe<Array<DescriptionMap>>;
};

export type IntegrationDescriptionInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionMap?: InputMaybe<Array<DescriptionMapInput>>;
};

export enum IntegrationDirection {
  Inbound = 'Inbound',
  Outbound = 'Outbound',
  PrivateOutbound = 'PrivateOutbound'
}

export type IntegrationEditFormData = {
  __typename?: 'IntegrationEditFormData';
  discord?: Maybe<DiscordEditFormData>;
  facebookPages?: Maybe<FacebookPagesEditFormData>;
  gainsight?: Maybe<GainsightEditFormData>;
  googleMyBusiness?: Maybe<GoogleMyBusinessEditFormData>;
  qualtrics?: Maybe<QualtricsEditFormData>;
  salesforce?: Maybe<SalesforceEditFormData>;
  slack?: Maybe<SlackEditFormData>;
  sprig?: Maybe<SprigEditFormData>;
  surveyMonkey?: Maybe<SurveyMonkeyEditFormData>;
  typeform?: Maybe<TypeformEditFormData>;
};

export type IntegrationFormData = {
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
};

export type IntegrationInputData = {
  amazonConnect?: InputMaybe<AmazonConnectIntegrationInputData>;
  amplitude?: InputMaybe<AmplitudeIntegrationInputData>;
  appstore?: InputMaybe<AppstoreIntegrationInputData>;
  chorus?: InputMaybe<ChorusIntegrationInputData>;
  delighted?: InputMaybe<DelightedIntegrationInputData>;
  discord?: InputMaybe<DiscordIntegrationInputData>;
  discourse?: InputMaybe<DiscourseIntegrationInputData>;
  emailInbound?: InputMaybe<EmailInboundInputData>;
  emails?: InputMaybe<EmailIntegrationInputData>;
  facebookPages?: InputMaybe<FacebookPagesIntegrationInputData>;
  feedbackMetadataEnrichment?: InputMaybe<FeedbackMetadataEnrichmentIntegrationInputData>;
  fileUpload?: InputMaybe<FileUploadIntegrationInputData>;
  freshDesk?: InputMaybe<FreshDeskIntegrationInputData>;
  freshchat?: InputMaybe<FreshchatIntegrationInputData>;
  front?: InputMaybe<FrontIntegrationInputData>;
  g2?: InputMaybe<G2IntegrationInputData>;
  gainsight?: InputMaybe<GainsightIntegrationInputData>;
  gong?: InputMaybe<GongIntegrationInputData>;
  googleMyBusiness?: InputMaybe<GoogleMyBusinessIntegrationInputData>;
  grain?: InputMaybe<GrainIntegrationInputData>;
  intercom?: InputMaybe<IntercomIntegrationInputData>;
  kustomer?: InputMaybe<KustomerIntegrationInputData>;
  livechat?: InputMaybe<LivechatIntegrationDataInput>;
  mixpanel?: InputMaybe<MixPanelIntegrationInputData>;
  playstore?: InputMaybe<PlaystoreIntegrationInputData>;
  qualtrics?: InputMaybe<QualtricsIntegrationInputData>;
  reddit?: InputMaybe<RedditIntegrationInputData>;
  salesforce?: InputMaybe<SalesforceIntegrationInputData>;
  slack?: InputMaybe<SlackIntegrationInputData>;
  snowflake?: InputMaybe<SnowflakeIntegrationInputData>;
  sprig?: InputMaybe<SprigIntegrationInputData>;
  stellaConnect?: InputMaybe<StellaConnectIntegrationInputData>;
  surveyMonkey?: InputMaybe<SurveyMonkeyIntegrationInputData>;
  twitter?: InputMaybe<TwitterIntegrationInputData>;
  typeform?: InputMaybe<TypeformInputData>;
  webhook?: InputMaybe<WebhookIntegrationInputData>;
  zendeskChat?: InputMaybe<ZendeskChatIntegrationDataInput>;
  zendeskSupport?: InputMaybe<ZendeskSupportIntegrationDataInput>;
  zohoDesk?: InputMaybe<ZohoDeskIntegrationInputData>;
};

export enum IntegrationType {
  Account = 'ACCOUNT',
  Cohorts = 'COHORTS',
  Comms = 'COMMS',
  Feedback = 'FEEDBACK',
  MetadataEnrichment = 'METADATA_ENRICHMENT',
  User = 'USER'
}

export type IntegrationsFormData = {
  __typename?: 'IntegrationsFormData';
  delighted: DelightedFormData;
  freshchat: FreshchatFormData;
  intercom: IntercomFormData;
  livechat: LivechatFormData;
  slack: SlackFormData;
  stellaConnect: StellaConnectFormData;
  surveyMonkey: SurveyMonkeyFormData;
  typeform: TypeformFormData;
  zendeskChat: ZendeskChatFormData;
  zendeskSupport: ZendeskSupportFormData;
  zohoDesk: ZohoDeskFormData;
};

export type IntegrationsFormDataV2 = {
  __typename?: 'IntegrationsFormDataV2';
  forms: Array<IntegrationFormData>;
};

export type IntercomData = SourceData & {
  __typename?: 'IntercomData';
  adminID?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<MapStrToStrTuple>>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
  userTags?: Maybe<Array<Scalars['String']>>;
};

export type IntercomFormData = IntegrationFormData & {
  __typename?: 'IntercomFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type IntercomIntegrationData = {
  __typename?: 'IntercomIntegrationData';
  accessToken: Scalars['String'];
  appID: Scalars['String'];
};

export type IntercomIntegrationInputData = {
  authGrant: Scalars['String'];
};

export type IntermediateAggregateDataPoint = {
  __typename?: 'IntermediateAggregateDataPoint';
  func: Scalars['String'];
  value: IntermediateAggregateDataPointValue;
};

export type IntermediateAggregateDataPointValue = {
  __typename?: 'IntermediateAggregateDataPointValue';
  anomaly?: Maybe<IntermediateAnomalyFuncValue>;
  applyTaxonomy?: Maybe<IntermediateApplyTaxonomyFuncValue>;
  csat?: Maybe<IntermediateCsatFuncValue>;
  dsat?: Maybe<IntermediateDsatFuncValue>;
  mean?: Maybe<IntermediateMeanFuncValue>;
  nps?: Maybe<IntermediateNpsFuncValue>;
  subGroupBy?: Maybe<IntermediateSubGroupByFuncValue>;
};

export type IntermediateAnomalyFuncValue = {
  __typename?: 'IntermediateAnomalyFuncValue';
  isAnomalous: Scalars['Boolean'];
  mean?: Maybe<Scalars['Float']>;
  zScore?: Maybe<Scalars['Float']>;
};

export type IntermediateApplyTaxonomyFuncValue = {
  __typename?: 'IntermediateApplyTaxonomyFuncValue';
  isRelevant: Scalars['Boolean'];
};

export type IntermediateCsatFuncValue = {
  __typename?: 'IntermediateCsatFuncValue';
  satisfiedResponses: Scalars['Float'];
  totalResponses: Scalars['Float'];
};

export type IntermediateDsatFuncValue = {
  __typename?: 'IntermediateDsatFuncValue';
  dissatisfiedResponses: Scalars['Float'];
  totalResponses: Scalars['Float'];
};

export type IntermediateMeanFuncValue = {
  __typename?: 'IntermediateMeanFuncValue';
  totalValue: Scalars['Float'];
  weightedSum: Scalars['Float'];
};

export type IntermediateNpsFuncValue = {
  __typename?: 'IntermediateNpsFuncValue';
  detractorsPercentage: Scalars['Float'];
  promotersPercentage: Scalars['Float'];
};

export type IntermediateSubGroupByFuncValue = {
  __typename?: 'IntermediateSubGroupByFuncValue';
  bucket?: Maybe<AggregateBucketKey>;
  dataPoints: Array<AggregateDataPoint>;
  value?: Maybe<Scalars['Float']>;
};

export type InviteInput = {
  isSubjectInvite: Scalars['Boolean'];
  message?: InputMaybe<Scalars['String']>;
  sharableLink: Scalars['String'];
  subjectID?: InputMaybe<Scalars['ID']>;
  subjectType?: InputMaybe<SubjectType>;
  tenantID: Scalars['ID'];
  toEmails: Array<Scalars['String']>;
  userID: Scalars['ID'];
};

export type InviteResponse = {
  __typename?: 'InviteResponse';
  invited: Scalars['Boolean'];
};

export type InviteUserInput = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  triggerInviteEmail?: InputMaybe<Scalars['Boolean']>;
  userType: UserType;
};

export type InviteUserResponse = {
  __typename?: 'InviteUserResponse';
  inviteToken: Scalars['String'];
};

export type IsDomainSsoResponse = {
  __typename?: 'IsDomainSsoResponse';
  isEnforced?: Maybe<Scalars['Boolean']>;
  isSaml?: Maybe<Scalars['Boolean']>;
  result: Scalars['Boolean'];
};

export type JunkPatternSuggestionInput = {
  annotatedPattern: Scalars['String'];
  sampleRecords?: InputMaybe<Array<Scalars['String']>>;
};

export type KeywordPhrasesUpdated = {
  __typename?: 'KeywordPhrasesUpdated';
  added?: Maybe<Array<Scalars['String']>>;
  removed?: Maybe<Array<Scalars['String']>>;
};

export type KeywordSummaryLocationInput = {
  keywordSummaryHash?: InputMaybe<Scalars['String']>;
  msgIdx?: InputMaybe<Scalars['Int']>;
};

export type KustomerData = SourceData & {
  __typename?: 'KustomerData';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isVerified?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
};

export type KustomerIntegrationInputData = {
  accessToken: Scalars['String'];
};

export type L1 = Label & TaxonomyNode & {
  __typename?: 'L1';
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isUncategorized?: Maybe<Scalars['Boolean']>;
  isVisible: Scalars['Boolean'];
  progress?: Maybe<ProgressInfo>;
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export type L1Manipulation = {
  child?: InputMaybe<EntityManipulation>;
  labelID: Scalars['ID'];
  manipulationType?: InputMaybe<HierarchyManipulationType>;
};

export type Label = {
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export type LabelAssociation = {
  __typename?: 'LabelAssociation';
  associationType: AssociationType;
  label: Label;
  labelID: Scalars['ID'];
};

export type LabelAssociationsUpdated = {
  __typename?: 'LabelAssociationsUpdated';
  added: Array<LabelAssociation>;
  removed: Array<LabelAssociation>;
};

export type LabelContextInput = {
  labelID: Scalars['String'];
};

export type LabelCreated = {
  __typename?: 'LabelCreated';
  labelData: LabelEventData;
};

export type LabelDescriptionUpdated = {
  __typename?: 'LabelDescriptionUpdated';
  newDescription: Scalars['String'];
  oldDescription: Scalars['String'];
};

export type LabelEventData = {
  __typename?: 'LabelEventData';
  clientReferenceID?: Maybe<Scalars['String']>;
  createdAt: Scalars['Int'];
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  isVisible: Scalars['Boolean'];
  mergedLabels: Array<Scalars['String']>;
  metadata?: Maybe<LabelMetadata>;
  type: LabelType;
  updatedAt: Scalars['Int'];
};

export type LabelExample = {
  __typename?: 'LabelExample';
  forLabel: Label;
  forLabelID: Scalars['ID'];
  recordIDs: Array<Scalars['ID']>;
};

export type LabelFilter = {
  labelID?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<LabelFilterMetadata>;
};

export type LabelFilterAspectMetadata = {
  sentiment?: InputMaybe<SentimentType>;
};

export type LabelFilterMetadata = {
  aspect?: InputMaybe<LabelFilterAspectMetadata>;
};

export type LabelHierarchyFilter = {
  nodeID: Scalars['String'];
};

export enum LabelHierarchyNodeType {
  Label = 'LABEL',
  Set = 'SET'
}

export type LabelMetadata = {
  __typename?: 'LabelMetadata';
  aspect?: Maybe<AspectMetadata>;
  reason?: Maybe<ReasonMetadata>;
};

export type LabelNameUpdated = {
  __typename?: 'LabelNameUpdated';
  newName: Scalars['String'];
  oldName: Scalars['String'];
};

export enum LabelType {
  Aspect = 'ASPECT',
  Cluster = 'CLUSTER',
  L1 = 'L1',
  Reason = 'REASON',
  Sentiment = 'SENTIMENT'
}

export type LabelVisibilityUpdated = {
  __typename?: 'LabelVisibilityUpdated';
  newVisibility: Scalars['Boolean'];
  oldVisibility: Scalars['Boolean'];
};

export type Language = {
  __typename?: 'Language';
  iso6391?: Maybe<Scalars['String']>;
  iso6393: Scalars['String'];
  language: Scalars['String'];
  source: LanguageSource;
};

export type LanguageFilter = {
  iso6393: Scalars['String'];
};

export enum LanguageSource {
  Default = 'DEFAULT',
  Detected = 'DETECTED',
  SourceMetadata = 'SOURCE_METADATA'
}

export type Level = TaxonomyNode & {
  __typename?: 'Level';
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type ListAnalysesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<AnalysisFilter>;
  sortAsc?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<AnalysisSortBy>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type ListAnalysesResponse = {
  __typename?: 'ListAnalysesResponse';
  analyses: Array<AnalysisListItem>;
  hits?: Maybe<Scalars['Int']>;
  nextCursor?: Maybe<Scalars['String']>;
  prevCursor?: Maybe<Scalars['String']>;
};

export type ListAnomaliesFilter = {
  ruleID?: InputMaybe<Scalars['ID']>;
  ruleVersion?: InputMaybe<Scalars['Int']>;
  timeRange?: InputMaybe<TimeRangeFilter>;
};

export type ListAnomaliesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ListAnomaliesFilter>;
  sortBys?: InputMaybe<Array<ListAnomaliesSortBy>>;
  tenantID: Scalars['ID'];
};

export type ListAnomaliesResponse = {
  __typename?: 'ListAnomaliesResponse';
  anomalies?: Maybe<Array<Anomaly>>;
  cursor?: Maybe<Scalars['String']>;
  hits: Scalars['Int'];
};

export type ListAnomaliesSortBy = {
  createdAt?: InputMaybe<Scalars['Boolean']>;
  isAsc: Scalars['Boolean'];
  ruleVersion?: InputMaybe<Scalars['Boolean']>;
  score?: InputMaybe<Scalars['Boolean']>;
};

export type ListAssociationsInput = {
  paginationToken?: InputMaybe<Scalars['String']>;
  sourceIDs: Array<Scalars['ID']>;
  tenantID: Scalars['ID'];
  type?: InputMaybe<AssociationType>;
};

export type ListAssociationsResponse = {
  __typename?: 'ListAssociationsResponse';
  associations?: Maybe<Array<Association>>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type ListChatsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  responseSize?: InputMaybe<Scalars['Int']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type ListChatsResponse = {
  __typename?: 'ListChatsResponse';
  chats: Array<Chat>;
  nextCursor?: Maybe<Scalars['String']>;
};

export type ListCohortJoinKey = {
  __typename?: 'ListCohortJoinKey';
  displayName: Scalars['String'];
  id: Scalars['String'];
};

export type ListDashboardsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DashboardFilter>;
  sortAsc?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<DashboardSortBy>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type ListDashboardsResponse = {
  __typename?: 'ListDashboardsResponse';
  dashboards: Array<DashboardListItem>;
  hits?: Maybe<Scalars['Int']>;
  nextCursor?: Maybe<Scalars['String']>;
  prevCursor?: Maybe<Scalars['String']>;
};

export type ListDemoTenantsInput = {
  tenantID: Scalars['String'];
};

export type ListDemoTenantsResponse = {
  __typename?: 'ListDemoTenantsResponse';
  tenants: Array<TenantOption>;
};

export type ListEqlFieldValuesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  eqlField: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type ListEqlFieldValuesResponse = {
  __typename?: 'ListEQLFieldValuesResponse';
  cursor?: Maybe<Scalars['String']>;
  values: Array<EqlFieldValue>;
};

export type ListEqlFieldsInput = {
  groupID?: InputMaybe<Scalars['String']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
  valueType?: InputMaybe<EqlFieldValueType>;
};

export type ListEqlFieldsResponse = {
  __typename?: 'ListEQLFieldsResponse';
  fields: Array<EqlField>;
};

export type ListIntegrationsInput = {
  createdBy?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  directions?: InputMaybe<Array<IntegrationDirection>>;
  integrationType?: InputMaybe<IntegrationType>;
  query?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type ListIntegrationsResponse = {
  __typename?: 'ListIntegrationsResponse';
  cursor?: Maybe<Scalars['String']>;
  integrations?: Maybe<Array<Integration>>;
};

export type ListLabelsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  includeInvisible?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  tenantID: Scalars['ID'];
  type: LabelType;
};

export type ListLabelsResponse = {
  __typename?: 'ListLabelsResponse';
  labels: Array<Label>;
  paginationToken?: Maybe<Scalars['String']>;
};

export type ListLabelsV2Input = {
  excludeMetadata?: InputMaybe<Scalars['Boolean']>;
  includeEdges?: InputMaybe<Scalars['Boolean']>;
  includeInvisible?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
  updateInProgress?: InputMaybe<Scalars['Boolean']>;
};

export type ListLabelsV2Response = {
  __typename?: 'ListLabelsV2Response';
  edges?: Maybe<Array<TaxonomyEdge>>;
  keywords: Array<Aspect>;
  l1s: Array<L1>;
  reasons: Array<Reason>;
  taxonomyID: Scalars['ID'];
};

export type ListMetadataKeysFilter = {
  integrationChannelTypes?: InputMaybe<Array<IntegrationChannelType>>;
  isFilterable?: InputMaybe<Scalars['Boolean']>;
  isGroupable?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  keys?: InputMaybe<Array<Scalars['String']>>;
  namespacedSources?: InputMaybe<Array<Scalars['String']>>;
  objectTypes?: InputMaybe<Array<ObjectType>>;
  sources?: InputMaybe<Array<Source>>;
};

export type ListMetadataKeysRequest = {
  filter?: InputMaybe<ListMetadataKeysFilter>;
  tenantID: Scalars['ID'];
};

export type ListMetadataKeysResponse = {
  __typename?: 'ListMetadataKeysResponse';
  metadata: Array<MetadataKey>;
};

export type ListMetricCriteriaInput = {
  tenantID: Scalars['ID'];
};

export type ListMetricCriteriaResponse = {
  __typename?: 'ListMetricCriteriaResponse';
  fields: Array<EqlField>;
};

export type ListQueryBuilderGroupsInput = {
  limitOptions?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type ListQueryBuilderGroupsResponse = {
  __typename?: 'ListQueryBuilderGroupsResponse';
  groups: Array<QueryBuilderGroup>;
};

export type ListRecentAnomaliesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  ruleID: Scalars['ID'];
  ruleVersion: Scalars['Int'];
  tenantID: Scalars['ID'];
};

export type ListRecentAnomaliesResponse = {
  __typename?: 'ListRecentAnomaliesResponse';
  anomalies?: Maybe<Array<Anomaly>>;
  cursor?: Maybe<Scalars['String']>;
};

export type ListRulesFilter = {
  createdBy?: InputMaybe<Scalars['ID']>;
  discoverability?: InputMaybe<Scope>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  query?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<TimeUnit>;
};

export type ListRulesInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ListRulesFilter>;
  tenantID: Scalars['ID'];
  userID?: InputMaybe<Scalars['ID']>;
};

export type ListRulesResponse = {
  __typename?: 'ListRulesResponse';
  cursor?: Maybe<Scalars['String']>;
  hits: Scalars['Int'];
  rules: Array<Rule>;
};

export type ListSourceDetailsResponse = {
  __typename?: 'ListSourceDetailsResponse';
  sources?: Maybe<Array<SourceDetails>>;
};

export type ListSubpartsRequest = {
  tenantID: Scalars['ID'];
  types?: InputMaybe<Array<SubpartType>>;
};

export type ListSubpartsResponse = {
  __typename?: 'ListSubpartsResponse';
  subparts?: Maybe<Array<Subpart>>;
};

export type ListSuggestionsFilter = {
  category?: InputMaybe<Category>;
  query?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<SuggestionResolutionStatus>>;
  tags?: InputMaybe<Array<SuggestionTagInput>>;
  type?: InputMaybe<Array<SuggestionType>>;
};

export type ListSuggestionsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ListSuggestionsFilter>;
  onlyHits?: InputMaybe<Scalars['Boolean']>;
  responseSize?: InputMaybe<Scalars['Int']>;
  tenantID: Scalars['ID'];
};

export type ListSuggestionsResponse = {
  __typename?: 'ListSuggestionsResponse';
  cursor?: Maybe<Scalars['String']>;
  hits: Scalars['Int'];
  suggestions?: Maybe<Array<Suggestion>>;
};

export type ListTaxonomySearchGroupsInput = {
  limitOptions?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type ListTaxonomySearchGroupsResponse = {
  __typename?: 'ListTaxonomySearchGroupsResponse';
  groups: Array<TaxonomySearchGroup>;
};

export type ListTenantsForEmailInput = {
  email: Scalars['String'];
  includeDemos?: InputMaybe<Scalars['Boolean']>;
};

export type ListTenantsForEmailResponse = {
  __typename?: 'ListTenantsForEmailResponse';
  tenantOptions?: Maybe<Array<TenantOption>>;
};

export type ListTenantsInput = {
  paginationToken?: InputMaybe<Scalars['String']>;
};

export type ListTenantsResponse = {
  __typename?: 'ListTenantsResponse';
  paginationToken?: Maybe<Scalars['String']>;
  tenants?: Maybe<Array<Tenant>>;
};

export type ListUnifiedFieldsInput = {
  key?: InputMaybe<Scalars['String']>;
  limitValues?: InputMaybe<Scalars['Int']>;
  query?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
};

export type ListUnifiedFieldsResponse = {
  __typename?: 'ListUnifiedFieldsResponse';
  fields: Array<UnifiedField>;
};

export type ListUsersFilter = {
  query?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<UserState>>;
};

export type ListUsersInput = {
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<ListUsersFilter>;
  tenantID: Scalars['ID'];
};

export type ListUsersResponse = {
  __typename?: 'ListUsersResponse';
  cursor?: Maybe<Scalars['String']>;
  hits: Scalars['Int'];
  users?: Maybe<Array<User>>;
};

export type LivechatData = SourceData & {
  __typename?: 'LivechatData';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<MapStrToStrTuple>>;
  name: Scalars['String'];
  sourcePage?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
};

export type LivechatFormData = IntegrationFormData & {
  __typename?: 'LivechatFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type LivechatIntegrationData = {
  __typename?: 'LivechatIntegrationData';
  orgID: Scalars['String'];
};

export type LivechatIntegrationDataInput = {
  authGrant: Scalars['String'];
  redirectURI: Scalars['String'];
};

export type ManipulatePredictionsInput = {
  hierarchyManipulations?: InputMaybe<Array<PredictionHierarchyManipulation>>;
  manipulations?: InputMaybe<Array<PredictionManipulation>>;
  recordID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type ManipulatePredictionsResponse = {
  __typename?: 'ManipulatePredictionsResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export enum ManipulationType {
  Add = 'ADD',
  Invalid = 'INVALID',
  Remove = 'REMOVE'
}

export type MappingInstructions = {
  __typename?: 'MappingInstructions';
  defaultValues?: Maybe<PrimitiveValueArray>;
  metadataPath: Scalars['String'];
};

export type MappingInstructionsInput = {
  defaultValues?: InputMaybe<PrimitiveValueArrayInput>;
  metadataPath: Scalars['String'];
};

export type MarkNotificationsAsReadInput = {
  createdBefore?: InputMaybe<Scalars['Int']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type MarkNotificationsAsReadResponse = {
  __typename?: 'MarkNotificationsAsReadResponse';
  updated: Scalars['Boolean'];
};

export type MatchedRecord = {
  __typename?: 'MatchedRecord';
  matches?: Maybe<Array<MatchedRecordMetadata>>;
  record: Record;
};

export type MatchedRecordMetadata = {
  __typename?: 'MatchedRecordMetadata';
  endIDx: Scalars['Int'];
  msgIDx: Scalars['Int'];
  startIDx: Scalars['Int'];
};

export type MergeLabelsInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<UpdateLabelMetadataInput>;
  sourceIDs: Array<Scalars['ID']>;
  targetID: Scalars['ID'];
};

export type MergeReasonsInput = {
  category?: InputMaybe<Category>;
  displayName: Scalars['String'];
  labelIDs: Array<Scalars['ID']>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type MergeReasonsResponse = {
  __typename?: 'MergeReasonsResponse';
  id: Scalars['ID'];
  taxonomyID?: Maybe<Scalars['ID']>;
  taxonomyVersion?: Maybe<Scalars['Int']>;
};

export type MergeSuggestion = {
  __typename?: 'MergeSuggestion';
  feedbackCount: Scalars['Int'];
  label: Label;
  labelID: Scalars['ID'];
  relatedReasonDetails?: Maybe<Array<Label>>;
  relatedReasons?: Maybe<Array<Scalars['ID']>>;
};

export type MetadataAggregateBucketKey = {
  __typename?: 'MetadataAggregateBucketKey';
  keyValues: Array<MapStrToStrTuple>;
};

export enum MetadataDataType {
  Boolean = 'BOOLEAN',
  DateTime = 'DATE_TIME',
  InvalidMetadataDatatype = 'INVALID_METADATA_DATATYPE',
  Number = 'NUMBER',
  String = 'STRING'
}

export type MetadataDetails = {
  __typename?: 'MetadataDetails';
  fieldMappings?: Maybe<Array<FieldResolver>>;
  integrationID: Scalars['ID'];
  metadataPaths?: Maybe<Array<MetadataPath>>;
  tenantID: Scalars['ID'];
};

export type MetadataFilter = {
  key: Scalars['String'];
  op?: InputMaybe<ComparisonOperator>;
  value: ValueInput;
};

export type MetadataKey = {
  __typename?: 'MetadataKey';
  cardinality: Scalars['Int'];
  description: Scalars['String'];
  displayText: Scalars['String'];
  isFilterable: Scalars['Boolean'];
  isGroupable: Scalars['Boolean'];
  isHidden: Scalars['Boolean'];
  isImportant: Scalars['Boolean'];
  key: Scalars['String'];
  namespace?: Maybe<Scalars['String']>;
  originalDisplayText: Scalars['String'];
  referencedIn?: Maybe<MetadataKey>;
  source?: Maybe<Source>;
  tenantID: Scalars['String'];
  type: MetadataDataType;
  values: Array<Value>;
};

export type MetadataKeys = {
  __typename?: 'MetadataKeys';
  keys?: Maybe<Array<MetadataKey>>;
};

export type MetadataPath = {
  __typename?: 'MetadataPath';
  isCustom: Scalars['Boolean'];
  path: Scalars['String'];
  suggestedType: PrimitiveDataType;
};

export type MetadataValue = {
  __typename?: 'MetadataValue';
  b?: Maybe<Array<Scalars['Boolean']>>;
  n?: Maybe<Array<Scalars['Float']>>;
  s?: Maybe<Array<Scalars['String']>>;
};

export type MixPanelIntegrationData = {
  __typename?: 'MixPanelIntegrationData';
  webhookURL: Scalars['String'];
};

export type MixPanelIntegrationInputData = {
  placeholder?: InputMaybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  SubscribeToLabel?: Maybe<SubscribeToLabelResponse>;
  addUserTags?: Maybe<AddUserTagsResponse>;
  archiveLabel?: Maybe<ArchiveLabelResponse>;
  askForArtefactAccess?: Maybe<AskForArtefactAccessResponse>;
  copyChat?: Maybe<CopyChatResponse>;
  createAnalysis?: Maybe<CreateAnalysisResponse>;
  createAssociations?: Maybe<CreateAssociationResponse>;
  createDashboard?: Maybe<CreateDashboardResponse>;
  createDashboardFromTemplate?: Maybe<CreateDashboardFromTemplateResponse>;
  createField?: Maybe<CreateFieldResponse>;
  createIntegration?: Maybe<CreateIntegrationResponse>;
  createKeyword?: Maybe<CreateKeywordResponse>;
  createL1?: Maybe<CreateL1Response>;
  createLevel?: Maybe<CreateLevelResponse>;
  createReason?: Maybe<CreateReasonResponse>;
  createReasonV2?: Maybe<CreateReasonV2Response>;
  createRule?: Maybe<CreateRuleResponse>;
  createSchedule?: Maybe<CreateScheduleResponse>;
  createSuggestion?: Maybe<CreateSuggestionResponse>;
  createTag?: Maybe<CreateTagResponse>;
  createTaxonomy?: Maybe<CreateTaxonomyResponse>;
  createTenant?: Maybe<CreateTenantResponse>;
  createTheme?: Maybe<CreateThemeResponse>;
  createUnifiedField?: Maybe<CreateUnifiedFieldResponse>;
  createUser?: Maybe<CreateUserResponse>;
  deleteAnalysis?: Maybe<DeleteAnalysisResponse>;
  deleteAssociations?: Maybe<DeleteAssociationsResponse>;
  deleteDashboard?: Maybe<DeleteDashboardResponse>;
  deleteLabel?: Maybe<DeleteLabelResponse>;
  deleteSchedule?: Maybe<DeleteScheduleResponse>;
  deleteTag?: Maybe<DeleteTagResponse>;
  deleteUnifiedField?: Maybe<DeleteUnifiedFieldResponse>;
  duplicateAndUpdateDashboard?: Maybe<DuplicateAndUpdateDashboardResponse>;
  duplicateDashboard?: Maybe<DuplicateDashboardResponse>;
  exportEQLResult?: Maybe<ExportEqlResultResponse>;
  flagAssistantResponse?: Maybe<Scalars['Boolean']>;
  flagFeedbackSummary?: Maybe<Scalars['Boolean']>;
  flagGeneratedEQLResponse?: Maybe<Scalars['Boolean']>;
  invite?: Maybe<InviteResponse>;
  inviteUser?: Maybe<InviteUserResponse>;
  manipulatePredictions?: Maybe<ManipulatePredictionsResponse>;
  markNotificationsAsRead?: Maybe<MarkNotificationsAsReadResponse>;
  mergeReasons?: Maybe<MergeReasonsResponse>;
  processOperation: ProcessOperationResponse;
  removeTenantSso: RemoveTenantSsoResponse;
  removeUserTags?: Maybe<RemoveUserTagsResponse>;
  requestReachout?: Maybe<RequestReachoutResponse>;
  submitFileUploadForCustomGroup?: Maybe<SubmitFileUploadForCustomGroupResponse>;
  submitFileUploadForm?: Maybe<SubmitFileUploadFormResponse>;
  testAnomalyAlert?: Maybe<TestAnomalyAlertResponse>;
  testReport?: Maybe<TestReportResponse>;
  triggerLabelManipulation?: Maybe<TriggerLabelManipulationResponse>;
  updateAnalysis?: Maybe<UpdateAnalysisResponse>;
  updateChat?: Maybe<UpdateChatResponse>;
  updateDashboard?: Maybe<UpdateDashboardResponse>;
  updateFieldRelations?: Maybe<UpdateFieldRelationsResponse>;
  updateIntegration?: Maybe<UpdateIntegrationResponse>;
  updateIntegrationCustomFields?: Maybe<UpdateIntegrationCustomFieldsResponse>;
  updateKeyword?: Maybe<UpdateKeywordResponse>;
  updateL1?: Maybe<UpdateL1Response>;
  updateLabel?: Maybe<UpdateLabelResponse>;
  updateLevel?: Maybe<UpdateLevelResponse>;
  updateManagedMetadata: UpdateManagedMetadataResponse;
  updateMetadataDetails?: Maybe<UpdateMetadataDetailsResponse>;
  updateNotificationSettings?: Maybe<UpdateNotificationSettingsResponse>;
  updateNotifications?: Maybe<UpdateNotificationsResponse>;
  updateReason?: Maybe<UpdateReasonResponse>;
  updateRecordFlags: UpdateRecordFlagsResponse;
  updateRule?: Maybe<UpdateRuleResponse>;
  updateSchedule?: Maybe<UpdateScheduleResponse>;
  updateSuggestionStatus?: Maybe<UpdateSuggestionStatusResponse>;
  updateSummaryFlag?: Maybe<UpdateSummaryFlagResponse>;
  updateTag?: Maybe<UpdateTagResponse>;
  updateTaxonomyEdges?: Maybe<UpdateTaxonomyEdgesResponse>;
  updateTaxonomyEdgesV2?: Maybe<UpdateTaxonomyEdgesResponse>;
  updateTenant?: Maybe<UpdateTenantResponse>;
  updateTenantSso: UpdateTenantSsoResponse;
  updateUser?: Maybe<UpdateUserResponse>;
  updatedField?: Maybe<UpdateFieldResponse>;
  uploadCohortFile?: Maybe<UploadCohortFileResponse>;
};


export type MutationSubscribeToLabelArgs = {
  request: SubscribeToLabelInput;
};


export type MutationAddUserTagsArgs = {
  request: AddUserTagsInput;
};


export type MutationArchiveLabelArgs = {
  request: ArchiveLabelInput;
};


export type MutationAskForArtefactAccessArgs = {
  request: AskForArtefactAccessInput;
};


export type MutationCopyChatArgs = {
  request: CopyChatInput;
};


export type MutationCreateAnalysisArgs = {
  request: CreateAnalysisInput;
};


export type MutationCreateAssociationsArgs = {
  request: CreateAssociationsInput;
};


export type MutationCreateDashboardArgs = {
  request: CreateDashboardInput;
};


export type MutationCreateDashboardFromTemplateArgs = {
  request?: InputMaybe<CreateDashboardFromTemplateInput>;
};


export type MutationCreateFieldArgs = {
  request: CreateFieldInput;
};


export type MutationCreateIntegrationArgs = {
  request: CreateIntegrationRequest;
};


export type MutationCreateKeywordArgs = {
  request: CreateKeywordInput;
};


export type MutationCreateL1Args = {
  request: CreateL1Input;
};


export type MutationCreateLevelArgs = {
  request: CreateLevelRequest;
};


export type MutationCreateReasonArgs = {
  request: CreateReasonInput;
};


export type MutationCreateReasonV2Args = {
  request: CreateReasonV2Input;
};


export type MutationCreateRuleArgs = {
  request: CreateRuleInput;
};


export type MutationCreateScheduleArgs = {
  request: CreateScheduleInput;
};


export type MutationCreateSuggestionArgs = {
  request: CreateSuggestionRequest;
};


export type MutationCreateTagArgs = {
  request: CreateTagInput;
};


export type MutationCreateTaxonomyArgs = {
  request: CreateTaxonomyInput;
};


export type MutationCreateTenantArgs = {
  request: CreateTenantInput;
};


export type MutationCreateThemeArgs = {
  request: CreateThemeInput;
};


export type MutationCreateUnifiedFieldArgs = {
  request: CreateUnifiedFieldInput;
};


export type MutationCreateUserArgs = {
  request: CreateUserInput;
};


export type MutationDeleteAnalysisArgs = {
  request: DeleteAnalysisInput;
};


export type MutationDeleteAssociationsArgs = {
  request: DeleteAssociationsInput;
};


export type MutationDeleteDashboardArgs = {
  request: DeleteDashboardInput;
};


export type MutationDeleteLabelArgs = {
  request: DeleteLabelRequest;
};


export type MutationDeleteScheduleArgs = {
  request: DeleteScheduleInput;
};


export type MutationDeleteTagArgs = {
  request: DeleteTagInput;
};


export type MutationDeleteUnifiedFieldArgs = {
  request: DeleteUnifiedFieldInput;
};


export type MutationDuplicateAndUpdateDashboardArgs = {
  request: DuplicateAndUpdateDashboardInput;
};


export type MutationDuplicateDashboardArgs = {
  request: DuplicateDashboardInput;
};


export type MutationExportEqlResultArgs = {
  request: ExportEqlResultInput;
};


export type MutationFlagAssistantResponseArgs = {
  request?: InputMaybe<FlagAssistantResponseInput>;
};


export type MutationFlagFeedbackSummaryArgs = {
  request?: InputMaybe<FlagFeedbackSummaryInput>;
};


export type MutationFlagGeneratedEqlResponseArgs = {
  request?: InputMaybe<FlagGeneratedEqlResponse>;
};


export type MutationInviteArgs = {
  request: InviteInput;
};


export type MutationInviteUserArgs = {
  request: InviteUserInput;
};


export type MutationManipulatePredictionsArgs = {
  request: ManipulatePredictionsInput;
};


export type MutationMarkNotificationsAsReadArgs = {
  request: MarkNotificationsAsReadInput;
};


export type MutationMergeReasonsArgs = {
  request: MergeReasonsInput;
};


export type MutationProcessOperationArgs = {
  request: ProcessOperationInput;
};


export type MutationRemoveTenantSsoArgs = {
  request: RemoveTenantSsoInput;
};


export type MutationRemoveUserTagsArgs = {
  request: RemoveUserTagsInput;
};


export type MutationRequestReachoutArgs = {
  request: RequestReachoutInput;
};


export type MutationSubmitFileUploadForCustomGroupArgs = {
  request: SubmitFileUploadForCustomGroupRequest;
};


export type MutationSubmitFileUploadFormArgs = {
  request: SubmitFileUploadFormInput;
};


export type MutationTestAnomalyAlertArgs = {
  request: TestAnomalyAlertInput;
};


export type MutationTestReportArgs = {
  request: TestReportInput;
};


export type MutationTriggerLabelManipulationArgs = {
  request: TriggerLabelManipulationInput;
};


export type MutationUpdateAnalysisArgs = {
  request: UpdateAnalysisInput;
};


export type MutationUpdateChatArgs = {
  request: UpdateChatInput;
};


export type MutationUpdateDashboardArgs = {
  request: UpdateDashboardInput;
};


export type MutationUpdateFieldRelationsArgs = {
  request: UpdateFieldRelationsInput;
};


export type MutationUpdateIntegrationArgs = {
  request: UpdateIntegrationInput;
};


export type MutationUpdateIntegrationCustomFieldsArgs = {
  request: UpdateIntegrationCustomFieldsInput;
};


export type MutationUpdateKeywordArgs = {
  request: UpdateKeywordInput;
};


export type MutationUpdateL1Args = {
  request: UpdateL1Input;
};


export type MutationUpdateLabelArgs = {
  request: UpdateLabelRequest;
};


export type MutationUpdateLevelArgs = {
  request: UpdateLevelRequest;
};


export type MutationUpdateManagedMetadataArgs = {
  request: UpdateManagedMetadataRequest;
};


export type MutationUpdateMetadataDetailsArgs = {
  request: UpdateMetadataDetailsInput;
};


export type MutationUpdateNotificationSettingsArgs = {
  request: UpdateNotificationSettingsInput;
};


export type MutationUpdateNotificationsArgs = {
  request: UpdateNotificationsInput;
};


export type MutationUpdateReasonArgs = {
  request: UpdateReasonInput;
};


export type MutationUpdateRecordFlagsArgs = {
  request: UpdateRecordFlagsInput;
};


export type MutationUpdateRuleArgs = {
  request: UpdateRuleInput;
};


export type MutationUpdateScheduleArgs = {
  request: UpdateScheduleInput;
};


export type MutationUpdateSuggestionStatusArgs = {
  request: UpdateSuggestionStatusInput;
};


export type MutationUpdateSummaryFlagArgs = {
  request: UpdateSummaryFlagInput;
};


export type MutationUpdateTagArgs = {
  request: UpdateTagInput;
};


export type MutationUpdateTaxonomyEdgesArgs = {
  request: UpdateTaxonomyEdgesRequest;
};


export type MutationUpdateTaxonomyEdgesV2Args = {
  request: UpdateTaxonomyEdgesRequestV2;
};


export type MutationUpdateTenantArgs = {
  request: UpdateTenantInput;
};


export type MutationUpdateTenantSsoArgs = {
  request: UpdateTenantSsoInput;
};


export type MutationUpdateUserArgs = {
  request: UpdateUserInput;
};


export type MutationUpdatedFieldArgs = {
  request: UpdateFieldInput;
};


export type MutationUploadCohortFileArgs = {
  request: UploadCohortFileRequest;
};

export type MutationResponse = {
  code: Scalars['String'];
  message: Scalars['String'];
};

export type NpsMetadata = SourceData & {
  __typename?: 'NPSMetadata';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Array<DataMap>>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  category: Scalars['ID'];
  createdAt: Scalars['Int'];
  id: Scalars['ID'];
  richText: Scalars['String'];
  title: Scalars['String'];
  type: NotificationType;
  viewed: Scalars['Boolean'];
  viewedAt?: Maybe<Scalars['Int']>;
};

export type NotificationCategory = {
  __typename?: 'NotificationCategory';
  channelConfigs?: Maybe<Array<ChannelConfig>>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  subCategories?: Maybe<Array<Scalars['String']>>;
};

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  categories?: Maybe<Array<NotificationCategory>>;
  outbounds?: Maybe<Array<Integration>>;
  root: Scalars['String'];
};

export type NotificationStatusUpdate = {
  category: Scalars['ID'];
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  outbound: Scalars['ID'];
};

export enum NotificationType {
  Error = 'ERROR',
  Info = 'INFO',
  Invalid = 'INVALID',
  Success = 'SUCCESS',
  Warning = 'WARNING'
}

export type NumberCollectionDataValue = {
  __typename?: 'NumberCollectionDataValue';
  numbers: Array<Scalars['Float']>;
};

export type NumberDataValue = {
  __typename?: 'NumberDataValue';
  number: Scalars['Float'];
};

export type OAuthFormData = IntegrationFormData & {
  __typename?: 'OAuthFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export enum ObjectType {
  Account = 'ACCOUNT',
  Feedback = 'FEEDBACK',
  User = 'USER'
}

export type OffsetTime = {
  unit: TimeUnit;
  value: Scalars['Int'];
};

export type OidcSsoSettingsInput = {
  clientID: Scalars['ID'];
  clientSecret: Scalars['ID'];
  issuerURL: Scalars['String'];
};

export enum OperationType {
  And = 'AND',
  Or = 'OR'
}

export type PanelQueryAlert = {
  __typename?: 'PanelQueryAlert';
  evaluationFrequencyInMins: Scalars['Int'];
  lowerCriticalThreshold?: Maybe<Scalars['Int']>;
  lowerWarningThreshold?: Maybe<Scalars['Int']>;
  outbounds: Array<Scalars['String']>;
  queryID: Scalars['ID'];
  upperCriticalThreshold?: Maybe<Scalars['Int']>;
  upperWarningThreshold?: Maybe<Scalars['Int']>;
};

export type PanelQueryAlertInput = {
  evaluationFrequencyInMins: Scalars['Int'];
  id: Scalars['ID'];
  lowerCriticalThreshold?: InputMaybe<Scalars['Int']>;
  lowerWarningThreshold?: InputMaybe<Scalars['Int']>;
  outbounds: Array<Scalars['ID']>;
  queryId: Scalars['ID'];
  upperCriticalThreshold?: InputMaybe<Scalars['Int']>;
  upperWarningThreshold?: InputMaybe<Scalars['Int']>;
};

export enum PermissionOperation {
  Invalid = 'INVALID',
  Read = 'READ',
  Write = 'WRITE'
}

export enum PermissionResource {
  AllArtefact = 'ALL_ARTEFACT',
  AllCustomFilters = 'ALL_CUSTOM_FILTERS',
  Artefact = 'ARTEFACT',
  Integration = 'INTEGRATION',
  Invalid = 'INVALID',
  Invite = 'INVITE',
  Metadata = 'METADATA',
  OutboundIntegration = 'OUTBOUND_INTEGRATION',
  Prediction = 'PREDICTION',
  Taxonomy = 'TAXONOMY',
  Template = 'TEMPLATE',
  WorkspaceSettings = 'WORKSPACE_SETTINGS'
}

export type PlaystoreData = SourceData & {
  __typename?: 'PlaystoreData';
  appID?: Maybe<Scalars['String']>;
  appVersion?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  score?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
  useful?: Maybe<Scalars['Int']>;
};

export type PlaystoreIntegrationData = {
  __typename?: 'PlaystoreIntegrationData';
  AppID: Scalars['String'];
};

export type PlaystoreIntegrationInputData = {
  appID?: InputMaybe<Scalars['String']>;
  appURL?: InputMaybe<Scalars['String']>;
  serviceAccountAPIKeyJSON?: InputMaybe<Scalars['String']>;
};

export type PlaystoreUpdateIntegrationData = {
  serviceAccountAPIKeyJSON?: InputMaybe<Scalars['String']>;
};

export type Prediction = {
  __typename?: 'Prediction';
  children?: Maybe<Array<Maybe<Prediction>>>;
  label: Label;
  labelID: Scalars['String'];
  predictionMetadata?: Maybe<PredictionMetadata>;
};

export type PredictionHierarchyManipulation = {
  hierarchy?: InputMaybe<L1Manipulation>;
};

export type PredictionManipulation = {
  entity?: InputMaybe<EntityManipulation>;
  l1?: InputMaybe<L1Manipulation>;
  manipulationType: ManipulationType;
  reason?: InputMaybe<ReasonManipulation>;
  recordSentiment?: InputMaybe<RecordSentimentManipulation>;
};

export type PredictionMatchMetadata = {
  __typename?: 'PredictionMatchMetadata';
  labelID: Scalars['String'];
  predictionMetadata: PredictionMetadata;
};

export type PredictionMetadata = AspectPredictionMetadata | ClusterPredictionMetadata | ReasonPredictionMetadata | SentimentPredictionMetadata;

export type PredictionSuggestionInput = {
  action: SuggestedAction;
  labelID: Scalars['String'];
  metadata: PredictionSuggestionMetadataInput;
  recordID: Scalars['String'];
};

export type PredictionSuggestionMetadataInput = {
  aspect?: InputMaybe<AspectSuggestionMetadataInput>;
  reason?: InputMaybe<ReasonSuggestionMetadataInput>;
  sentiment?: InputMaybe<SentimentSuggestionMetadataInput>;
};

export enum PrimitiveDataType {
  Boolean = 'BOOLEAN',
  Datetime = 'DATETIME',
  InvalidMetadataDatatype = 'INVALID_METADATA_DATATYPE',
  Number = 'NUMBER',
  String = 'STRING'
}

export type PrimitiveValueArray = {
  __typename?: 'PrimitiveValueArray';
  B?: Maybe<Array<Scalars['Boolean']>>;
  D?: Maybe<Array<Scalars['Int']>>;
  N?: Maybe<Array<Scalars['Float']>>;
  S?: Maybe<Array<Scalars['String']>>;
};

export type PrimitiveValueArrayInput = {
  B?: InputMaybe<Array<Scalars['Boolean']>>;
  D?: InputMaybe<Array<Scalars['Int']>>;
  N?: InputMaybe<Array<Scalars['Float']>>;
  S?: InputMaybe<Array<Scalars['String']>>;
};

export type ProcessOperationInput = {
  operationToken: Scalars['String'];
  tenantID?: InputMaybe<Scalars['ID']>;
  userID?: InputMaybe<Scalars['ID']>;
};

export type ProcessOperationResponse = {
  __typename?: 'ProcessOperationResponse';
  processed: Scalars['Boolean'];
};

export type ProgressInfo = {
  __typename?: 'ProgressInfo';
  error?: Maybe<Scalars['String']>;
  estimatedTimeInMins?: Maybe<Scalars['Int']>;
};

export type ProxyFileDownloadInput = {
  url: Scalars['String'];
};

export type ProxyFileDownloadResponse = {
  __typename?: 'ProxyFileDownloadResponse';
  base64Data: Scalars['String'];
};

export type PublishChannelEmail = {
  to?: InputMaybe<Array<Scalars['String']>>;
};

export type QualtricsEditFormData = {
  __typename?: 'QualtricsEditFormData';
  surveys: Array<QualtricsSurvey>;
};

export type QualtricsIntegrationData = {
  __typename?: 'QualtricsIntegrationData';
  surveys: Array<QualtricsSurvey>;
};

export type QualtricsIntegrationInputData = {
  clientID: Scalars['String'];
  clientSecret: Scalars['String'];
  code: Scalars['String'];
  datacenter: Scalars['String'];
  redirectURI: Scalars['String'];
};

export type QualtricsSurvey = {
  __typename?: 'QualtricsSurvey';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type QualtricsSurveyInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type QualtricsUpdateIntegrationData = {
  surveys: Array<QualtricsSurveyInput>;
};

export type QuantifyMetadata = {
  __typename?: 'QuantifyMetadata';
  compareMetadata?: Maybe<CompareMetadata>;
  visualisationType?: Maybe<QuantifyVisualisationType>;
};

export type QuantifyMetadataInput = {
  compareMetadata?: InputMaybe<CompareMetadataInput>;
  visualisationType?: InputMaybe<QuantifyVisualisationType>;
};

export enum QuantifyVisualisationType {
  Bar = 'BAR',
  Count = 'COUNT',
  Pie = 'PIE',
  StackedBar = 'STACKED_BAR',
  Trend = 'TREND'
}

export type Query = {
  __typename?: 'Query';
  SearchMetadataFields?: Maybe<SearchMetadataFieldsResponse>;
  batchExecuteEQL?: Maybe<BatchExecuteEqlResponse>;
  batchGetAggregates?: Maybe<BatchGetAggregatesResponse>;
  captureSnapshot?: Maybe<CaptureSnapshotResponse>;
  executeEQL?: Maybe<ExecuteEqlResponse>;
  exportEQLAsCSV?: Maybe<ExportEqlAsCsvResponse>;
  fullTextSearch?: Maybe<FullTextSearchResponse>;
  generateEql?: Maybe<GenerateEqlResponse>;
  generateFeedbackSummary?: Maybe<GenerateFeedbackSummaryResponse>;
  getAggregates?: Maybe<GetAggregatesResponse>;
  getAnalysisByToken?: Maybe<Analysis>;
  getAnomalies?: Maybe<GetAnomaliesResponse>;
  getAssistantResponse?: Maybe<AssistantResponseFuture>;
  getAssistantSamples?: Maybe<GetAssistantSamplesResponse>;
  getAssociations?: Maybe<GetAssociationsResponse>;
  getChatByToken?: Maybe<GetChatByTokenResponse>;
  getCohortUploadFormData?: Maybe<GetCohortUploadFormDataResponse>;
  getCorrelatedLabels?: Maybe<GetCorrelatedLabelsResponse>;
  getDashboardByID?: Maybe<GetDashboardByIdResponse>;
  getDashboardByToken?: Maybe<Dashboard>;
  getDeltaAggregates?: Maybe<GetDeltaAggregatesResponse>;
  getExtendedUser?: Maybe<GetExtendedUserResponse>;
  getFieldRelations?: Maybe<GetFieldRelationsResponse>;
  getFileUploadForm?: Maybe<GetFileUploadFormResponse>;
  getFileUploadUrl?: Maybe<GetFileUploadUrlResponse>;
  getFormulas?: Maybe<GetFormulasResponse>;
  getFullThreadForRecord?: Maybe<GetFullThreadForRecordResponse>;
  getHighlights?: Maybe<GetHighlightsResponse>;
  getHistory?: Maybe<GetHistoryResponse>;
  getIntegrationEditFormData?: Maybe<GetIntegrationEditFormDataResponse>;
  getIntegrationsFormData?: Maybe<IntegrationsFormData>;
  getIntegrationsFormDataV2?: Maybe<IntegrationsFormDataV2>;
  getLabelByID?: Maybe<Label>;
  getMediaUrl?: Maybe<GetMediaUrlResponse>;
  getMergeSuggestions?: Maybe<GetMergeSuggestionsResponse>;
  getNotificationSettings?: Maybe<GetNotificationSettingsResponse>;
  getNotifications?: Maybe<GetNotificationsResponse>;
  getPermissionsForUserTypes?: Maybe<GetPermissionsForUserTypesResponse>;
  getRCForReason?: Maybe<GetRcForReasonResponse>;
  getRCSuggestion?: Maybe<GetRcSuggestionResponse>;
  getRCsForRecord?: Maybe<GetRCsForRecordResponse>;
  getRCsFromDescription?: Maybe<GetRCsFromDescriptionResponse>;
  getReasonNameForCandidates?: Maybe<GetReasonNameForCandidatesResponse>;
  getReasonNameRecommendation?: Maybe<GetReasonNameRecommendationResponse>;
  getReasonSentiment?: Maybe<GetReasonSentimentResponse>;
  getReasonSuggestion?: Maybe<GetReasonSuggestionResponse>;
  getRecord?: Maybe<Record>;
  getRecords?: Maybe<GetRecordsResponse>;
  getRelatedEntities?: Maybe<GetRelatedEntitiesResponse>;
  getRelatedLabels?: Maybe<GetRelatedLabelsResponse>;
  getRelatedQueries?: Maybe<GetRelatedQueriesResponse>;
  getReportStatus?: Maybe<GetReportStatusResponse>;
  getReportWindowMetadata?: Maybe<ReportWindowMetadata>;
  getRepresentativeSentences?: Maybe<GetRepresentativeSentencesResponse>;
  getRuleByID?: Maybe<Rule>;
  getRuleByToken?: Maybe<Rule>;
  getSampleDescription?: Maybe<GetSampleDescriptionResponse>;
  getScheduleByID?: Maybe<Schedule>;
  getSearchRecommendations?: Maybe<GetSearchRecommendationsResponse>;
  getSearchSuggestions?: Maybe<GetSearchSuggestionsResponse>;
  getSimilarReasons?: Maybe<GetSimilarReasonsResponse>;
  getSuggestionByID?: Maybe<Suggestion>;
  getSummaryUserQuote?: Maybe<GetSummaryUserQuoteResponse>;
  getTagByID?: Maybe<Tag>;
  getTaxonomy?: Maybe<GetTaxonomyResponse>;
  getTaxonomyByID?: Maybe<Taxonomy>;
  getTaxonomyT3?: Maybe<GetTaxonomyT3Response>;
  getTenantByID?: Maybe<Tenant>;
  getTopAggregateChanges?: Maybe<GetTopAggregateChangesResponse>;
  getTopAggregates?: Maybe<GetTopAggregatesResponse>;
  getUncategorizedNode?: Maybe<GetUncategorizedNodeResponse>;
  getUserByEmail?: Maybe<User>;
  getUserQuote?: Maybe<GetUserQuoteResponse>;
  isDomainSso?: Maybe<IsDomainSsoResponse>;
  listAnalyses?: Maybe<ListAnalysesResponse>;
  listAnomalies?: Maybe<ListAnomaliesResponse>;
  listAssociations?: Maybe<ListAssociationsResponse>;
  listChats?: Maybe<ListChatsResponse>;
  listDashboards?: Maybe<ListDashboardsResponse>;
  listDemoTenants?: Maybe<ListDemoTenantsResponse>;
  listEQLFieldValues?: Maybe<ListEqlFieldValuesResponse>;
  listEQLFields?: Maybe<ListEqlFieldsResponse>;
  listIntegrations?: Maybe<ListIntegrationsResponse>;
  listLabels?: Maybe<ListLabelsResponse>;
  listLabelsV2?: Maybe<ListLabelsV2Response>;
  listMetadataKeys?: Maybe<MetadataKeys>;
  listMetadataKeysForTenant?: Maybe<MetadataKeys>;
  listMetricCriteria?: Maybe<ListMetricCriteriaResponse>;
  listQueryBuilderGroups?: Maybe<ListQueryBuilderGroupsResponse>;
  listRecentAnomalies?: Maybe<ListRecentAnomaliesResponse>;
  listRules?: Maybe<ListRulesResponse>;
  listSourceDetails?: Maybe<ListSourceDetailsResponse>;
  listSubparts?: Maybe<ListSubpartsResponse>;
  listSuggestions?: Maybe<ListSuggestionsResponse>;
  listTagsForTenant?: Maybe<Array<Tag>>;
  listTaxonomiesForOrganisation?: Maybe<Array<Taxonomy>>;
  listTaxonomySearchGroups?: Maybe<ListTaxonomySearchGroupsResponse>;
  listTenants?: Maybe<ListTenantsResponse>;
  listTenantsForEmail?: Maybe<ListTenantsForEmailResponse>;
  listUnifiedFields?: Maybe<ListUnifiedFieldsResponse>;
  listUsers?: Maybe<ListUsersResponse>;
  proxyFileDownload?: Maybe<ProxyFileDownloadResponse>;
  regenerateAssistantResponse?: Maybe<AssistantResponseFuture>;
  resolveEQLReferences?: Maybe<ResolveEqlReferencesResponse>;
  search?: Maybe<SearchResponse>;
  searchArtefacts?: Maybe<SearchArtefactsResponse>;
  searchTaxonomyNode?: Maybe<SearchTaxonomyNodeResponse>;
  searchUnassignedRCs?: Maybe<SearchUnassignedRCsResponse>;
  semanticSearch?: Maybe<SemanticSearchResponse>;
  stopAssistantResponse?: Maybe<Scalars['Boolean']>;
  submitReportGenerationRequest?: Maybe<GenerateReportResponse>;
  testAnomalyRule?: Maybe<TestAnomalyRuleResponse>;
  validateDescription?: Maybe<ValidateDescriptionResponse>;
  validateFeedbackFieldName?: Maybe<ValidateFeedbackFieldNameResponse>;
  validateFileUpload?: Maybe<ValidateFileUploadResponse>;
  validateFileUploadV2?: Maybe<ValidateFileUploadV2Response>;
  validatePhraseInRecord?: Maybe<ValidatePhraseInRecordResponse>;
};


export type QuerySearchMetadataFieldsArgs = {
  request?: InputMaybe<SearchMetadataFieldsInput>;
};


export type QueryBatchExecuteEqlArgs = {
  request: BatchExecuteEqlInput;
};


export type QueryBatchGetAggregatesArgs = {
  request: BatchGetAggregatesInput;
};


export type QueryCaptureSnapshotArgs = {
  request: CaptureSnapshotInput;
};


export type QueryExecuteEqlArgs = {
  request: ExecuteEqlInput;
};


export type QueryExportEqlAsCsvArgs = {
  request: ExportEqlAsCsvInput;
};


export type QueryFullTextSearchArgs = {
  request: FullTextSearchInput;
};


export type QueryGenerateEqlArgs = {
  request?: InputMaybe<GenerateEqlRequest>;
};


export type QueryGenerateFeedbackSummaryArgs = {
  request?: InputMaybe<GenerateFeedbackSummaryInput>;
};


export type QueryGetAggregatesArgs = {
  request: GetAggregatesInput;
};


export type QueryGetAnalysisByTokenArgs = {
  request: GetAnalysisByTokenInput;
};


export type QueryGetAnomaliesArgs = {
  request: GetAnomaliesInput;
};


export type QueryGetAssistantResponseArgs = {
  request?: InputMaybe<GetAssistantResponseInput>;
};


export type QueryGetAssistantSamplesArgs = {
  request?: InputMaybe<GetAssistantSamplesInput>;
};


export type QueryGetAssociationsArgs = {
  request: GetAssociationsInput;
};


export type QueryGetChatByTokenArgs = {
  request?: InputMaybe<GetChatByTokenInput>;
};


export type QueryGetCohortUploadFormDataArgs = {
  tenantID: Scalars['ID'];
};


export type QueryGetCorrelatedLabelsArgs = {
  request: GetCorrelatedLabelsInput;
};


export type QueryGetDashboardByIdArgs = {
  request?: InputMaybe<GetDashboardByIdInput>;
};


export type QueryGetDashboardByTokenArgs = {
  request: GetDashboardByTokenInput;
};


export type QueryGetDeltaAggregatesArgs = {
  request: GetDeltaAggregatesInput;
};


export type QueryGetExtendedUserArgs = {
  request: GetExtendedUserInput;
};


export type QueryGetFieldRelationsArgs = {
  request: GetFieldRelationsInput;
};


export type QueryGetFileUploadFormArgs = {
  request: GetFileUploadFormInput;
};


export type QueryGetFileUploadUrlArgs = {
  request: GetFileUploadUrlInput;
};


export type QueryGetFormulasArgs = {
  request: GetFormulasInput;
};


export type QueryGetFullThreadForRecordArgs = {
  request: GetFullThreadForRecordInput;
};


export type QueryGetHighlightsArgs = {
  request?: InputMaybe<GetHighlightsInput>;
};


export type QueryGetHistoryArgs = {
  request?: InputMaybe<GetHistoryInput>;
};


export type QueryGetIntegrationEditFormDataArgs = {
  request: GetIntegrationEditFormDataInput;
};


export type QueryGetIntegrationsFormDataArgs = {
  tenantID: Scalars['ID'];
};


export type QueryGetIntegrationsFormDataV2Args = {
  tenantID: Scalars['ID'];
};


export type QueryGetLabelByIdArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryGetMediaUrlArgs = {
  request?: InputMaybe<GetMediaUrlInput>;
};


export type QueryGetMergeSuggestionsArgs = {
  request: GetMergeSuggestionsInput;
};


export type QueryGetNotificationSettingsArgs = {
  request: GetNotificationSettingsInput;
};


export type QueryGetNotificationsArgs = {
  request: GetNotificationsInput;
};


export type QueryGetPermissionsForUserTypesArgs = {
  request: GetPermissionsForUserTypesInput;
};


export type QueryGetRcForReasonArgs = {
  request: GetRcForReasonInput;
};


export type QueryGetRcSuggestionArgs = {
  request: GetRcSuggestionInput;
};


export type QueryGetRCsForRecordArgs = {
  request: GetRCsForRecordInput;
};


export type QueryGetRCsFromDescriptionArgs = {
  request: GetRCsFromDescriptionInput;
};


export type QueryGetReasonNameForCandidatesArgs = {
  request: GetReasonNameForCandidatesInput;
};


export type QueryGetReasonNameRecommendationArgs = {
  request: GetReasonNameRecommendationRequest;
};


export type QueryGetReasonSentimentArgs = {
  request: GetReasonSentimentInput;
};


export type QueryGetReasonSuggestionArgs = {
  request: GetReasonSuggestionInput;
};


export type QueryGetRecordArgs = {
  request: GetRecordInput;
};


export type QueryGetRecordsArgs = {
  request: GetRecordsInput;
};


export type QueryGetRelatedEntitiesArgs = {
  request: GetRelatedEntitiesInput;
};


export type QueryGetRelatedLabelsArgs = {
  request: GetRelatedLabelsInput;
};


export type QueryGetRelatedQueriesArgs = {
  request: GetRelatedQueriesInput;
};


export type QueryGetReportStatusArgs = {
  request: GetReportStatusRequest;
};


export type QueryGetReportWindowMetadataArgs = {
  request: GetReportWindowMetadataInput;
};


export type QueryGetRepresentativeSentencesArgs = {
  request?: InputMaybe<GetRepresentativeSentencesInput>;
};


export type QueryGetRuleByIdArgs = {
  request: GetRuleByIdInput;
};


export type QueryGetRuleByTokenArgs = {
  request: GetRuleByTokenInput;
};


export type QueryGetSampleDescriptionArgs = {
  request?: InputMaybe<GetSampleDescriptionInput>;
};


export type QueryGetScheduleByIdArgs = {
  request: GetScheduleByIdInput;
};


export type QueryGetSearchRecommendationsArgs = {
  request: GetSearchRecommendationsInput;
};


export type QueryGetSearchSuggestionsArgs = {
  request: GetSearchSuggestionsInput;
};


export type QueryGetSimilarReasonsArgs = {
  request: GetSimilarReasonsInput;
};


export type QueryGetSuggestionByIdArgs = {
  request: GetSuggestionByIdInput;
};


export type QueryGetSummaryUserQuoteArgs = {
  request: GetSummaryUserQuoteInput;
};


export type QueryGetTagByIdArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryGetTaxonomyArgs = {
  request: GetTaxonomyInput;
};


export type QueryGetTaxonomyByIdArgs = {
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};


export type QueryGetTaxonomyT3Args = {
  request: GetTaxonomyT3Input;
};


export type QueryGetTenantByIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetTopAggregateChangesArgs = {
  request: GetTopAggregateChangesInput;
};


export type QueryGetTopAggregatesArgs = {
  request: GetTopAggregatesInput;
};


export type QueryGetUncategorizedNodeArgs = {
  request?: InputMaybe<GetUncategorizedNodeInput>;
};


export type QueryGetUserByEmailArgs = {
  email: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserQuoteArgs = {
  request?: InputMaybe<GetUserQuoteInput>;
};


export type QueryIsDomainSsoArgs = {
  domain: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryListAnalysesArgs = {
  request: ListAnalysesInput;
};


export type QueryListAnomaliesArgs = {
  request: ListAnomaliesInput;
};


export type QueryListAssociationsArgs = {
  request: ListAssociationsInput;
};


export type QueryListChatsArgs = {
  request?: InputMaybe<ListChatsInput>;
};


export type QueryListDashboardsArgs = {
  request: ListDashboardsInput;
};


export type QueryListDemoTenantsArgs = {
  request: ListDemoTenantsInput;
};


export type QueryListEqlFieldValuesArgs = {
  request: ListEqlFieldValuesInput;
};


export type QueryListEqlFieldsArgs = {
  request: ListEqlFieldsInput;
};


export type QueryListIntegrationsArgs = {
  request?: InputMaybe<ListIntegrationsInput>;
};


export type QueryListLabelsArgs = {
  request: ListLabelsInput;
};


export type QueryListLabelsV2Args = {
  request: ListLabelsV2Input;
};


export type QueryListMetadataKeysArgs = {
  request: ListMetadataKeysRequest;
};


export type QueryListMetadataKeysForTenantArgs = {
  tenantID: Scalars['ID'];
};


export type QueryListMetricCriteriaArgs = {
  request: ListMetricCriteriaInput;
};


export type QueryListQueryBuilderGroupsArgs = {
  request: ListQueryBuilderGroupsInput;
};


export type QueryListRecentAnomaliesArgs = {
  request: ListRecentAnomaliesInput;
};


export type QueryListRulesArgs = {
  request: ListRulesInput;
};


export type QueryListSubpartsArgs = {
  request: ListSubpartsRequest;
};


export type QueryListSuggestionsArgs = {
  request: ListSuggestionsInput;
};


export type QueryListTagsForTenantArgs = {
  tenantID: Scalars['ID'];
};


export type QueryListTaxonomiesForOrganisationArgs = {
  tenantID: Scalars['ID'];
};


export type QueryListTaxonomySearchGroupsArgs = {
  request: ListTaxonomySearchGroupsInput;
};


export type QueryListTenantsArgs = {
  request: ListTenantsInput;
};


export type QueryListTenantsForEmailArgs = {
  request: ListTenantsForEmailInput;
};


export type QueryListUnifiedFieldsArgs = {
  request?: InputMaybe<ListUnifiedFieldsInput>;
};


export type QueryListUsersArgs = {
  request: ListUsersInput;
};


export type QueryProxyFileDownloadArgs = {
  request: ProxyFileDownloadInput;
};


export type QueryRegenerateAssistantResponseArgs = {
  request?: InputMaybe<RegenerateAssistantResponseInput>;
};


export type QueryResolveEqlReferencesArgs = {
  request: ResolveEqlReferencesInput;
};


export type QuerySearchArgs = {
  request: SearchInput;
};


export type QuerySearchArtefactsArgs = {
  request: SearchArtefactsInput;
};


export type QuerySearchTaxonomyNodeArgs = {
  request?: InputMaybe<SearchTaxonomyNodeInput>;
};


export type QuerySearchUnassignedRCsArgs = {
  request: SearchUnassignedRCsInput;
};


export type QuerySemanticSearchArgs = {
  request: SemanticSearchInput;
};


export type QueryStopAssistantResponseArgs = {
  request?: InputMaybe<StopAssistantResponseInput>;
};


export type QuerySubmitReportGenerationRequestArgs = {
  request: GenerateReportRequest;
};


export type QueryTestAnomalyRuleArgs = {
  request: TestAnomalyRuleInput;
};


export type QueryValidateDescriptionArgs = {
  request?: InputMaybe<ValidateDescriptionInput>;
};


export type QueryValidateFeedbackFieldNameArgs = {
  request: ValidateFeedbackFieldNameInput;
};


export type QueryValidateFileUploadArgs = {
  request: ValidateFileUploadInput;
};


export type QueryValidateFileUploadV2Args = {
  request: ValidateFileUploadV2Input;
};


export type QueryValidatePhraseInRecordArgs = {
  request: ValidatePhraseInRecordInput;
};

export type QueryBuilderGroup = {
  __typename?: 'QueryBuilderGroup';
  displayName: Scalars['String'];
  field?: Maybe<EqlField>;
  hasMore: Scalars['Boolean'];
  id: Scalars['String'];
  options: Array<QueryBuilderGroupOption>;
  type: QueryBuilderGroupType;
};

export type QueryBuilderGroupOption = {
  __typename?: 'QueryBuilderGroupOption';
  field: EqlField;
  isCompleteMatch: Scalars['Boolean'];
  value?: Maybe<EqlFieldValue>;
};

export enum QueryBuilderGroupType {
  Field = 'FIELD',
  Value = 'VALUE'
}

export enum QuestionType {
  AnalysisGoal = 'AnalysisGoal',
  FeedbackType = 'FeedbackType',
  FeedbackUser = 'FeedbackUser',
  Invalid = 'Invalid'
}

export type Quote = {
  __typename?: 'Quote';
  location: IndexMetadata;
  text: Scalars['String'];
};

export type QuoteContext = {
  claim?: InputMaybe<Scalars['String']>;
};

export type Quotes = {
  __typename?: 'Quotes';
  conversation?: Maybe<Conversation>;
  forumThread?: Maybe<ForumThread>;
  isTrimmedFromEnd?: Maybe<Scalars['Boolean']>;
  isTrimmedFromStart?: Maybe<Scalars['Boolean']>;
  predictionMatches?: Maybe<Array<PredictionMatchMetadata>>;
  review?: Maybe<Scalars['String']>;
  surveyResponse?: Maybe<SurveyResponse>;
  textMatches?: Maybe<Array<MatchedRecordMetadata>>;
};

export type Rc = GeneratedRc | UnassignedRc;

export type RcInput = {
  generatedRCs: Array<GeneratedRcInput>;
  unassignedRCs: Array<UnassignedRcInput>;
};

export type RcMetadata = {
  __typename?: 'RCMetadata';
  isPredicted?: Maybe<Scalars['Boolean']>;
};

export type RcUnit = {
  __typename?: 'RCUnit';
  metadata?: Maybe<RcMetadata>;
  text: Scalars['String'];
};

export type Reason = Label & TaxonomyNode & {
  __typename?: 'Reason';
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  metadata?: Maybe<ReasonMetadata>;
  progress?: Maybe<ProgressInfo>;
  requestedID?: Maybe<Scalars['ID']>;
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export type ReasonCategoryUpdated = {
  __typename?: 'ReasonCategoryUpdated';
  newCategory: Category;
  oldCategory: Category;
};

export type ReasonManipulation = {
  isSuggested?: InputMaybe<Scalars['Boolean']>;
  labelID: Scalars['ID'];
  manipulationType?: InputMaybe<HierarchyManipulationType>;
  relatedRCs?: InputMaybe<Array<Scalars['String']>>;
};

export type ReasonMergeSuggestion = {
  __typename?: 'ReasonMergeSuggestion';
  reasonsToMerge?: Maybe<Array<Label>>;
  suggestedCategory: Category;
  suggestedName: Scalars['String'];
};

export type ReasonMergeUpdatedSuggestion = {
  acceptedCategory?: InputMaybe<Category>;
  acceptedDisplayName?: InputMaybe<Scalars['String']>;
  acceptedReasonIDs?: InputMaybe<Array<Scalars['ID']>>;
  shownCategory?: InputMaybe<Category>;
  shownReasonIDs?: InputMaybe<Array<Scalars['ID']>>;
  shownReasonName?: InputMaybe<Scalars['String']>;
};

export type ReasonMerged = {
  __typename?: 'ReasonMerged';
  childIDs: Array<Scalars['ID']>;
  childReasons: Array<Label>;
  parentID: Scalars['ID'];
  parentReason: Label;
};

export type ReasonMetadata = {
  __typename?: 'ReasonMetadata';
  category?: Maybe<Category>;
  createdBy?: Maybe<User>;
  representativeSentences?: Maybe<Array<Scalars['String']>>;
  sentiment?: Maybe<SentimentType>;
  type?: Maybe<ReasonType>;
};

export type ReasonMetadataInput = {
  category?: InputMaybe<Category>;
  createdBy?: InputMaybe<Scalars['ID']>;
  rc?: InputMaybe<RcInput>;
  representativeSentences?: InputMaybe<Array<Scalars['String']>>;
  sentiment?: InputMaybe<SentimentType>;
};

export type ReasonPredictionMetadata = {
  __typename?: 'ReasonPredictionMetadata';
  confidence?: Maybe<Scalars['Float']>;
  sentiment: SentimentType;
  units?: Maybe<Array<ReasonPredictionMetadataUnit>>;
};

export type ReasonPredictionMetadataUnit = {
  __typename?: 'ReasonPredictionMetadataUnit';
  endOffset: Scalars['Int'];
  indexMetadata: IndexMetadata;
  msgIndex?: Maybe<Scalars['Int']>;
  startOffset: Scalars['Int'];
};

export type ReasonRCsUpdated = {
  __typename?: 'ReasonRCsUpdated';
  added?: Maybe<Array<Scalars['String']>>;
  removed?: Maybe<Array<Scalars['String']>>;
  removedTo?: Maybe<Label>;
  removedToReasonID?: Maybe<Scalars['ID']>;
};

export type ReasonSuggestionMetadataInput = {
  indexMetadata: IndexMetadataInput;
};

export enum ReasonType {
  AutomaticallyIdentified = 'AUTOMATICALLY_IDENTIFIED',
  ManuallyDefined = 'MANUALLY_DEFINED'
}

export type Record = {
  __typename?: 'Record';
  audioConversation?: Maybe<AudioConversation>;
  audioConversationEn?: Maybe<AudioConversation>;
  conversation?: Maybe<Conversation>;
  conversationEn?: Maybe<Conversation>;
  createdAt?: Maybe<Scalars['Int']>;
  forumThread?: Maybe<ForumThread>;
  forumThreadEn?: Maybe<ForumThread>;
  id: Scalars['ID'];
  language?: Maybe<Language>;
  matchMetadata?: Maybe<RecordMatchMetadata>;
  namespace?: Maybe<Scalars['String']>;
  predictionHierarchies?: Maybe<Array<Maybe<Prediction>>>;
  predictions?: Maybe<Array<Prediction>>;
  rcData?: Maybe<RecordRc>;
  sourceData?: Maybe<SourceData>;
  sourceDataV2?: Maybe<SourceDataV2>;
  sourceID: Source;
  sourceTimestamp?: Maybe<Scalars['Int']>;
  summary?: Maybe<RecordSummary>;
  surveyResponse?: Maybe<SurveyResponse>;
  surveyResponseEn?: Maybe<SurveyResponse>;
  text: Scalars['String'];
  textEN: Scalars['String'];
  type?: Maybe<RecordType>;
};

export enum RecordFlag {
  Junk = 'JUNK'
}

export type RecordMatchMetadata = {
  __typename?: 'RecordMatchMetadata';
  search?: Maybe<Array<MatchedRecordMetadata>>;
};

export type RecordRc = {
  __typename?: 'RecordRC';
  units?: Maybe<Array<RcUnit>>;
};

export type RecordSegment = {
  __typename?: 'RecordSegment';
  audioSnippet?: Maybe<AudioSnippet>;
  conversation?: Maybe<Conversation>;
  forumThread?: Maybe<ForumThread>;
  isTrimmedFromEnd?: Maybe<Scalars['Boolean']>;
  isTrimmedFromStart?: Maybe<Scalars['Boolean']>;
  predictionMatches?: Maybe<Array<PredictionMatchMetadata>>;
  quoteLocation: IndexMetadata;
  review?: Maybe<Scalars['String']>;
  segmentLocation: IndexMetadata;
  surveyResponse?: Maybe<SurveyResponse>;
  textMatches?: Maybe<Array<MatchedRecordMetadata>>;
};

export type RecordSentimentManipulation = {
  sentiment: SentimentName;
};

export type RecordSummary = {
  __typename?: 'RecordSummary';
  flag?: Maybe<SummaryFlag>;
  units?: Maybe<Array<SummaryMessageUnit>>;
};

export enum RecordType {
  AudioRecording = 'AUDIO_RECORDING',
  Conversation = 'CONVERSATION',
  ForumThread = 'FORUM_THREAD',
  Review = 'REVIEW',
  Survey = 'SURVEY'
}

export type RecordTypeDetails = {
  __typename?: 'RecordTypeDetails';
  audioConversation?: Maybe<AudioConversationDetails>;
};

export type RedditIntegrationData = {
  __typename?: 'RedditIntegrationData';
  subreddit: Scalars['String'];
};

export type RedditIntegrationInputData = {
  code?: InputMaybe<Scalars['String']>;
  subreddit?: InputMaybe<Scalars['String']>;
};

export type RedditUpdateIntegrationData = {
  subreddit: Scalars['String'];
};

export type RegenerateAssistantResponseInput = {
  chatEditToken?: InputMaybe<Scalars['ID']>;
  question?: InputMaybe<Scalars['String']>;
  responseID: Scalars['ID'];
  sessionID: Scalars['ID'];
  step?: InputMaybe<RegenerateAssistantResponseStepInput>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type RegenerateAssistantResponseStepInput = {
  eql?: InputMaybe<Scalars['String']>;
  stepID: Scalars['ID'];
  tokenID?: InputMaybe<Scalars['ID']>;
};

export enum RelationType {
  Reply = 'REPLY'
}

export type RelativeTimeRange = {
  unit: TimeUnit;
  value: Scalars['Int'];
};

export type RelativeTimeRangeResponse = {
  __typename?: 'RelativeTimeRangeResponse';
  unit: TimeUnit;
  value: Scalars['Int'];
};

export type RemoveTenantSsoInput = {
  tenantID: Scalars['ID'];
};

export type RemoveTenantSsoResponse = {
  __typename?: 'RemoveTenantSsoResponse';
  success: Scalars['Boolean'];
};

export type RemoveUserTagsInput = {
  tags?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type RemoveUserTagsResponse = MutationResponse & {
  __typename?: 'RemoveUserTagsResponse';
  code: Scalars['String'];
  message: Scalars['String'];
};

export enum ReportStatus {
  Created = 'Created',
  NotFound = 'NotFound',
  Pending = 'Pending'
}

export enum ReportType {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

export type ReportWindowMetadata = {
  __typename?: 'ReportWindowMetadata';
  nextTriggerTimestamp: Scalars['Int'];
  recordHitsInLastWindow?: Maybe<Scalars['Int']>;
};

export type Reporting = {
  __typename?: 'Reporting';
  primarySchedule?: Maybe<Schedule>;
  secondarySchedules?: Maybe<Array<Schedule>>;
};

export enum ReportingCadence {
  OneTime = 'ONE_TIME',
  Weekly = 'WEEKLY'
}

export enum ReportingType {
  DefaultReport = 'DEFAULT_REPORT',
  FeedbackReport = 'FEEDBACK_REPORT'
}

export type RequestReachoutInput = {
  email: Scalars['String'];
  tenantID: Scalars['String'];
};

export type RequestReachoutResponse = {
  __typename?: 'RequestReachoutResponse';
  success: Scalars['Boolean'];
};

export type ResolveEqlReferencesInput = {
  eql: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type ResolveEqlReferencesResponse = {
  __typename?: 'ResolveEQLReferencesResponse';
  filters: Array<ResolvedEqlFilter>;
};

export type ResolvedEqlFilter = {
  __typename?: 'ResolvedEQLFilter';
  field: EqlField;
  values: Array<EqlFieldValue>;
  valuesV2: Array<ResolvedEqlFilterValue>;
};

export type ResolvedEqlFilterValue = {
  __typename?: 'ResolvedEQLFilterValue';
  reference: Scalars['String'];
  value: EqlFieldValue;
};

export type ResumeWebSocketSessionRequest = {
  __typename?: 'ResumeWebSocketSessionRequest';
  sessionID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type Rule = {
  __typename?: 'Rule';
  actions: Actions;
  anomalyFunction: Scalars['String'];
  createdBy?: Maybe<UserInfo>;
  data: Data;
  discoverability: Scope;
  editToken?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastRanAt: Scalars['Int'];
  name: Scalars['String'];
  recentAnomaliesResponse: ListAnomaliesResponse;
  schedule: TimeUnit;
  tenantID: Scalars['ID'];
  thresholds?: Maybe<Array<Threshold>>;
  valueFunctions?: Maybe<Array<Scalars['String']>>;
  version: Scalars['Int'];
  viewToken: Scalars['String'];
};

export type SalesforceDescribeField = {
  __typename?: 'SalesforceDescribeField';
  label: Scalars['String'];
  name: Scalars['String'];
  type: PrimitiveDataType;
};

export type SalesforceDescribeObjectInput = {
  objectName: Scalars['String'];
};

export type SalesforceDescribeObjectResponse = {
  __typename?: 'SalesforceDescribeObjectResponse';
  fields: Array<SalesforceDescribeField>;
  name: Scalars['String'];
  references: Array<SalesforceReferenceSchema>;
};

export type SalesforceEditFormData = {
  __typename?: 'SalesforceEditFormData';
  describeObject?: Maybe<SalesforceDescribeObjectResponse>;
  listObjectNames?: Maybe<SalesforceListObjectNamesResponse>;
};

export type SalesforceEditFormDataInput = {
  describeObject?: InputMaybe<SalesforceDescribeObjectInput>;
  listObjectNames?: InputMaybe<Scalars['Boolean']>;
};

export type SalesforceFieldSchema = {
  __typename?: 'SalesforceFieldSchema';
  label: Scalars['String'];
  name: Scalars['String'];
};

export type SalesforceFieldSchemaInput = {
  label: Scalars['String'];
  name: Scalars['String'];
};

export type SalesforceIngestionCondition = {
  __typename?: 'SalesforceIngestionCondition';
  field: Array<SalesforceIngestionFieldCondition>;
};

export type SalesforceIngestionConditionInput = {
  field: Array<SalesforceIngestionFieldConditionInput>;
};

export type SalesforceIngestionFieldCondition = {
  __typename?: 'SalesforceIngestionFieldCondition';
  field: Scalars['String'];
  values: PrimitiveValueArray;
};

export type SalesforceIngestionFieldConditionInput = {
  field: Scalars['String'];
  values?: InputMaybe<PrimitiveValueArrayInput>;
};

export type SalesforceIntegrationData = {
  __typename?: 'SalesforceIntegrationData';
  condition?: Maybe<SalesforceIngestionCondition>;
  instanceURL: Scalars['String'];
  objectSchema?: Maybe<SalesforceObjectSchema>;
  orderBy: SalesforceOrderByField;
};

export type SalesforceIntegrationInputData = {
  authGrant: Scalars['String'];
  redirectURI?: InputMaybe<Scalars['String']>;
};

export type SalesforceListObjectNamesResponse = {
  __typename?: 'SalesforceListObjectNamesResponse';
  objectNames: Array<Scalars['String']>;
};

export type SalesforceObjectSchema = {
  __typename?: 'SalesforceObjectSchema';
  fieldsToResolve: Array<SalesforceReferenceSchema>;
  name: Scalars['String'];
  surveyContent?: Maybe<Array<SalesforceFieldSchema>>;
};

export type SalesforceObjectSchemaInput = {
  fieldsToResolve: Array<InputMaybe<SalesforceReferenceSchemaInput>>;
  name: Scalars['String'];
  surveyContent?: InputMaybe<Array<SalesforceFieldSchemaInput>>;
};

export enum SalesforceOrderByField {
  CreatedDate = 'CREATED_DATE',
  LastModifiedDate = 'LAST_MODIFIED_DATE'
}

export type SalesforceReferenceSchema = {
  __typename?: 'SalesforceReferenceSchema';
  name: Scalars['String'];
  objectName: Scalars['String'];
  relationshipName: Scalars['String'];
};

export type SalesforceReferenceSchemaInput = {
  name: Scalars['String'];
  objectName: Scalars['String'];
  relationshipName: Scalars['String'];
};

export type SalesforceUpdateIntegrationData = {
  condition?: InputMaybe<SalesforceIngestionConditionInput>;
  orderBy?: InputMaybe<SalesforceOrderByField>;
  schema: SalesforceObjectSchemaInput;
};

export type SamlSsoSettingsInput = {
  metadataURL: Scalars['String'];
};

export type SavedFeedbackMetadata = {
  __typename?: 'SavedFeedbackMetadata';
  feedbackID: Scalars['ID'];
  isFeedbackSaved?: Maybe<Scalars['Boolean']>;
  snippetMetadata?: Maybe<Array<SavedSnippetMetadata>>;
  snippetMetadataV2?: Maybe<Array<SavedSnippetMetadataV2>>;
};

export type SavedFeedbackMetadataInput = {
  feedbackID: Scalars['ID'];
  isFeedbackSaved?: InputMaybe<Scalars['Boolean']>;
  snippetMetadata?: InputMaybe<Array<SavedSnippetMetadataInput>>;
  snippetMetadataV2?: InputMaybe<Array<SavedSnippetMetadataV2Input>>;
};

export type SavedSnippetMetadata = {
  __typename?: 'SavedSnippetMetadata';
  labelID?: Maybe<Scalars['ID']>;
  snippetIDs?: Maybe<Array<Scalars['ID']>>;
};

export type SavedSnippetMetadataInput = {
  labelID?: InputMaybe<Scalars['ID']>;
  snippetIDs?: InputMaybe<Array<Scalars['ID']>>;
};

export type SavedSnippetMetadataV2 = {
  __typename?: 'SavedSnippetMetadataV2';
  location?: Maybe<IndexMetadata>;
};

export type SavedSnippetMetadataV2Input = {
  location: IndexMetadataInput;
};

export type Schedule = {
  __typename?: 'Schedule';
  createdAt: Scalars['Int'];
  cron: Cron;
  id: Scalars['ID'];
  integrations?: Maybe<Array<Integration>>;
  isDisabled: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  metadata: ScheduleMetadata;
  outbounds?: Maybe<Array<Scalars['String']>>;
  reportType: ReportingType;
  subjectID: Scalars['ID'];
  subjectType: SubjectType;
  updatedAt: Scalars['Int'];
};

export type ScheduleMetadata = {
  __typename?: 'ScheduleMetadata';
  defaultReportMetadata?: Maybe<DefaultReportMetadata>;
  feedbackReportMetadata?: Maybe<FeedbackReportMetadata>;
};

export type ScheduleMetadataInput = {
  defaultReportMetadata?: InputMaybe<DefaultReportMetadataInput>;
  feedbackReportMetadata?: InputMaybe<FeedbackReportMetadataInput>;
};

export enum Scope {
  Hidden = 'HIDDEN',
  Invalid = 'INVALID',
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  PublicEditable = 'PUBLIC_EDITABLE',
  Snapshot = 'SNAPSHOT',
  SystemGenerated = 'SYSTEM_GENERATED'
}

export type SearchArtefactsInput = {
  createdByFilter?: InputMaybe<ArtefactCreatedByFilter>;
  cursor?: InputMaybe<Scalars['String']>;
  editableByFilter?: InputMaybe<ArtefactEditableByFilter>;
  filter?: InputMaybe<ArtefactSpecificFilter>;
  query?: InputMaybe<Scalars['String']>;
  responseSize?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<Scope>>;
  statuses?: InputMaybe<Array<Status>>;
  tenantID: Scalars['ID'];
  types?: InputMaybe<Array<ArtefactType>>;
};

export type SearchArtefactsResponse = {
  __typename?: 'SearchArtefactsResponse';
  artefacts: Array<ArtefactListItem>;
  cursor?: Maybe<Scalars['String']>;
  hits?: Maybe<Scalars['Int']>;
};

export enum SearchCoherenceLevel {
  Strong = 'STRONG',
  Weak = 'WEAK'
}

export type SearchInput = {
  CoherenceLevel?: InputMaybe<SearchCoherenceLevel>;
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<FilterQueryUnion>;
  query: Scalars['String'];
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['ID'];
  timerange?: InputMaybe<TimeRange>;
};

export type SearchMetadataFieldsInput = {
  excludeSources?: InputMaybe<Array<Scalars['String']>>;
  includeHidden?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  tenantID: Scalars['ID'];
  valueType?: InputMaybe<EqlFieldValueType>;
};

export type SearchMetadataFieldsResponse = {
  __typename?: 'SearchMetadataFieldsResponse';
  fields: Array<EqlField>;
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  hits: Scalars['Int'];
  matchedRecords?: Maybe<Array<MatchedRecord>>;
  next?: Maybe<Scalars['String']>;
  previous?: Maybe<Scalars['String']>;
  records?: Maybe<Array<Record>>;
};

export type SearchResponseRecord = {
  __typename?: 'SearchResponseRecord';
  score: Scalars['Int'];
  value: Record;
};

export type SearchTaxonomyNodeInput = {
  id: Scalars['ID'];
  labelType: LabelType;
  tenantID: Scalars['ID'];
};

export type SearchTaxonomyNodeResponse = {
  __typename?: 'SearchTaxonomyNodeResponse';
  paths: Array<TaxonomyNodeV2>;
};

export type SearchUnassignedRCsInput = {
  cursor?: InputMaybe<Scalars['String']>;
  query: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type SearchUnassignedRCsResponse = {
  __typename?: 'SearchUnassignedRCsResponse';
  unassignedRCs: Array<UnassignedRc>;
};

export type SelectAggregates = {
  __typename?: 'SelectAggregates';
  groupBy?: Maybe<GroupByClause>;
};

export type SelectAggregatesInput = {
  groupBy?: InputMaybe<GroupBy>;
};

export type SelectClause = {
  __typename?: 'SelectClause';
  aggregates?: Maybe<SelectAggregates>;
  records?: Maybe<SelectRecords>;
};

export type SelectClauseInput = {
  aggregates?: InputMaybe<SelectAggregatesInput>;
  records?: InputMaybe<SelectRecordsInput>;
};

export type SelectRecords = {
  __typename?: 'SelectRecords';
  sortBy?: Maybe<Array<SortByClause>>;
};

export type SelectRecordsInput = {
  sortBy?: InputMaybe<Array<SortBy>>;
};

export type SemanticSearchInput = {
  filters?: InputMaybe<FilterQueryUnion>;
  includeAgentData?: InputMaybe<Scalars['Boolean']>;
  includeBotData?: InputMaybe<Scalars['Boolean']>;
  query: Scalars['String'];
  summary?: InputMaybe<Scalars['Boolean']>;
  taxonomyID?: InputMaybe<Scalars['ID']>;
  tenantID: Scalars['String'];
  timerange?: InputMaybe<TimeRange>;
  topN?: InputMaybe<Scalars['Int']>;
};

export type SemanticSearchResponse = {
  __typename?: 'SemanticSearchResponse';
  records?: Maybe<Array<SearchResponseRecord>>;
  summary?: Maybe<Scalars['String']>;
};

export type Sentiment = Label & {
  __typename?: 'Sentiment';
  children?: Maybe<Array<Maybe<Label>>>;
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  type: LabelType;
  updateInProgress: Scalars['Boolean'];
};

export enum SentimentName {
  Invalid = 'INVALID',
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SentimentPredictionMetadata = {
  __typename?: 'SentimentPredictionMetadata';
  confidence: Scalars['Int'];
  units?: Maybe<Array<SentimentPredictionMetadataUnit>>;
};

export type SentimentPredictionMetadataUnit = {
  __typename?: 'SentimentPredictionMetadataUnit';
  indexMetadata: IndexMetadata;
  probability: Scalars['Float'];
  sentiment: SentimentType;
};

export type SentimentSuggestionMetadataInput = {
  sentiment?: InputMaybe<SentimentType>;
};

export enum SentimentType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SlackChannel = {
  __typename?: 'SlackChannel';
  id: Scalars['String'];
  isPrivate?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type SlackChannelInput = {
  id: Scalars['String'];
  isPrivate?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type SlackData = SourceData & {
  __typename?: 'SlackData';
  channel?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type SlackEditFormData = {
  __typename?: 'SlackEditFormData';
  channelsInWorkspace: Array<SlackChannel>;
  refreshID?: Maybe<Scalars['String']>;
};

export type SlackEditFormDataInput = {
  refreshID?: InputMaybe<Scalars['String']>;
};

export type SlackFormData = IntegrationFormData & {
  __typename?: 'SlackFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type SlackIntegrationData = {
  __typename?: 'SlackIntegrationData';
  accessToken: Scalars['String'];
  additionalOrgDomains?: Maybe<Array<Scalars['String']>>;
  createdByUserID?: Maybe<Scalars['String']>;
  subscribedChannels: Array<SlackChannel>;
};

export type SlackIntegrationInputData = {
  authGrant: Scalars['String'];
  redirectURI?: InputMaybe<Scalars['String']>;
  subscribedChannels?: InputMaybe<Array<SlackChannelInput>>;
};

export type SlackUpdateIntegrationData = {
  additionalOrgDomains?: InputMaybe<Array<Scalars['String']>>;
  subscribedChannels: Array<SlackChannelInput>;
};

export type SnowflakeIntegrationData = {
  __typename?: 'SnowflakeIntegrationData';
  accountName: Scalars['String'];
  database: Scalars['String'];
  publicKey: Scalars['String'];
  role: Scalars['String'];
  schema: Scalars['String'];
  table: Scalars['String'];
  user: Scalars['String'];
  warehouse: Scalars['String'];
};

export type SnowflakeIntegrationInputData = {
  accountName: Scalars['String'];
  database: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  schema: Scalars['String'];
  table: Scalars['String'];
  user?: InputMaybe<Scalars['String']>;
  warehouse: Scalars['String'];
};

export type SortBy = {
  isAsc: Scalars['Boolean'];
  metadataKey?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['Boolean']>;
  timestamp?: InputMaybe<Scalars['Boolean']>;
};

export type SortByClause = {
  __typename?: 'SortByClause';
  isAsc: Scalars['Boolean'];
  metadataKey?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['Boolean']>;
  timestamp?: Maybe<Scalars['Boolean']>;
};

export enum Source {
  AmazonConnect = 'AMAZON_CONNECT',
  Appstore = 'APPSTORE',
  Chorus = 'CHORUS',
  Delighted = 'DELIGHTED',
  Discord = 'DISCORD',
  Discourse = 'DISCOURSE',
  Email = 'EMAIL',
  FacebookPages = 'FACEBOOK_PAGES',
  FileUpload = 'FILE_UPLOAD',
  Freshchat = 'FRESHCHAT',
  Freshdesk = 'FRESHDESK',
  Front = 'FRONT',
  G2 = 'G2',
  Gainsight = 'GAINSIGHT',
  Gong = 'GONG',
  GoogleMyBusiness = 'GOOGLE_MY_BUSINESS',
  Grain = 'GRAIN',
  Intercom = 'INTERCOM',
  Kustomer = 'KUSTOMER',
  Livechat = 'LIVECHAT',
  Nps = 'NPS',
  Playstore = 'PLAYSTORE',
  Qualtrics = 'QUALTRICS',
  Reddit = 'REDDIT',
  Salesforce = 'SALESFORCE',
  Slack = 'SLACK',
  Snowflake = 'SNOWFLAKE',
  Sprig = 'SPRIG',
  StellaConnect = 'STELLA_CONNECT',
  SurveyMonkey = 'SURVEY_MONKEY',
  Twitter = 'TWITTER',
  Typeform = 'TYPEFORM',
  ZendeskChat = 'ZENDESK_CHAT',
  ZendeskSupport = 'ZENDESK_SUPPORT',
  ZohoDesk = 'ZOHO_DESK'
}

export type SourceData = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type SourceDataV2 = {
  __typename?: 'SourceDataV2';
  externalLink?: Maybe<Scalars['String']>;
  integrationChannelType: IntegrationChannelType;
  logo: Scalars['String'];
  metadata?: Maybe<Array<SourceMetadata>>;
  name: Scalars['String'];
};

export type SourceDetails = {
  __typename?: 'SourceDetails';
  eqlValue: Scalars['String'];
  id: Source;
};

export type SourceFilter = {
  source: Source;
};

export type SourceMetadata = {
  __typename?: 'SourceMetadata';
  field: Scalars['String'];
  isImportant: Scalars['Boolean'];
  isReference: Scalars['Boolean'];
  key: Scalars['String'];
  objectID: Scalars['ID'];
  objectType: ObjectType;
  queriable: Scalars['Boolean'];
  referencedIn: Scalars['String'];
  value: MetadataValue;
};

export type SprigEditFormData = {
  __typename?: 'SprigEditFormData';
  surveys: Array<SprigSurvey>;
};

export type SprigIntegrationData = {
  __typename?: 'SprigIntegrationData';
  surveys: Array<SprigSurvey>;
};

export type SprigIntegrationInputData = {
  apiKey: Scalars['String'];
};

export type SprigSurvey = {
  __typename?: 'SprigSurvey';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SprigSurveyInput = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type SprigUpdateIntegrationData = {
  surveys: Array<InputMaybe<SprigSurveyInput>>;
};

export type StatDataPoint = {
  __typename?: 'StatDataPoint';
  bucket: AggregateStatKey;
  value: Scalars['Float'];
};

export enum Status {
  Archived = 'ARCHIVED',
  Invalid = 'INVALID',
  Unarchived = 'UNARCHIVED'
}

export type StellaConnectData = SourceData & {
  __typename?: 'StellaConnectData';
  agentStarRating?: Maybe<Scalars['Int']>;
  areasOfExcellence?: Maybe<Array<Scalars['String']>>;
  areasOfImprovement?: Maybe<Array<Scalars['String']>>;
  branding?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nps?: Maybe<Scalars['Int']>;
  surveyName?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  teamLeader?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type StellaConnectFormData = IntegrationFormData & {
  __typename?: 'StellaConnectFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
};

export type StellaConnectIntegrationData = {
  __typename?: 'StellaConnectIntegrationData';
  apiKey: Scalars['String'];
  jwtToken: Scalars['String'];
};

export type StellaConnectIntegrationInputData = {
  apiKey: Scalars['String'];
  secretKey: Scalars['String'];
};

export type StopAssistantResponseInput = {
  responseID: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type StringCollectionDataValue = {
  __typename?: 'StringCollectionDataValue';
  strings: Array<Scalars['String']>;
};

export type StringDataValue = {
  __typename?: 'StringDataValue';
  string: Scalars['String'];
};

export enum SubjectType {
  Analysis = 'ANALYSIS',
  Dashboard = 'DASHBOARD',
  Invalid = 'INVALID'
}

export type SubmitFileUploadDateFieldInput = {
  autoAssign: Scalars['Boolean'];
  dateFormat?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['Int']>;
};

export type SubmitFileUploadFeedbackFieldInput = {
  fieldName: Scalars['String'];
  index: Scalars['Int'];
};

export type SubmitFileUploadFieldsInput = {
  dateField: SubmitFileUploadDateFieldInput;
  feedbackFields?: InputMaybe<Array<InputMaybe<SubmitFileUploadFeedbackFieldInput>>>;
  idField: SubmitFileUploadIdFieldInput;
  metadataFields?: InputMaybe<Array<InputMaybe<SubmitFileUploadMetadataFieldInput>>>;
};

export type SubmitFileUploadForCustomGroupRequest = {
  integrationID: Scalars['String'];
  tenantID: Scalars['ID'];
  url: Scalars['String'];
};

export type SubmitFileUploadForCustomGroupResponse = {
  __typename?: 'SubmitFileUploadForCustomGroupResponse';
  uploaded: Scalars['Boolean'];
};

export type SubmitFileUploadFormInput = {
  fields: SubmitFileUploadFieldsInput;
  integrationID: Scalars['ID'];
  tenantID: Scalars['ID'];
  url: Scalars['String'];
};

export type SubmitFileUploadFormResponse = {
  __typename?: 'SubmitFileUploadFormResponse';
  errorMsg?: Maybe<Scalars['String']>;
};

export type SubmitFileUploadIdFieldInput = {
  autoGenerate: Scalars['Boolean'];
  index?: InputMaybe<Scalars['Int']>;
};

export type SubmitFileUploadMetadataFieldInput = {
  fieldName: Scalars['String'];
  index: Scalars['Int'];
  type?: InputMaybe<FileUploadFieldType>;
};

export type Subpart = {
  __typename?: 'Subpart';
  displayText: Scalars['String'];
  id: Scalars['ID'];
  namespace?: Maybe<Scalars['String']>;
  source: Source;
  type: SubpartType;
};

export enum SubpartType {
  Question = 'QUESTION',
  Unknown = 'UNKNOWN'
}

export type SubscribeToLabelInput = {
  labelID: Scalars['ID'];
  labelType: LabelType;
  outbounds: Array<Scalars['ID']>;
  tenantID: Scalars['ID'];
};

export type SubscribeToLabelResponse = {
  __typename?: 'SubscribeToLabelResponse';
  ok: Scalars['Boolean'];
};

export type SubscribedFacebookPageInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  token: Scalars['String'];
};

export enum SuggestedAction {
  AddPrediction = 'AddPrediction',
  RemovePrediction = 'RemovePrediction'
}

export type SuggestedReason = {
  __typename?: 'SuggestedReason';
  label?: Maybe<Label>;
  labelID?: Maybe<Scalars['ID']>;
  relatedRCs?: Maybe<Array<Scalars['String']>>;
};

export type Suggestion = {
  __typename?: 'Suggestion';
  createdAt: Scalars['Int'];
  createdBy: Scalars['ID'];
  description: Scalars['String'];
  id: Scalars['ID'];
  lastUpdatedAt: Scalars['Int'];
  status: SuggestionResolutionStatus;
  suggestionData: SuggestionData;
  tags?: Maybe<Array<SuggestionTag>>;
  tenantID: Scalars['ID'];
  type: SuggestionType;
};

export type SuggestionData = ReasonMergeSuggestion;

export type SuggestionDataInput = {
  addReasons?: InputMaybe<AddReasonsSuggestionInput>;
  junkPattern?: InputMaybe<JunkPatternSuggestionInput>;
  predictionSuggestion?: InputMaybe<PredictionSuggestionInput>;
};

export enum SuggestionItem {
  Entity = 'ENTITY',
  L1 = 'L1',
  Reason = 'REASON'
}

export enum SuggestionResolutionStatus {
  Accepted = 'Accepted',
  Ignored = 'Ignored',
  Invalid = 'Invalid',
  Pending = 'Pending'
}

export type SuggestionTag = {
  __typename?: 'SuggestionTag';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SuggestionTagInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export enum SuggestionType {
  AddReasons = 'AddReasons',
  Invalid = 'Invalid',
  JunkPattern = 'JunkPattern',
  Prediction = 'Prediction',
  ReasonMerge = 'ReasonMerge'
}

export enum SummaryFlag {
  Incorrect = 'Incorrect',
  Missing = 'Missing'
}

export type SummaryMessageUnit = {
  __typename?: 'SummaryMessageUnit';
  metadata?: Maybe<SummaryMetadata>;
  text: Scalars['String'];
};

export type SummaryMetadata = {
  __typename?: 'SummaryMetadata';
  flag?: Maybe<SummaryFlag>;
  location?: Maybe<Array<IndexMetadata>>;
};

export type SummaryV2 = {
  __typename?: 'SummaryV2';
  audioMetadata?: Maybe<AudioRecordingMetadata>;
  forLabelID?: Maybe<Scalars['String']>;
  summaryText?: Maybe<Scalars['String']>;
};

export type Survey = {
  __typename?: 'Survey';
  name: Scalars['String'];
  surveyID: Scalars['String'];
};

export type SurveyInput = {
  name: Scalars['String'];
  surveyID: Scalars['String'];
};

export type SurveyMonkeyData = SourceData & {
  __typename?: 'SurveyMonkeyData';
  analyzeURL?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerID?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  editURL?: Maybe<Scalars['String']>;
  freshchatInteractionID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  nps?: Maybe<Scalars['Int']>;
  pageCount?: Maybe<Scalars['Int']>;
  questionCount?: Maybe<Scalars['Int']>;
  surveyCategory?: Maybe<Scalars['String']>;
  surveyID?: Maybe<Scalars['String']>;
  surveyNickname?: Maybe<Scalars['String']>;
  surveyTitle?: Maybe<Scalars['String']>;
  timeTaken?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
};

export type SurveyMonkeyEditFormData = {
  __typename?: 'SurveyMonkeyEditFormData';
  surveys: Array<Maybe<Survey>>;
};

export type SurveyMonkeyFormData = IntegrationFormData & {
  __typename?: 'SurveyMonkeyFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type SurveyMonkeyIntegrationData = {
  __typename?: 'SurveyMonkeyIntegrationData';
  accessToken: Scalars['String'];
  excludedSurveyIDs?: Maybe<Array<Scalars['String']>>;
  includedSurveys?: Maybe<Array<Survey>>;
};

export type SurveyMonkeyIntegrationInputData = {
  authCode: Scalars['String'];
  redirectURI: Scalars['String'];
};

export type SurveyMonkeyUpdateIntegrationData = {
  excludedSurveyIDs?: InputMaybe<Array<Scalars['String']>>;
  includedSurveys?: InputMaybe<Array<SurveyInput>>;
};

export type SurveyQa = {
  __typename?: 'SurveyQA';
  answer: Scalars['String'];
  question: Scalars['String'];
  selectedOptions?: Maybe<Array<Scalars['String']>>;
};

export type SurveyResponse = {
  __typename?: 'SurveyResponse';
  responses: Array<SurveyQa>;
};

export type Tag = {
  __typename?: 'Tag';
  conditionExpression: Scalars['String'];
  createdAt: Scalars['Int'];
  createdBy: User;
  description: Scalars['String'];
  displayName: Scalars['String'];
  eqlExpression: TagEqlExpression;
  id: Scalars['ID'];
  isVisible: Scalars['Boolean'];
  metadata: TagMetadata;
  tenantID: Scalars['ID'];
  updatedAt: Scalars['Int'];
};

export type TagEqlExpression = {
  __typename?: 'TagEQLExpression';
  aggregates: Scalars['String'];
  records: Scalars['String'];
};

export type TagMetadata = {
  __typename?: 'TagMetadata';
  references?: Maybe<TagReferences>;
};

export type TagReferences = {
  __typename?: 'TagReferences';
  entities?: Maybe<Array<Label>>;
  reasons?: Maybe<Array<Label>>;
  tags?: Maybe<Array<Tag>>;
};

export type Taxonomy = {
  __typename?: 'Taxonomy';
  hierarchy?: Maybe<TaxonomyHierarchy>;
  id: Scalars['String'];
  name: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type TaxonomyEdge = {
  __typename?: 'TaxonomyEdge';
  destination: Scalars['String'];
  source: Scalars['String'];
};

export type TaxonomyEdgeInput = {
  destinationID: Scalars['ID'];
  destinationType: TaxonomyNodeType;
  sourceID: Scalars['ID'];
  sourceType: TaxonomyNodeType;
};

export type TaxonomyHierarchy = {
  __typename?: 'TaxonomyHierarchy';
  edges?: Maybe<Array<TaxonomyEdge>>;
  nodes: Array<TaxonomyNode>;
  root: Scalars['String'];
  version: Scalars['Int'];
};

export type TaxonomyNode = {
  createdAt?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export enum TaxonomyNodeType {
  Label = 'LABEL',
  Level = 'LEVEL'
}

export type TaxonomyNodeV2 = {
  __typename?: 'TaxonomyNodeV2';
  category?: Maybe<Category>;
  children?: Maybe<Array<TaxonomyNodeV2>>;
  feedbackVolume: Scalars['Int'];
  isRelevant?: Maybe<Scalars['Boolean']>;
  isUncategorized?: Maybe<Scalars['Boolean']>;
  label: Label;
  labelID: Scalars['ID'];
};

export type TaxonomySearchGroup = {
  __typename?: 'TaxonomySearchGroup';
  hasMore: Scalars['Boolean'];
  options: Array<TaxonomySearchGroupField>;
  type: LabelType;
};

export type TaxonomySearchGroupField = {
  __typename?: 'TaxonomySearchGroupField';
  category?: Maybe<Category>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export enum TaxonomySortField {
  DisplayName = 'DISPLAY_NAME',
  FeedbackVolume = 'FEEDBACK_VOLUME'
}

export enum TaxonomySortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TaxonomyT3Filter = {
  containsNode?: InputMaybe<TaxonomyT3Node>;
  prefixPath?: InputMaybe<TaxonomyT3Path>;
  searchFilter?: InputMaybe<Scalars['String']>;
};

export type TaxonomyT3Node = {
  labelID: Scalars['String'];
  labelType: LabelType;
};

export type TaxonomyT3Path = {
  nodes: Array<TaxonomyT3Node>;
};

export type Tenant = {
  __typename?: 'Tenant';
  avatarURL?: Maybe<Scalars['String']>;
  dashboardSettings?: Maybe<TenantDashboardSettings>;
  domains: Array<Scalars['String']>;
  fields?: Maybe<Array<Field>>;
  id: Scalars['ID'];
  integrations?: Maybe<Array<Integration>>;
  name: Scalars['String'];
  pinnedDashboards?: Maybe<Array<DashboardListItem>>;
  slug?: Maybe<Scalars['String']>;
  state: TenantState;
  tier: TenantTier;
  timezone?: Maybe<Scalars['String']>;
};

export type TenantDashboardSettings = {
  __typename?: 'TenantDashboardSettings';
  anomalySettings: AnomalySettings;
  backfillSettings?: Maybe<BackfillSettings>;
  defaultAggregationWindowUnit: TimeUnit;
  defaultLookbackWindowInDays: Scalars['Int'];
  defaultLookbackWindowInMonths: Scalars['Int'];
  defaultTimeRange?: Maybe<RelativeTimeRangeResponse>;
  defaultUserType?: Maybe<UserType>;
  demoSettings?: Maybe<TenantDemoSettings>;
  homePageStatsDashboard?: Maybe<Scalars['String']>;
  homepageDashboardID?: Maybe<Scalars['String']>;
  isAutoApprovalDisabled?: Maybe<Scalars['Boolean']>;
  maxLookbackDate: Scalars['Int'];
  showUnTranslatedRecords?: Maybe<Scalars['Boolean']>;
  ssoSettings?: Maybe<TenantSsoSettings>;
};

export type TenantDashboardSettingsInput = {
  DefaultAggregationWindowUnit: TimeUnit;
  DefaultLookbackWindowInDays: Scalars['Int'];
  MaxLookbackDate: Scalars['Int'];
  defaultLookbackWindowInMonths: Scalars['Int'];
  isAutoApprovalDisabled?: InputMaybe<Scalars['Boolean']>;
  showUnTranslatedRecords?: InputMaybe<Scalars['Boolean']>;
};

export type TenantDemoSettings = {
  __typename?: 'TenantDemoSettings';
  demoExpiryTimestamp?: Maybe<Scalars['Int']>;
  infoPageURL?: Maybe<Scalars['String']>;
  isDemo?: Maybe<Scalars['Boolean']>;
};

export type TenantOption = {
  __typename?: 'TenantOption';
  avatarURL?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  slug: Scalars['String'];
  tenantCategory?: Maybe<Scalars['String']>;
};

export type TenantSsoSettings = {
  __typename?: 'TenantSsoSettings';
  authSecret?: Maybe<Scalars['String']>;
  isEnabled: Scalars['Boolean'];
  isEnforced: Scalars['Boolean'];
};

export enum TenantState {
  Active = 'ACTIVE',
  AllIntegrationsAdded = 'ALL_INTEGRATIONS_ADDED',
  Audit = 'AUDIT',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Onboarding = 'ONBOARDING',
  SetupInprogress = 'SETUP_INPROGRESS'
}

export enum TenantTier {
  Basic = 'BASIC',
  Freemium = 'FREEMIUM',
  Premium = 'PREMIUM'
}

export type TestAnomalyAlertInput = {
  anomalyFunction: Scalars['String'];
  channels: Array<Scalars['String']>;
  data: DataInput;
  ruleID: Scalars['ID'];
  ruleVersion?: InputMaybe<Scalars['Int']>;
  schedule: TimeUnit;
  tenantID: Scalars['ID'];
  thresholds: Array<ThresholdInput>;
  valueFunctions: Array<Scalars['String']>;
};

export type TestAnomalyAlertResponse = {
  __typename?: 'TestAnomalyAlertResponse';
  tested: Scalars['Boolean'];
};

export type TestAnomalyRuleInput = {
  anomalyFunction: Scalars['String'];
  data: DataInput;
  limit?: InputMaybe<Scalars['Int']>;
  ruleID?: InputMaybe<Scalars['ID']>;
  ruleVersion?: InputMaybe<Scalars['Int']>;
  tenantID: Scalars['ID'];
  thresholds: Array<ThresholdInput>;
  valueFunctions: Array<Scalars['String']>;
};

export type TestAnomalyRuleResponse = {
  __typename?: 'TestAnomalyRuleResponse';
  anomalies: Array<Anomaly>;
};

export type TestReportInput = {
  outbounds: Array<Scalars['ID']>;
  reportType: ReportingType;
  subjectID: Scalars['ID'];
  subjectType: SubjectType;
  tenantID: Scalars['ID'];
};

export type TestReportResponse = {
  __typename?: 'TestReportResponse';
  reportTriggered: Scalars['Boolean'];
};

export type TextWidget = {
  __typename?: 'TextWidget';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type TextWidgetInput = {
  text: Scalars['String'];
};

export type Thread = {
  __typename?: 'Thread';
  records: Array<ThreadRecord>;
  sourceID: Source;
};

export type ThreadRecord = {
  __typename?: 'ThreadRecord';
  record: Record;
  relatedTo?: Maybe<Scalars['ID']>;
  relationType?: Maybe<RelationType>;
};

export type Threshold = {
  __typename?: 'Threshold';
  level: AnomalyLevel;
  score?: Maybe<ThresholdValue>;
  volume?: Maybe<ThresholdValue>;
  volumeThreshold?: Maybe<VolumeThreshold>;
};

export type ThresholdInput = {
  level: AnomalyLevel;
  score?: InputMaybe<ThresholdValueInput>;
  volume?: InputMaybe<ThresholdValueInput>;
  volumeThreshold?: InputMaybe<VolumeThresholdInput>;
};

export type ThresholdValue = {
  __typename?: 'ThresholdValue';
  lowerBound?: Maybe<Scalars['Float']>;
  upperBound?: Maybe<Scalars['Float']>;
};

export type ThresholdValueInput = {
  lowerBound?: InputMaybe<Scalars['Float']>;
  upperBound?: InputMaybe<Scalars['Float']>;
};

export type TimePeriod = {
  __typename?: 'TimePeriod';
  unit: TimeUnit;
  value: Scalars['Int'];
};

export type TimePeriodInput = {
  unit: TimeUnit;
  value: Scalars['Int'];
};

export type TimeRange = {
  endBefore?: InputMaybe<Scalars['Int']>;
  relative?: InputMaybe<RelativeTimeRange>;
  startAfter?: InputMaybe<Scalars['Int']>;
};

export type TimeRangeFilter = {
  endTime: Scalars['Int'];
  startTime: Scalars['Int'];
};

export type TimeRangeResponse = {
  __typename?: 'TimeRangeResponse';
  endBefore?: Maybe<Scalars['Int']>;
  relative?: Maybe<RelativeTimeRangeResponse>;
  startAfter?: Maybe<Scalars['Int']>;
};

export enum TimeUnit {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Second = 'Second',
  Week = 'Week',
  Year = 'Year'
}

export type Timezone = {
  ianaID?: InputMaybe<Scalars['String']>;
  iso8601Offset?: InputMaybe<Scalars['String']>;
};

export type TriggerLabelManipulationInput = {
  backfillStrategy: BackfillStrategy;
  create?: InputMaybe<CreateLabelInput>;
  delete?: InputMaybe<DeleteLabelsInput>;
  labelType: LabelType;
  merge?: InputMaybe<MergeLabelsInput>;
  taxonomyID: Scalars['ID'];
  taxonomyVersion: Scalars['Int'];
  tenantID: Scalars['ID'];
  update?: InputMaybe<UpdateLabelInput>;
  userID: Scalars['ID'];
};

export type TriggerLabelManipulationResponse = {
  __typename?: 'TriggerLabelManipulationResponse';
  workflowID: Scalars['ID'];
};

export type TwitterData = SourceData & {
  __typename?: 'TwitterData';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  likes?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  quotes?: Maybe<Scalars['Int']>;
  replies?: Maybe<Scalars['Int']>;
  retweets?: Maybe<Scalars['Int']>;
  timezone?: Maybe<Scalars['String']>;
};

export type TwitterIntegrationData = {
  __typename?: 'TwitterIntegrationData';
  TwitterHandle: Scalars['String'];
};

export type TwitterIntegrationInputData = {
  twitterHandle: Scalars['String'];
};

export type TypeMetadata = {
  __typename?: 'TypeMetadata';
  defaultDataType: FileUploadFieldType;
  supportedDateFormats?: Maybe<Array<Scalars['String']>>;
};

export type TypeformData = SourceData & {
  __typename?: 'TypeformData';
  Browser?: Maybe<Scalars['String']>;
  NetworkID?: Maybe<Scalars['String']>;
  Platform?: Maybe<Scalars['String']>;
  Referer?: Maybe<Scalars['String']>;
  UserAgent?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

export type TypeformEditFormData = {
  __typename?: 'TypeformEditFormData';
  forms: Array<TypeformForm>;
};

export type TypeformForm = {
  __typename?: 'TypeformForm';
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TypeformFormData = IntegrationFormData & {
  __typename?: 'TypeformFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type TypeformFormInput = {
  id: Scalars['String'];
  title: Scalars['String'];
};

export type TypeformInputData = {
  authCode: Scalars['String'];
  redirectURI: Scalars['String'];
};

export type TypeformIntegrationData = {
  __typename?: 'TypeformIntegrationData';
  accessToken: Scalars['String'];
  includedFormIDs?: Maybe<Array<Scalars['String']>>;
  includedForms?: Maybe<Array<TypeformForm>>;
};

export type TypeformUpdateIntegrationData = {
  includedFormIDs?: InputMaybe<Array<Scalars['String']>>;
  includedForms?: InputMaybe<Array<TypeformFormInput>>;
};

export type UnassignedRc = {
  __typename?: 'UnassignedRC';
  category?: Maybe<Category>;
  id?: Maybe<Scalars['ID']>;
  isSelected?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recordIDs: Array<Scalars['ID']>;
};

export type UnassignedRcInput = {
  category?: InputMaybe<Category>;
  id?: InputMaybe<Scalars['ID']>;
  isSelected?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  recordIDs: Array<Scalars['ID']>;
};

export type UnifiedField = {
  __typename?: 'UnifiedField';
  eqlField: EqlField;
  values: Array<EqlFieldValue>;
};

export type UpdateAnalysisInput = {
  context?: InputMaybe<AnalysisContextInput>;
  createdBy?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
  editToken: Scalars['String'];
  id: Scalars['ID'];
  isReportingDisabled?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['String']>;
  metadataV2?: InputMaybe<AnalysisMetadataInput>;
  panels?: InputMaybe<Array<AnalysisPanelInput>>;
  scope?: InputMaybe<Scope>;
  status?: InputMaybe<Status>;
  tenantID: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  useCase?: InputMaybe<AnalysisUseCase>;
};

export type UpdateAnalysisResponse = {
  __typename?: 'UpdateAnalysisResponse';
  updated: Scalars['Boolean'];
};

export type UpdateAspectMetadataInput = {
  phrases?: InputMaybe<Array<Scalars['String']>>;
  themes?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateChatInput = {
  editToken: Scalars['ID'];
  status?: InputMaybe<Status>;
  tenantID: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  userID: Scalars['ID'];
};

export type UpdateChatResponse = {
  __typename?: 'UpdateChatResponse';
  chat: Chat;
};

export type UpdateDashboardInput = {
  addAnalysisIDs?: InputMaybe<Array<Scalars['String']>>;
  addWidget?: InputMaybe<CreateDashboardWidgetInput>;
  analysisIDs?: InputMaybe<Array<Scalars['String']>>;
  analysisWidgetSelection?: InputMaybe<Array<MapStrToStrListTupleInput>>;
  createdBy?: InputMaybe<Scalars['ID']>;
  deleteWidget?: InputMaybe<DeleteDashboardWidgetInput>;
  description?: InputMaybe<Scalars['String']>;
  editToken: Scalars['String'];
  editorsToAdd?: InputMaybe<Array<Scalars['ID']>>;
  editorsToInvite?: InputMaybe<Array<Scalars['String']>>;
  editorsToRemove?: InputMaybe<Array<Scalars['ID']>>;
  filterClause?: InputMaybe<FilterClauseInput>;
  id: Scalars['ID'];
  isReportingDisabled?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<Scalars['String']>;
  metadataV2?: InputMaybe<DashboardMetadataInput>;
  removeAnalysisIDs?: InputMaybe<Array<Scalars['String']>>;
  scope?: InputMaybe<Scope>;
  shortMetadata?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Status>;
  tenantID: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  updateWidget?: InputMaybe<UpdateDashboardWidgetInput>;
  useCase?: InputMaybe<DashboardUseCase>;
  userID?: InputMaybe<Scalars['ID']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type UpdateDashboardResponse = {
  __typename?: 'UpdateDashboardResponse';
  dashboard?: Maybe<Dashboard>;
  updated: Scalars['Boolean'];
};

export type UpdateDashboardWidgetInput = {
  id: Scalars['ID'];
  imageWidget?: InputMaybe<ImageWidgetInput>;
  textWidget?: InputMaybe<TextWidgetInput>;
  videoWidget?: InputMaybe<VideoWidgetInput>;
};

export type UpdateFieldInput = {
  id: Scalars['ID'];
  isDisabled: Scalars['Boolean'];
  tenantID: Scalars['ID'];
};

export type UpdateFieldRelationsInput = {
  add?: InputMaybe<Array<FieldRelationInput>>;
  remove?: InputMaybe<Array<FieldRelationInput>>;
  tenantID: Scalars['ID'];
};

export type UpdateFieldRelationsResponse = {
  __typename?: 'UpdateFieldRelationsResponse';
  updated: Scalars['Boolean'];
};

export type UpdateFieldResponse = {
  __typename?: 'UpdateFieldResponse';
  updated: Scalars['Boolean'];
};

export type UpdateIntegrationCustomFieldsInput = {
  customFields: Array<CustomField>;
  integrationID: Scalars['ID'];
};

export type UpdateIntegrationCustomFieldsResponse = {
  __typename?: 'UpdateIntegrationCustomFieldsResponse';
  updated: Scalars['Boolean'];
};

export type UpdateIntegrationData = {
  appstore?: InputMaybe<AppstoreUpdateIntegrationData>;
  discord?: InputMaybe<DiscordUpdateIntegrationData>;
  email?: InputMaybe<EmailUpdateIntegrationData>;
  facebookPages?: InputMaybe<FacebookPagesUpdateIntegrationData>;
  feedbackMetadataEnrichment?: InputMaybe<FeedbackMetadataEnrichmentUpdateIntegrationData>;
  gainsight?: InputMaybe<GainsightUpdateIntegrationData>;
  googleMyBusiness?: InputMaybe<GoogleMyBusinessUpdateIntegrationData>;
  playstore?: InputMaybe<PlaystoreUpdateIntegrationData>;
  qualtrics?: InputMaybe<QualtricsUpdateIntegrationData>;
  reddit?: InputMaybe<RedditUpdateIntegrationData>;
  salesforce?: InputMaybe<SalesforceUpdateIntegrationData>;
  slack?: InputMaybe<SlackUpdateIntegrationData>;
  sprig?: InputMaybe<SprigUpdateIntegrationData>;
  surveyMonkey?: InputMaybe<SurveyMonkeyUpdateIntegrationData>;
  typeform?: InputMaybe<TypeformUpdateIntegrationData>;
};

export type UpdateIntegrationInput = {
  disableIntegration?: InputMaybe<Scalars['Boolean']>;
  externalLinkKey?: InputMaybe<Scalars['String']>;
  integrationID: Scalars['ID'];
  isActive?: InputMaybe<Scalars['Boolean']>;
  updateData?: InputMaybe<UpdateIntegrationData>;
  updateDescription?: InputMaybe<IntegrationDescriptionInput>;
};

export type UpdateIntegrationResponse = {
  __typename?: 'UpdateIntegrationResponse';
  updated: Scalars['Boolean'];
};

export type UpdateKeywordInput = {
  addAssociatedReasons?: InputMaybe<Array<Scalars['String']>>;
  backfillPeriod?: InputMaybe<TimeRange>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  excludedPhrases?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  path?: InputMaybe<TaxonomyT3Path>;
  phrases?: InputMaybe<Array<Scalars['String']>>;
  removeAssociatedReasons?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type UpdateKeywordResponse = {
  __typename?: 'UpdateKeywordResponse';
  taxonomyID?: Maybe<Scalars['ID']>;
  taxonomyVersion?: Maybe<Scalars['Int']>;
};

export type UpdateL1Input = {
  addAssociatedKeywords?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  removeAssociatedKeywords?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type UpdateL1Response = {
  __typename?: 'UpdateL1Response';
  taxonomyID?: Maybe<Scalars['ID']>;
  taxonomyVersion?: Maybe<Scalars['Int']>;
};

export type UpdateLabelInput = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<UpdateLabelMetadataInput>;
};

export type UpdateLabelMetadataInput = {
  aspect?: InputMaybe<UpdateAspectMetadataInput>;
  reason?: InputMaybe<UpdateReasonMetadataInput>;
};

export type UpdateLabelMetadataRequest = {
  reason?: InputMaybe<UpdateReasonMetadataRequest>;
};

export type UpdateLabelRequest = {
  IsVisible?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  metadata?: InputMaybe<UpdateLabelMetadataRequest>;
  tenantID: Scalars['ID'];
};

export type UpdateLabelResponse = {
  __typename?: 'UpdateLabelResponse';
  updated: Scalars['Boolean'];
};

export type UpdateLevelRequest = {
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type UpdateLevelResponse = {
  __typename?: 'UpdateLevelResponse';
  updated: Scalars['Boolean'];
};

export type UpdateManagedMetadataRequest = {
  description?: InputMaybe<Scalars['String']>;
  displayText?: InputMaybe<Scalars['String']>;
  isFilterable?: InputMaybe<Scalars['Boolean']>;
  isGroupable?: InputMaybe<Scalars['Boolean']>;
  isHidden?: InputMaybe<Scalars['Boolean']>;
  isImportant?: InputMaybe<Scalars['Boolean']>;
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
  referencedKeys?: InputMaybe<Array<Scalars['String']>>;
  source?: InputMaybe<Source>;
  tenantID: Scalars['ID'];
  type?: InputMaybe<MetadataDataType>;
};

export type UpdateManagedMetadataResponse = {
  __typename?: 'UpdateManagedMetadataResponse';
  updated: Scalars['Boolean'];
};

export type UpdateMetadataDetailsInput = {
  fieldMappings?: InputMaybe<Array<FieldResolverInput>>;
  integrationID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type UpdateMetadataDetailsResponse = {
  __typename?: 'UpdateMetadataDetailsResponse';
  updated: Scalars['Boolean'];
};

export type UpdateNotificationSettingsInput = {
  tenantID: Scalars['ID'];
  updates?: InputMaybe<Array<NotificationStatusUpdate>>;
  userID: Scalars['ID'];
};

export type UpdateNotificationSettingsResponse = {
  __typename?: 'UpdateNotificationSettingsResponse';
  updated: Scalars['Boolean'];
};

export type UpdateNotificationsInput = {
  notificationIDs?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateNotificationsResponse = {
  __typename?: 'UpdateNotificationsResponse';
  updated: Scalars['Boolean'];
};

export type UpdateReasonInput = {
  addAssociatedKeywords?: InputMaybe<Array<Scalars['String']>>;
  addReasonCandidates?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Category>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  path?: InputMaybe<TaxonomyT3Path>;
  removeAssociatedKeywords?: InputMaybe<Array<Scalars['String']>>;
  removeReasonCandidates?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type UpdateReasonMetadataInput = {
  category?: InputMaybe<Category>;
  entities?: InputMaybe<Array<Scalars['String']>>;
  representativeSentences?: InputMaybe<Array<Scalars['String']>>;
  sentiment?: InputMaybe<SentimentType>;
};

export type UpdateReasonMetadataRequest = {
  category?: InputMaybe<Category>;
};

export type UpdateReasonResponse = {
  __typename?: 'UpdateReasonResponse';
  taxonomyID?: Maybe<Scalars['ID']>;
  taxonomyVersion?: Maybe<Scalars['Int']>;
};

export type UpdateRecordFlagsInput = {
  addFlags?: InputMaybe<Array<RecordFlag>>;
  justification?: InputMaybe<Scalars['String']>;
  recordID: Scalars['ID'];
  removeFlags?: InputMaybe<Array<RecordFlag>>;
  tenantID: Scalars['ID'];
};

export type UpdateRecordFlagsResponse = {
  __typename?: 'UpdateRecordFlagsResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateRuleInput = {
  actions?: InputMaybe<ActionsInput>;
  anomalyFunction?: InputMaybe<Scalars['String']>;
  data?: InputMaybe<DataInput>;
  discoverability?: InputMaybe<Scope>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<TimeUnit>;
  tenantID: Scalars['ID'];
  thresholds?: InputMaybe<Array<ThresholdInput>>;
  valueFunctions?: InputMaybe<Array<Scalars['String']>>;
  version?: InputMaybe<Scalars['Int']>;
};

export type UpdateRuleResponse = {
  __typename?: 'UpdateRuleResponse';
  updated: Scalars['Boolean'];
};

export type UpdateScheduleInput = {
  cron?: InputMaybe<CronInput>;
  id: Scalars['ID'];
  isDisabled?: InputMaybe<Scalars['Boolean']>;
  metadata?: InputMaybe<ScheduleMetadataInput>;
  outbounds?: InputMaybe<Array<Scalars['String']>>;
  tenantID: Scalars['ID'];
};

export type UpdateScheduleResponse = {
  __typename?: 'UpdateScheduleResponse';
  updated: Scalars['Boolean'];
};

export type UpdateSuggestionStatusInput = {
  id: Scalars['ID'];
  status: SuggestionResolutionStatus;
  tenantID: Scalars['ID'];
  updatedSuggestion: UpdatedSuggestionInput;
};

export type UpdateSuggestionStatusResponse = {
  __typename?: 'UpdateSuggestionStatusResponse';
  updated: Scalars['Boolean'];
};

export type UpdateSummaryFlagInput = {
  addFlag?: InputMaybe<SummaryFlag>;
  justification?: InputMaybe<Scalars['String']>;
  keywordSummaryLocation?: InputMaybe<KeywordSummaryLocationInput>;
  recordID: Scalars['ID'];
  removeFlag?: InputMaybe<SummaryFlag>;
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
};

export type UpdateSummaryFlagResponse = {
  __typename?: 'UpdateSummaryFlagResponse';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateTagInput = {
  conditionExpression?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isVisible?: InputMaybe<Scalars['Boolean']>;
  tenantID: Scalars['ID'];
};

export type UpdateTagResponse = {
  __typename?: 'UpdateTagResponse';
  updated: Scalars['Boolean'];
};

export type UpdateTaxonomyEdgesRequest = {
  edgesToAdd?: InputMaybe<Array<TaxonomyEdgeInput>>;
  edgesToRemove?: InputMaybe<Array<TaxonomyEdgeInput>>;
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type UpdateTaxonomyEdgesRequestV2 = {
  edgesToAdd?: InputMaybe<Array<TaxonomyEdgeInput>>;
  edgesToRemove?: InputMaybe<Array<TaxonomyEdgeInput>>;
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  version: Scalars['Int'];
};

export type UpdateTaxonomyEdgesResponse = {
  __typename?: 'UpdateTaxonomyEdgesResponse';
  updated: Scalars['Boolean'];
};

export type UpdateTenantBackfillSettingsInput = {
  duration: RelativeTimeRange;
  tenantID: Scalars['ID'];
};

export type UpdateTenantDashboardSettingsInput = {
  DefaultAggregationWindowUnit?: InputMaybe<TimeUnit>;
  DefaultLookbackWindowInDays?: InputMaybe<Scalars['Int']>;
  MaxLookbackDate?: InputMaybe<Scalars['Int']>;
  defaultLookbackWindowInMonths?: InputMaybe<Scalars['Int']>;
  defaultUserType?: InputMaybe<UserType>;
  homepageDashboardID?: InputMaybe<Scalars['String']>;
  isAutoApprovalDisabled?: InputMaybe<Scalars['Boolean']>;
  showUnTranslatedRecords?: InputMaybe<Scalars['Boolean']>;
  updateTenantBackfillSettingsInput?: InputMaybe<UpdateTenantBackfillSettingsInput>;
};

export type UpdateTenantInput = {
  avatarURL?: InputMaybe<Scalars['String']>;
  dashboardSettings?: InputMaybe<UpdateTenantDashboardSettingsInput>;
  domains?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pinnedDashboardIDs?: InputMaybe<Array<Scalars['ID']>>;
  state?: InputMaybe<TenantState>;
  tier?: InputMaybe<TenantTier>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UpdateTenantResponse = MutationResponse & {
  __typename?: 'UpdateTenantResponse';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type UpdateTenantSsoInput = {
  isEnforced?: InputMaybe<Scalars['Boolean']>;
  oidc?: InputMaybe<OidcSsoSettingsInput>;
  saml?: InputMaybe<SamlSsoSettingsInput>;
  tenantID: Scalars['ID'];
};

export type UpdateTenantSsoResponse = {
  __typename?: 'UpdateTenantSsoResponse';
  success: Scalars['Boolean'];
};

export type UpdateUserInput = {
  addPinnedDashboardIDs?: InputMaybe<Array<Scalars['ID']>>;
  customRole?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  homepageDashboardID?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  interests?: InputMaybe<UserInterestsInput>;
  lastName?: InputMaybe<Scalars['String']>;
  removeHomepageDashboardID?: InputMaybe<Scalars['Boolean']>;
  removePinnedDashboardIDs?: InputMaybe<Array<Scalars['ID']>>;
  role?: InputMaybe<UserRole>;
  state?: InputMaybe<UserState>;
  tenantID: Scalars['ID'];
  type?: InputMaybe<UserType>;
  userProfile?: InputMaybe<UserProfileInput>;
};

export type UpdateUserResponse = MutationResponse & {
  __typename?: 'UpdateUserResponse';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type UpdatedSuggestionInput = {
  reasonMerge?: InputMaybe<ReasonMergeUpdatedSuggestion>;
};

export type UploadCohortFileRequest = {
  cohortID: Scalars['String'];
  fileCSVData: Scalars['String'];
  idHeader: Scalars['String'];
  joinFieldKey: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type UploadCohortFileResponse = {
  __typename?: 'UploadCohortFileResponse';
  uploaded: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  Tenant: Tenant;
  createdAt: Scalars['Int'];
  customRole?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  homepageDashboardID?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  intercomUserHash?: Maybe<Scalars['String']>;
  interests?: Maybe<UserInterests>;
  lastName?: Maybe<Scalars['String']>;
  notificationChannels?: Maybe<Array<Integration>>;
  permissions?: Maybe<Array<UserPermission>>;
  pinnedDashboards?: Maybe<Array<DashboardListItem>>;
  role?: Maybe<UserRole>;
  state?: Maybe<UserState>;
  type: UserType;
  userProfile?: Maybe<UserProfile>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type UserInterests = {
  __typename?: 'UserInterests';
  keywords?: Maybe<Array<Scalars['String']>>;
  labelIDs?: Maybe<Array<Scalars['String']>>;
};

export type UserInterestsInput = {
  keywords?: InputMaybe<Array<Scalars['String']>>;
  labelIDs?: InputMaybe<Array<Scalars['String']>>;
};

export type UserPermission = {
  __typename?: 'UserPermission';
  operation: PermissionOperation;
  resource: PermissionResource;
};

export type UserProfile = {
  __typename?: 'UserProfile';
  customRole?: Maybe<Scalars['String']>;
  role: UserRole;
  workDescription: Scalars['String'];
};

export type UserProfileInput = {
  customRole?: InputMaybe<Scalars['String']>;
  role: UserRole;
  workDescription: Scalars['String'];
};

export type UserQuoteContextInput = {
  claim?: InputMaybe<Scalars['String']>;
  eqlContext?: InputMaybe<EqlContextInput>;
  labelContext?: InputMaybe<LabelContextInput>;
};

export enum UserRole {
  CustomerSuccess = 'CUSTOMER_SUCCESS',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  Engineering = 'ENGINEERING',
  Founder = 'FOUNDER',
  Marketing = 'MARKETING',
  Other = 'OTHER',
  ProductManagement = 'PRODUCT_MANAGEMENT',
  ProductOperation = 'PRODUCT_OPERATION',
  Sales = 'SALES',
  UserResearch = 'USER_RESEARCH',
  UxResearch = 'UX_RESEARCH'
}

export enum UserState {
  Active = 'ACTIVE',
  Invalid = 'INVALID',
  Suspended = 'SUSPENDED',
  Unapproved = 'UNAPPROVED'
}

export enum UserType {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Manager = 'MANAGER',
  Member = 'MEMBER',
  SuperAdmin = 'SUPER_ADMIN',
  SuperEditor = 'SUPER_EDITOR',
  SuperManager = 'SUPER_MANAGER',
  SuperMember = 'SUPER_MEMBER',
  SuperViewer = 'SUPER_VIEWER',
  Viewer = 'VIEWER'
}

export type UserTypeWithPermissions = {
  __typename?: 'UserTypeWithPermissions';
  permissions?: Maybe<Array<UserPermission>>;
  type: UserType;
};

export type ValidForQuestion = {
  __typename?: 'ValidForQuestion';
  isValid: Scalars['Boolean'];
  question: QuestionType;
};

export type ValidateDescriptionInput = {
  description: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type ValidateDescriptionResponse = {
  __typename?: 'ValidateDescriptionResponse';
  message?: Maybe<Scalars['String']>;
  validForQuestions: Array<ValidForQuestion>;
};

export type ValidateFeedbackFieldNameInput = {
  name: Scalars['String'];
  tenantID: Scalars['ID'];
};

export type ValidateFeedbackFieldNameResponse = {
  __typename?: 'ValidateFeedbackFieldNameResponse';
  isValid: Scalars['Boolean'];
  suggestedName?: Maybe<Scalars['String']>;
};

export type ValidateFileUploadInput = {
  integrationID: Scalars['ID'];
  tenantID: Scalars['ID'];
  url: Scalars['String'];
};

export type ValidateFileUploadResponse = {
  __typename?: 'ValidateFileUploadResponse';
  errorFileUrl?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValidateFileUploadV2Input = {
  integrationID: Scalars['ID'];
  tenantID: Scalars['ID'];
  url: Scalars['String'];
};

export type ValidateFileUploadV2Response = {
  __typename?: 'ValidateFileUploadV2Response';
  errorFileUrl?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
};

export type ValidatePhraseInRecordInput = {
  labelID?: InputMaybe<Scalars['ID']>;
  phrase: Scalars['String'];
  recordID: Scalars['ID'];
  tenantID: Scalars['ID'];
};

export type ValidatePhraseInRecordResponse = {
  __typename?: 'ValidatePhraseInRecordResponse';
  entityLocations?: Maybe<Array<AspectPredictionMetadataUnit>>;
  isPhraseValid: Scalars['Boolean'];
};

export type Value = {
  __typename?: 'Value';
  B?: Maybe<Scalars['Boolean']>;
  N?: Maybe<Scalars['Float']>;
  S?: Maybe<Scalars['String']>;
};

export type ValueInput = {
  B?: InputMaybe<Scalars['Boolean']>;
  N?: InputMaybe<Scalars['Float']>;
  S?: InputMaybe<Scalars['String']>;
};

export type ValueRage = {
  __typename?: 'ValueRage';
  end: Scalars['Int'];
  start: Scalars['Int'];
};

export type VideoWidget = {
  __typename?: 'VideoWidget';
  id: Scalars['ID'];
  url: Scalars['String'];
};

export type VideoWidgetInput = {
  url: Scalars['String'];
};

export type VolumeThreshold = {
  __typename?: 'VolumeThreshold';
  volume?: Maybe<ThresholdValue>;
  volumeByTotalFeedback?: Maybe<ThresholdValue>;
};

export type VolumeThresholdInput = {
  volume?: InputMaybe<ThresholdValueInput>;
  volumeByTotalFeedback?: InputMaybe<ThresholdValueInput>;
};

export type WebSocketError = {
  __typename?: 'WebSocketError';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type WebSocketMessage = {
  __typename?: 'WebSocketMessage';
  assistantResponse?: Maybe<AssistantResponsePart>;
  createSession?: Maybe<CreateWebSocketSessionResponse>;
  endOfResponse?: Maybe<Scalars['Boolean']>;
  error?: Maybe<WebSocketError>;
  feedbackSummary?: Maybe<FeedbackSummaryMessage>;
  isHealthCheckOK?: Maybe<Scalars['Boolean']>;
  isSessionResumed?: Maybe<Scalars['Boolean']>;
  requestID?: Maybe<Scalars['ID']>;
  responseID: Scalars['ID'];
  sessionID: Scalars['ID'];
};

export type WebSocketRequest = {
  __typename?: 'WebSocketRequest';
  authToken: Scalars['String'];
  createSession?: Maybe<CreateWebSocketSessionRequest>;
  healthCheck?: Maybe<Scalars['Boolean']>;
  requestID?: Maybe<Scalars['ID']>;
  resumeSession?: Maybe<ResumeWebSocketSessionRequest>;
  slug?: Maybe<Scalars['String']>;
};

export type WebhookIntegrationData = {
  __typename?: 'WebhookIntegrationData';
  apiKey: Scalars['String'];
  displayName: Scalars['String'];
};

export type WebhookIntegrationInputData = {
  displayName: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type ZendeskChatData = SourceData & {
  __typename?: 'ZendeskChatData';
  browser?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerID?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oS?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['String']>;
  tagsList?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
  userAgent?: Maybe<Scalars['String']>;
  webpaths?: Maybe<Array<Scalars['String']>>;
};

export type ZendeskChatFormData = IntegrationFormData & {
  __typename?: 'ZendeskChatFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type ZendeskChatIntegrationData = {
  __typename?: 'ZendeskChatIntegrationData';
  accessToken: Scalars['String'];
  subDomain: Scalars['String'];
};

export type ZendeskChatIntegrationDataInput = {
  accessToken: Scalars['String'];
  subDomain: Scalars['String'];
};

export type ZendeskSupportData = SourceData & {
  __typename?: 'ZendeskSupportData';
  channel?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customFields?: Maybe<Array<MapStrToStrTuple>>;
  customerID?: Maybe<Scalars['String']>;
  externalLink?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  satisfactionRating?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  timezone?: Maybe<Scalars['String']>;
};

export type ZendeskSupportFormData = IntegrationFormData & {
  __typename?: 'ZendeskSupportFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
};

export type ZendeskSupportIntegrationData = {
  __typename?: 'ZendeskSupportIntegrationData';
  bearerToken: Scalars['String'];
  subDomain: Scalars['String'];
};

export type ZendeskSupportIntegrationDataInput = {
  authCode: Scalars['String'];
  redirectURI: Scalars['String'];
  subDomain: Scalars['String'];
};

export type ZohoDeskData = SourceData & {
  __typename?: 'ZohoDeskData';
  accountID?: Maybe<Scalars['String']>;
  channel?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Int']>;
  customerEmail?: Maybe<Scalars['String']>;
  customerID?: Maybe<Scalars['String']>;
  customerName?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  ticketNumber?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type ZohoDeskFormData = IntegrationFormData & {
  __typename?: 'ZohoDeskFormData';
  channel: IntegrationChannel;
  direction: IntegrationDirection;
  integrationType: IntegrationType;
  isContextual?: Maybe<Scalars['Boolean']>;
  oAuthURL: Scalars['String'];
};

export type ZohoDeskIntegrationData = {
  __typename?: 'ZohoDeskIntegrationData';
  accessToken: Scalars['String'];
  topLevelDomain: Scalars['String'];
};

export type ZohoDeskIntegrationInputData = {
  accountsServer: Scalars['String'];
  authCode: Scalars['String'];
  redirectURI: Scalars['String'];
  topLevelDomain: Scalars['String'];
};

export type MapIdToStringInput = {
  rc?: InputMaybe<Scalars['String']>;
  recordID: Scalars['ID'];
};

export type MapStrToBoolTuple = {
  __typename?: 'mapStrToBoolTuple';
  key: Scalars['String'];
  value: Scalars['Boolean'];
};

export type MapStrToBoolTupleInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type MapStrToFloatTuple = {
  __typename?: 'mapStrToFloatTuple';
  key: Scalars['String'];
  value: Scalars['Float'];
};

export type MapStrToStrListTuple = {
  __typename?: 'mapStrToStrListTuple';
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type MapStrToStrListTupleInput = {
  key: Scalars['String'];
  value: Array<Scalars['String']>;
};

export type MapStrToStrTuple = {
  __typename?: 'mapStrToStrTuple';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type MapStrToStrTupleInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole>;
  interests?: InputMaybe<UserInterestsInput>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'CreateUserResponse', code: string, message: string, id: string } | undefined };

export type CreateIntegrationMutationVariables = Exact<{
  tenantID: Scalars['ID'];
  direction: IntegrationDirection;
  channel: IntegrationChannelType;
  createdByUser: Scalars['String'];
  data: IntegrationInputData;
  integrationType: IntegrationType;
  integrationDescription?: InputMaybe<IntegrationDescriptionInput>;
  externalLinkKey?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', createIntegration?: { __typename?: 'CreateIntegrationResponse', id: string } | undefined };

export type CreateAnalysisMutationVariables = Exact<{
  tenantID: Scalars['ID'];
  title: Scalars['String'];
  panels: Array<AnalysisPanelInput> | AnalysisPanelInput;
  scope?: InputMaybe<Scope>;
  metadata: Scalars['String'];
  metadataV2?: InputMaybe<AnalysisMetadataInput>;
  createdBy: Scalars['ID'];
  analysisExpresssion: Scalars['String'];
  useCase?: InputMaybe<AnalysisUseCase>;
  dashboardToAddTo?: InputMaybe<AddAnalysisToDashboardInput>;
  addToNewDashboard?: InputMaybe<CreateDashboardInput>;
  addToDuplicateOfDashboard?: InputMaybe<DuplicateDashboardInput>;
  description?: InputMaybe<Scalars['String']>;
  prompt?: InputMaybe<Scalars['String']>;
  eql?: InputMaybe<EqlQueryInput>;
}>;


export type CreateAnalysisMutation = { __typename?: 'Mutation', createAnalysis?: { __typename?: 'CreateAnalysisResponse', id: string, viewToken: string, editToken: string, createDashboardResponse?: { __typename?: 'CreateDashboardResponse', id: string, viewToken: string, editToken: string, dashboard: { __typename?: 'Dashboard', version: number } } | undefined, duplicateDashboardResponse?: { __typename?: 'DuplicateDashboardResponse', dashboard: { __typename?: 'Dashboard', id: string, tenantID: string, title: string, description: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase?: DashboardUseCase | undefined, metadata: string, shortMetadata: string, createdAt: number, updatedAt: number, isReportingDisabled: boolean, status: Status, version: number, widgets?: Array<{ __typename?: 'DashboardWidget', id: string, analysis?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined, textWidget?: { __typename?: 'TextWidget', id: string, text: string } | undefined }> | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined, originDashboard?: { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined, editors?: Array<{ __typename?: 'UserInfo', id: string, firstName: string, lastName: string }> | undefined, filterClause?: { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined } | undefined, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } } | undefined } | undefined };

export type UpdateAnalysisMutationVariables = Exact<{
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  panels?: InputMaybe<Array<AnalysisPanelInput> | AnalysisPanelInput>;
  scope?: InputMaybe<Scope>;
  metadata?: InputMaybe<Scalars['String']>;
  metadataV2?: InputMaybe<AnalysisMetadataInput>;
  context?: InputMaybe<AnalysisContextInput>;
  editToken: Scalars['String'];
  isReportingDisabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Status>;
  createdBy?: InputMaybe<Scalars['ID']>;
  useCase?: InputMaybe<AnalysisUseCase>;
  description?: InputMaybe<Scalars['String']>;
}>;


export type UpdateAnalysisMutation = { __typename?: 'Mutation', updateAnalysis?: { __typename?: 'UpdateAnalysisResponse', updated: boolean } | undefined };

export type DeleteAnalysisMutationVariables = Exact<{
  request: DeleteAnalysisInput;
}>;


export type DeleteAnalysisMutation = { __typename?: 'Mutation', deleteAnalysis?: { __typename?: 'DeleteAnalysisResponse', deleted: boolean } | undefined };

export type CreateDashboardMutationVariables = Exact<{
  tenantID: Scalars['String'];
  title: Scalars['String'];
  scope?: InputMaybe<Scope>;
  analysisIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  metadata: Scalars['String'];
  shortMetadata?: InputMaybe<Scalars['String']>;
  createdBy: Scalars['ID'];
  useCase?: InputMaybe<DashboardUseCase>;
  metadataV2?: InputMaybe<DashboardMetadataInput>;
  addWidget?: InputMaybe<CreateDashboardWidgetInput>;
}>;


export type CreateDashboardMutation = { __typename?: 'Mutation', createDashboard?: { __typename?: 'CreateDashboardResponse', id: string, viewToken: string, editToken: string, dashboard: { __typename?: 'Dashboard', id: string, tenantID: string, title: string, description: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase?: DashboardUseCase | undefined, metadata: string, shortMetadata: string, createdAt: number, updatedAt: number, isReportingDisabled: boolean, status: Status, version: number, widgets?: Array<{ __typename?: 'DashboardWidget', id: string, analysis?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined, textWidget?: { __typename?: 'TextWidget', id: string, text: string } | undefined }> | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined, originDashboard?: { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined, editors?: Array<{ __typename?: 'UserInfo', id: string, firstName: string, lastName: string }> | undefined, filterClause?: { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined } | undefined, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } } | undefined };

export type UpdateDashboardMutationVariables = Exact<{
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  analysisIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  scope?: InputMaybe<Scope>;
  metadata?: InputMaybe<Scalars['String']>;
  shortMetadata?: InputMaybe<Scalars['String']>;
  editToken: Scalars['String'];
  isReportingDisabled?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Status>;
  createdBy?: InputMaybe<Scalars['ID']>;
  addAnalysisIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  removeAnalysisIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  editorsToAdd?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  editorsToRemove?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  editorsToInvite?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  useCase?: InputMaybe<DashboardUseCase>;
  filterClause?: InputMaybe<FilterClauseInput>;
  metadataV2?: InputMaybe<DashboardMetadataInput>;
  version: Scalars['Int'];
  addWidget?: InputMaybe<CreateDashboardWidgetInput>;
  updateWidget?: InputMaybe<UpdateDashboardWidgetInput>;
  deleteWidget?: InputMaybe<DeleteDashboardWidgetInput>;
}>;


export type UpdateDashboardMutation = { __typename?: 'Mutation', updateDashboard?: { __typename?: 'UpdateDashboardResponse', updated: boolean, dashboard?: { __typename?: 'Dashboard', id: string, tenantID: string, title: string, description: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase?: DashboardUseCase | undefined, metadata: string, shortMetadata: string, createdAt: number, updatedAt: number, isReportingDisabled: boolean, status: Status, version: number, widgets?: Array<{ __typename?: 'DashboardWidget', id: string, analysis?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined, textWidget?: { __typename?: 'TextWidget', id: string, text: string } | undefined }> | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined, originDashboard?: { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined, editors?: Array<{ __typename?: 'UserInfo', id: string, firstName: string, lastName: string }> | undefined, filterClause?: { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined } | undefined, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined } | undefined };

export type UpdateTenantMutationVariables = Exact<{
  id: Scalars['ID'];
  pinnedDashboardIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type UpdateTenantMutation = { __typename?: 'Mutation', updateTenant?: { __typename?: 'UpdateTenantResponse', code: string, message: string } | undefined };

export type CreateScheduleMutationVariables = Exact<{
  cron: CronInput;
  outbounds: Array<Scalars['String']> | Scalars['String'];
  subjectID: Scalars['ID'];
  subjectType: SubjectType;
  reportType: ReportingType;
  metadata: ScheduleMetadataInput;
  tenantID: Scalars['ID'];
  isPrimary?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateScheduleMutation = { __typename?: 'Mutation', createSchedule?: { __typename?: 'CreateScheduleResponse', id: string } | undefined };

export type UpdateScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
  cron?: InputMaybe<CronInput>;
  metadata?: InputMaybe<ScheduleMetadataInput>;
  outbounds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tenantID: Scalars['ID'];
  isDisabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateScheduleMutation = { __typename?: 'Mutation', updateSchedule?: { __typename?: 'UpdateScheduleResponse', updated: boolean } | undefined };

export type DeleteScheduleMutationVariables = Exact<{
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
}>;


export type DeleteScheduleMutation = { __typename?: 'Mutation', deleteSchedule?: { __typename?: 'DeleteScheduleResponse', deleted: boolean } | undefined };

export type UpdateIntegrationMutationVariables = Exact<{
  integrationID: Scalars['ID'];
  isActive: Scalars['Boolean'];
  updateData?: InputMaybe<UpdateIntegrationData>;
  disableIntegration?: InputMaybe<Scalars['Boolean']>;
  updateDescription?: InputMaybe<IntegrationDescriptionInput>;
  externalLinkKey?: InputMaybe<Scalars['String']>;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', updateIntegration?: { __typename?: 'UpdateIntegrationResponse', updated: boolean } | undefined };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  tenantID: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<UserRole>;
  customRole?: InputMaybe<Scalars['String']>;
  interests?: InputMaybe<UserInterestsInput>;
  addPinnedDashboardIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  removePinnedDashboardIDs?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  type?: InputMaybe<UserType>;
  state?: InputMaybe<UserState>;
  homepageDashboardID?: InputMaybe<Scalars['String']>;
  removeHomepageDashboardID?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'UpdateUserResponse', code: string, message: string } | undefined };

export type UpdateNotificationsMutationVariables = Exact<{
  tenantID: Scalars['ID'];
  notificationIDs?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  viewed?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateNotificationsMutation = { __typename?: 'Mutation', updateNotifications?: { __typename?: 'UpdateNotificationsResponse', updated: boolean } | undefined };

export type MarkNotificationsAsReadMutationVariables = Exact<{
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  createdBefore?: InputMaybe<Scalars['Int']>;
}>;


export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation', markNotificationsAsRead?: { __typename?: 'MarkNotificationsAsReadResponse', updated: boolean } | undefined };

export type AddUserTagsMutationVariables = Exact<{
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type AddUserTagsMutation = { __typename?: 'Mutation', addUserTags?: { __typename?: 'AddUserTagsResponse', code: string, message: string } | undefined };

export type RemoveUserTagsMutationVariables = Exact<{
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type RemoveUserTagsMutation = { __typename?: 'Mutation', removeUserTags?: { __typename?: 'RemoveUserTagsResponse', code: string, message: string } | undefined };

export type UpdateMetadataMutationVariables = Exact<{
  request: UpdateManagedMetadataRequest;
}>;


export type UpdateMetadataMutation = { __typename?: 'Mutation', updateManagedMetadata: { __typename?: 'UpdateManagedMetadataResponse', updated: boolean } };

export type ManipulatePredictionsMutationVariables = Exact<{
  request: ManipulatePredictionsInput;
}>;


export type ManipulatePredictionsMutation = { __typename?: 'Mutation', manipulatePredictions?: { __typename?: 'ManipulatePredictionsResponse', success?: boolean | undefined } | undefined };

export type UpdateTenantSsoMutationVariables = Exact<{
  request: UpdateTenantSsoInput;
}>;


export type UpdateTenantSsoMutation = { __typename?: 'Mutation', updateTenantSso: { __typename?: 'UpdateTenantSsoResponse', success: boolean } };

export type RemoveTenantSsoMutationVariables = Exact<{
  request: RemoveTenantSsoInput;
}>;


export type RemoveTenantSsoMutation = { __typename?: 'Mutation', removeTenantSso: { __typename?: 'RemoveTenantSsoResponse', success: boolean } };

export type AskForArtefactAccessMutationVariables = Exact<{
  request: AskForArtefactAccessInput;
}>;


export type AskForArtefactAccessMutation = { __typename?: 'Mutation', askForArtefactAccess?: { __typename?: 'AskForArtefactAccessResponse', success: boolean } | undefined };

export type ProcessOperationMutationVariables = Exact<{
  request: ProcessOperationInput;
}>;


export type ProcessOperationMutation = { __typename?: 'Mutation', processOperation: { __typename?: 'ProcessOperationResponse', processed: boolean } };

export type CreateDashboardFromTemplateMutationVariables = Exact<{
  request: CreateDashboardFromTemplateInput;
}>;


export type CreateDashboardFromTemplateMutation = { __typename?: 'Mutation', createDashboardFromTemplate?: { __typename?: 'CreateDashboardFromTemplateResponse', dashboard: { __typename?: 'Dashboard', id: string, tenantID: string, title: string, description: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase?: DashboardUseCase | undefined, metadata: string, shortMetadata: string, createdAt: number, updatedAt: number, isReportingDisabled: boolean, status: Status, version: number, widgets?: Array<{ __typename?: 'DashboardWidget', id: string, analysis?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined, textWidget?: { __typename?: 'TextWidget', id: string, text: string } | undefined }> | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined, originDashboard?: { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined, editors?: Array<{ __typename?: 'UserInfo', id: string, firstName: string, lastName: string }> | undefined, filterClause?: { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined } | undefined, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } } | undefined };

export type UpdateTenantDashboardSettingsMutationVariables = Exact<{
  id: Scalars['ID'];
  dashboardSettings?: InputMaybe<UpdateTenantDashboardSettingsInput>;
}>;


export type UpdateTenantDashboardSettingsMutation = { __typename?: 'Mutation', updateTenant?: { __typename?: 'UpdateTenantResponse', code: string, message: string } | undefined };

export type UpdateSummaryFlagMutationVariables = Exact<{
  request: UpdateSummaryFlagInput;
}>;


export type UpdateSummaryFlagMutation = { __typename?: 'Mutation', updateSummaryFlag?: { __typename?: 'UpdateSummaryFlagResponse', success?: boolean | undefined } | undefined };

export type UserInfoViewFragment = { __typename?: 'UserInfo', id: string, firstName: string, lastName: string };

export type DashboardListItemViewFragment = { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined };

export type IntegrationChannelViewFragment = { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType };

export type IntegrationViewFragment = { __typename?: 'Integration', id: string, tenantID: string, direction: IntegrationDirection, isActive: boolean, createdByUser?: string | undefined, createdAt: number, externalID?: string | undefined, namespace?: string | undefined, onboardingProgress?: number | undefined, integrationType: IntegrationType, source?: string | undefined, eqlFieldsGroupID?: string | undefined, externalLinkKey?: string | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType }, data: { __typename: 'IntegrationData', emailInbound?: { __typename?: 'EmailInboundIntegrationData', receiveOnEmail: string } | undefined, emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string>, ccEmails?: Array<string> | undefined } | undefined, surveyMonkey?: { __typename?: 'SurveyMonkeyIntegrationData', includedSurveys?: Array<{ __typename?: 'Survey', name: string, surveyID: string }> | undefined } | undefined, typeform?: { __typename?: 'TypeformIntegrationData', includedForms?: Array<{ __typename?: 'TypeformForm', title: string, id: string }> | undefined } | undefined, salesforce?: { __typename: 'SalesforceIntegrationData', orderBy: SalesforceOrderByField, objectSchema?: { __typename?: 'SalesforceObjectSchema', name: string, surveyContent?: Array<{ __typename?: 'SalesforceFieldSchema', name: string, label: string }> | undefined, fieldsToResolve: Array<{ __typename?: 'SalesforceReferenceSchema', name: string, objectName: string, relationshipName: string }> } | undefined, condition?: { __typename?: 'SalesforceIngestionCondition', field: Array<{ __typename?: 'SalesforceIngestionFieldCondition', field: string, values: { __typename?: 'PrimitiveValueArray', S?: Array<string> | undefined, N?: Array<number> | undefined, B?: Array<boolean> | undefined } }> } | undefined } | undefined, fileUpload?: { __typename: 'FileUploadIntegrationData', fileSource: string, isEmpty: boolean } | undefined, discord?: { __typename: 'DiscordIntegrationData', guildName: string, guildID: string, subscribedChannels: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, snowflake?: { __typename?: 'SnowflakeIntegrationData', publicKey: string } | undefined, slack?: { __typename?: 'SlackIntegrationData', createdByUserID?: string | undefined, subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, webhook?: { __typename?: 'WebhookIntegrationData', displayName: string } | undefined, discourse?: { __typename?: 'DiscourseIntegrationData', subscribedCategories: Array<{ __typename?: 'DiscourseCategory', id: string, name: string }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesIntegrationData', userAccessToken: string, subscribedPage?: { __typename?: 'FacebookPage', id: string, name: string } | undefined } | undefined, reddit?: { __typename?: 'RedditIntegrationData', subreddit: string } | undefined, qualtrics?: { __typename?: 'QualtricsIntegrationData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessIntegrationData', account?: { __typename?: 'GoogleMyBusinessAccount', id: string, name: string } | undefined } | undefined, gainsight?: { __typename?: 'GainsightIntegrationData', subscribedCategories: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigIntegrationData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined, feedbackMetadataEnrichment?: { __typename?: 'FeedbackMetadataEnrichmentIntegrationData', metadataKeys?: Array<string> | undefined } | undefined }, description?: { __typename?: 'IntegrationDescription', description?: string | undefined, descriptionMap?: Array<{ __typename?: 'DescriptionMap', sourceID: string, description: string }> | undefined } | undefined };

export type TenantViewFragment = { __typename?: 'Tenant', id: string, name: string, domains: Array<string>, tier: TenantTier, slug?: string | undefined, avatarURL?: string | undefined, timezone?: string | undefined, state: TenantState, integrations?: Array<{ __typename?: 'Integration', id: string, tenantID: string, direction: IntegrationDirection, isActive: boolean, createdByUser?: string | undefined, createdAt: number, externalID?: string | undefined, namespace?: string | undefined, onboardingProgress?: number | undefined, integrationType: IntegrationType, source?: string | undefined, eqlFieldsGroupID?: string | undefined, externalLinkKey?: string | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType }, data: { __typename: 'IntegrationData', emailInbound?: { __typename?: 'EmailInboundIntegrationData', receiveOnEmail: string } | undefined, emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string>, ccEmails?: Array<string> | undefined } | undefined, surveyMonkey?: { __typename?: 'SurveyMonkeyIntegrationData', includedSurveys?: Array<{ __typename?: 'Survey', name: string, surveyID: string }> | undefined } | undefined, typeform?: { __typename?: 'TypeformIntegrationData', includedForms?: Array<{ __typename?: 'TypeformForm', title: string, id: string }> | undefined } | undefined, salesforce?: { __typename: 'SalesforceIntegrationData', orderBy: SalesforceOrderByField, objectSchema?: { __typename?: 'SalesforceObjectSchema', name: string, surveyContent?: Array<{ __typename?: 'SalesforceFieldSchema', name: string, label: string }> | undefined, fieldsToResolve: Array<{ __typename?: 'SalesforceReferenceSchema', name: string, objectName: string, relationshipName: string }> } | undefined, condition?: { __typename?: 'SalesforceIngestionCondition', field: Array<{ __typename?: 'SalesforceIngestionFieldCondition', field: string, values: { __typename?: 'PrimitiveValueArray', S?: Array<string> | undefined, N?: Array<number> | undefined, B?: Array<boolean> | undefined } }> } | undefined } | undefined, fileUpload?: { __typename: 'FileUploadIntegrationData', fileSource: string, isEmpty: boolean } | undefined, discord?: { __typename: 'DiscordIntegrationData', guildName: string, guildID: string, subscribedChannels: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, snowflake?: { __typename?: 'SnowflakeIntegrationData', publicKey: string } | undefined, slack?: { __typename?: 'SlackIntegrationData', createdByUserID?: string | undefined, subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, webhook?: { __typename?: 'WebhookIntegrationData', displayName: string } | undefined, discourse?: { __typename?: 'DiscourseIntegrationData', subscribedCategories: Array<{ __typename?: 'DiscourseCategory', id: string, name: string }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesIntegrationData', userAccessToken: string, subscribedPage?: { __typename?: 'FacebookPage', id: string, name: string } | undefined } | undefined, reddit?: { __typename?: 'RedditIntegrationData', subreddit: string } | undefined, qualtrics?: { __typename?: 'QualtricsIntegrationData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessIntegrationData', account?: { __typename?: 'GoogleMyBusinessAccount', id: string, name: string } | undefined } | undefined, gainsight?: { __typename?: 'GainsightIntegrationData', subscribedCategories: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigIntegrationData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined, feedbackMetadataEnrichment?: { __typename?: 'FeedbackMetadataEnrichmentIntegrationData', metadataKeys?: Array<string> | undefined } | undefined }, description?: { __typename?: 'IntegrationDescription', description?: string | undefined, descriptionMap?: Array<{ __typename?: 'DescriptionMap', sourceID: string, description: string }> | undefined } | undefined }> | undefined, dashboardSettings?: { __typename?: 'TenantDashboardSettings', maxLookbackDate: number, homePageStatsDashboard?: string | undefined, showUnTranslatedRecords?: boolean | undefined, defaultUserType?: UserType | undefined, homepageDashboardID?: string | undefined, defaultTimeRange?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined };

export type TenantWithoutIntegrationsViewFragment = { __typename?: 'Tenant', id: string, name: string, domains: Array<string>, tier: TenantTier, slug?: string | undefined, avatarURL?: string | undefined, timezone?: string | undefined, state: TenantState, dashboardSettings?: { __typename?: 'TenantDashboardSettings', maxLookbackDate: number, homePageStatsDashboard?: string | undefined, showUnTranslatedRecords?: boolean | undefined, defaultUserType?: UserType | undefined, homepageDashboardID?: string | undefined, defaultTimeRange?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined };

export type UserViewFragment = { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, role?: UserRole | undefined, type: UserType, state?: UserState | undefined, createdAt: number, intercomUserHash?: string | undefined, homepageDashboardID?: string | undefined, notificationChannels?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType, displayName: string } }> | undefined, Tenant: { __typename?: 'Tenant', id: string, name: string, domains: Array<string>, tier: TenantTier, slug?: string | undefined, avatarURL?: string | undefined, timezone?: string | undefined, state: TenantState, integrations?: Array<{ __typename?: 'Integration', id: string, tenantID: string, direction: IntegrationDirection, isActive: boolean, createdByUser?: string | undefined, createdAt: number, externalID?: string | undefined, namespace?: string | undefined, onboardingProgress?: number | undefined, integrationType: IntegrationType, source?: string | undefined, eqlFieldsGroupID?: string | undefined, externalLinkKey?: string | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType }, data: { __typename: 'IntegrationData', emailInbound?: { __typename?: 'EmailInboundIntegrationData', receiveOnEmail: string } | undefined, emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string>, ccEmails?: Array<string> | undefined } | undefined, surveyMonkey?: { __typename?: 'SurveyMonkeyIntegrationData', includedSurveys?: Array<{ __typename?: 'Survey', name: string, surveyID: string }> | undefined } | undefined, typeform?: { __typename?: 'TypeformIntegrationData', includedForms?: Array<{ __typename?: 'TypeformForm', title: string, id: string }> | undefined } | undefined, salesforce?: { __typename: 'SalesforceIntegrationData', orderBy: SalesforceOrderByField, objectSchema?: { __typename?: 'SalesforceObjectSchema', name: string, surveyContent?: Array<{ __typename?: 'SalesforceFieldSchema', name: string, label: string }> | undefined, fieldsToResolve: Array<{ __typename?: 'SalesforceReferenceSchema', name: string, objectName: string, relationshipName: string }> } | undefined, condition?: { __typename?: 'SalesforceIngestionCondition', field: Array<{ __typename?: 'SalesforceIngestionFieldCondition', field: string, values: { __typename?: 'PrimitiveValueArray', S?: Array<string> | undefined, N?: Array<number> | undefined, B?: Array<boolean> | undefined } }> } | undefined } | undefined, fileUpload?: { __typename: 'FileUploadIntegrationData', fileSource: string, isEmpty: boolean } | undefined, discord?: { __typename: 'DiscordIntegrationData', guildName: string, guildID: string, subscribedChannels: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, snowflake?: { __typename?: 'SnowflakeIntegrationData', publicKey: string } | undefined, slack?: { __typename?: 'SlackIntegrationData', createdByUserID?: string | undefined, subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, webhook?: { __typename?: 'WebhookIntegrationData', displayName: string } | undefined, discourse?: { __typename?: 'DiscourseIntegrationData', subscribedCategories: Array<{ __typename?: 'DiscourseCategory', id: string, name: string }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesIntegrationData', userAccessToken: string, subscribedPage?: { __typename?: 'FacebookPage', id: string, name: string } | undefined } | undefined, reddit?: { __typename?: 'RedditIntegrationData', subreddit: string } | undefined, qualtrics?: { __typename?: 'QualtricsIntegrationData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessIntegrationData', account?: { __typename?: 'GoogleMyBusinessAccount', id: string, name: string } | undefined } | undefined, gainsight?: { __typename?: 'GainsightIntegrationData', subscribedCategories: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigIntegrationData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined, feedbackMetadataEnrichment?: { __typename?: 'FeedbackMetadataEnrichmentIntegrationData', metadataKeys?: Array<string> | undefined } | undefined }, description?: { __typename?: 'IntegrationDescription', description?: string | undefined, descriptionMap?: Array<{ __typename?: 'DescriptionMap', sourceID: string, description: string }> | undefined } | undefined }> | undefined, dashboardSettings?: { __typename?: 'TenantDashboardSettings', maxLookbackDate: number, homePageStatsDashboard?: string | undefined, showUnTranslatedRecords?: boolean | undefined, defaultUserType?: UserType | undefined, homepageDashboardID?: string | undefined, defaultTimeRange?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined }, interests?: { __typename?: 'UserInterests', keywords?: Array<string> | undefined, labelIDs?: Array<string> | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined, permissions?: Array<{ __typename?: 'UserPermission', resource: PermissionResource, operation: PermissionOperation }> | undefined };

export type GetUserByEmailQueryVariables = Exact<{
  email: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetUserByEmailQuery = { __typename?: 'Query', getUserByEmail?: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, role?: UserRole | undefined, type: UserType, state?: UserState | undefined, createdAt: number, intercomUserHash?: string | undefined, homepageDashboardID?: string | undefined, notificationChannels?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType, displayName: string } }> | undefined, Tenant: { __typename?: 'Tenant', id: string, name: string, domains: Array<string>, tier: TenantTier, slug?: string | undefined, avatarURL?: string | undefined, timezone?: string | undefined, state: TenantState, integrations?: Array<{ __typename?: 'Integration', id: string, tenantID: string, direction: IntegrationDirection, isActive: boolean, createdByUser?: string | undefined, createdAt: number, externalID?: string | undefined, namespace?: string | undefined, onboardingProgress?: number | undefined, integrationType: IntegrationType, source?: string | undefined, eqlFieldsGroupID?: string | undefined, externalLinkKey?: string | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType }, data: { __typename: 'IntegrationData', emailInbound?: { __typename?: 'EmailInboundIntegrationData', receiveOnEmail: string } | undefined, emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string>, ccEmails?: Array<string> | undefined } | undefined, surveyMonkey?: { __typename?: 'SurveyMonkeyIntegrationData', includedSurveys?: Array<{ __typename?: 'Survey', name: string, surveyID: string }> | undefined } | undefined, typeform?: { __typename?: 'TypeformIntegrationData', includedForms?: Array<{ __typename?: 'TypeformForm', title: string, id: string }> | undefined } | undefined, salesforce?: { __typename: 'SalesforceIntegrationData', orderBy: SalesforceOrderByField, objectSchema?: { __typename?: 'SalesforceObjectSchema', name: string, surveyContent?: Array<{ __typename?: 'SalesforceFieldSchema', name: string, label: string }> | undefined, fieldsToResolve: Array<{ __typename?: 'SalesforceReferenceSchema', name: string, objectName: string, relationshipName: string }> } | undefined, condition?: { __typename?: 'SalesforceIngestionCondition', field: Array<{ __typename?: 'SalesforceIngestionFieldCondition', field: string, values: { __typename?: 'PrimitiveValueArray', S?: Array<string> | undefined, N?: Array<number> | undefined, B?: Array<boolean> | undefined } }> } | undefined } | undefined, fileUpload?: { __typename: 'FileUploadIntegrationData', fileSource: string, isEmpty: boolean } | undefined, discord?: { __typename: 'DiscordIntegrationData', guildName: string, guildID: string, subscribedChannels: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, snowflake?: { __typename?: 'SnowflakeIntegrationData', publicKey: string } | undefined, slack?: { __typename?: 'SlackIntegrationData', createdByUserID?: string | undefined, subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, webhook?: { __typename?: 'WebhookIntegrationData', displayName: string } | undefined, discourse?: { __typename?: 'DiscourseIntegrationData', subscribedCategories: Array<{ __typename?: 'DiscourseCategory', id: string, name: string }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesIntegrationData', userAccessToken: string, subscribedPage?: { __typename?: 'FacebookPage', id: string, name: string } | undefined } | undefined, reddit?: { __typename?: 'RedditIntegrationData', subreddit: string } | undefined, qualtrics?: { __typename?: 'QualtricsIntegrationData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessIntegrationData', account?: { __typename?: 'GoogleMyBusinessAccount', id: string, name: string } | undefined } | undefined, gainsight?: { __typename?: 'GainsightIntegrationData', subscribedCategories: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigIntegrationData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined, feedbackMetadataEnrichment?: { __typename?: 'FeedbackMetadataEnrichmentIntegrationData', metadataKeys?: Array<string> | undefined } | undefined }, description?: { __typename?: 'IntegrationDescription', description?: string | undefined, descriptionMap?: Array<{ __typename?: 'DescriptionMap', sourceID: string, description: string }> | undefined } | undefined }> | undefined, dashboardSettings?: { __typename?: 'TenantDashboardSettings', maxLookbackDate: number, homePageStatsDashboard?: string | undefined, showUnTranslatedRecords?: boolean | undefined, defaultUserType?: UserType | undefined, homepageDashboardID?: string | undefined, defaultTimeRange?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined }, interests?: { __typename?: 'UserInterests', keywords?: Array<string> | undefined, labelIDs?: Array<string> | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined, permissions?: Array<{ __typename?: 'UserPermission', resource: PermissionResource, operation: PermissionOperation }> | undefined } | undefined };

export type TextIndexViewFragment = { __typename?: 'IndexTypeText', startOffset: number, endOffset: number };

type IndexMetadataView_IndexTypeAudioConversation_Fragment = { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined };

type IndexMetadataView_IndexTypeConversation_Fragment = { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } };

type IndexMetadataView_IndexTypeKeywordSummary_Fragment = { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined };

type IndexMetadataView_IndexTypeSurvey_Fragment = { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } };

type IndexMetadataView_IndexTypeText_Fragment = { __typename?: 'IndexTypeText', startOffset: number, endOffset: number };

export type IndexMetadataViewFragment = IndexMetadataView_IndexTypeAudioConversation_Fragment | IndexMetadataView_IndexTypeConversation_Fragment | IndexMetadataView_IndexTypeKeywordSummary_Fragment | IndexMetadataView_IndexTypeSurvey_Fragment | IndexMetadataView_IndexTypeText_Fragment;

export type RecordSummaryViewFragment = { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined };

type PredictionMetadataView_AspectPredictionMetadata_Fragment = { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined };

type PredictionMetadataView_ClusterPredictionMetadata_Fragment = { __typename?: 'ClusterPredictionMetadata' };

type PredictionMetadataView_ReasonPredictionMetadata_Fragment = { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined };

type PredictionMetadataView_SentimentPredictionMetadata_Fragment = { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined };

export type PredictionMetadataViewFragment = PredictionMetadataView_AspectPredictionMetadata_Fragment | PredictionMetadataView_ClusterPredictionMetadata_Fragment | PredictionMetadataView_ReasonPredictionMetadata_Fragment | PredictionMetadataView_SentimentPredictionMetadata_Fragment;

type RecordLabelView_Aspect_Fragment = { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean };

type RecordLabelView_Cluster_Fragment = { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean };

type RecordLabelView_GenericLabel_Fragment = { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean };

type RecordLabelView_L1_Fragment = { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean };

type RecordLabelView_Reason_Fragment = { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined };

type RecordLabelView_Sentiment_Fragment = { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean };

export type RecordLabelViewFragment = RecordLabelView_Aspect_Fragment | RecordLabelView_Cluster_Fragment | RecordLabelView_GenericLabel_Fragment | RecordLabelView_L1_Fragment | RecordLabelView_Reason_Fragment | RecordLabelView_Sentiment_Fragment;

export type RecordPredictionViewFragment = { __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined };

export type RecordViewFragment = { __typename?: 'Record', id: string, text: string, type?: RecordType | undefined, sourceTimestamp?: number | undefined, textEN: string, sourceID: Source, createdAt?: number | undefined, namespace?: string | undefined, rcData?: { __typename?: 'RecordRC', units?: Array<{ __typename?: 'RCUnit', metadata?: { __typename?: 'RCMetadata', isPredicted?: boolean | undefined } | undefined }> | undefined } | undefined, matchMetadata?: { __typename?: 'RecordMatchMetadata', search?: Array<{ __typename?: 'MatchedRecordMetadata', startIDx: number, endIDx: number, msgIDx: number }> | undefined } | undefined, surveyResponse?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, surveyResponseEn?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, conversation?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, summary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined, forumThreadEn?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, forumThread?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, conversationEn?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, audioConversation?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, audioConversationEn?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, language?: { __typename?: 'Language', source: LanguageSource, iso6393: string, language: string } | undefined, sourceDataV2?: { __typename: 'SourceDataV2', name: string, logo: string, externalLink?: string | undefined, integrationChannelType: IntegrationChannelType, metadata?: Array<{ __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } }> | undefined } | undefined, predictions?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined }> | undefined, predictionHierarchies?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined };

export type SourceDataV2ViewFragment = { __typename: 'SourceDataV2', name: string, logo: string, externalLink?: string | undefined, integrationChannelType: IntegrationChannelType, metadata?: Array<{ __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } }> | undefined };

export type SourceMetadataViewFragment = { __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } };

export type BucketParamsFragment = { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined };

export type GetRecordByIdQueryVariables = Exact<{
  tenantID: Scalars['String'];
  recordID: Scalars['String'];
}>;


export type GetRecordByIdQuery = { __typename?: 'Query', getRecord?: { __typename?: 'Record', id: string, text: string, type?: RecordType | undefined, sourceTimestamp?: number | undefined, textEN: string, sourceID: Source, createdAt?: number | undefined, namespace?: string | undefined, rcData?: { __typename?: 'RecordRC', units?: Array<{ __typename?: 'RCUnit', metadata?: { __typename?: 'RCMetadata', isPredicted?: boolean | undefined } | undefined }> | undefined } | undefined, matchMetadata?: { __typename?: 'RecordMatchMetadata', search?: Array<{ __typename?: 'MatchedRecordMetadata', startIDx: number, endIDx: number, msgIDx: number }> | undefined } | undefined, surveyResponse?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, surveyResponseEn?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, conversation?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, summary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined, forumThreadEn?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, forumThread?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, conversationEn?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, audioConversation?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, audioConversationEn?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, language?: { __typename?: 'Language', source: LanguageSource, iso6393: string, language: string } | undefined, sourceDataV2?: { __typename: 'SourceDataV2', name: string, logo: string, externalLink?: string | undefined, integrationChannelType: IntegrationChannelType, metadata?: Array<{ __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } }> | undefined } | undefined, predictions?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined }> | undefined, predictionHierarchies?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };

export type GetRecordsResponseViewFragment = { __typename?: 'GetRecordsResponse', cursor?: string | undefined, previous?: string | undefined, hits: number, records: Array<{ __typename?: 'Record', id: string, text: string, type?: RecordType | undefined, sourceTimestamp?: number | undefined, textEN: string, sourceID: Source, createdAt?: number | undefined, namespace?: string | undefined, rcData?: { __typename?: 'RecordRC', units?: Array<{ __typename?: 'RCUnit', metadata?: { __typename?: 'RCMetadata', isPredicted?: boolean | undefined } | undefined }> | undefined } | undefined, matchMetadata?: { __typename?: 'RecordMatchMetadata', search?: Array<{ __typename?: 'MatchedRecordMetadata', startIDx: number, endIDx: number, msgIDx: number }> | undefined } | undefined, surveyResponse?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, surveyResponseEn?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, conversation?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, summary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined, forumThreadEn?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, forumThread?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, conversationEn?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, audioConversation?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, audioConversationEn?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, language?: { __typename?: 'Language', source: LanguageSource, iso6393: string, language: string } | undefined, sourceDataV2?: { __typename: 'SourceDataV2', name: string, logo: string, externalLink?: string | undefined, integrationChannelType: IntegrationChannelType, metadata?: Array<{ __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } }> | undefined } | undefined, predictions?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined }> | undefined, predictionHierarchies?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined }> };

export type GetMetadataKeysQueryVariables = Exact<{
  tenant: Scalars['ID'];
}>;


export type GetMetadataKeysQuery = { __typename?: 'Query', listMetadataKeys?: { __typename?: 'MetadataKeys', keys?: Array<{ __typename?: 'MetadataKey', key: string, type: MetadataDataType, cardinality: number, source?: Source | undefined, displayText: string, originalDisplayText: string, description: string, isHidden: boolean, isImportant: boolean, isFilterable: boolean, isGroupable: boolean, namespace?: string | undefined, id: string, values: Array<{ __typename?: 'Value', S?: string | undefined, N?: number | undefined, B?: boolean | undefined }>, referencedIn?: { __typename?: 'MetadataKey', displayText: string, key: string } | undefined }> | undefined } | undefined };

export type AggregateDataPointViewFragment = { __typename?: 'AggregateDataPoint', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, intermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, anomaly?: { __typename?: 'IntermediateAnomalyFuncValue', zScore?: number | undefined, mean?: number | undefined, isAnomalous: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined, subGroupBy?: { __typename?: 'IntermediateSubGroupByFuncValue', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined } | undefined } }> | undefined };

export type GetAggregatesResponseViewFragment = { __typename?: 'GetAggregatesResponse', aggregateHits?: number | undefined, data: Array<{ __typename?: 'AggregateDataPoint', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, intermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, anomaly?: { __typename?: 'IntermediateAnomalyFuncValue', zScore?: number | undefined, mean?: number | undefined, isAnomalous: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined, subGroupBy?: { __typename?: 'IntermediateSubGroupByFuncValue', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined } | undefined } }> | undefined }>, valueRange?: { __typename?: 'ValueRage', start: number, end: number } | undefined };

export type DeltaAggregateDataPointViewFragment = { __typename?: 'DeltaAggregateDataPoint', prevValue: number, currValue: number, absoluteDelta: number, relativeDelta: number, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, currIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined, prevIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined };

export type GetDeltaAggregatesResponseViewFragment = { __typename?: 'GetDeltaAggregatesResponse', aggregateHits?: number | undefined, dataV2: Array<{ __typename?: 'DeltaAggregateDataPoint', prevValue: number, currValue: number, absoluteDelta: number, relativeDelta: number, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, currIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined, prevIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined }>, valueRange?: { __typename?: 'ValueRage', start: number, end: number } | undefined };

export type GetTenantByIdQueryVariables = Exact<{
  tenantID: Scalars['ID'];
}>;


export type GetTenantByIdQuery = { __typename?: 'Query', getTenantByID?: { __typename?: 'Tenant', id: string, name: string, domains: Array<string>, tier: TenantTier, slug?: string | undefined, avatarURL?: string | undefined, timezone?: string | undefined, state: TenantState, integrations?: Array<{ __typename?: 'Integration', id: string, tenantID: string, direction: IntegrationDirection, isActive: boolean, createdByUser?: string | undefined, createdAt: number, externalID?: string | undefined, namespace?: string | undefined, onboardingProgress?: number | undefined, integrationType: IntegrationType, source?: string | undefined, eqlFieldsGroupID?: string | undefined, externalLinkKey?: string | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType }, data: { __typename: 'IntegrationData', emailInbound?: { __typename?: 'EmailInboundIntegrationData', receiveOnEmail: string } | undefined, emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string>, ccEmails?: Array<string> | undefined } | undefined, surveyMonkey?: { __typename?: 'SurveyMonkeyIntegrationData', includedSurveys?: Array<{ __typename?: 'Survey', name: string, surveyID: string }> | undefined } | undefined, typeform?: { __typename?: 'TypeformIntegrationData', includedForms?: Array<{ __typename?: 'TypeformForm', title: string, id: string }> | undefined } | undefined, salesforce?: { __typename: 'SalesforceIntegrationData', orderBy: SalesforceOrderByField, objectSchema?: { __typename?: 'SalesforceObjectSchema', name: string, surveyContent?: Array<{ __typename?: 'SalesforceFieldSchema', name: string, label: string }> | undefined, fieldsToResolve: Array<{ __typename?: 'SalesforceReferenceSchema', name: string, objectName: string, relationshipName: string }> } | undefined, condition?: { __typename?: 'SalesforceIngestionCondition', field: Array<{ __typename?: 'SalesforceIngestionFieldCondition', field: string, values: { __typename?: 'PrimitiveValueArray', S?: Array<string> | undefined, N?: Array<number> | undefined, B?: Array<boolean> | undefined } }> } | undefined } | undefined, fileUpload?: { __typename: 'FileUploadIntegrationData', fileSource: string, isEmpty: boolean } | undefined, discord?: { __typename: 'DiscordIntegrationData', guildName: string, guildID: string, subscribedChannels: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, snowflake?: { __typename?: 'SnowflakeIntegrationData', publicKey: string } | undefined, slack?: { __typename?: 'SlackIntegrationData', createdByUserID?: string | undefined, subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, webhook?: { __typename?: 'WebhookIntegrationData', displayName: string } | undefined, discourse?: { __typename?: 'DiscourseIntegrationData', subscribedCategories: Array<{ __typename?: 'DiscourseCategory', id: string, name: string }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesIntegrationData', userAccessToken: string, subscribedPage?: { __typename?: 'FacebookPage', id: string, name: string } | undefined } | undefined, reddit?: { __typename?: 'RedditIntegrationData', subreddit: string } | undefined, qualtrics?: { __typename?: 'QualtricsIntegrationData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessIntegrationData', account?: { __typename?: 'GoogleMyBusinessAccount', id: string, name: string } | undefined } | undefined, gainsight?: { __typename?: 'GainsightIntegrationData', subscribedCategories: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigIntegrationData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined, feedbackMetadataEnrichment?: { __typename?: 'FeedbackMetadataEnrichmentIntegrationData', metadataKeys?: Array<string> | undefined } | undefined }, description?: { __typename?: 'IntegrationDescription', description?: string | undefined, descriptionMap?: Array<{ __typename?: 'DescriptionMap', sourceID: string, description: string }> | undefined } | undefined }> | undefined, dashboardSettings?: { __typename?: 'TenantDashboardSettings', maxLookbackDate: number, homePageStatsDashboard?: string | undefined, showUnTranslatedRecords?: boolean | undefined, defaultUserType?: UserType | undefined, homepageDashboardID?: string | undefined, defaultTimeRange?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined } | undefined };

export type DownloadFeatureFlagDataFileQueryVariables = Exact<{
  fileURL: Scalars['String'];
}>;


export type DownloadFeatureFlagDataFileQuery = { __typename?: 'Query', proxyFileDownload?: { __typename?: 'ProxyFileDownloadResponse', base64Data: string } | undefined };

export type ListTenantsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type ListTenantsQuery = { __typename?: 'Query', listTenants?: { __typename?: 'ListTenantsResponse', paginationToken?: string | undefined, tenants?: Array<{ __typename?: 'Tenant', id: string, name: string, domains: Array<string>, tier: TenantTier, slug?: string | undefined, avatarURL?: string | undefined, timezone?: string | undefined, state: TenantState, dashboardSettings?: { __typename?: 'TenantDashboardSettings', maxLookbackDate: number, homePageStatsDashboard?: string | undefined, showUnTranslatedRecords?: boolean | undefined, defaultUserType?: UserType | undefined, homepageDashboardID?: string | undefined, defaultTimeRange?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, pinnedDashboards?: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> | undefined }> | undefined } | undefined };

type IntegrationFormDataView_DelightedFormData_Fragment = { __typename?: 'DelightedFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_FreshchatFormData_Fragment = { __typename?: 'FreshchatFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_InputFormData_Fragment = { __typename?: 'InputFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_IntercomFormData_Fragment = { __typename?: 'IntercomFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_LivechatFormData_Fragment = { __typename?: 'LivechatFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_OAuthFormData_Fragment = { __typename?: 'OAuthFormData', oAuthURL: string, direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_SlackFormData_Fragment = { __typename?: 'SlackFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_StellaConnectFormData_Fragment = { __typename?: 'StellaConnectFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_SurveyMonkeyFormData_Fragment = { __typename?: 'SurveyMonkeyFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_TypeformFormData_Fragment = { __typename?: 'TypeformFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_ZendeskChatFormData_Fragment = { __typename?: 'ZendeskChatFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_ZendeskSupportFormData_Fragment = { __typename?: 'ZendeskSupportFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

type IntegrationFormDataView_ZohoDeskFormData_Fragment = { __typename?: 'ZohoDeskFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } };

export type IntegrationFormDataViewFragment = IntegrationFormDataView_DelightedFormData_Fragment | IntegrationFormDataView_FreshchatFormData_Fragment | IntegrationFormDataView_InputFormData_Fragment | IntegrationFormDataView_IntercomFormData_Fragment | IntegrationFormDataView_LivechatFormData_Fragment | IntegrationFormDataView_OAuthFormData_Fragment | IntegrationFormDataView_SlackFormData_Fragment | IntegrationFormDataView_StellaConnectFormData_Fragment | IntegrationFormDataView_SurveyMonkeyFormData_Fragment | IntegrationFormDataView_TypeformFormData_Fragment | IntegrationFormDataView_ZendeskChatFormData_Fragment | IntegrationFormDataView_ZendeskSupportFormData_Fragment | IntegrationFormDataView_ZohoDeskFormData_Fragment;

export type GetIntegrationsFormDataV2QueryVariables = Exact<{
  tenantID: Scalars['ID'];
}>;


export type GetIntegrationsFormDataV2Query = { __typename?: 'Query', getIntegrationsFormDataV2?: { __typename?: 'IntegrationsFormDataV2', forms: Array<{ __typename?: 'DelightedFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'FreshchatFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'InputFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'IntercomFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'LivechatFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'OAuthFormData', oAuthURL: string, direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'SlackFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'StellaConnectFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'SurveyMonkeyFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'TypeformFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'ZendeskChatFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'ZendeskSupportFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } } | { __typename?: 'ZohoDeskFormData', direction: IntegrationDirection, integrationType: IntegrationType, isContextual?: boolean | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType } }> } | undefined };

type LabelFragment_Aspect_Fragment = { __typename?: 'Aspect', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean, metadata?: { __typename?: 'AspectMetadata', phrases?: Array<string> | undefined, excludedPhrases?: Array<string> | undefined } | undefined };

type LabelFragment_Cluster_Fragment = { __typename?: 'Cluster', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean };

type LabelFragment_GenericLabel_Fragment = { __typename?: 'GenericLabel', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean };

type LabelFragment_L1_Fragment = { __typename?: 'L1', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean };

type LabelFragment_Reason_Fragment = { __typename?: 'Reason', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean, metadata?: { __typename?: 'ReasonMetadata', sentiment?: SentimentType | undefined, representativeSentences?: Array<string> | undefined, type?: ReasonType | undefined, category?: Category | undefined, createdBy?: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, role?: UserRole | undefined, type: UserType } | undefined } | undefined };

type LabelFragment_Sentiment_Fragment = { __typename?: 'Sentiment', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean };

export type LabelFragmentFragment = LabelFragment_Aspect_Fragment | LabelFragment_Cluster_Fragment | LabelFragment_GenericLabel_Fragment | LabelFragment_L1_Fragment | LabelFragment_Reason_Fragment | LabelFragment_Sentiment_Fragment;

export type ListLabelsQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  type: LabelType;
  includeInvisible?: InputMaybe<Scalars['Boolean']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type ListLabelsQuery = { __typename?: 'Query', listLabels?: { __typename?: 'ListLabelsResponse', paginationToken?: string | undefined, labels: Array<{ __typename?: 'Aspect', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'Cluster', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'GenericLabel', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'L1', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'Reason', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'Sentiment', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean }> } | undefined };

export type ExecuteEqlQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  expression: Scalars['String'];
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type ExecuteEqlQuery = { __typename?: 'Query', executeEQL?: { __typename?: 'ExecuteEQLResponse', result: { __typename?: 'GetAggregatesResponse', aggregateHits?: number | undefined, data: Array<{ __typename?: 'AggregateDataPoint', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, intermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, anomaly?: { __typename?: 'IntermediateAnomalyFuncValue', zScore?: number | undefined, mean?: number | undefined, isAnomalous: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined, subGroupBy?: { __typename?: 'IntermediateSubGroupByFuncValue', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined } | undefined } }> | undefined }>, valueRange?: { __typename?: 'ValueRage', start: number, end: number } | undefined } | { __typename?: 'GetDeltaAggregatesResponse', aggregateHits?: number | undefined, dataV2: Array<{ __typename?: 'DeltaAggregateDataPoint', prevValue: number, currValue: number, absoluteDelta: number, relativeDelta: number, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, currIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined, prevIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined }>, valueRange?: { __typename?: 'ValueRage', start: number, end: number } | undefined } | { __typename?: 'GetRecordsResponse', cursor?: string | undefined, previous?: string | undefined, hits: number, records: Array<{ __typename?: 'Record', id: string, text: string, type?: RecordType | undefined, sourceTimestamp?: number | undefined, textEN: string, sourceID: Source, createdAt?: number | undefined, namespace?: string | undefined, rcData?: { __typename?: 'RecordRC', units?: Array<{ __typename?: 'RCUnit', metadata?: { __typename?: 'RCMetadata', isPredicted?: boolean | undefined } | undefined }> | undefined } | undefined, matchMetadata?: { __typename?: 'RecordMatchMetadata', search?: Array<{ __typename?: 'MatchedRecordMetadata', startIDx: number, endIDx: number, msgIDx: number }> | undefined } | undefined, surveyResponse?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, surveyResponseEn?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, conversation?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, summary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined, forumThreadEn?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, forumThread?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, conversationEn?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, audioConversation?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, audioConversationEn?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, language?: { __typename?: 'Language', source: LanguageSource, iso6393: string, language: string } | undefined, sourceDataV2?: { __typename: 'SourceDataV2', name: string, logo: string, externalLink?: string | undefined, integrationChannelType: IntegrationChannelType, metadata?: Array<{ __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } }> | undefined } | undefined, predictions?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined }> | undefined, predictionHierarchies?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined }> } } | undefined };

export type BatchExecuteEqlQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  expressions: Array<BatchExecuteEqlExpression> | BatchExecuteEqlExpression;
}>;


export type BatchExecuteEqlQuery = { __typename?: 'Query', batchExecuteEQL?: { __typename?: 'BatchExecuteEQLResponse', results?: Array<{ __typename?: 'BatchExecuteEQLResponseItem', queryID: string, result: { __typename?: 'GetAggregatesResponse', aggregateHits?: number | undefined, data: Array<{ __typename?: 'AggregateDataPoint', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, intermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, anomaly?: { __typename?: 'IntermediateAnomalyFuncValue', zScore?: number | undefined, mean?: number | undefined, isAnomalous: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined, subGroupBy?: { __typename?: 'IntermediateSubGroupByFuncValue', value?: number | undefined, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined } | undefined } }> | undefined }>, valueRange?: { __typename?: 'ValueRage', start: number, end: number } | undefined } | { __typename?: 'GetDeltaAggregatesResponse', aggregateHits?: number | undefined, dataV2: Array<{ __typename?: 'DeltaAggregateDataPoint', prevValue: number, currValue: number, absoluteDelta: number, relativeDelta: number, bucket?: { __typename?: 'AggregateBucketKey', timestamp?: number | undefined, source?: Source | undefined, labelID?: string | undefined, entitySentiment?: SentimentType | undefined, namespace?: string | undefined, category?: Category | undefined, bucketID?: string | undefined, language?: { __typename?: 'Language', iso6393: string } | undefined, metadata?: { __typename?: 'MetadataAggregateBucketKey', keyValues: Array<{ __typename?: 'mapStrToStrTuple', key: string, value: string }> } | undefined, label?: { __typename?: 'Aspect', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Cluster', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'GenericLabel', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'L1', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Reason', displayName: string, isVisible: boolean, updateInProgress: boolean } | { __typename?: 'Sentiment', displayName: string, isVisible: boolean, updateInProgress: boolean } | undefined } | undefined, currIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined, prevIntermediates?: Array<{ __typename?: 'IntermediateAggregateDataPoint', func: string, value: { __typename?: 'IntermediateAggregateDataPointValue', applyTaxonomy?: { __typename?: 'IntermediateApplyTaxonomyFuncValue', isRelevant: boolean } | undefined, nps?: { __typename?: 'IntermediateNpsFuncValue', detractorsPercentage: number, promotersPercentage: number } | undefined, csat?: { __typename?: 'IntermediateCsatFuncValue', satisfiedResponses: number, totalResponses: number } | undefined, mean?: { __typename?: 'IntermediateMeanFuncValue', totalValue: number, weightedSum: number } | undefined, dsat?: { __typename?: 'IntermediateDsatFuncValue', dissatisfiedResponses: number, totalResponses: number } | undefined } }> | undefined }>, valueRange?: { __typename?: 'ValueRage', start: number, end: number } | undefined } | { __typename?: 'GetRecordsResponse', cursor?: string | undefined, previous?: string | undefined, hits: number, records: Array<{ __typename?: 'Record', id: string, text: string, type?: RecordType | undefined, sourceTimestamp?: number | undefined, textEN: string, sourceID: Source, createdAt?: number | undefined, namespace?: string | undefined, rcData?: { __typename?: 'RecordRC', units?: Array<{ __typename?: 'RCUnit', metadata?: { __typename?: 'RCMetadata', isPredicted?: boolean | undefined } | undefined }> | undefined } | undefined, matchMetadata?: { __typename?: 'RecordMatchMetadata', search?: Array<{ __typename?: 'MatchedRecordMetadata', startIDx: number, endIDx: number, msgIDx: number }> | undefined } | undefined, surveyResponse?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, surveyResponseEn?: { __typename?: 'SurveyResponse', responses: Array<{ __typename?: 'SurveyQA', answer: string, question: string, selectedOptions?: Array<string> | undefined }> } | undefined, conversation?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, summary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined, forumThreadEn?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, forumThread?: { __typename?: 'ForumThread', title?: string | undefined, header?: { __typename?: 'ForumThreadMsg', actorID: string, text: string } | undefined, intermediatePosts?: Array<{ __typename?: 'ForumThreadMsg', text: string, actorID: string }> | undefined, latestPost?: { __typename?: 'ForumThreadMsg', text: string, actorID: string } | undefined } | undefined, conversationEn?: { __typename?: 'Conversation', msgs?: Array<{ __typename?: 'ConversationMsg', text: string, actor: ActorType, actorID?: string | undefined }> | undefined } | undefined, audioConversation?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, audioConversationEn?: { __typename?: 'AudioConversation', audioFileS3: string, units?: Array<{ __typename?: 'AudioRecordingMessageUnit', actor: string, text: string, actorType: ActorType, metadata: { __typename?: 'AudioRecordingMetadata', startTime: number, endTime: number } }> | undefined } | undefined, language?: { __typename?: 'Language', source: LanguageSource, iso6393: string, language: string } | undefined, sourceDataV2?: { __typename: 'SourceDataV2', name: string, logo: string, externalLink?: string | undefined, integrationChannelType: IntegrationChannelType, metadata?: Array<{ __typename: 'SourceMetadata', objectID: string, key: string, field: string, queriable: boolean, isImportant: boolean, objectType: ObjectType, isReference: boolean, value: { __typename?: 'MetadataValue', s?: Array<string> | undefined, b?: Array<boolean> | undefined, n?: Array<number> | undefined } }> | undefined } | undefined, predictions?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined }> | undefined, predictionHierarchies?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined, children?: Array<{ __typename?: 'Prediction', labelID: string, label: { __typename: 'Aspect', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'L1', isUncategorized?: boolean | undefined, id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean } | { __typename: 'Reason', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, createdAt?: number | undefined, isVisible: boolean, updateInProgress: boolean }, predictionMetadata?: { __typename?: 'AspectPredictionMetadata', sentiment: SentimentType, keywordSummaryHash?: string | undefined, units?: Array<{ __typename?: 'AspectPredictionMetadataUnit', sentiment: SentimentType, category?: Category | undefined, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined, keywordSummary?: { __typename?: 'RecordSummary', flag?: SummaryFlag | undefined, units?: Array<{ __typename?: 'SummaryMessageUnit', text: string, metadata?: { __typename?: 'SummaryMetadata', flag?: SummaryFlag | undefined, location?: Array<{ __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number }> | undefined } | undefined }> | undefined } | undefined } | { __typename?: 'ClusterPredictionMetadata' } | { __typename?: 'ReasonPredictionMetadata', sentiment: SentimentType, units?: Array<{ __typename?: 'ReasonPredictionMetadataUnit', indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | { __typename?: 'SentimentPredictionMetadata', units?: Array<{ __typename?: 'SentimentPredictionMetadataUnit', sentiment: SentimentType, indexMetadata: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } }> | undefined } | undefined } | undefined> | undefined } | undefined> | undefined } | undefined> | undefined }> } }> | undefined } | undefined };

export type AnalysisListItemViewFragment = { __typename?: 'AnalysisListItem', id: string, title: string, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, useCase?: AnalysisUseCase | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context?: { __typename?: 'AnalysisContext', eqlExpression: string } | undefined, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined }> | undefined } | undefined } | undefined };

export type ListSourceDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSourceDetailsQuery = { __typename?: 'Query', listSourceDetails?: { __typename?: 'ListSourceDetailsResponse', sources?: Array<{ __typename?: 'SourceDetails', id: Source, eqlValue: string }> | undefined } | undefined };

export type CronValueFragmentFragment = { __typename?: 'CronValue', unit: CronUnit, count: number };

export type CronValueV2FragmentFragment = { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined };

export type CronValueNestedFragmentFragment = { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined };

export type ScheduleMetadataFragmentFragment = { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined };

export type ReportingIntegrationViewFragment = { __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } };

export type ScheduleViewFragment = { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined };

export type ReportingScheduleViewFragment = { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined };

export type AnalysisViewFragment = { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined };

export type GetAnalysisByTokenQueryVariables = Exact<{
  token: Scalars['String'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  includeScheduleOutbounds?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetAnalysisByTokenQuery = { __typename?: 'Query', getAnalysisByToken?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined };

export type ListAnalysesQueryVariables = Exact<{
  request: ListAnalysesInput;
}>;


export type ListAnalysesQuery = { __typename?: 'Query', listAnalyses?: { __typename?: 'ListAnalysesResponse', nextCursor?: string | undefined, prevCursor?: string | undefined, hits?: number | undefined, analyses: Array<{ __typename?: 'AnalysisListItem', id: string, title: string, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, useCase?: AnalysisUseCase | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context?: { __typename?: 'AnalysisContext', eqlExpression: string } | undefined, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined }> | undefined } | undefined } | undefined }> } | undefined };

export type GetDashboardByTokenQueryVariables = Exact<{
  token: Scalars['String'];
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  includeScheduleOutbounds?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetDashboardByTokenQuery = { __typename?: 'Query', getDashboardByToken?: { __typename?: 'Dashboard', id: string, tenantID: string, title: string, description: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase?: DashboardUseCase | undefined, metadata: string, shortMetadata: string, createdAt: number, updatedAt: number, isReportingDisabled: boolean, status: Status, version: number, widgets?: Array<{ __typename?: 'DashboardWidget', id: string, analysis?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined, textWidget?: { __typename?: 'TextWidget', id: string, text: string } | undefined }> | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined, originDashboard?: { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined, editors?: Array<{ __typename?: 'UserInfo', id: string, firstName: string, lastName: string }> | undefined, filterClause?: { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined } | undefined, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined };

export type FilterClauseViewFragment = { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined };

export type DashboardMetadataViewFragment = { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined };

export type DashboardViewFragment = { __typename?: 'Dashboard', id: string, tenantID: string, title: string, description: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase?: DashboardUseCase | undefined, metadata: string, shortMetadata: string, createdAt: number, updatedAt: number, isReportingDisabled: boolean, status: Status, version: number, widgets?: Array<{ __typename?: 'DashboardWidget', id: string, analysis?: { __typename?: 'Analysis', id: string, tenantID: string, title: string, editToken?: string | undefined, viewToken: string, scope: Scope, useCase: AnalysisUseCase, metadata: string, description?: string | undefined, createdAt: number, updatedAt: number, originAnalysisViewToken?: string | undefined, isReportingDisabled: boolean, status: Status, metadataV2?: { __typename?: 'AnalysisMetadata', collection?: { __typename?: 'CollectionMetadata', savedFeedbackMetadata?: Array<{ __typename?: 'SavedFeedbackMetadata', feedbackID: string, isFeedbackSaved?: boolean | undefined, snippetMetadataV2?: Array<{ __typename?: 'SavedSnippetMetadataV2', location?: { __typename?: 'IndexTypeAudioConversation', startTime: number, endTime: number, msgIdx: number, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeConversation', messageIndex: number, messageEndIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeKeywordSummary', msgIdx: number, labelID: string, startIdx?: number | undefined, endIdx?: number | undefined } | { __typename?: 'IndexTypeSurvey', qnaIndex: number, optionIndex?: number | undefined, textIndex: { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } } | { __typename?: 'IndexTypeText', startOffset: number, endOffset: number } | undefined }> | undefined, snippetMetadata?: Array<{ __typename?: 'SavedSnippetMetadata', labelID?: string | undefined, snippetIDs?: Array<string> | undefined }> | undefined }> | undefined } | undefined, quantify?: { __typename?: 'QuantifyMetadata', visualisationType?: QuantifyVisualisationType | undefined, compareMetadata?: { __typename?: 'CompareMetadata', baseQueryName?: string | undefined, deltaQueryName?: string | undefined } | undefined } | undefined } | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, context: { __typename?: 'AnalysisContext', eqlExpression: string, prompt?: string | undefined, eql?: { __typename?: 'EQLQuery', eql: string, properties: { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined } } | undefined }, panels: Array<{ __typename?: 'AnalysisPanel', title: string, metadata: string, panelQueries: Array<{ __typename?: 'AnalysisPanelQuery', eqlExpression: string, panelID: string }> }>, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined } | undefined, textWidget?: { __typename?: 'TextWidget', id: string, text: string } | undefined }> | undefined, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, reporting?: { __typename?: 'Reporting', primarySchedule?: { __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined } | undefined, secondarySchedules?: Array<{ __typename?: 'Schedule', id: string, outbounds?: Array<string> | undefined, subjectID: string, subjectType: SubjectType, reportType: ReportingType, isDisabled: boolean, isPrimary: boolean, createdAt: number, updatedAt: number, cron: { __typename?: 'Cron', realtime?: boolean | undefined, value?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number, offset?: { __typename?: 'CronValue', unit: CronUnit, count: number } | undefined } | undefined } | undefined } | undefined, valueV2?: { __typename?: 'CronValueV2', dayOfWeek?: Array<DayName> | undefined, hourOfDay: number, minuteOfHour?: number | undefined, dayOfMonth?: { __typename?: 'DayOfMonth', day?: number | undefined, last?: boolean | undefined } | undefined } | undefined }, metadata: { __typename?: 'ScheduleMetadata', defaultReportMetadata?: { __typename?: 'DefaultReportMetadata', skipSnapshot?: boolean | undefined } | undefined, feedbackReportMetadata?: { __typename?: 'FeedbackReportMetadata', recordCount: number } | undefined }, integrations?: Array<{ __typename?: 'Integration', id: string, direction: IntegrationDirection, isActive: boolean, channel: { __typename?: 'IntegrationChannel', type: IntegrationChannelType }, data: { __typename?: 'IntegrationData', emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string> } | undefined, slack?: { __typename?: 'SlackIntegrationData', subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined } }> | undefined }> | undefined } | undefined, originDashboard?: { __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined } | undefined, editors?: Array<{ __typename?: 'UserInfo', id: string, firstName: string, lastName: string }> | undefined, filterClause?: { __typename?: 'FilterClause', whereClause?: string | undefined, timeRange?: { __typename?: 'TimeRangeResponse', startAfter?: number | undefined, endBefore?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', value: number, unit: TimeUnit } | undefined } | undefined } | undefined, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined };

export type EqlQueryPropertiesViewFragment = { __typename?: 'EQLQueryProperties', aggregatePeriod?: TimeUnit | undefined, isCoOccurring?: boolean | undefined, type: EqlQueryType, whereClause?: string | undefined, duration?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined, functions?: Array<{ __typename?: 'EQLFunction', anomaly?: { __typename?: 'EQLFunctionAnomaly', shouldIncludeNonAnomalies: boolean, threshold: number } | undefined, top?: { __typename?: 'EQLFunctionTopQuery', count: number } | undefined, taxonomy?: { __typename?: 'EQLFunctionTaxonomy', shouldIncludeIrrelevant: boolean } | undefined, selection?: { __typename?: 'EQLFunctionSelection', values: Array<string> } | undefined, search?: { __typename?: 'EQLFunctionSearch', terms: Array<string> } | undefined, paginate?: { __typename?: 'EQLFunctionPaginate', pageNumber: number, pageSize: number } | undefined, order?: { __typename?: 'EQLFunctionOrder', anomalousValue?: boolean | undefined, isDescending: boolean, metadataValue?: boolean | undefined, timestamp?: number | undefined, value?: boolean | undefined, volume?: boolean | undefined } | undefined, deltaTop?: { __typename?: 'EQLFunctionDeltaTop', count: number } | undefined, deltaPaginate?: { __typename?: 'EQLFunctionDeltaPaginate', pageNumber: number, pageSize: number } | undefined, deltaOrder?: { __typename?: 'EQLFunctionDeltaOrder', absoluteDifference?: boolean | undefined, baseline?: boolean | undefined, difference?: boolean | undefined, inspect?: boolean | undefined, metadataValue?: boolean | undefined, isDescending: boolean } | undefined }> | undefined, formula?: { __typename?: 'Formula', description: string, displayName: string, eqlFunction: string, group: string, helpCentreURL: string, isSupported: boolean, shortName: string } | undefined, formulaQuery?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, compareQuery?: { __typename?: 'CompareQuery', whereClause?: string | undefined, formula?: { __typename?: 'FormulaQuery', denominatorWhereClause?: string | undefined, eqlFunction: string, criteria: { __typename?: 'EQLField', field: string, displayName: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } } | undefined, previousPeriod?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined, timerange?: { __typename?: 'TimeRangeResponse', endBefore?: number | undefined, startAfter?: number | undefined, relative?: { __typename?: 'RelativeTimeRangeResponse', unit: TimeUnit, value: number } | undefined } | undefined } | undefined, groupBy?: { __typename?: 'GroupByResponse', entity?: boolean | undefined, entitySentiment?: boolean | undefined, labelID?: boolean | undefined, language?: boolean | undefined, predictedOn?: boolean | undefined, reason?: boolean | undefined, recordSentiment?: boolean | undefined, source?: boolean | undefined, entityCategory?: boolean | undefined, metadata?: { __typename?: 'GroupByMetadataResponse', keys?: Array<string> | undefined } | undefined } | undefined, groupByField?: { __typename?: 'EQLField', displayName: string, field: string, iconURL?: string | undefined, isMultiValue: boolean, objectType: ObjectType, valueType: EqlFieldValueType, detail?: { __typename?: 'EQLFieldDetail', metadata?: { __typename?: 'EQLFieldMetadataDetail', source: string, references?: Array<{ __typename?: 'EQLFieldMetadataReference', displayName: string, iconURL: string, key: string, source: string }> | undefined } | undefined, reference?: { __typename?: 'EQLFieldReferenceDetail', creatorID?: string | undefined, creatorName?: string | undefined, referenceID: string, referenceType: EqlFieldReferenceType } | undefined } | undefined } | undefined };

export type ListDashboardsQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  cursor?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DashboardFilter>;
  sortBy?: InputMaybe<DashboardSortBy>;
  sortAsc?: InputMaybe<Scalars['Boolean']>;
}>;


export type ListDashboardsQuery = { __typename?: 'Query', listDashboards?: { __typename?: 'ListDashboardsResponse', nextCursor?: string | undefined, prevCursor?: string | undefined, hits?: number | undefined, dashboards: Array<{ __typename?: 'DashboardListItem', id: string, title: string, description?: string | undefined, viewToken: string, editToken?: string | undefined, scope: Scope, recency: number, analysisIDs?: Array<string> | undefined, shortMetadata: string, createdAt: number, tenantID: string, useCase?: DashboardUseCase | undefined, version: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, metadataV2?: { __typename?: 'DashboardMetadata', layout?: { __typename?: 'DashboardLayout', rows: Array<{ __typename: 'DashboardRow', height: number, id: string, cells: Array<{ __typename: 'DashboardCell', columnSpan: number, contentID: string, id: string }> }> } | undefined, analysesMetadata?: Array<{ __typename?: 'DashboardAnalysisMetadata', id: string, shouldShowAnomaliesAsChart?: boolean | undefined, shouldExcludeCooccurring?: boolean | undefined, shouldShowAsTable?: boolean | undefined, barLabelWidth?: number | undefined, shouldShowAsFeed?: boolean | undefined }> | undefined } | undefined }> } | undefined };

export type ListUserViewFragment = { __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined, email: string, type: UserType, state?: UserState | undefined };

export type ListUsersQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  filter?: InputMaybe<ListUsersFilter>;
}>;


export type ListUsersQuery = { __typename?: 'Query', listUsers?: { __typename?: 'ListUsersResponse', users?: Array<{ __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined, email: string, type: UserType, state?: UserState | undefined }> | undefined } | undefined };

export type IntegrationEditFormDataViewFragment = { __typename?: 'IntegrationEditFormData', surveyMonkey?: { __typename?: 'SurveyMonkeyEditFormData', surveys: Array<{ __typename?: 'Survey', name: string, surveyID: string } | undefined> } | undefined, typeform?: { __typename?: 'TypeformEditFormData', forms: Array<{ __typename?: 'TypeformForm', title: string, id: string }> } | undefined, salesforce?: { __typename?: 'SalesforceEditFormData', listObjectNames?: { __typename?: 'SalesforceListObjectNamesResponse', objectNames: Array<string> } | undefined, describeObject?: { __typename?: 'SalesforceDescribeObjectResponse', name: string, fields: Array<{ __typename?: 'SalesforceDescribeField', name: string, label: string, type: PrimitiveDataType }> } | undefined } | undefined, discord?: { __typename?: 'DiscordEditFormData', channelsInGuild: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, slack?: { __typename?: 'SlackEditFormData', refreshID?: string | undefined, channelsInWorkspace: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesEditFormData', pages: Array<{ __typename?: 'FacebookPage', id: string, name: string, token?: string | undefined }> } | undefined, qualtrics?: { __typename?: 'QualtricsEditFormData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessEditFormData', accounts?: Array<{ __typename?: 'GoogleMyBusinessAccount', id: string, name: string }> | undefined } | undefined, gainsight?: { __typename?: 'GainsightEditFormData', categoryList: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigEditFormData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined };

export type GetIntegrationEditFormDataQueryVariables = Exact<{
  integrationID: Scalars['ID'];
  salesforce?: InputMaybe<SalesforceEditFormDataInput>;
  slack?: InputMaybe<SlackEditFormDataInput>;
  googleMyBusiness?: InputMaybe<GoogleMyBusinessEditFormDataInput>;
}>;


export type GetIntegrationEditFormDataQuery = { __typename?: 'Query', getIntegrationEditFormData?: { __typename?: 'GetIntegrationEditFormDataResponse', formData?: { __typename?: 'IntegrationEditFormData', surveyMonkey?: { __typename?: 'SurveyMonkeyEditFormData', surveys: Array<{ __typename?: 'Survey', name: string, surveyID: string } | undefined> } | undefined, typeform?: { __typename?: 'TypeformEditFormData', forms: Array<{ __typename?: 'TypeformForm', title: string, id: string }> } | undefined, salesforce?: { __typename?: 'SalesforceEditFormData', listObjectNames?: { __typename?: 'SalesforceListObjectNamesResponse', objectNames: Array<string> } | undefined, describeObject?: { __typename?: 'SalesforceDescribeObjectResponse', name: string, fields: Array<{ __typename?: 'SalesforceDescribeField', name: string, label: string, type: PrimitiveDataType }> } | undefined } | undefined, discord?: { __typename?: 'DiscordEditFormData', channelsInGuild: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, slack?: { __typename?: 'SlackEditFormData', refreshID?: string | undefined, channelsInWorkspace: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesEditFormData', pages: Array<{ __typename?: 'FacebookPage', id: string, name: string, token?: string | undefined }> } | undefined, qualtrics?: { __typename?: 'QualtricsEditFormData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessEditFormData', accounts?: Array<{ __typename?: 'GoogleMyBusinessAccount', id: string, name: string }> | undefined } | undefined, gainsight?: { __typename?: 'GainsightEditFormData', categoryList: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigEditFormData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined } | undefined } | undefined };

export type GetLabelQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type GetLabelQuery = { __typename?: 'Query', getLabelByID?: { __typename?: 'Aspect', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean, metadata?: { __typename?: 'AspectMetadata', phrases?: Array<string> | undefined } | undefined } | { __typename?: 'Cluster', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'GenericLabel', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'L1', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | { __typename?: 'Reason', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean, metadata?: { __typename?: 'ReasonMetadata', sentiment?: SentimentType | undefined, representativeSentences?: Array<string> | undefined, category?: Category | undefined, type?: ReasonType | undefined, createdBy?: { __typename?: 'User', id: string, email: string, firstName?: string | undefined, lastName?: string | undefined, role?: UserRole | undefined, type: UserType } | undefined } | undefined } | { __typename?: 'Sentiment', id: string, displayName: string, description?: string | undefined, type: LabelType, createdAt?: number | undefined, isVisible: boolean } | undefined };

export type GetNotificationsQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  includeViewed?: InputMaybe<Scalars['Boolean']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', getNotifications?: { __typename?: 'GetNotificationsResponse', hits: number, cursor?: string | undefined, notifications?: Array<{ __typename?: 'Notification', id: string, type: NotificationType, category: string, title: string, richText: string, createdAt: number, viewed: boolean }> | undefined } | undefined };

export type SuggestionViewFragment = { __typename?: 'Suggestion', id: string, tenantID: string, description: string, type: SuggestionType, createdBy: string, createdAt: number, lastUpdatedAt: number, status: SuggestionResolutionStatus, tags?: Array<{ __typename?: 'SuggestionTag', key: string, value: string }> | undefined };

export type ListSuggestionsQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  filter?: InputMaybe<ListSuggestionsFilter>;
  responseSize?: InputMaybe<Scalars['Int']>;
}>;


export type ListSuggestionsQuery = { __typename?: 'Query', listSuggestions?: { __typename?: 'ListSuggestionsResponse', cursor?: string | undefined, suggestions?: Array<{ __typename?: 'Suggestion', id: string, tenantID: string, description: string, type: SuggestionType, createdBy: string, createdAt: number, lastUpdatedAt: number, status: SuggestionResolutionStatus, tags?: Array<{ __typename?: 'SuggestionTag', key: string, value: string }> | undefined }> | undefined } | undefined };

export type GetExtendedUserQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  userID: Scalars['ID'];
  onlyReference?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetExtendedUserQuery = { __typename?: 'Query', getExtendedUser?: { __typename?: 'GetExtendedUserResponse', tags?: Array<string> | undefined } | undefined };

export type MetadataDetailsViewFragment = { __typename?: 'MetadataKey', key: string, type: MetadataDataType, cardinality: number, source?: Source | undefined, displayText: string, originalDisplayText: string, description: string, isHidden: boolean, isImportant: boolean, isFilterable: boolean, isGroupable: boolean, namespace?: string | undefined, id: string, values: Array<{ __typename?: 'Value', S?: string | undefined, N?: number | undefined, B?: boolean | undefined }>, referencedIn?: { __typename?: 'MetadataKey', displayText: string, key: string } | undefined };

export type ListMetadataKeysQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  filter?: InputMaybe<ListMetadataKeysFilter>;
}>;


export type ListMetadataKeysQuery = { __typename?: 'Query', listMetadataKeys?: { __typename?: 'MetadataKeys', keys?: Array<{ __typename?: 'MetadataKey', key: string, type: MetadataDataType, cardinality: number, source?: Source | undefined, displayText: string, originalDisplayText: string, description: string, isHidden: boolean, isImportant: boolean, isFilterable: boolean, isGroupable: boolean, namespace?: string | undefined, id: string, values: Array<{ __typename?: 'Value', S?: string | undefined, N?: number | undefined, B?: boolean | undefined }>, referencedIn?: { __typename?: 'MetadataKey', displayText: string, key: string } | undefined }> | undefined } | undefined };

export type SearchArtefactsQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<ArtefactType> | ArtefactType>;
  statuses?: InputMaybe<Array<Status> | Status>;
  scopes?: InputMaybe<Array<Scope> | Scope>;
  editableByFilter?: InputMaybe<ArtefactEditableByFilter>;
  filter?: InputMaybe<ArtefactSpecificFilter>;
  responseSize?: InputMaybe<Scalars['Int']>;
  cursor?: InputMaybe<Scalars['String']>;
}>;


export type SearchArtefactsQuery = { __typename?: 'Query', searchArtefacts?: { __typename?: 'SearchArtefactsResponse', cursor?: string | undefined, artefacts: Array<{ __typename?: 'ArtefactListItem', id: string, title: string, type: ArtefactType, viewToken: string, scope?: Scope | undefined, status?: Status | undefined, createdAt: number, updatedAt: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, artefactDetails?: { __typename?: 'ArtefactDetails', analysis?: { __typename?: 'AnalysisArtefactDetails', useCase: AnalysisUseCase } | undefined, dashboard?: { __typename?: 'DashboardArtefactDetails', useCase: DashboardUseCase } | undefined } | undefined }> } | undefined };

export type ArtefactListItemViewFragment = { __typename?: 'ArtefactListItem', id: string, title: string, type: ArtefactType, viewToken: string, scope?: Scope | undefined, status?: Status | undefined, createdAt: number, updatedAt: number, createdBy: { __typename?: 'UserInfo', id: string, firstName: string, lastName: string }, artefactDetails?: { __typename?: 'ArtefactDetails', analysis?: { __typename?: 'AnalysisArtefactDetails', useCase: AnalysisUseCase } | undefined, dashboard?: { __typename?: 'DashboardArtefactDetails', useCase: DashboardUseCase } | undefined } | undefined };

export type ListIntegrationsQueryVariables = Exact<{
  tenantID: Scalars['ID'];
  query?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  cursor?: InputMaybe<Scalars['String']>;
  directions?: InputMaybe<Array<IntegrationDirection> | IntegrationDirection>;
}>;


export type ListIntegrationsQuery = { __typename?: 'Query', listIntegrations?: { __typename?: 'ListIntegrationsResponse', cursor?: string | undefined, integrations?: Array<{ __typename?: 'Integration', id: string, tenantID: string, direction: IntegrationDirection, isActive: boolean, createdByUser?: string | undefined, createdAt: number, externalID?: string | undefined, namespace?: string | undefined, onboardingProgress?: number | undefined, integrationType: IntegrationType, source?: string | undefined, eqlFieldsGroupID?: string | undefined, externalLinkKey?: string | undefined, channel: { __typename?: 'IntegrationChannel', displayName: string, logo?: string | undefined, type: IntegrationChannelType }, data: { __typename: 'IntegrationData', emailInbound?: { __typename?: 'EmailInboundIntegrationData', receiveOnEmail: string } | undefined, emails?: { __typename?: 'EmailIntegrationData', toEmails: Array<string>, ccEmails?: Array<string> | undefined } | undefined, surveyMonkey?: { __typename?: 'SurveyMonkeyIntegrationData', includedSurveys?: Array<{ __typename?: 'Survey', name: string, surveyID: string }> | undefined } | undefined, typeform?: { __typename?: 'TypeformIntegrationData', includedForms?: Array<{ __typename?: 'TypeformForm', title: string, id: string }> | undefined } | undefined, salesforce?: { __typename: 'SalesforceIntegrationData', orderBy: SalesforceOrderByField, objectSchema?: { __typename?: 'SalesforceObjectSchema', name: string, surveyContent?: Array<{ __typename?: 'SalesforceFieldSchema', name: string, label: string }> | undefined, fieldsToResolve: Array<{ __typename?: 'SalesforceReferenceSchema', name: string, objectName: string, relationshipName: string }> } | undefined, condition?: { __typename?: 'SalesforceIngestionCondition', field: Array<{ __typename?: 'SalesforceIngestionFieldCondition', field: string, values: { __typename?: 'PrimitiveValueArray', S?: Array<string> | undefined, N?: Array<number> | undefined, B?: Array<boolean> | undefined } }> } | undefined } | undefined, fileUpload?: { __typename: 'FileUploadIntegrationData', fileSource: string, isEmpty: boolean } | undefined, discord?: { __typename: 'DiscordIntegrationData', guildName: string, guildID: string, subscribedChannels: Array<{ __typename?: 'DiscordChannel', id: string, name: string }> } | undefined, snowflake?: { __typename?: 'SnowflakeIntegrationData', publicKey: string } | undefined, slack?: { __typename?: 'SlackIntegrationData', createdByUserID?: string | undefined, subscribedChannels: Array<{ __typename?: 'SlackChannel', id: string, name: string, isPrivate?: boolean | undefined }> } | undefined, webhook?: { __typename?: 'WebhookIntegrationData', displayName: string } | undefined, discourse?: { __typename?: 'DiscourseIntegrationData', subscribedCategories: Array<{ __typename?: 'DiscourseCategory', id: string, name: string }> } | undefined, facebookPages?: { __typename?: 'FacebookPagesIntegrationData', userAccessToken: string, subscribedPage?: { __typename?: 'FacebookPage', id: string, name: string } | undefined } | undefined, reddit?: { __typename?: 'RedditIntegrationData', subreddit: string } | undefined, qualtrics?: { __typename?: 'QualtricsIntegrationData', surveys: Array<{ __typename?: 'QualtricsSurvey', id: string, name: string }> } | undefined, googleMyBusiness?: { __typename?: 'GoogleMyBusinessIntegrationData', account?: { __typename?: 'GoogleMyBusinessAccount', id: string, name: string } | undefined } | undefined, gainsight?: { __typename?: 'GainsightIntegrationData', subscribedCategories: Array<{ __typename?: 'GainsightCategory', id: string, name: string }> } | undefined, sprig?: { __typename?: 'SprigIntegrationData', surveys: Array<{ __typename?: 'SprigSurvey', id: string, name: string }> } | undefined, feedbackMetadataEnrichment?: { __typename?: 'FeedbackMetadataEnrichmentIntegrationData', metadataKeys?: Array<string> | undefined } | undefined }, description?: { __typename?: 'IntegrationDescription', description?: string | undefined, descriptionMap?: Array<{ __typename?: 'DescriptionMap', sourceID: string, description: string }> | undefined } | undefined }> | undefined } | undefined };

export type IsDomainSsoQueryVariables = Exact<{
  domain: Scalars['String'];
  slug?: InputMaybe<Scalars['String']>;
}>;


export type IsDomainSsoQuery = { __typename?: 'Query', isDomainSso?: { __typename?: 'IsDomainSsoResponse', result: boolean, isEnforced?: boolean | undefined, isSaml?: boolean | undefined } | undefined };

export type ValidatePhraseInRecordQueryVariables = Exact<{
  request: ValidatePhraseInRecordInput;
}>;


export type ValidatePhraseInRecordQuery = { __typename?: 'Query', validatePhraseInRecord?: { __typename?: 'ValidatePhraseInRecordResponse', isPhraseValid: boolean, entityLocations?: Array<{ __typename?: 'AspectPredictionMetadataUnit', startOffset: number, endOffset: number, msgIndex?: number | undefined }> | undefined } | undefined };

export type GetReasonSuggestionQueryVariables = Exact<{
  request: GetReasonSuggestionInput;
}>;


export type GetReasonSuggestionQuery = { __typename?: 'Query', getReasonSuggestion?: { __typename?: 'GetReasonSuggestionResponse', suggestedReasons: Array<{ __typename?: 'SuggestedReason', relatedRCs?: Array<string> | undefined, labelID?: string | undefined, label?: { __typename: 'Aspect', id: string, displayName: string, type: LabelType, description?: string | undefined, createdAt?: number | undefined, isVisible: boolean } | { __typename: 'Cluster', id: string, displayName: string, type: LabelType, description?: string | undefined, createdAt?: number | undefined, isVisible: boolean } | { __typename: 'GenericLabel', id: string, displayName: string, type: LabelType, description?: string | undefined, createdAt?: number | undefined, isVisible: boolean } | { __typename: 'L1', id: string, displayName: string, type: LabelType, description?: string | undefined, createdAt?: number | undefined, isVisible: boolean } | { __typename: 'Reason', updateInProgress: boolean, id: string, displayName: string, type: LabelType, description?: string | undefined, createdAt?: number | undefined, isVisible: boolean, metadata?: { __typename?: 'ReasonMetadata', category?: Category | undefined } | undefined } | { __typename: 'Sentiment', id: string, displayName: string, type: LabelType, description?: string | undefined, createdAt?: number | undefined, isVisible: boolean } | undefined }> } | undefined };

export type ListTenantsForEmailQueryVariables = Exact<{
  request: ListTenantsForEmailInput;
}>;


export type ListTenantsForEmailQuery = { __typename?: 'Query', listTenantsForEmail?: { __typename?: 'ListTenantsForEmailResponse', tenantOptions?: Array<{ __typename?: 'TenantOption', id: string, name: string, slug: string, avatarURL?: string | undefined }> | undefined } | undefined };

export type SearchUnassignedRCsQueryVariables = Exact<{
  request: SearchUnassignedRCsInput;
}>;


export type SearchUnassignedRCsQuery = { __typename?: 'Query', searchUnassignedRCs?: { __typename?: 'SearchUnassignedRCsResponse', unassignedRCs: Array<{ __typename?: 'UnassignedRC', id?: string | undefined, name: string, category?: Category | undefined, recordIDs: Array<string> }> } | undefined };

export type GetRcSuggestionQueryVariables = Exact<{
  request: GetRcSuggestionInput;
}>;


export type GetRcSuggestionQuery = { __typename?: 'Query', getRCSuggestion?: { __typename?: 'GetRCSuggestionResponse', suggestedRCs: Array<{ __typename?: 'UnassignedRC', id?: string | undefined, name: string, recordIDs: Array<string> }> } | undefined };

export type ListDemoTenantsQueryVariables = Exact<{
  request: ListDemoTenantsInput;
}>;


export type ListDemoTenantsQuery = { __typename?: 'Query', listDemoTenants?: { __typename?: 'ListDemoTenantsResponse', tenants: Array<{ __typename?: 'TenantOption', id: string, name: string, tenantCategory?: string | undefined, slug: string, avatarURL?: string | undefined }> } | undefined };

export const UserInfoViewFragmentDoc = gql`
    fragment UserInfoView on UserInfo {
  id
  firstName
  lastName
}
    `;
export const DashboardMetadataViewFragmentDoc = gql`
    fragment DashboardMetadataView on DashboardMetadata {
  layout {
    rows {
      cells {
        columnSpan
        contentID
        id
        __typename @skip(if: true)
      }
      height
      id
      __typename @skip(if: true)
    }
  }
  analysesMetadata {
    id
    shouldShowAnomaliesAsChart
    shouldExcludeCooccurring
    shouldShowAsTable
    barLabelWidth
    shouldShowAsFeed
  }
}
    `;
export const DashboardListItemViewFragmentDoc = gql`
    fragment DashboardListItemView on DashboardListItem {
  id
  title
  description
  viewToken
  editToken
  scope
  createdBy {
    ...UserInfoView
  }
  recency
  analysisIDs
  shortMetadata
  createdAt
  tenantID
  useCase
  metadataV2 {
    ...DashboardMetadataView
  }
  version
}
    ${UserInfoViewFragmentDoc}
${DashboardMetadataViewFragmentDoc}`;
export const TenantWithoutIntegrationsViewFragmentDoc = gql`
    fragment TenantWithoutIntegrationsView on Tenant {
  id
  name
  domains
  tier
  slug
  avatarURL
  timezone
  state
  dashboardSettings {
    maxLookbackDate
    defaultTimeRange {
      unit
      value
    }
    homePageStatsDashboard
    showUnTranslatedRecords
    defaultUserType
    homepageDashboardID
  }
  pinnedDashboards {
    ...DashboardListItemView
  }
}
    ${DashboardListItemViewFragmentDoc}`;
export const IntegrationChannelViewFragmentDoc = gql`
    fragment IntegrationChannelView on IntegrationChannel {
  displayName
  logo
  type
}
    `;
export const IntegrationViewFragmentDoc = gql`
    fragment IntegrationView on Integration {
  id
  tenantID
  channel {
    ...IntegrationChannelView
  }
  data {
    emailInbound {
      receiveOnEmail
    }
    emails {
      toEmails
      ccEmails
    }
    surveyMonkey {
      includedSurveys {
        name
        surveyID
      }
    }
    typeform {
      includedForms {
        title
        id
      }
    }
    salesforce {
      objectSchema {
        name
        surveyContent {
          name
          label
        }
        fieldsToResolve {
          name
          objectName
          relationshipName
        }
      }
      condition {
        field {
          field
          values {
            S
            N
            B
          }
        }
      }
      orderBy
      __typename
    }
    fileUpload {
      fileSource
      isEmpty
      __typename
    }
    discord {
      guildName
      guildID
      subscribedChannels {
        id
        name
      }
      __typename
    }
    snowflake {
      publicKey
    }
    slack {
      subscribedChannels {
        id
        name
        isPrivate
      }
      createdByUserID
    }
    webhook {
      displayName
    }
    discourse {
      subscribedCategories {
        id
        name
      }
    }
    facebookPages {
      subscribedPage {
        id
        name
      }
      userAccessToken
    }
    reddit {
      subreddit
    }
    qualtrics {
      surveys {
        id
        name
      }
    }
    googleMyBusiness {
      account {
        id
        name
      }
    }
    gainsight {
      subscribedCategories {
        id
        name
      }
    }
    sprig {
      surveys {
        id
        name
      }
    }
    feedbackMetadataEnrichment {
      metadataKeys
    }
    __typename
  }
  direction
  isActive
  createdByUser
  createdAt
  externalID
  namespace
  onboardingProgress
  integrationType
  source
  eqlFieldsGroupID
  description {
    description
    descriptionMap {
      sourceID
      description
    }
  }
  externalLinkKey
}
    ${IntegrationChannelViewFragmentDoc}`;
export const TenantViewFragmentDoc = gql`
    fragment TenantView on Tenant {
  ...TenantWithoutIntegrationsView
  integrations {
    ...IntegrationView
  }
}
    ${TenantWithoutIntegrationsViewFragmentDoc}
${IntegrationViewFragmentDoc}`;
export const UserViewFragmentDoc = gql`
    fragment UserView on User {
  id
  email
  firstName
  lastName
  role
  type
  state
  createdAt
  intercomUserHash
  homepageDashboardID
  notificationChannels {
    id
    direction
    isActive
    channel {
      type
      displayName
    }
  }
  Tenant {
    ...TenantView
  }
  interests {
    keywords
    labelIDs
  }
  pinnedDashboards {
    ...DashboardListItemView
  }
  permissions {
    resource
    operation
  }
}
    ${TenantViewFragmentDoc}
${DashboardListItemViewFragmentDoc}`;
export const TextIndexViewFragmentDoc = gql`
    fragment TextIndexView on IndexTypeText {
  startOffset
  endOffset
}
    `;
export const IndexMetadataViewFragmentDoc = gql`
    fragment IndexMetadataView on IndexMetadata {
  ... on IndexTypeText {
    ...TextIndexView
  }
  ... on IndexTypeConversation {
    messageIndex
    textIndex {
      ...TextIndexView
    }
    messageEndIndex
  }
  ... on IndexTypeSurvey {
    qnaIndex
    optionIndex
    textIndex {
      ...TextIndexView
    }
  }
  ... on IndexTypeAudioConversation {
    startTime
    endTime
    msgIdx
    startIdx
    endIdx
  }
  ... on IndexTypeKeywordSummary {
    msgIdx
    labelID
    startIdx
    endIdx
  }
}
    ${TextIndexViewFragmentDoc}`;
export const RecordSummaryViewFragmentDoc = gql`
    fragment RecordSummaryView on RecordSummary {
  units {
    text
    metadata {
      location {
        ...IndexMetadataView
      }
      flag
    }
  }
  flag
}
    ${IndexMetadataViewFragmentDoc}`;
export const SourceMetadataViewFragmentDoc = gql`
    fragment SourceMetadataView on SourceMetadata {
  __typename
  objectID
  key
  field
  value {
    s
    b
    n
  }
  queriable
  isImportant
  objectType
  isReference
}
    `;
export const SourceDataV2ViewFragmentDoc = gql`
    fragment SourceDataV2View on SourceDataV2 {
  name
  logo
  externalLink
  integrationChannelType
  __typename
  metadata {
    ...SourceMetadataView
  }
}
    ${SourceMetadataViewFragmentDoc}`;
export const RecordLabelViewFragmentDoc = gql`
    fragment RecordLabelView on Label {
  id
  displayName
  type
  createdAt
  isVisible
  ... on Aspect {
    isUncategorized
  }
  ... on L1 {
    isUncategorized
  }
  __typename
  ... on Reason {
    metadata {
      category
    }
  }
  updateInProgress
}
    `;
export const PredictionMetadataViewFragmentDoc = gql`
    fragment PredictionMetadataView on PredictionMetadata {
  ... on AspectPredictionMetadata {
    sentiment
    units {
      sentiment
      category
      indexMetadata {
        ...IndexMetadataView
      }
    }
    keywordSummary {
      ...RecordSummaryView
    }
    keywordSummaryHash
  }
  ... on ReasonPredictionMetadata {
    sentiment
    units {
      indexMetadata {
        ...IndexMetadataView
      }
    }
  }
  ... on SentimentPredictionMetadata {
    units {
      sentiment
      indexMetadata {
        ...IndexMetadataView
      }
    }
  }
}
    ${IndexMetadataViewFragmentDoc}
${RecordSummaryViewFragmentDoc}`;
export const RecordPredictionViewFragmentDoc = gql`
    fragment RecordPredictionView on Prediction {
  labelID
  label {
    ...RecordLabelView
  }
  predictionMetadata {
    ...PredictionMetadataView
  }
  children {
    labelID
    label {
      ...RecordLabelView
    }
    predictionMetadata {
      ...PredictionMetadataView
    }
    children {
      labelID
      label {
        ...RecordLabelView
      }
      predictionMetadata {
        ...PredictionMetadataView
      }
    }
  }
}
    ${RecordLabelViewFragmentDoc}
${PredictionMetadataViewFragmentDoc}`;
export const RecordViewFragmentDoc = gql`
    fragment RecordView on Record {
  id
  text
  type
  rcData {
    units {
      metadata {
        isPredicted
      }
    }
  }
  matchMetadata {
    search {
      startIDx
      endIDx
      msgIDx
    }
  }
  surveyResponse {
    responses {
      answer
      question
      selectedOptions
    }
  }
  surveyResponseEn {
    responses {
      answer
      question
      selectedOptions
    }
  }
  conversation {
    msgs {
      text
      actor
      actorID
    }
  }
  summary {
    ...RecordSummaryView
  }
  forumThreadEn {
    title
    header {
      actorID
      text
    }
    intermediatePosts {
      text
      actorID
    }
    latestPost {
      text
      actorID
    }
  }
  forumThread {
    title
    header {
      actorID
      text
    }
    intermediatePosts {
      text
      actorID
    }
    latestPost {
      text
      actorID
    }
  }
  conversationEn {
    msgs {
      text
      actor
      actorID
    }
  }
  audioConversation {
    audioFileS3
    units {
      actor
      text
      actorType
      metadata {
        startTime
        endTime
      }
    }
  }
  audioConversationEn {
    audioFileS3
    units {
      actor
      text
      actorType
      metadata {
        startTime
        endTime
      }
    }
  }
  language {
    source
    iso6393
    language
  }
  sourceTimestamp
  sourceDataV2 {
    ...SourceDataV2View
  }
  textEN
  sourceID
  createdAt
  namespace
  predictions {
    ...RecordPredictionView
  }
  predictionHierarchies {
    ...RecordPredictionView
  }
}
    ${RecordSummaryViewFragmentDoc}
${SourceDataV2ViewFragmentDoc}
${RecordPredictionViewFragmentDoc}`;
export const GetRecordsResponseViewFragmentDoc = gql`
    fragment GetRecordsResponseView on GetRecordsResponse {
  records {
    ...RecordView
  }
  cursor
  previous
  hits
}
    ${RecordViewFragmentDoc}`;
export const BucketParamsFragmentDoc = gql`
    fragment BucketParams on AggregateBucketKey {
  bucketID: id
  timestamp
  source
  labelID
  language {
    iso6393
  }
  metadata {
    keyValues {
      key
      value
    }
  }
  entitySentiment
  namespace
  category
  label {
    displayName
    isVisible
    updateInProgress
  }
}
    `;
export const AggregateDataPointViewFragmentDoc = gql`
    fragment AggregateDataPointView on AggregateDataPoint {
  bucket {
    ...BucketParams
  }
  value
  intermediates {
    func
    value {
      applyTaxonomy {
        isRelevant
      }
      anomaly {
        zScore
        mean
        isAnomalous
      }
      nps {
        detractorsPercentage
        promotersPercentage
      }
      csat {
        satisfiedResponses
        totalResponses
      }
      mean {
        totalValue
        weightedSum
      }
      dsat {
        dissatisfiedResponses
        totalResponses
      }
      subGroupBy {
        value
        bucket {
          ...BucketParams
        }
      }
    }
  }
}
    ${BucketParamsFragmentDoc}`;
export const GetAggregatesResponseViewFragmentDoc = gql`
    fragment GetAggregatesResponseView on GetAggregatesResponse {
  data {
    ...AggregateDataPointView
  }
  valueRange {
    start
    end
  }
  aggregateHits: hits
}
    ${AggregateDataPointViewFragmentDoc}`;
export const DeltaAggregateDataPointViewFragmentDoc = gql`
    fragment DeltaAggregateDataPointView on DeltaAggregateDataPoint {
  bucket {
    ...BucketParams
  }
  prevValue
  currValue
  absoluteDelta
  relativeDelta
  currIntermediates {
    func
    value {
      applyTaxonomy {
        isRelevant
      }
      nps {
        detractorsPercentage
        promotersPercentage
      }
      csat {
        satisfiedResponses
        totalResponses
      }
      mean {
        totalValue
        weightedSum
      }
      dsat {
        dissatisfiedResponses
        totalResponses
      }
    }
  }
  prevIntermediates {
    func
    value {
      applyTaxonomy {
        isRelevant
      }
      nps {
        detractorsPercentage
        promotersPercentage
      }
      csat {
        satisfiedResponses
        totalResponses
      }
      mean {
        totalValue
        weightedSum
      }
      dsat {
        dissatisfiedResponses
        totalResponses
      }
    }
  }
}
    ${BucketParamsFragmentDoc}`;
export const GetDeltaAggregatesResponseViewFragmentDoc = gql`
    fragment GetDeltaAggregatesResponseView on GetDeltaAggregatesResponse {
  dataV2 {
    ...DeltaAggregateDataPointView
  }
  valueRange {
    start
    end
  }
  aggregateHits: hits
}
    ${DeltaAggregateDataPointViewFragmentDoc}`;
export const IntegrationFormDataViewFragmentDoc = gql`
    fragment IntegrationFormDataView on IntegrationFormData {
  channel {
    ...IntegrationChannelView
  }
  direction
  integrationType
  ... on OAuthFormData {
    oAuthURL
  }
  isContextual
}
    ${IntegrationChannelViewFragmentDoc}`;
export const LabelFragmentFragmentDoc = gql`
    fragment LabelFragment on Label {
  id
  displayName
  description
  type
  createdAt
  isVisible
  ... on Reason {
    metadata {
      sentiment
      representativeSentences
      type
      category
      createdBy {
        id
        email
        firstName
        lastName
        role
        type
      }
    }
  }
  ... on Aspect {
    metadata {
      phrases
      excludedPhrases
    }
  }
}
    `;
export const AnalysisListItemViewFragmentDoc = gql`
    fragment AnalysisListItemView on AnalysisListItem {
  id
  title
  viewToken
  editToken
  scope
  recency
  createdBy {
    ...UserInfoView
  }
  useCase
  context {
    eqlExpression
  }
  metadataV2 {
    collection {
      savedFeedbackMetadata {
        feedbackID
        isFeedbackSaved
        snippetMetadataV2 {
          location {
            ...IndexMetadataView
          }
        }
      }
    }
  }
}
    ${UserInfoViewFragmentDoc}
${IndexMetadataViewFragmentDoc}`;
export const EqlQueryPropertiesViewFragmentDoc = gql`
    fragment EqlQueryPropertiesView on EQLQueryProperties {
  aggregatePeriod
  duration {
    endBefore
    relative {
      unit
      value
    }
    startAfter
  }
  functions {
    anomaly {
      shouldIncludeNonAnomalies
      threshold
    }
    top {
      count
    }
    taxonomy {
      shouldIncludeIrrelevant
    }
    selection {
      values
    }
    search {
      terms
    }
    paginate {
      pageNumber
      pageSize
    }
    order {
      anomalousValue
      isDescending
      metadataValue
      timestamp
      value
      volume
    }
    deltaTop {
      count
    }
    deltaPaginate {
      pageNumber
      pageSize
    }
    deltaOrder {
      absoluteDifference
      baseline
      difference
      inspect
      metadataValue
      isDescending
    }
  }
  formula {
    description
    displayName
    eqlFunction
    group
    helpCentreURL
    isSupported
    shortName
  }
  formulaQuery {
    criteria {
      field
      displayName
      iconURL
      isMultiValue
      objectType
      valueType
      detail {
        metadata {
          references {
            displayName
            iconURL
            key
            source
          }
          source
        }
        reference {
          creatorID
          creatorName
          referenceID
          referenceType
        }
      }
    }
    denominatorWhereClause
    eqlFunction
  }
  compareQuery {
    formula {
      criteria {
        field
        displayName
        iconURL
        isMultiValue
        objectType
        valueType
        detail {
          metadata {
            references {
              displayName
              iconURL
              key
              source
            }
            source
          }
          reference {
            creatorID
            creatorName
            referenceID
            referenceType
          }
        }
      }
      denominatorWhereClause
      eqlFunction
    }
    previousPeriod {
      unit
      value
    }
    timerange {
      endBefore
      relative {
        unit
        value
      }
      startAfter
    }
    whereClause
  }
  groupBy {
    entity
    entitySentiment
    labelID
    language
    metadata {
      keys
    }
    predictedOn
    reason
    recordSentiment
    source
    entityCategory
  }
  groupByField {
    detail {
      metadata {
        references {
          displayName
          iconURL
          key
          source
        }
        source
      }
      reference {
        creatorID
        creatorName
        referenceID
        referenceType
      }
    }
    displayName
    field
    iconURL
    isMultiValue
    objectType
    valueType
  }
  isCoOccurring
  type
  whereClause
}
    `;
export const CronValueFragmentFragmentDoc = gql`
    fragment CronValueFragment on CronValue {
  unit
  count
}
    `;
export const CronValueNestedFragmentFragmentDoc = gql`
    fragment CronValueNestedFragment on CronValue {
  ...CronValueFragment
  offset: Offset {
    ...CronValueFragment
    offset: Offset {
      ...CronValueFragment
      offset: Offset {
        ...CronValueFragment
      }
    }
  }
}
    ${CronValueFragmentFragmentDoc}`;
export const CronValueV2FragmentFragmentDoc = gql`
    fragment CronValueV2Fragment on CronValueV2 {
  dayOfWeek
  hourOfDay
  minuteOfHour
  dayOfMonth {
    day
    last
  }
}
    `;
export const ScheduleMetadataFragmentFragmentDoc = gql`
    fragment ScheduleMetadataFragment on ScheduleMetadata {
  defaultReportMetadata {
    skipSnapshot
  }
  feedbackReportMetadata {
    recordCount
  }
}
    `;
export const ReportingIntegrationViewFragmentDoc = gql`
    fragment ReportingIntegrationView on Integration {
  id
  direction
  channel {
    type
  }
  data {
    emails {
      toEmails
    }
    slack {
      subscribedChannels {
        id
        name
        isPrivate
      }
    }
  }
  isActive
}
    `;
export const ScheduleViewFragmentDoc = gql`
    fragment ScheduleView on Schedule {
  id
  cron {
    value {
      ...CronValueNestedFragment
    }
    realtime
    valueV2 {
      ...CronValueV2Fragment
    }
  }
  outbounds
  subjectID
  subjectType
  reportType
  metadata {
    ...ScheduleMetadataFragment
  }
  isDisabled
  isPrimary
  createdAt
  updatedAt
  integrations {
    ...ReportingIntegrationView
  }
}
    ${CronValueNestedFragmentFragmentDoc}
${CronValueV2FragmentFragmentDoc}
${ScheduleMetadataFragmentFragmentDoc}
${ReportingIntegrationViewFragmentDoc}`;
export const ReportingScheduleViewFragmentDoc = gql`
    fragment ReportingScheduleView on Reporting {
  primarySchedule {
    ...ScheduleView
  }
  secondarySchedules {
    ...ScheduleView
  }
}
    ${ScheduleViewFragmentDoc}`;
export const AnalysisViewFragmentDoc = gql`
    fragment AnalysisView on Analysis {
  id
  tenantID
  title
  editToken
  viewToken
  scope
  useCase
  metadata
  description
  metadataV2 {
    collection {
      savedFeedbackMetadata {
        feedbackID
        isFeedbackSaved
        snippetMetadataV2 {
          location {
            ...IndexMetadataView
          }
        }
        snippetMetadata {
          labelID
          snippetIDs
        }
      }
    }
    quantify {
      compareMetadata {
        baseQueryName
        deltaQueryName
      }
      visualisationType
    }
  }
  createdAt
  createdBy {
    ...UserInfoView
  }
  updatedAt
  context {
    eqlExpression
    prompt
    eql {
      eql
      properties {
        ...EqlQueryPropertiesView
      }
    }
  }
  panels {
    title
    metadata
    panelQueries {
      panelID: id
      eqlExpression
    }
  }
  reporting {
    ...ReportingScheduleView
  }
  originAnalysisViewToken
  isReportingDisabled
  status
}
    ${IndexMetadataViewFragmentDoc}
${UserInfoViewFragmentDoc}
${EqlQueryPropertiesViewFragmentDoc}
${ReportingScheduleViewFragmentDoc}`;
export const FilterClauseViewFragmentDoc = gql`
    fragment FilterClauseView on FilterClause {
  whereClause
  timeRange {
    startAfter
    endBefore
    relative {
      value
      unit
    }
  }
}
    `;
export const DashboardViewFragmentDoc = gql`
    fragment DashboardView on Dashboard {
  id
  tenantID
  title
  description
  editToken
  viewToken
  scope
  useCase
  widgets {
    id
    analysis {
      ...AnalysisView
    }
    textWidget {
      id
      text
    }
  }
  metadata
  shortMetadata
  createdAt
  createdBy {
    ...UserInfoView
  }
  updatedAt
  reporting {
    ...ReportingScheduleView
  }
  originDashboard {
    ...DashboardListItemView
  }
  isReportingDisabled
  status
  editors {
    ...UserInfoView
  }
  filterClause {
    ...FilterClauseView
  }
  metadataV2 {
    ...DashboardMetadataView
  }
  version
}
    ${AnalysisViewFragmentDoc}
${UserInfoViewFragmentDoc}
${ReportingScheduleViewFragmentDoc}
${DashboardListItemViewFragmentDoc}
${FilterClauseViewFragmentDoc}
${DashboardMetadataViewFragmentDoc}`;
export const ListUserViewFragmentDoc = gql`
    fragment ListUserView on User {
  id
  firstName
  lastName
  email
  type
  state
}
    `;
export const IntegrationEditFormDataViewFragmentDoc = gql`
    fragment IntegrationEditFormDataView on IntegrationEditFormData {
  surveyMonkey {
    surveys {
      name
      surveyID
    }
  }
  typeform {
    forms {
      title
      id
    }
  }
  salesforce {
    listObjectNames {
      objectNames
    }
    describeObject {
      name
      fields {
        name
        label
        type
      }
    }
  }
  discord {
    channelsInGuild {
      id
      name
    }
  }
  slack {
    channelsInWorkspace {
      id
      name
      isPrivate
    }
    refreshID
  }
  facebookPages {
    pages {
      id
      name
      token
    }
  }
  qualtrics {
    surveys {
      id
      name
    }
  }
  googleMyBusiness {
    accounts {
      id
      name
    }
  }
  gainsight {
    categoryList {
      id
      name
    }
  }
  sprig {
    surveys {
      id
      name
    }
  }
}
    `;
export const SuggestionViewFragmentDoc = gql`
    fragment SuggestionView on Suggestion {
  id
  tenantID
  description
  type
  createdBy
  createdAt
  lastUpdatedAt
  status
  tags {
    key
    value
  }
}
    `;
export const MetadataDetailsViewFragmentDoc = gql`
    fragment MetadataDetailsView on MetadataKey {
  id: key
  key
  type
  cardinality
  values {
    S
    N
    B
  }
  source
  displayText
  originalDisplayText
  description
  isHidden
  isImportant
  isFilterable
  isGroupable
  namespace
  referencedIn {
    displayText
    key
  }
}
    `;
export const ArtefactListItemViewFragmentDoc = gql`
    fragment ArtefactListItemView on ArtefactListItem {
  id
  title
  type
  viewToken
  scope
  status
  createdBy {
    ...UserInfoView
  }
  createdAt
  updatedAt
  artefactDetails {
    analysis {
      useCase
    }
    dashboard {
      useCase
    }
  }
}
    ${UserInfoViewFragmentDoc}`;
export const CreateUserDocument = gql`
    mutation createUser($email: String!, $firstName: String, $lastName: String, $role: UserRole, $interests: UserInterestsInput, $slug: String) {
  createUser(
    request: {email: $email, firstName: $firstName, lastName: $lastName, role: $role, interests: $interests, slug: $slug}
  ) {
    code
    message
    id
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *      interests: // value for 'interests'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const CreateIntegrationDocument = gql`
    mutation createIntegration($tenantID: ID!, $direction: IntegrationDirection!, $channel: IntegrationChannelType!, $createdByUser: String!, $data: IntegrationInputData!, $integrationType: IntegrationType!, $integrationDescription: IntegrationDescriptionInput, $externalLinkKey: String, $displayName: String) {
  createIntegration(
    request: {tenantID: $tenantID, direction: $direction, channel: $channel, createdByUser: $createdByUser, data: $data, integrationType: $integrationType, integrationDescription: $integrationDescription, externalLinkKey: $externalLinkKey, displayName: $displayName}
  ) {
    id
  }
}
    `;
export type CreateIntegrationMutationFn = Apollo.MutationFunction<CreateIntegrationMutation, CreateIntegrationMutationVariables>;

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationMutation, { data, loading, error }] = useCreateIntegrationMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      direction: // value for 'direction'
 *      channel: // value for 'channel'
 *      createdByUser: // value for 'createdByUser'
 *      data: // value for 'data'
 *      integrationType: // value for 'integrationType'
 *      integrationDescription: // value for 'integrationDescription'
 *      externalLinkKey: // value for 'externalLinkKey'
 *      displayName: // value for 'displayName'
 *   },
 * });
 */
export function useCreateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(CreateIntegrationDocument, options);
      }
export type CreateIntegrationMutationHookResult = ReturnType<typeof useCreateIntegrationMutation>;
export type CreateIntegrationMutationResult = Apollo.MutationResult<CreateIntegrationMutation>;
export type CreateIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>;
export const CreateAnalysisDocument = gql`
    mutation createAnalysis($tenantID: ID!, $title: String!, $panels: [AnalysisPanelInput!]!, $scope: Scope, $metadata: String!, $metadataV2: AnalysisMetadataInput, $createdBy: ID!, $analysisExpresssion: String!, $useCase: AnalysisUseCase, $dashboardToAddTo: AddAnalysisToDashboardInput, $addToNewDashboard: CreateDashboardInput, $addToDuplicateOfDashboard: DuplicateDashboardInput, $description: String, $prompt: String, $eql: EQLQueryInput) {
  createAnalysis(
    request: {tenantID: $tenantID, title: $title, panels: $panels, scope: $scope, metadata: $metadata, metadataV2: $metadataV2, createdBy: $createdBy, context: {eqlExpression: $analysisExpresssion, prompt: $prompt, eql: $eql}, useCase: $useCase, addToDashboard: $dashboardToAddTo, addToNewDashboard: $addToNewDashboard, description: $description, addToDuplicateOfDashboard: $addToDuplicateOfDashboard}
  ) {
    id
    viewToken
    editToken
    createDashboardResponse {
      id
      viewToken
      editToken
      dashboard {
        version
      }
    }
    duplicateDashboardResponse {
      dashboard {
        ...DashboardView
      }
    }
  }
}
    ${DashboardViewFragmentDoc}`;
export type CreateAnalysisMutationFn = Apollo.MutationFunction<CreateAnalysisMutation, CreateAnalysisMutationVariables>;

/**
 * __useCreateAnalysisMutation__
 *
 * To run a mutation, you first call `useCreateAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAnalysisMutation, { data, loading, error }] = useCreateAnalysisMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      title: // value for 'title'
 *      panels: // value for 'panels'
 *      scope: // value for 'scope'
 *      metadata: // value for 'metadata'
 *      metadataV2: // value for 'metadataV2'
 *      createdBy: // value for 'createdBy'
 *      analysisExpresssion: // value for 'analysisExpresssion'
 *      useCase: // value for 'useCase'
 *      dashboardToAddTo: // value for 'dashboardToAddTo'
 *      addToNewDashboard: // value for 'addToNewDashboard'
 *      addToDuplicateOfDashboard: // value for 'addToDuplicateOfDashboard'
 *      description: // value for 'description'
 *      prompt: // value for 'prompt'
 *      eql: // value for 'eql'
 *   },
 * });
 */
export function useCreateAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<CreateAnalysisMutation, CreateAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAnalysisMutation, CreateAnalysisMutationVariables>(CreateAnalysisDocument, options);
      }
export type CreateAnalysisMutationHookResult = ReturnType<typeof useCreateAnalysisMutation>;
export type CreateAnalysisMutationResult = Apollo.MutationResult<CreateAnalysisMutation>;
export type CreateAnalysisMutationOptions = Apollo.BaseMutationOptions<CreateAnalysisMutation, CreateAnalysisMutationVariables>;
export const UpdateAnalysisDocument = gql`
    mutation updateAnalysis($id: ID!, $tenantID: ID!, $title: String, $panels: [AnalysisPanelInput!], $scope: Scope, $metadata: String, $metadataV2: AnalysisMetadataInput, $context: AnalysisContextInput, $editToken: String!, $isReportingDisabled: Boolean, $status: Status, $createdBy: ID, $useCase: AnalysisUseCase, $description: String) {
  updateAnalysis(
    request: {id: $id, tenantID: $tenantID, title: $title, panels: $panels, scope: $scope, metadata: $metadata, metadataV2: $metadataV2, editToken: $editToken, context: $context, isReportingDisabled: $isReportingDisabled, status: $status, createdBy: $createdBy, useCase: $useCase, description: $description}
  ) {
    updated
  }
}
    `;
export type UpdateAnalysisMutationFn = Apollo.MutationFunction<UpdateAnalysisMutation, UpdateAnalysisMutationVariables>;

/**
 * __useUpdateAnalysisMutation__
 *
 * To run a mutation, you first call `useUpdateAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalysisMutation, { data, loading, error }] = useUpdateAnalysisMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenantID: // value for 'tenantID'
 *      title: // value for 'title'
 *      panels: // value for 'panels'
 *      scope: // value for 'scope'
 *      metadata: // value for 'metadata'
 *      metadataV2: // value for 'metadataV2'
 *      context: // value for 'context'
 *      editToken: // value for 'editToken'
 *      isReportingDisabled: // value for 'isReportingDisabled'
 *      status: // value for 'status'
 *      createdBy: // value for 'createdBy'
 *      useCase: // value for 'useCase'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useUpdateAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalysisMutation, UpdateAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalysisMutation, UpdateAnalysisMutationVariables>(UpdateAnalysisDocument, options);
      }
export type UpdateAnalysisMutationHookResult = ReturnType<typeof useUpdateAnalysisMutation>;
export type UpdateAnalysisMutationResult = Apollo.MutationResult<UpdateAnalysisMutation>;
export type UpdateAnalysisMutationOptions = Apollo.BaseMutationOptions<UpdateAnalysisMutation, UpdateAnalysisMutationVariables>;
export const DeleteAnalysisDocument = gql`
    mutation deleteAnalysis($request: DeleteAnalysisInput!) {
  deleteAnalysis(request: $request) {
    deleted
  }
}
    `;
export type DeleteAnalysisMutationFn = Apollo.MutationFunction<DeleteAnalysisMutation, DeleteAnalysisMutationVariables>;

/**
 * __useDeleteAnalysisMutation__
 *
 * To run a mutation, you first call `useDeleteAnalysisMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalysisMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalysisMutation, { data, loading, error }] = useDeleteAnalysisMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useDeleteAnalysisMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalysisMutation, DeleteAnalysisMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalysisMutation, DeleteAnalysisMutationVariables>(DeleteAnalysisDocument, options);
      }
export type DeleteAnalysisMutationHookResult = ReturnType<typeof useDeleteAnalysisMutation>;
export type DeleteAnalysisMutationResult = Apollo.MutationResult<DeleteAnalysisMutation>;
export type DeleteAnalysisMutationOptions = Apollo.BaseMutationOptions<DeleteAnalysisMutation, DeleteAnalysisMutationVariables>;
export const CreateDashboardDocument = gql`
    mutation createDashboard($tenantID: String!, $title: String!, $scope: Scope, $analysisIDs: [String!], $metadata: String!, $shortMetadata: String, $createdBy: ID!, $useCase: DashboardUseCase, $metadataV2: DashboardMetadataInput, $addWidget: CreateDashboardWidgetInput) {
  createDashboard(
    request: {tenantID: $tenantID, title: $title, scope: $scope, analysisIDs: $analysisIDs, metadata: $metadata, shortMetadata: $shortMetadata, createdBy: $createdBy, useCase: $useCase, metadataV2: $metadataV2, addWidget: $addWidget}
  ) {
    id
    viewToken
    editToken
    dashboard {
      ...DashboardView
    }
  }
}
    ${DashboardViewFragmentDoc}`;
export type CreateDashboardMutationFn = Apollo.MutationFunction<CreateDashboardMutation, CreateDashboardMutationVariables>;

/**
 * __useCreateDashboardMutation__
 *
 * To run a mutation, you first call `useCreateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDashboardMutation, { data, loading, error }] = useCreateDashboardMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      title: // value for 'title'
 *      scope: // value for 'scope'
 *      analysisIDs: // value for 'analysisIDs'
 *      metadata: // value for 'metadata'
 *      shortMetadata: // value for 'shortMetadata'
 *      createdBy: // value for 'createdBy'
 *      useCase: // value for 'useCase'
 *      metadataV2: // value for 'metadataV2'
 *      addWidget: // value for 'addWidget'
 *   },
 * });
 */
export function useCreateDashboardMutation(baseOptions?: Apollo.MutationHookOptions<CreateDashboardMutation, CreateDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDashboardMutation, CreateDashboardMutationVariables>(CreateDashboardDocument, options);
      }
export type CreateDashboardMutationHookResult = ReturnType<typeof useCreateDashboardMutation>;
export type CreateDashboardMutationResult = Apollo.MutationResult<CreateDashboardMutation>;
export type CreateDashboardMutationOptions = Apollo.BaseMutationOptions<CreateDashboardMutation, CreateDashboardMutationVariables>;
export const UpdateDashboardDocument = gql`
    mutation updateDashboard($id: ID!, $tenantID: ID!, $userID: ID!, $title: String, $description: String, $analysisIDs: [String!], $scope: Scope, $metadata: String, $shortMetadata: String, $editToken: String!, $isReportingDisabled: Boolean, $status: Status, $createdBy: ID, $addAnalysisIDs: [String!], $removeAnalysisIDs: [String!], $editorsToAdd: [ID!], $editorsToRemove: [ID!], $editorsToInvite: [String!], $useCase: DashboardUseCase, $filterClause: FilterClauseInput, $metadataV2: DashboardMetadataInput, $version: Int!, $addWidget: CreateDashboardWidgetInput, $updateWidget: UpdateDashboardWidgetInput, $deleteWidget: DeleteDashboardWidgetInput) {
  updateDashboard(
    request: {id: $id, tenantID: $tenantID, userID: $userID, title: $title, description: $description, analysisIDs: $analysisIDs, scope: $scope, metadata: $metadata, shortMetadata: $shortMetadata, editToken: $editToken, isReportingDisabled: $isReportingDisabled, status: $status, createdBy: $createdBy, addAnalysisIDs: $addAnalysisIDs, removeAnalysisIDs: $removeAnalysisIDs, editorsToAdd: $editorsToAdd, editorsToRemove: $editorsToRemove, editorsToInvite: $editorsToInvite, useCase: $useCase, filterClause: $filterClause, metadataV2: $metadataV2, version: $version, addWidget: $addWidget, updateWidget: $updateWidget, deleteWidget: $deleteWidget}
  ) {
    updated
    dashboard {
      ...DashboardView
    }
  }
}
    ${DashboardViewFragmentDoc}`;
export type UpdateDashboardMutationFn = Apollo.MutationFunction<UpdateDashboardMutation, UpdateDashboardMutationVariables>;

/**
 * __useUpdateDashboardMutation__
 *
 * To run a mutation, you first call `useUpdateDashboardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDashboardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDashboardMutation, { data, loading, error }] = useUpdateDashboardMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      analysisIDs: // value for 'analysisIDs'
 *      scope: // value for 'scope'
 *      metadata: // value for 'metadata'
 *      shortMetadata: // value for 'shortMetadata'
 *      editToken: // value for 'editToken'
 *      isReportingDisabled: // value for 'isReportingDisabled'
 *      status: // value for 'status'
 *      createdBy: // value for 'createdBy'
 *      addAnalysisIDs: // value for 'addAnalysisIDs'
 *      removeAnalysisIDs: // value for 'removeAnalysisIDs'
 *      editorsToAdd: // value for 'editorsToAdd'
 *      editorsToRemove: // value for 'editorsToRemove'
 *      editorsToInvite: // value for 'editorsToInvite'
 *      useCase: // value for 'useCase'
 *      filterClause: // value for 'filterClause'
 *      metadataV2: // value for 'metadataV2'
 *      version: // value for 'version'
 *      addWidget: // value for 'addWidget'
 *      updateWidget: // value for 'updateWidget'
 *      deleteWidget: // value for 'deleteWidget'
 *   },
 * });
 */
export function useUpdateDashboardMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDashboardMutation, UpdateDashboardMutationVariables>(UpdateDashboardDocument, options);
      }
export type UpdateDashboardMutationHookResult = ReturnType<typeof useUpdateDashboardMutation>;
export type UpdateDashboardMutationResult = Apollo.MutationResult<UpdateDashboardMutation>;
export type UpdateDashboardMutationOptions = Apollo.BaseMutationOptions<UpdateDashboardMutation, UpdateDashboardMutationVariables>;
export const UpdateTenantDocument = gql`
    mutation updateTenant($id: ID!, $pinnedDashboardIDs: [ID!]) {
  updateTenant(request: {id: $id, pinnedDashboardIDs: $pinnedDashboardIDs}) {
    code
    message
  }
}
    `;
export type UpdateTenantMutationFn = Apollo.MutationFunction<UpdateTenantMutation, UpdateTenantMutationVariables>;

/**
 * __useUpdateTenantMutation__
 *
 * To run a mutation, you first call `useUpdateTenantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantMutation, { data, loading, error }] = useUpdateTenantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      pinnedDashboardIDs: // value for 'pinnedDashboardIDs'
 *   },
 * });
 */
export function useUpdateTenantMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantMutation, UpdateTenantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantMutation, UpdateTenantMutationVariables>(UpdateTenantDocument, options);
      }
export type UpdateTenantMutationHookResult = ReturnType<typeof useUpdateTenantMutation>;
export type UpdateTenantMutationResult = Apollo.MutationResult<UpdateTenantMutation>;
export type UpdateTenantMutationOptions = Apollo.BaseMutationOptions<UpdateTenantMutation, UpdateTenantMutationVariables>;
export const CreateScheduleDocument = gql`
    mutation createSchedule($cron: CronInput!, $outbounds: [String!]!, $subjectID: ID!, $subjectType: SubjectType!, $reportType: ReportingType!, $metadata: ScheduleMetadataInput!, $tenantID: ID!, $isPrimary: Boolean) {
  createSchedule(
    request: {cron: $cron, outbounds: $outbounds, subjectID: $subjectID, subjectType: $subjectType, reportType: $reportType, metadata: $metadata, tenantID: $tenantID, isPrimary: $isPrimary}
  ) {
    id
  }
}
    `;
export type CreateScheduleMutationFn = Apollo.MutationFunction<CreateScheduleMutation, CreateScheduleMutationVariables>;

/**
 * __useCreateScheduleMutation__
 *
 * To run a mutation, you first call `useCreateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduleMutation, { data, loading, error }] = useCreateScheduleMutation({
 *   variables: {
 *      cron: // value for 'cron'
 *      outbounds: // value for 'outbounds'
 *      subjectID: // value for 'subjectID'
 *      subjectType: // value for 'subjectType'
 *      reportType: // value for 'reportType'
 *      metadata: // value for 'metadata'
 *      tenantID: // value for 'tenantID'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useCreateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduleMutation, CreateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduleMutation, CreateScheduleMutationVariables>(CreateScheduleDocument, options);
      }
export type CreateScheduleMutationHookResult = ReturnType<typeof useCreateScheduleMutation>;
export type CreateScheduleMutationResult = Apollo.MutationResult<CreateScheduleMutation>;
export type CreateScheduleMutationOptions = Apollo.BaseMutationOptions<CreateScheduleMutation, CreateScheduleMutationVariables>;
export const UpdateScheduleDocument = gql`
    mutation updateSchedule($id: ID!, $cron: CronInput, $metadata: ScheduleMetadataInput, $outbounds: [String!], $tenantID: ID!, $isDisabled: Boolean) {
  updateSchedule(
    request: {id: $id, cron: $cron, metadata: $metadata, outbounds: $outbounds, tenantID: $tenantID, isDisabled: $isDisabled}
  ) {
    updated
  }
}
    `;
export type UpdateScheduleMutationFn = Apollo.MutationFunction<UpdateScheduleMutation, UpdateScheduleMutationVariables>;

/**
 * __useUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduleMutation, { data, loading, error }] = useUpdateScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cron: // value for 'cron'
 *      metadata: // value for 'metadata'
 *      outbounds: // value for 'outbounds'
 *      tenantID: // value for 'tenantID'
 *      isDisabled: // value for 'isDisabled'
 *   },
 * });
 */
export function useUpdateScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduleMutation, UpdateScheduleMutationVariables>(UpdateScheduleDocument, options);
      }
export type UpdateScheduleMutationHookResult = ReturnType<typeof useUpdateScheduleMutation>;
export type UpdateScheduleMutationResult = Apollo.MutationResult<UpdateScheduleMutation>;
export type UpdateScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const DeleteScheduleDocument = gql`
    mutation deleteSchedule($id: ID!, $tenantID: ID!) {
  deleteSchedule(request: {id: $id, tenantID: $tenantID}) {
    deleted
  }
}
    `;
export type DeleteScheduleMutationFn = Apollo.MutationFunction<DeleteScheduleMutation, DeleteScheduleMutationVariables>;

/**
 * __useDeleteScheduleMutation__
 *
 * To run a mutation, you first call `useDeleteScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScheduleMutation, { data, loading, error }] = useDeleteScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenantID: // value for 'tenantID'
 *   },
 * });
 */
export function useDeleteScheduleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScheduleMutation, DeleteScheduleMutationVariables>(DeleteScheduleDocument, options);
      }
export type DeleteScheduleMutationHookResult = ReturnType<typeof useDeleteScheduleMutation>;
export type DeleteScheduleMutationResult = Apollo.MutationResult<DeleteScheduleMutation>;
export type DeleteScheduleMutationOptions = Apollo.BaseMutationOptions<DeleteScheduleMutation, DeleteScheduleMutationVariables>;
export const UpdateIntegrationDocument = gql`
    mutation updateIntegration($integrationID: ID!, $isActive: Boolean!, $updateData: UpdateIntegrationData, $disableIntegration: Boolean, $updateDescription: IntegrationDescriptionInput, $externalLinkKey: String) {
  updateIntegration(
    request: {integrationID: $integrationID, isActive: $isActive, updateData: $updateData, disableIntegration: $disableIntegration, updateDescription: $updateDescription, externalLinkKey: $externalLinkKey}
  ) {
    updated
  }
}
    `;
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      integrationID: // value for 'integrationID'
 *      isActive: // value for 'isActive'
 *      updateData: // value for 'updateData'
 *      disableIntegration: // value for 'disableIntegration'
 *      updateDescription: // value for 'updateDescription'
 *      externalLinkKey: // value for 'externalLinkKey'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(UpdateIntegrationDocument, options);
      }
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;
export const UpdateUserDocument = gql`
    mutation updateUser($id: ID!, $tenantID: ID!, $firstName: String, $lastName: String, $role: UserRole, $customRole: String, $interests: UserInterestsInput, $addPinnedDashboardIDs: [ID!], $removePinnedDashboardIDs: [ID!], $type: UserType, $state: UserState, $homepageDashboardID: String, $removeHomepageDashboardID: Boolean) {
  updateUser(
    request: {id: $id, tenantID: $tenantID, firstName: $firstName, lastName: $lastName, role: $role, customRole: $customRole, interests: $interests, addPinnedDashboardIDs: $addPinnedDashboardIDs, removePinnedDashboardIDs: $removePinnedDashboardIDs, type: $type, state: $state, homepageDashboardID: $homepageDashboardID, removeHomepageDashboardID: $removeHomepageDashboardID}
  ) {
    code
    message
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tenantID: // value for 'tenantID'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      role: // value for 'role'
 *      customRole: // value for 'customRole'
 *      interests: // value for 'interests'
 *      addPinnedDashboardIDs: // value for 'addPinnedDashboardIDs'
 *      removePinnedDashboardIDs: // value for 'removePinnedDashboardIDs'
 *      type: // value for 'type'
 *      state: // value for 'state'
 *      homepageDashboardID: // value for 'homepageDashboardID'
 *      removeHomepageDashboardID: // value for 'removeHomepageDashboardID'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateNotificationsDocument = gql`
    mutation updateNotifications($tenantID: ID!, $notificationIDs: [String!], $viewed: Boolean) {
  updateNotifications(
    request: {tenantID: $tenantID, notificationIDs: $notificationIDs, viewed: $viewed}
  ) {
    updated
  }
}
    `;
export type UpdateNotificationsMutationFn = Apollo.MutationFunction<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;

/**
 * __useUpdateNotificationsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationsMutation, { data, loading, error }] = useUpdateNotificationsMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      notificationIDs: // value for 'notificationIDs'
 *      viewed: // value for 'viewed'
 *   },
 * });
 */
export function useUpdateNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>(UpdateNotificationsDocument, options);
      }
export type UpdateNotificationsMutationHookResult = ReturnType<typeof useUpdateNotificationsMutation>;
export type UpdateNotificationsMutationResult = Apollo.MutationResult<UpdateNotificationsMutation>;
export type UpdateNotificationsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationsMutation, UpdateNotificationsMutationVariables>;
export const MarkNotificationsAsReadDocument = gql`
    mutation markNotificationsAsRead($tenantID: ID!, $userID: ID!, $createdBefore: Int) {
  markNotificationsAsRead(
    request: {tenantID: $tenantID, userID: $userID, createdBefore: $createdBefore}
  ) {
    updated
  }
}
    `;
export type MarkNotificationsAsReadMutationFn = Apollo.MutationFunction<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;

/**
 * __useMarkNotificationsAsReadMutation__
 *
 * To run a mutation, you first call `useMarkNotificationsAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkNotificationsAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markNotificationsAsReadMutation, { data, loading, error }] = useMarkNotificationsAsReadMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      createdBefore: // value for 'createdBefore'
 *   },
 * });
 */
export function useMarkNotificationsAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>(MarkNotificationsAsReadDocument, options);
      }
export type MarkNotificationsAsReadMutationHookResult = ReturnType<typeof useMarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationResult = Apollo.MutationResult<MarkNotificationsAsReadMutation>;
export type MarkNotificationsAsReadMutationOptions = Apollo.BaseMutationOptions<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const AddUserTagsDocument = gql`
    mutation addUserTags($tenantID: ID!, $userID: ID!, $tags: [String!]) {
  addUserTags(request: {tenantID: $tenantID, userID: $userID, tags: $tags}) {
    code
    message
  }
}
    `;
export type AddUserTagsMutationFn = Apollo.MutationFunction<AddUserTagsMutation, AddUserTagsMutationVariables>;

/**
 * __useAddUserTagsMutation__
 *
 * To run a mutation, you first call `useAddUserTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserTagsMutation, { data, loading, error }] = useAddUserTagsMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useAddUserTagsMutation(baseOptions?: Apollo.MutationHookOptions<AddUserTagsMutation, AddUserTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserTagsMutation, AddUserTagsMutationVariables>(AddUserTagsDocument, options);
      }
export type AddUserTagsMutationHookResult = ReturnType<typeof useAddUserTagsMutation>;
export type AddUserTagsMutationResult = Apollo.MutationResult<AddUserTagsMutation>;
export type AddUserTagsMutationOptions = Apollo.BaseMutationOptions<AddUserTagsMutation, AddUserTagsMutationVariables>;
export const RemoveUserTagsDocument = gql`
    mutation removeUserTags($tenantID: ID!, $userID: ID!, $tags: [String!]) {
  removeUserTags(request: {tenantID: $tenantID, userID: $userID, tags: $tags}) {
    code
    message
  }
}
    `;
export type RemoveUserTagsMutationFn = Apollo.MutationFunction<RemoveUserTagsMutation, RemoveUserTagsMutationVariables>;

/**
 * __useRemoveUserTagsMutation__
 *
 * To run a mutation, you first call `useRemoveUserTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserTagsMutation, { data, loading, error }] = useRemoveUserTagsMutation({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useRemoveUserTagsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserTagsMutation, RemoveUserTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserTagsMutation, RemoveUserTagsMutationVariables>(RemoveUserTagsDocument, options);
      }
export type RemoveUserTagsMutationHookResult = ReturnType<typeof useRemoveUserTagsMutation>;
export type RemoveUserTagsMutationResult = Apollo.MutationResult<RemoveUserTagsMutation>;
export type RemoveUserTagsMutationOptions = Apollo.BaseMutationOptions<RemoveUserTagsMutation, RemoveUserTagsMutationVariables>;
export const UpdateMetadataDocument = gql`
    mutation updateMetadata($request: UpdateManagedMetadataRequest!) {
  updateManagedMetadata(request: $request) {
    updated
  }
}
    `;
export type UpdateMetadataMutationFn = Apollo.MutationFunction<UpdateMetadataMutation, UpdateMetadataMutationVariables>;

/**
 * __useUpdateMetadataMutation__
 *
 * To run a mutation, you first call `useUpdateMetadataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMetadataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMetadataMutation, { data, loading, error }] = useUpdateMetadataMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateMetadataMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMetadataMutation, UpdateMetadataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMetadataMutation, UpdateMetadataMutationVariables>(UpdateMetadataDocument, options);
      }
export type UpdateMetadataMutationHookResult = ReturnType<typeof useUpdateMetadataMutation>;
export type UpdateMetadataMutationResult = Apollo.MutationResult<UpdateMetadataMutation>;
export type UpdateMetadataMutationOptions = Apollo.BaseMutationOptions<UpdateMetadataMutation, UpdateMetadataMutationVariables>;
export const ManipulatePredictionsDocument = gql`
    mutation manipulatePredictions($request: ManipulatePredictionsInput!) {
  manipulatePredictions(request: $request) {
    success
  }
}
    `;
export type ManipulatePredictionsMutationFn = Apollo.MutationFunction<ManipulatePredictionsMutation, ManipulatePredictionsMutationVariables>;

/**
 * __useManipulatePredictionsMutation__
 *
 * To run a mutation, you first call `useManipulatePredictionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManipulatePredictionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [manipulatePredictionsMutation, { data, loading, error }] = useManipulatePredictionsMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useManipulatePredictionsMutation(baseOptions?: Apollo.MutationHookOptions<ManipulatePredictionsMutation, ManipulatePredictionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManipulatePredictionsMutation, ManipulatePredictionsMutationVariables>(ManipulatePredictionsDocument, options);
      }
export type ManipulatePredictionsMutationHookResult = ReturnType<typeof useManipulatePredictionsMutation>;
export type ManipulatePredictionsMutationResult = Apollo.MutationResult<ManipulatePredictionsMutation>;
export type ManipulatePredictionsMutationOptions = Apollo.BaseMutationOptions<ManipulatePredictionsMutation, ManipulatePredictionsMutationVariables>;
export const UpdateTenantSsoDocument = gql`
    mutation updateTenantSso($request: UpdateTenantSsoInput!) {
  updateTenantSso(request: $request) {
    success
  }
}
    `;
export type UpdateTenantSsoMutationFn = Apollo.MutationFunction<UpdateTenantSsoMutation, UpdateTenantSsoMutationVariables>;

/**
 * __useUpdateTenantSsoMutation__
 *
 * To run a mutation, you first call `useUpdateTenantSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantSsoMutation, { data, loading, error }] = useUpdateTenantSsoMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateTenantSsoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantSsoMutation, UpdateTenantSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantSsoMutation, UpdateTenantSsoMutationVariables>(UpdateTenantSsoDocument, options);
      }
export type UpdateTenantSsoMutationHookResult = ReturnType<typeof useUpdateTenantSsoMutation>;
export type UpdateTenantSsoMutationResult = Apollo.MutationResult<UpdateTenantSsoMutation>;
export type UpdateTenantSsoMutationOptions = Apollo.BaseMutationOptions<UpdateTenantSsoMutation, UpdateTenantSsoMutationVariables>;
export const RemoveTenantSsoDocument = gql`
    mutation removeTenantSso($request: RemoveTenantSsoInput!) {
  removeTenantSso(request: $request) {
    success
  }
}
    `;
export type RemoveTenantSsoMutationFn = Apollo.MutationFunction<RemoveTenantSsoMutation, RemoveTenantSsoMutationVariables>;

/**
 * __useRemoveTenantSsoMutation__
 *
 * To run a mutation, you first call `useRemoveTenantSsoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTenantSsoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTenantSsoMutation, { data, loading, error }] = useRemoveTenantSsoMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useRemoveTenantSsoMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTenantSsoMutation, RemoveTenantSsoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTenantSsoMutation, RemoveTenantSsoMutationVariables>(RemoveTenantSsoDocument, options);
      }
export type RemoveTenantSsoMutationHookResult = ReturnType<typeof useRemoveTenantSsoMutation>;
export type RemoveTenantSsoMutationResult = Apollo.MutationResult<RemoveTenantSsoMutation>;
export type RemoveTenantSsoMutationOptions = Apollo.BaseMutationOptions<RemoveTenantSsoMutation, RemoveTenantSsoMutationVariables>;
export const AskForArtefactAccessDocument = gql`
    mutation askForArtefactAccess($request: AskForArtefactAccessInput!) {
  askForArtefactAccess(request: $request) {
    success
  }
}
    `;
export type AskForArtefactAccessMutationFn = Apollo.MutationFunction<AskForArtefactAccessMutation, AskForArtefactAccessMutationVariables>;

/**
 * __useAskForArtefactAccessMutation__
 *
 * To run a mutation, you first call `useAskForArtefactAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskForArtefactAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askForArtefactAccessMutation, { data, loading, error }] = useAskForArtefactAccessMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useAskForArtefactAccessMutation(baseOptions?: Apollo.MutationHookOptions<AskForArtefactAccessMutation, AskForArtefactAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AskForArtefactAccessMutation, AskForArtefactAccessMutationVariables>(AskForArtefactAccessDocument, options);
      }
export type AskForArtefactAccessMutationHookResult = ReturnType<typeof useAskForArtefactAccessMutation>;
export type AskForArtefactAccessMutationResult = Apollo.MutationResult<AskForArtefactAccessMutation>;
export type AskForArtefactAccessMutationOptions = Apollo.BaseMutationOptions<AskForArtefactAccessMutation, AskForArtefactAccessMutationVariables>;
export const ProcessOperationDocument = gql`
    mutation processOperation($request: ProcessOperationInput!) {
  processOperation(request: $request) {
    processed
  }
}
    `;
export type ProcessOperationMutationFn = Apollo.MutationFunction<ProcessOperationMutation, ProcessOperationMutationVariables>;

/**
 * __useProcessOperationMutation__
 *
 * To run a mutation, you first call `useProcessOperationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessOperationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processOperationMutation, { data, loading, error }] = useProcessOperationMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useProcessOperationMutation(baseOptions?: Apollo.MutationHookOptions<ProcessOperationMutation, ProcessOperationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessOperationMutation, ProcessOperationMutationVariables>(ProcessOperationDocument, options);
      }
export type ProcessOperationMutationHookResult = ReturnType<typeof useProcessOperationMutation>;
export type ProcessOperationMutationResult = Apollo.MutationResult<ProcessOperationMutation>;
export type ProcessOperationMutationOptions = Apollo.BaseMutationOptions<ProcessOperationMutation, ProcessOperationMutationVariables>;
export const CreateDashboardFromTemplateDocument = gql`
    mutation createDashboardFromTemplate($request: CreateDashboardFromTemplateInput!) {
  createDashboardFromTemplate(request: $request) {
    dashboard {
      ...DashboardView
    }
  }
}
    ${DashboardViewFragmentDoc}`;
export type CreateDashboardFromTemplateMutationFn = Apollo.MutationFunction<CreateDashboardFromTemplateMutation, CreateDashboardFromTemplateMutationVariables>;

/**
 * __useCreateDashboardFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDashboardFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDashboardFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDashboardFromTemplateMutation, { data, loading, error }] = useCreateDashboardFromTemplateMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useCreateDashboardFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateDashboardFromTemplateMutation, CreateDashboardFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDashboardFromTemplateMutation, CreateDashboardFromTemplateMutationVariables>(CreateDashboardFromTemplateDocument, options);
      }
export type CreateDashboardFromTemplateMutationHookResult = ReturnType<typeof useCreateDashboardFromTemplateMutation>;
export type CreateDashboardFromTemplateMutationResult = Apollo.MutationResult<CreateDashboardFromTemplateMutation>;
export type CreateDashboardFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateDashboardFromTemplateMutation, CreateDashboardFromTemplateMutationVariables>;
export const UpdateTenantDashboardSettingsDocument = gql`
    mutation updateTenantDashboardSettings($id: ID!, $dashboardSettings: UpdateTenantDashboardSettingsInput) {
  updateTenant(request: {id: $id, dashboardSettings: $dashboardSettings}) {
    code
    message
  }
}
    `;
export type UpdateTenantDashboardSettingsMutationFn = Apollo.MutationFunction<UpdateTenantDashboardSettingsMutation, UpdateTenantDashboardSettingsMutationVariables>;

/**
 * __useUpdateTenantDashboardSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateTenantDashboardSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTenantDashboardSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTenantDashboardSettingsMutation, { data, loading, error }] = useUpdateTenantDashboardSettingsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dashboardSettings: // value for 'dashboardSettings'
 *   },
 * });
 */
export function useUpdateTenantDashboardSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTenantDashboardSettingsMutation, UpdateTenantDashboardSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTenantDashboardSettingsMutation, UpdateTenantDashboardSettingsMutationVariables>(UpdateTenantDashboardSettingsDocument, options);
      }
export type UpdateTenantDashboardSettingsMutationHookResult = ReturnType<typeof useUpdateTenantDashboardSettingsMutation>;
export type UpdateTenantDashboardSettingsMutationResult = Apollo.MutationResult<UpdateTenantDashboardSettingsMutation>;
export type UpdateTenantDashboardSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateTenantDashboardSettingsMutation, UpdateTenantDashboardSettingsMutationVariables>;
export const UpdateSummaryFlagDocument = gql`
    mutation updateSummaryFlag($request: UpdateSummaryFlagInput!) {
  updateSummaryFlag(request: $request) {
    success
  }
}
    `;
export type UpdateSummaryFlagMutationFn = Apollo.MutationFunction<UpdateSummaryFlagMutation, UpdateSummaryFlagMutationVariables>;

/**
 * __useUpdateSummaryFlagMutation__
 *
 * To run a mutation, you first call `useUpdateSummaryFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSummaryFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSummaryFlagMutation, { data, loading, error }] = useUpdateSummaryFlagMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useUpdateSummaryFlagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSummaryFlagMutation, UpdateSummaryFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSummaryFlagMutation, UpdateSummaryFlagMutationVariables>(UpdateSummaryFlagDocument, options);
      }
export type UpdateSummaryFlagMutationHookResult = ReturnType<typeof useUpdateSummaryFlagMutation>;
export type UpdateSummaryFlagMutationResult = Apollo.MutationResult<UpdateSummaryFlagMutation>;
export type UpdateSummaryFlagMutationOptions = Apollo.BaseMutationOptions<UpdateSummaryFlagMutation, UpdateSummaryFlagMutationVariables>;
export const GetUserByEmailDocument = gql`
    query getUserByEmail($email: String!, $slug: String) {
  getUserByEmail(email: $email, slug: $slug) {
    ...UserView
  }
}
    ${UserViewFragmentDoc}`;

/**
 * __useGetUserByEmailQuery__
 *
 * To run a query within a React component, call `useGetUserByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetUserByEmailQuery(baseOptions: Apollo.QueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
      }
export function useGetUserByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByEmailQuery, GetUserByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByEmailQuery, GetUserByEmailQueryVariables>(GetUserByEmailDocument, options);
        }
export type GetUserByEmailQueryHookResult = ReturnType<typeof useGetUserByEmailQuery>;
export type GetUserByEmailLazyQueryHookResult = ReturnType<typeof useGetUserByEmailLazyQuery>;
export type GetUserByEmailQueryResult = Apollo.QueryResult<GetUserByEmailQuery, GetUserByEmailQueryVariables>;
export const GetRecordByIdDocument = gql`
    query getRecordByID($tenantID: String!, $recordID: String!) {
  getRecord(request: {recordID: $recordID, tenantID: $tenantID}) {
    ...RecordView
  }
}
    ${RecordViewFragmentDoc}`;

/**
 * __useGetRecordByIdQuery__
 *
 * To run a query within a React component, call `useGetRecordByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecordByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecordByIdQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      recordID: // value for 'recordID'
 *   },
 * });
 */
export function useGetRecordByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRecordByIdQuery, GetRecordByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecordByIdQuery, GetRecordByIdQueryVariables>(GetRecordByIdDocument, options);
      }
export function useGetRecordByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRecordByIdQuery, GetRecordByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecordByIdQuery, GetRecordByIdQueryVariables>(GetRecordByIdDocument, options);
        }
export type GetRecordByIdQueryHookResult = ReturnType<typeof useGetRecordByIdQuery>;
export type GetRecordByIdLazyQueryHookResult = ReturnType<typeof useGetRecordByIdLazyQuery>;
export type GetRecordByIdQueryResult = Apollo.QueryResult<GetRecordByIdQuery, GetRecordByIdQueryVariables>;
export const GetMetadataKeysDocument = gql`
    query getMetadataKeys($tenant: ID!) {
  listMetadataKeys(request: {tenantID: $tenant}) {
    keys {
      ...MetadataDetailsView
    }
  }
}
    ${MetadataDetailsViewFragmentDoc}`;

/**
 * __useGetMetadataKeysQuery__
 *
 * To run a query within a React component, call `useGetMetadataKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMetadataKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMetadataKeysQuery({
 *   variables: {
 *      tenant: // value for 'tenant'
 *   },
 * });
 */
export function useGetMetadataKeysQuery(baseOptions: Apollo.QueryHookOptions<GetMetadataKeysQuery, GetMetadataKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMetadataKeysQuery, GetMetadataKeysQueryVariables>(GetMetadataKeysDocument, options);
      }
export function useGetMetadataKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMetadataKeysQuery, GetMetadataKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMetadataKeysQuery, GetMetadataKeysQueryVariables>(GetMetadataKeysDocument, options);
        }
export type GetMetadataKeysQueryHookResult = ReturnType<typeof useGetMetadataKeysQuery>;
export type GetMetadataKeysLazyQueryHookResult = ReturnType<typeof useGetMetadataKeysLazyQuery>;
export type GetMetadataKeysQueryResult = Apollo.QueryResult<GetMetadataKeysQuery, GetMetadataKeysQueryVariables>;
export const GetTenantByIdDocument = gql`
    query getTenantByID($tenantID: ID!) {
  getTenantByID(id: $tenantID) {
    ...TenantView
  }
}
    ${TenantViewFragmentDoc}`;

/**
 * __useGetTenantByIdQuery__
 *
 * To run a query within a React component, call `useGetTenantByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTenantByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTenantByIdQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *   },
 * });
 */
export function useGetTenantByIdQuery(baseOptions: Apollo.QueryHookOptions<GetTenantByIdQuery, GetTenantByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTenantByIdQuery, GetTenantByIdQueryVariables>(GetTenantByIdDocument, options);
      }
export function useGetTenantByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTenantByIdQuery, GetTenantByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTenantByIdQuery, GetTenantByIdQueryVariables>(GetTenantByIdDocument, options);
        }
export type GetTenantByIdQueryHookResult = ReturnType<typeof useGetTenantByIdQuery>;
export type GetTenantByIdLazyQueryHookResult = ReturnType<typeof useGetTenantByIdLazyQuery>;
export type GetTenantByIdQueryResult = Apollo.QueryResult<GetTenantByIdQuery, GetTenantByIdQueryVariables>;
export const DownloadFeatureFlagDataFileDocument = gql`
    query downloadFeatureFlagDataFile($fileURL: String!) {
  proxyFileDownload(request: {url: $fileURL}) {
    base64Data
  }
}
    `;

/**
 * __useDownloadFeatureFlagDataFileQuery__
 *
 * To run a query within a React component, call `useDownloadFeatureFlagDataFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadFeatureFlagDataFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadFeatureFlagDataFileQuery({
 *   variables: {
 *      fileURL: // value for 'fileURL'
 *   },
 * });
 */
export function useDownloadFeatureFlagDataFileQuery(baseOptions: Apollo.QueryHookOptions<DownloadFeatureFlagDataFileQuery, DownloadFeatureFlagDataFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadFeatureFlagDataFileQuery, DownloadFeatureFlagDataFileQueryVariables>(DownloadFeatureFlagDataFileDocument, options);
      }
export function useDownloadFeatureFlagDataFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadFeatureFlagDataFileQuery, DownloadFeatureFlagDataFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadFeatureFlagDataFileQuery, DownloadFeatureFlagDataFileQueryVariables>(DownloadFeatureFlagDataFileDocument, options);
        }
export type DownloadFeatureFlagDataFileQueryHookResult = ReturnType<typeof useDownloadFeatureFlagDataFileQuery>;
export type DownloadFeatureFlagDataFileLazyQueryHookResult = ReturnType<typeof useDownloadFeatureFlagDataFileLazyQuery>;
export type DownloadFeatureFlagDataFileQueryResult = Apollo.QueryResult<DownloadFeatureFlagDataFileQuery, DownloadFeatureFlagDataFileQueryVariables>;
export const ListTenantsDocument = gql`
    query listTenants($cursor: String) {
  listTenants(request: {paginationToken: $cursor}) {
    tenants {
      ...TenantWithoutIntegrationsView
    }
    paginationToken
  }
}
    ${TenantWithoutIntegrationsViewFragmentDoc}`;

/**
 * __useListTenantsQuery__
 *
 * To run a query within a React component, call `useListTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTenantsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListTenantsQuery(baseOptions?: Apollo.QueryHookOptions<ListTenantsQuery, ListTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTenantsQuery, ListTenantsQueryVariables>(ListTenantsDocument, options);
      }
export function useListTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTenantsQuery, ListTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTenantsQuery, ListTenantsQueryVariables>(ListTenantsDocument, options);
        }
export type ListTenantsQueryHookResult = ReturnType<typeof useListTenantsQuery>;
export type ListTenantsLazyQueryHookResult = ReturnType<typeof useListTenantsLazyQuery>;
export type ListTenantsQueryResult = Apollo.QueryResult<ListTenantsQuery, ListTenantsQueryVariables>;
export const GetIntegrationsFormDataV2Document = gql`
    query getIntegrationsFormDataV2($tenantID: ID!) {
  getIntegrationsFormDataV2(tenantID: $tenantID) {
    forms {
      ...IntegrationFormDataView
    }
  }
}
    ${IntegrationFormDataViewFragmentDoc}`;

/**
 * __useGetIntegrationsFormDataV2Query__
 *
 * To run a query within a React component, call `useGetIntegrationsFormDataV2Query` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsFormDataV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsFormDataV2Query({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *   },
 * });
 */
export function useGetIntegrationsFormDataV2Query(baseOptions: Apollo.QueryHookOptions<GetIntegrationsFormDataV2Query, GetIntegrationsFormDataV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsFormDataV2Query, GetIntegrationsFormDataV2QueryVariables>(GetIntegrationsFormDataV2Document, options);
      }
export function useGetIntegrationsFormDataV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsFormDataV2Query, GetIntegrationsFormDataV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsFormDataV2Query, GetIntegrationsFormDataV2QueryVariables>(GetIntegrationsFormDataV2Document, options);
        }
export type GetIntegrationsFormDataV2QueryHookResult = ReturnType<typeof useGetIntegrationsFormDataV2Query>;
export type GetIntegrationsFormDataV2LazyQueryHookResult = ReturnType<typeof useGetIntegrationsFormDataV2LazyQuery>;
export type GetIntegrationsFormDataV2QueryResult = Apollo.QueryResult<GetIntegrationsFormDataV2Query, GetIntegrationsFormDataV2QueryVariables>;
export const ListLabelsDocument = gql`
    query listLabels($tenantID: ID!, $type: LabelType!, $includeInvisible: Boolean, $cursor: String) {
  listLabels(
    request: {tenantID: $tenantID, type: $type, includeInvisible: $includeInvisible, cursor: $cursor}
  ) {
    labels {
      id
      displayName
      description
      type
      createdAt
      isVisible
    }
    paginationToken
  }
}
    `;

/**
 * __useListLabelsQuery__
 *
 * To run a query within a React component, call `useListLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLabelsQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      type: // value for 'type'
 *      includeInvisible: // value for 'includeInvisible'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useListLabelsQuery(baseOptions: Apollo.QueryHookOptions<ListLabelsQuery, ListLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListLabelsQuery, ListLabelsQueryVariables>(ListLabelsDocument, options);
      }
export function useListLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListLabelsQuery, ListLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListLabelsQuery, ListLabelsQueryVariables>(ListLabelsDocument, options);
        }
export type ListLabelsQueryHookResult = ReturnType<typeof useListLabelsQuery>;
export type ListLabelsLazyQueryHookResult = ReturnType<typeof useListLabelsLazyQuery>;
export type ListLabelsQueryResult = Apollo.QueryResult<ListLabelsQuery, ListLabelsQueryVariables>;
export const ExecuteEqlDocument = gql`
    query executeEQL($tenantID: ID!, $expression: String!, $cursor: String) {
  executeEQL(
    request: {tenantID: $tenantID, expression: $expression, cursor: $cursor}
  ) {
    result {
      ...GetAggregatesResponseView
      ...GetRecordsResponseView
      ...GetDeltaAggregatesResponseView
    }
  }
}
    ${GetAggregatesResponseViewFragmentDoc}
${GetRecordsResponseViewFragmentDoc}
${GetDeltaAggregatesResponseViewFragmentDoc}`;

/**
 * __useExecuteEqlQuery__
 *
 * To run a query within a React component, call `useExecuteEqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useExecuteEqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExecuteEqlQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      expression: // value for 'expression'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useExecuteEqlQuery(baseOptions: Apollo.QueryHookOptions<ExecuteEqlQuery, ExecuteEqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExecuteEqlQuery, ExecuteEqlQueryVariables>(ExecuteEqlDocument, options);
      }
export function useExecuteEqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExecuteEqlQuery, ExecuteEqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExecuteEqlQuery, ExecuteEqlQueryVariables>(ExecuteEqlDocument, options);
        }
export type ExecuteEqlQueryHookResult = ReturnType<typeof useExecuteEqlQuery>;
export type ExecuteEqlLazyQueryHookResult = ReturnType<typeof useExecuteEqlLazyQuery>;
export type ExecuteEqlQueryResult = Apollo.QueryResult<ExecuteEqlQuery, ExecuteEqlQueryVariables>;
export const BatchExecuteEqlDocument = gql`
    query batchExecuteEQL($tenantID: ID!, $expressions: [BatchExecuteEQLExpression!]!) {
  batchExecuteEQL(request: {tenantID: $tenantID, expressions: $expressions}) {
    results {
      queryID: id
      result {
        ...GetAggregatesResponseView
        ...GetRecordsResponseView
        ...GetDeltaAggregatesResponseView
      }
    }
  }
}
    ${GetAggregatesResponseViewFragmentDoc}
${GetRecordsResponseViewFragmentDoc}
${GetDeltaAggregatesResponseViewFragmentDoc}`;

/**
 * __useBatchExecuteEqlQuery__
 *
 * To run a query within a React component, call `useBatchExecuteEqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useBatchExecuteEqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBatchExecuteEqlQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      expressions: // value for 'expressions'
 *   },
 * });
 */
export function useBatchExecuteEqlQuery(baseOptions: Apollo.QueryHookOptions<BatchExecuteEqlQuery, BatchExecuteEqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BatchExecuteEqlQuery, BatchExecuteEqlQueryVariables>(BatchExecuteEqlDocument, options);
      }
export function useBatchExecuteEqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BatchExecuteEqlQuery, BatchExecuteEqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BatchExecuteEqlQuery, BatchExecuteEqlQueryVariables>(BatchExecuteEqlDocument, options);
        }
export type BatchExecuteEqlQueryHookResult = ReturnType<typeof useBatchExecuteEqlQuery>;
export type BatchExecuteEqlLazyQueryHookResult = ReturnType<typeof useBatchExecuteEqlLazyQuery>;
export type BatchExecuteEqlQueryResult = Apollo.QueryResult<BatchExecuteEqlQuery, BatchExecuteEqlQueryVariables>;
export const ListSourceDetailsDocument = gql`
    query listSourceDetails {
  listSourceDetails {
    sources {
      id
      eqlValue
    }
  }
}
    `;

/**
 * __useListSourceDetailsQuery__
 *
 * To run a query within a React component, call `useListSourceDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSourceDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSourceDetailsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSourceDetailsQuery(baseOptions?: Apollo.QueryHookOptions<ListSourceDetailsQuery, ListSourceDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSourceDetailsQuery, ListSourceDetailsQueryVariables>(ListSourceDetailsDocument, options);
      }
export function useListSourceDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSourceDetailsQuery, ListSourceDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSourceDetailsQuery, ListSourceDetailsQueryVariables>(ListSourceDetailsDocument, options);
        }
export type ListSourceDetailsQueryHookResult = ReturnType<typeof useListSourceDetailsQuery>;
export type ListSourceDetailsLazyQueryHookResult = ReturnType<typeof useListSourceDetailsLazyQuery>;
export type ListSourceDetailsQueryResult = Apollo.QueryResult<ListSourceDetailsQuery, ListSourceDetailsQueryVariables>;
export const GetAnalysisByTokenDocument = gql`
    query getAnalysisByToken($token: String!, $tenantID: ID!, $userID: ID!, $includeScheduleOutbounds: Boolean) {
  getAnalysisByToken(
    request: {token: $token, tenantID: $tenantID, userID: $userID, includeScheduleOutbounds: $includeScheduleOutbounds}
  ) {
    ...AnalysisView
  }
}
    ${AnalysisViewFragmentDoc}`;

/**
 * __useGetAnalysisByTokenQuery__
 *
 * To run a query within a React component, call `useGetAnalysisByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      includeScheduleOutbounds: // value for 'includeScheduleOutbounds'
 *   },
 * });
 */
export function useGetAnalysisByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysisByTokenQuery, GetAnalysisByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisByTokenQuery, GetAnalysisByTokenQueryVariables>(GetAnalysisByTokenDocument, options);
      }
export function useGetAnalysisByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisByTokenQuery, GetAnalysisByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisByTokenQuery, GetAnalysisByTokenQueryVariables>(GetAnalysisByTokenDocument, options);
        }
export type GetAnalysisByTokenQueryHookResult = ReturnType<typeof useGetAnalysisByTokenQuery>;
export type GetAnalysisByTokenLazyQueryHookResult = ReturnType<typeof useGetAnalysisByTokenLazyQuery>;
export type GetAnalysisByTokenQueryResult = Apollo.QueryResult<GetAnalysisByTokenQuery, GetAnalysisByTokenQueryVariables>;
export const ListAnalysesDocument = gql`
    query listAnalyses($request: ListAnalysesInput!) {
  listAnalyses(request: $request) {
    nextCursor
    prevCursor
    hits
    analyses {
      ...AnalysisListItemView
    }
  }
}
    ${AnalysisListItemViewFragmentDoc}`;

/**
 * __useListAnalysesQuery__
 *
 * To run a query within a React component, call `useListAnalysesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListAnalysesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListAnalysesQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListAnalysesQuery(baseOptions: Apollo.QueryHookOptions<ListAnalysesQuery, ListAnalysesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListAnalysesQuery, ListAnalysesQueryVariables>(ListAnalysesDocument, options);
      }
export function useListAnalysesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListAnalysesQuery, ListAnalysesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListAnalysesQuery, ListAnalysesQueryVariables>(ListAnalysesDocument, options);
        }
export type ListAnalysesQueryHookResult = ReturnType<typeof useListAnalysesQuery>;
export type ListAnalysesLazyQueryHookResult = ReturnType<typeof useListAnalysesLazyQuery>;
export type ListAnalysesQueryResult = Apollo.QueryResult<ListAnalysesQuery, ListAnalysesQueryVariables>;
export const GetDashboardByTokenDocument = gql`
    query getDashboardByToken($token: String!, $tenantID: ID!, $userID: ID!, $includeScheduleOutbounds: Boolean) {
  getDashboardByToken(
    request: {token: $token, tenantID: $tenantID, userID: $userID, includeScheduleOutbounds: $includeScheduleOutbounds}
  ) {
    ...DashboardView
  }
}
    ${DashboardViewFragmentDoc}`;

/**
 * __useGetDashboardByTokenQuery__
 *
 * To run a query within a React component, call `useGetDashboardByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardByTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      includeScheduleOutbounds: // value for 'includeScheduleOutbounds'
 *   },
 * });
 */
export function useGetDashboardByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardByTokenQuery, GetDashboardByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardByTokenQuery, GetDashboardByTokenQueryVariables>(GetDashboardByTokenDocument, options);
      }
export function useGetDashboardByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardByTokenQuery, GetDashboardByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardByTokenQuery, GetDashboardByTokenQueryVariables>(GetDashboardByTokenDocument, options);
        }
export type GetDashboardByTokenQueryHookResult = ReturnType<typeof useGetDashboardByTokenQuery>;
export type GetDashboardByTokenLazyQueryHookResult = ReturnType<typeof useGetDashboardByTokenLazyQuery>;
export type GetDashboardByTokenQueryResult = Apollo.QueryResult<GetDashboardByTokenQuery, GetDashboardByTokenQueryVariables>;
export const ListDashboardsDocument = gql`
    query listDashboards($tenantID: ID!, $userID: ID!, $cursor: String, $filter: DashboardFilter, $sortBy: DashboardSortBy, $sortAsc: Boolean) {
  listDashboards(
    request: {tenantID: $tenantID, userID: $userID, cursor: $cursor, filter: $filter, sortBy: $sortBy, sortAsc: $sortAsc}
  ) {
    nextCursor
    prevCursor
    hits
    dashboards {
      ...DashboardListItemView
    }
  }
}
    ${DashboardListItemViewFragmentDoc}`;

/**
 * __useListDashboardsQuery__
 *
 * To run a query within a React component, call `useListDashboardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDashboardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDashboardsQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      cursor: // value for 'cursor'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortAsc: // value for 'sortAsc'
 *   },
 * });
 */
export function useListDashboardsQuery(baseOptions: Apollo.QueryHookOptions<ListDashboardsQuery, ListDashboardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDashboardsQuery, ListDashboardsQueryVariables>(ListDashboardsDocument, options);
      }
export function useListDashboardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDashboardsQuery, ListDashboardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDashboardsQuery, ListDashboardsQueryVariables>(ListDashboardsDocument, options);
        }
export type ListDashboardsQueryHookResult = ReturnType<typeof useListDashboardsQuery>;
export type ListDashboardsLazyQueryHookResult = ReturnType<typeof useListDashboardsLazyQuery>;
export type ListDashboardsQueryResult = Apollo.QueryResult<ListDashboardsQuery, ListDashboardsQueryVariables>;
export const ListUsersDocument = gql`
    query listUsers($tenantID: ID!, $filter: ListUsersFilter) {
  listUsers(request: {tenantID: $tenantID, filter: $filter}) {
    users {
      ...ListUserView
    }
  }
}
    ${ListUserViewFragmentDoc}`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
      }
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListUsersQuery, ListUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListUsersQuery, ListUsersQueryVariables>(ListUsersDocument, options);
        }
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<ListUsersQuery, ListUsersQueryVariables>;
export const GetIntegrationEditFormDataDocument = gql`
    query getIntegrationEditFormData($integrationID: ID!, $salesforce: SalesforceEditFormDataInput, $slack: SlackEditFormDataInput, $googleMyBusiness: GoogleMyBusinessEditFormDataInput) {
  getIntegrationEditFormData(
    request: {integrationID: $integrationID, salesforce: $salesforce, slack: $slack, googleMyBusiness: $googleMyBusiness}
  ) {
    formData {
      ...IntegrationEditFormDataView
    }
  }
}
    ${IntegrationEditFormDataViewFragmentDoc}`;

/**
 * __useGetIntegrationEditFormDataQuery__
 *
 * To run a query within a React component, call `useGetIntegrationEditFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationEditFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationEditFormDataQuery({
 *   variables: {
 *      integrationID: // value for 'integrationID'
 *      salesforce: // value for 'salesforce'
 *      slack: // value for 'slack'
 *      googleMyBusiness: // value for 'googleMyBusiness'
 *   },
 * });
 */
export function useGetIntegrationEditFormDataQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationEditFormDataQuery, GetIntegrationEditFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationEditFormDataQuery, GetIntegrationEditFormDataQueryVariables>(GetIntegrationEditFormDataDocument, options);
      }
export function useGetIntegrationEditFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationEditFormDataQuery, GetIntegrationEditFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationEditFormDataQuery, GetIntegrationEditFormDataQueryVariables>(GetIntegrationEditFormDataDocument, options);
        }
export type GetIntegrationEditFormDataQueryHookResult = ReturnType<typeof useGetIntegrationEditFormDataQuery>;
export type GetIntegrationEditFormDataLazyQueryHookResult = ReturnType<typeof useGetIntegrationEditFormDataLazyQuery>;
export type GetIntegrationEditFormDataQueryResult = Apollo.QueryResult<GetIntegrationEditFormDataQuery, GetIntegrationEditFormDataQueryVariables>;
export const GetLabelDocument = gql`
    query getLabel($tenantID: ID!, $id: ID!) {
  getLabelByID(tenantID: $tenantID, id: $id) {
    id
    displayName
    description
    type
    createdAt
    isVisible
    ... on Reason {
      metadata {
        sentiment
        representativeSentences
        category
        type
        createdBy {
          id
          email
          firstName
          lastName
          role
          type
        }
      }
    }
    ... on Aspect {
      metadata {
        phrases
      }
    }
  }
}
    `;

/**
 * __useGetLabelQuery__
 *
 * To run a query within a React component, call `useGetLabelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLabelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLabelQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLabelQuery(baseOptions: Apollo.QueryHookOptions<GetLabelQuery, GetLabelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLabelQuery, GetLabelQueryVariables>(GetLabelDocument, options);
      }
export function useGetLabelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLabelQuery, GetLabelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLabelQuery, GetLabelQueryVariables>(GetLabelDocument, options);
        }
export type GetLabelQueryHookResult = ReturnType<typeof useGetLabelQuery>;
export type GetLabelLazyQueryHookResult = ReturnType<typeof useGetLabelLazyQuery>;
export type GetLabelQueryResult = Apollo.QueryResult<GetLabelQuery, GetLabelQueryVariables>;
export const GetNotificationsDocument = gql`
    query getNotifications($tenantID: ID!, $userID: ID!, $includeViewed: Boolean, $pageSize: Int, $cursor: String) {
  getNotifications(
    request: {tenantID: $tenantID, userID: $userID, includeViewed: $includeViewed, pageSize: $pageSize, cursor: $cursor}
  ) {
    hits
    cursor
    notifications {
      id
      type
      category
      title
      richText
      createdAt
      viewed
    }
  }
}
    `;

/**
 * __useGetNotificationsQuery__
 *
 * To run a query within a React component, call `useGetNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      includeViewed: // value for 'includeViewed'
 *      pageSize: // value for 'pageSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetNotificationsQuery(baseOptions: Apollo.QueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
      }
export function useGetNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNotificationsQuery, GetNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNotificationsQuery, GetNotificationsQueryVariables>(GetNotificationsDocument, options);
        }
export type GetNotificationsQueryHookResult = ReturnType<typeof useGetNotificationsQuery>;
export type GetNotificationsLazyQueryHookResult = ReturnType<typeof useGetNotificationsLazyQuery>;
export type GetNotificationsQueryResult = Apollo.QueryResult<GetNotificationsQuery, GetNotificationsQueryVariables>;
export const ListSuggestionsDocument = gql`
    query ListSuggestions($tenantID: ID!, $filter: ListSuggestionsFilter, $responseSize: Int) {
  listSuggestions(
    request: {tenantID: $tenantID, filter: $filter, responseSize: $responseSize}
  ) {
    suggestions {
      ...SuggestionView
    }
    cursor
  }
}
    ${SuggestionViewFragmentDoc}`;

/**
 * __useListSuggestionsQuery__
 *
 * To run a query within a React component, call `useListSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSuggestionsQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      filter: // value for 'filter'
 *      responseSize: // value for 'responseSize'
 *   },
 * });
 */
export function useListSuggestionsQuery(baseOptions: Apollo.QueryHookOptions<ListSuggestionsQuery, ListSuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSuggestionsQuery, ListSuggestionsQueryVariables>(ListSuggestionsDocument, options);
      }
export function useListSuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSuggestionsQuery, ListSuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSuggestionsQuery, ListSuggestionsQueryVariables>(ListSuggestionsDocument, options);
        }
export type ListSuggestionsQueryHookResult = ReturnType<typeof useListSuggestionsQuery>;
export type ListSuggestionsLazyQueryHookResult = ReturnType<typeof useListSuggestionsLazyQuery>;
export type ListSuggestionsQueryResult = Apollo.QueryResult<ListSuggestionsQuery, ListSuggestionsQueryVariables>;
export const GetExtendedUserDocument = gql`
    query getExtendedUser($tenantID: ID!, $userID: ID!, $onlyReference: Boolean, $tags: Boolean) {
  getExtendedUser(
    request: {tenantID: $tenantID, userID: $userID, onlyReference: $onlyReference, tags: $tags}
  ) {
    tags
  }
}
    `;

/**
 * __useGetExtendedUserQuery__
 *
 * To run a query within a React component, call `useGetExtendedUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExtendedUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExtendedUserQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      userID: // value for 'userID'
 *      onlyReference: // value for 'onlyReference'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useGetExtendedUserQuery(baseOptions: Apollo.QueryHookOptions<GetExtendedUserQuery, GetExtendedUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExtendedUserQuery, GetExtendedUserQueryVariables>(GetExtendedUserDocument, options);
      }
export function useGetExtendedUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExtendedUserQuery, GetExtendedUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExtendedUserQuery, GetExtendedUserQueryVariables>(GetExtendedUserDocument, options);
        }
export type GetExtendedUserQueryHookResult = ReturnType<typeof useGetExtendedUserQuery>;
export type GetExtendedUserLazyQueryHookResult = ReturnType<typeof useGetExtendedUserLazyQuery>;
export type GetExtendedUserQueryResult = Apollo.QueryResult<GetExtendedUserQuery, GetExtendedUserQueryVariables>;
export const ListMetadataKeysDocument = gql`
    query listMetadataKeys($tenantID: ID!, $filter: ListMetadataKeysFilter) {
  listMetadataKeys(request: {tenantID: $tenantID, filter: $filter}) {
    keys {
      ...MetadataDetailsView
    }
  }
}
    ${MetadataDetailsViewFragmentDoc}`;

/**
 * __useListMetadataKeysQuery__
 *
 * To run a query within a React component, call `useListMetadataKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMetadataKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMetadataKeysQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useListMetadataKeysQuery(baseOptions: Apollo.QueryHookOptions<ListMetadataKeysQuery, ListMetadataKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListMetadataKeysQuery, ListMetadataKeysQueryVariables>(ListMetadataKeysDocument, options);
      }
export function useListMetadataKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListMetadataKeysQuery, ListMetadataKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListMetadataKeysQuery, ListMetadataKeysQueryVariables>(ListMetadataKeysDocument, options);
        }
export type ListMetadataKeysQueryHookResult = ReturnType<typeof useListMetadataKeysQuery>;
export type ListMetadataKeysLazyQueryHookResult = ReturnType<typeof useListMetadataKeysLazyQuery>;
export type ListMetadataKeysQueryResult = Apollo.QueryResult<ListMetadataKeysQuery, ListMetadataKeysQueryVariables>;
export const SearchArtefactsDocument = gql`
    query searchArtefacts($tenantID: ID!, $query: String, $types: [ArtefactType!], $statuses: [Status!], $scopes: [Scope!], $editableByFilter: ArtefactEditableByFilter, $filter: ArtefactSpecificFilter, $responseSize: Int, $cursor: String) {
  searchArtefacts(
    request: {tenantID: $tenantID, query: $query, types: $types, statuses: $statuses, scopes: $scopes, editableByFilter: $editableByFilter, filter: $filter, responseSize: $responseSize, cursor: $cursor}
  ) {
    artefacts {
      ...ArtefactListItemView
    }
    cursor
  }
}
    ${ArtefactListItemViewFragmentDoc}`;

/**
 * __useSearchArtefactsQuery__
 *
 * To run a query within a React component, call `useSearchArtefactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArtefactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArtefactsQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      query: // value for 'query'
 *      types: // value for 'types'
 *      statuses: // value for 'statuses'
 *      scopes: // value for 'scopes'
 *      editableByFilter: // value for 'editableByFilter'
 *      filter: // value for 'filter'
 *      responseSize: // value for 'responseSize'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useSearchArtefactsQuery(baseOptions: Apollo.QueryHookOptions<SearchArtefactsQuery, SearchArtefactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArtefactsQuery, SearchArtefactsQueryVariables>(SearchArtefactsDocument, options);
      }
export function useSearchArtefactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArtefactsQuery, SearchArtefactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArtefactsQuery, SearchArtefactsQueryVariables>(SearchArtefactsDocument, options);
        }
export type SearchArtefactsQueryHookResult = ReturnType<typeof useSearchArtefactsQuery>;
export type SearchArtefactsLazyQueryHookResult = ReturnType<typeof useSearchArtefactsLazyQuery>;
export type SearchArtefactsQueryResult = Apollo.QueryResult<SearchArtefactsQuery, SearchArtefactsQueryVariables>;
export const ListIntegrationsDocument = gql`
    query listIntegrations($tenantID: ID!, $query: String, $createdBy: String, $cursor: String, $directions: [IntegrationDirection!]) {
  listIntegrations(
    request: {tenantID: $tenantID, query: $query, createdBy: $createdBy, cursor: $cursor, directions: $directions}
  ) {
    integrations {
      ...IntegrationView
    }
    cursor
  }
}
    ${IntegrationViewFragmentDoc}`;

/**
 * __useListIntegrationsQuery__
 *
 * To run a query within a React component, call `useListIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListIntegrationsQuery({
 *   variables: {
 *      tenantID: // value for 'tenantID'
 *      query: // value for 'query'
 *      createdBy: // value for 'createdBy'
 *      cursor: // value for 'cursor'
 *      directions: // value for 'directions'
 *   },
 * });
 */
export function useListIntegrationsQuery(baseOptions: Apollo.QueryHookOptions<ListIntegrationsQuery, ListIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListIntegrationsQuery, ListIntegrationsQueryVariables>(ListIntegrationsDocument, options);
      }
export function useListIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListIntegrationsQuery, ListIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListIntegrationsQuery, ListIntegrationsQueryVariables>(ListIntegrationsDocument, options);
        }
export type ListIntegrationsQueryHookResult = ReturnType<typeof useListIntegrationsQuery>;
export type ListIntegrationsLazyQueryHookResult = ReturnType<typeof useListIntegrationsLazyQuery>;
export type ListIntegrationsQueryResult = Apollo.QueryResult<ListIntegrationsQuery, ListIntegrationsQueryVariables>;
export const IsDomainSsoDocument = gql`
    query isDomainSso($domain: String!, $slug: String) {
  isDomainSso(domain: $domain, slug: $slug) {
    result
    isEnforced
    isSaml
  }
}
    `;

/**
 * __useIsDomainSsoQuery__
 *
 * To run a query within a React component, call `useIsDomainSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsDomainSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsDomainSsoQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useIsDomainSsoQuery(baseOptions: Apollo.QueryHookOptions<IsDomainSsoQuery, IsDomainSsoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsDomainSsoQuery, IsDomainSsoQueryVariables>(IsDomainSsoDocument, options);
      }
export function useIsDomainSsoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsDomainSsoQuery, IsDomainSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsDomainSsoQuery, IsDomainSsoQueryVariables>(IsDomainSsoDocument, options);
        }
export type IsDomainSsoQueryHookResult = ReturnType<typeof useIsDomainSsoQuery>;
export type IsDomainSsoLazyQueryHookResult = ReturnType<typeof useIsDomainSsoLazyQuery>;
export type IsDomainSsoQueryResult = Apollo.QueryResult<IsDomainSsoQuery, IsDomainSsoQueryVariables>;
export const ValidatePhraseInRecordDocument = gql`
    query validatePhraseInRecord($request: ValidatePhraseInRecordInput!) {
  validatePhraseInRecord(request: $request) {
    isPhraseValid
    entityLocations {
      startOffset
      endOffset
      msgIndex
    }
  }
}
    `;

/**
 * __useValidatePhraseInRecordQuery__
 *
 * To run a query within a React component, call `useValidatePhraseInRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePhraseInRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePhraseInRecordQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useValidatePhraseInRecordQuery(baseOptions: Apollo.QueryHookOptions<ValidatePhraseInRecordQuery, ValidatePhraseInRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePhraseInRecordQuery, ValidatePhraseInRecordQueryVariables>(ValidatePhraseInRecordDocument, options);
      }
export function useValidatePhraseInRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePhraseInRecordQuery, ValidatePhraseInRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePhraseInRecordQuery, ValidatePhraseInRecordQueryVariables>(ValidatePhraseInRecordDocument, options);
        }
export type ValidatePhraseInRecordQueryHookResult = ReturnType<typeof useValidatePhraseInRecordQuery>;
export type ValidatePhraseInRecordLazyQueryHookResult = ReturnType<typeof useValidatePhraseInRecordLazyQuery>;
export type ValidatePhraseInRecordQueryResult = Apollo.QueryResult<ValidatePhraseInRecordQuery, ValidatePhraseInRecordQueryVariables>;
export const GetReasonSuggestionDocument = gql`
    query getReasonSuggestion($request: GetReasonSuggestionInput!) {
  getReasonSuggestion(request: $request) {
    suggestedReasons {
      relatedRCs
      labelID
      label {
        id
        displayName
        type
        description
        createdAt
        isVisible
        __typename
        ... on Reason {
          updateInProgress
          metadata {
            category
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReasonSuggestionQuery__
 *
 * To run a query within a React component, call `useGetReasonSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReasonSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReasonSuggestionQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetReasonSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetReasonSuggestionQuery, GetReasonSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReasonSuggestionQuery, GetReasonSuggestionQueryVariables>(GetReasonSuggestionDocument, options);
      }
export function useGetReasonSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReasonSuggestionQuery, GetReasonSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReasonSuggestionQuery, GetReasonSuggestionQueryVariables>(GetReasonSuggestionDocument, options);
        }
export type GetReasonSuggestionQueryHookResult = ReturnType<typeof useGetReasonSuggestionQuery>;
export type GetReasonSuggestionLazyQueryHookResult = ReturnType<typeof useGetReasonSuggestionLazyQuery>;
export type GetReasonSuggestionQueryResult = Apollo.QueryResult<GetReasonSuggestionQuery, GetReasonSuggestionQueryVariables>;
export const ListTenantsForEmailDocument = gql`
    query listTenantsForEmail($request: ListTenantsForEmailInput!) {
  listTenantsForEmail(request: $request) {
    tenantOptions {
      id
      name
      slug
      avatarURL
    }
  }
}
    `;

/**
 * __useListTenantsForEmailQuery__
 *
 * To run a query within a React component, call `useListTenantsForEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTenantsForEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTenantsForEmailQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListTenantsForEmailQuery(baseOptions: Apollo.QueryHookOptions<ListTenantsForEmailQuery, ListTenantsForEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTenantsForEmailQuery, ListTenantsForEmailQueryVariables>(ListTenantsForEmailDocument, options);
      }
export function useListTenantsForEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTenantsForEmailQuery, ListTenantsForEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTenantsForEmailQuery, ListTenantsForEmailQueryVariables>(ListTenantsForEmailDocument, options);
        }
export type ListTenantsForEmailQueryHookResult = ReturnType<typeof useListTenantsForEmailQuery>;
export type ListTenantsForEmailLazyQueryHookResult = ReturnType<typeof useListTenantsForEmailLazyQuery>;
export type ListTenantsForEmailQueryResult = Apollo.QueryResult<ListTenantsForEmailQuery, ListTenantsForEmailQueryVariables>;
export const SearchUnassignedRCsDocument = gql`
    query searchUnassignedRCs($request: SearchUnassignedRCsInput!) {
  searchUnassignedRCs(request: $request) {
    unassignedRCs {
      id
      name
      category
      recordIDs
    }
  }
}
    `;

/**
 * __useSearchUnassignedRCsQuery__
 *
 * To run a query within a React component, call `useSearchUnassignedRCsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnassignedRCsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnassignedRCsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSearchUnassignedRCsQuery(baseOptions: Apollo.QueryHookOptions<SearchUnassignedRCsQuery, SearchUnassignedRCsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUnassignedRCsQuery, SearchUnassignedRCsQueryVariables>(SearchUnassignedRCsDocument, options);
      }
export function useSearchUnassignedRCsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUnassignedRCsQuery, SearchUnassignedRCsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUnassignedRCsQuery, SearchUnassignedRCsQueryVariables>(SearchUnassignedRCsDocument, options);
        }
export type SearchUnassignedRCsQueryHookResult = ReturnType<typeof useSearchUnassignedRCsQuery>;
export type SearchUnassignedRCsLazyQueryHookResult = ReturnType<typeof useSearchUnassignedRCsLazyQuery>;
export type SearchUnassignedRCsQueryResult = Apollo.QueryResult<SearchUnassignedRCsQuery, SearchUnassignedRCsQueryVariables>;
export const GetRcSuggestionDocument = gql`
    query getRCSuggestion($request: GetRCSuggestionInput!) {
  getRCSuggestion(request: $request) {
    suggestedRCs {
      id
      name
      recordIDs
    }
  }
}
    `;

/**
 * __useGetRcSuggestionQuery__
 *
 * To run a query within a React component, call `useGetRcSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRcSuggestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRcSuggestionQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useGetRcSuggestionQuery(baseOptions: Apollo.QueryHookOptions<GetRcSuggestionQuery, GetRcSuggestionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRcSuggestionQuery, GetRcSuggestionQueryVariables>(GetRcSuggestionDocument, options);
      }
export function useGetRcSuggestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRcSuggestionQuery, GetRcSuggestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRcSuggestionQuery, GetRcSuggestionQueryVariables>(GetRcSuggestionDocument, options);
        }
export type GetRcSuggestionQueryHookResult = ReturnType<typeof useGetRcSuggestionQuery>;
export type GetRcSuggestionLazyQueryHookResult = ReturnType<typeof useGetRcSuggestionLazyQuery>;
export type GetRcSuggestionQueryResult = Apollo.QueryResult<GetRcSuggestionQuery, GetRcSuggestionQueryVariables>;
export const ListDemoTenantsDocument = gql`
    query listDemoTenants($request: ListDemoTenantsInput!) {
  listDemoTenants(request: $request) {
    tenants {
      id
      name
      tenantCategory
      slug
      avatarURL
    }
  }
}
    `;

/**
 * __useListDemoTenantsQuery__
 *
 * To run a query within a React component, call `useListDemoTenantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDemoTenantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDemoTenantsQuery({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useListDemoTenantsQuery(baseOptions: Apollo.QueryHookOptions<ListDemoTenantsQuery, ListDemoTenantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDemoTenantsQuery, ListDemoTenantsQueryVariables>(ListDemoTenantsDocument, options);
      }
export function useListDemoTenantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDemoTenantsQuery, ListDemoTenantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDemoTenantsQuery, ListDemoTenantsQueryVariables>(ListDemoTenantsDocument, options);
        }
export type ListDemoTenantsQueryHookResult = ReturnType<typeof useListDemoTenantsQuery>;
export type ListDemoTenantsLazyQueryHookResult = ReturnType<typeof useListDemoTenantsLazyQuery>;
export type ListDemoTenantsQueryResult = Apollo.QueryResult<ListDemoTenantsQuery, ListDemoTenantsQueryVariables>;